import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
const defaultOptions = {} as const;
export type ApproveDenyTimeOffRequestMutationVariables = Exact<{
  memberUuid: Scalars['String']['input'];
  notesPrivate?: InputMaybe<Scalars['String']['input']>;
  notesPublic?: InputMaybe<Scalars['String']['input']>;
  status: ApproveDenyTimeOffRequestStatus;
  timeOffRequestUuid: Scalars['String']['input'];
}>;


export type ApproveDenyTimeOffRequestMutation = { __typename?: 'Mutation', approveDenyTimeOffRequest?: { __typename?: 'ApproveDenyTimeOffRequestPayload', success: boolean, userErrors?: Array<{ __typename?: 'UserError', inputField?: string | null, message: string }> | null } | null };

export type GetCompanyDisplayQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCompanyDisplayQuery = { __typename?: 'Query', authenticatedMember: { __typename?: 'AllMembers', uuid: string, company: { __typename?: 'Company', uuid: string, name: string } } };

export type GetHelpMenuQueryVariables = Exact<{ [key: string]: never; }>;


export type GetHelpMenuQuery = { __typename?: 'Query', authenticatedMember: { __typename?: 'AllMembers', uuid: string, capabilities: { __typename?: 'CapabilitiesList', hasAccessToAdvancedHelpChat: boolean }, company: { __typename?: 'Company', uuid: string, accountManager: { __typename?: 'AccountManager', emailExternal: string, isDesignatedAccountManager: boolean, name: string, phone: string, primaryPhotoUrl?: string | null, secondaryPhotoUrl?: string | null } } } };

export type GetMemberAlertsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetMemberAlertsQuery = { __typename?: 'Query', currentMember: { __typename?: 'SelfMember', uuid: string, notificationsCount: number, notificationList?: { __typename?: 'Notifications', i9ToSign?: { __typename?: 'I9IncompleteList', count: number, notifications?: Array<{ __typename?: 'I9IncompleteDetails', addedToNotificationCount: boolean, message: string, priority: number, type: string, url: string, member?: { __typename?: 'NotificationMemberDetails', preferredName: string, lastName: string, photoUrl?: string | null } | null }> | null } | null, irsRequired?: { __typename?: 'IrsRequiredList', count: number, notifications?: Array<{ __typename?: 'IrsRequiredDetails', addedToNotificationCount: boolean, message: string, priority: number, type: string, url: string }> | null } | null, irsVerified?: { __typename?: 'IrsVerifiedList', count: number, notifications?: Array<{ __typename?: 'IrsVerifiedDetails', addedToNotificationCount: boolean, message: string, priority: number, type: string, url: string }> | null } | null, missingBankAccount?: { __typename?: 'MissingBankAccountList', count: number, notifications?: Array<{ __typename?: 'MissingBankAccountDetails', addedToNotificationCount: boolean, message: string, priority: number, type: string, url: string }> | null } | null, pennyTest?: { __typename?: 'PennyTestList', count: number, notifications?: Array<{ __typename?: 'PennyTestDetails', addedToNotificationCount: boolean, message: string, priority: number, type: string, url: string }> | null } | null, processingSuspended?: { __typename?: 'ProcessingSuspendedList', count: number, notifications?: Array<{ __typename?: 'ProcessingSuspendedDetails', addedToNotificationCount: boolean, message: string, priority: number, type: string, url: string }> | null } | null, ptoRequest?: { __typename?: 'PtoRequestList', count: number, notifications?: Array<{ __typename?: 'PtoRequestDetails', addedToNotificationCount: boolean, approvalUrl: string, message: string, priority: number, timeOffUuid: string, type: string, url: string, member: { __typename?: 'NotificationMemberDetails', preferredName: string, lastName: string, photoUrl?: string | null, uuid: string } }> | null } | null, unpaidEmployees?: { __typename?: 'UnpaidEmployeeList', count: number, notifications?: Array<{ __typename?: 'UnpaidEmployeeDetails', addedToNotificationCount: boolean, message: string, priority: number, type: string, url: string }> | null } | null, upcomingHolidays?: { __typename?: 'UpcomingHolidaysList', count: number, notifications?: Array<{ __typename?: 'UpcomingHolidaysDetails', addedToNotificationCount: boolean, message: string, priority: number, type: string }> | null } | null, upgradePending?: { __typename?: 'UpgradePendingList', count: number, notifications?: Array<{ __typename?: 'UpgradePendingDetails', addedToNotificationCount: boolean, message: string, priority: number, type: string }> | null } | null, atsPendingHire?: { __typename?: 'AtsPendingHireList', count: number, notifications?: Array<{ __typename?: 'AtsPendingHireDetails', addedToNotificationCount: boolean, message: string, priority: number, type: string, url: string }> | null } | null, pmtIntegrationAlerts?: { __typename?: 'PmtIntegrationAlertsList', count: number, notifications?: Array<{ __typename?: 'PmtIntegrationAlertsDetails', addedToNotificationCount: boolean, message: string, priority: number, type: string, integrationName: string, url: string }> | null } | null, reimbursementRequests?: { __typename?: 'ReimbursementRequestList', count: number, notifications?: Array<{ __typename?: 'ReimbursementRequestDetails', type: string, message: string, priority: number, addedToNotificationCount: boolean }> | null } | null, directReportsUpcomingHolidays?: { __typename?: 'DirectReportsUpcomingHolidaysList', count: number, notifications?: Array<{ __typename?: 'DirectReportsUpcomingHolidaysDetails', type: string, message: string, priority: number, addedToNotificationCount: boolean, url: string, member: { __typename?: 'NotificationMemberDetails', preferredName: string, lastName: string, photoUrl?: string | null, uuid: string } }> | null } | null, nsfNotifications?: { __typename?: 'NsfNotificationList', count: number, notifications?: Array<{ __typename?: 'NsfNotification', type: string, message: string, priority: number, url: string, returnCode: string, addedToNotificationCount: boolean }> | null } | null, reconnectPlaid?: { __typename?: 'ReconnectPlaidList', count: number, notifications?: Array<{ __typename?: 'ReconnectPlaidDetails', type: string, message: string, priority: number, url: string, addedToNotificationCount: boolean }> | null } | null, connectBankAccount?: { __typename?: 'ConnectBankAccountList', count: number, notifications?: Array<{ __typename?: 'ConnectBankAccountDetails', type: string, message: string, priority: number, url: string, addedToNotificationCount: boolean }> | null } | null, confirmBankDeposits?: { __typename?: 'ConfirmBankDepositsList', count: number, notifications?: Array<{ __typename?: 'ConfirmBankDepositsDetails', type: string, message: string, priority: number, url: string, addedToNotificationCount: boolean }> | null } | null, continueHiUpsellApp?: { __typename?: 'ContinueHiUpsellAppList', count: number, notifications?: Array<{ __typename?: 'ContinueHiUpsellAppDetails', type: string, message: string, priority: number, url: string, addedToNotificationCount: boolean }> | null } | null, pendingFirmInvitation?: { __typename?: 'PendingFirmInvitationList', count: number, notifications?: Array<{ __typename?: 'PendingFirmInvitationDetails', addedToNotificationCount: boolean, message: string, priority: number, url: string, member: { __typename?: 'NotificationMemberDetails', preferredName: string, lastName: string, photoUrl?: string | null, uuid: string } }> | null } | null, taxExemptionRenewals?: { __typename?: 'TaxExemptionRenewalList', count: number, notifications?: Array<{ __typename?: 'TaxExemptionRenewalDetails', addedToNotificationCount: boolean, message: string, priority: number, type: string, url: string }> | null } | null } | null } };

export type GetNavigationGroupsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetNavigationGroupsQuery = { __typename?: 'Query', authenticatedMember: { __typename?: 'AllMembers', uuid: string, routeDirectory: Array<{ __typename?: 'NavGroup', groupName: string, standaloneContent: boolean, navItems: Array<{ __typename?: 'NavItem', path: string, displayText: string, hasBadge: boolean, outstandingTaskCount?: number | null, isBoxCallout: boolean, secondaryText?: string | null, badge?: { __typename?: 'NavBadge', type: NavBadgeTypeEnum, text?: string | null, imageUrl?: string | null } | null }> }> } };

export type GetUserInfoQueryVariables = Exact<{ [key: string]: never; }>;


export type GetUserInfoQuery = { __typename?: 'Query', currentMember: { __typename?: 'SelfMember', uuid: string, company: { __typename?: 'Company', uuid: string, directoryMembersWithoutInviteStatusCheck: Array<{ __typename?: 'CompanyMember', firstName: string, lastName: string, uuid: string }> } } };

export type GetUserMenuQueryVariables = Exact<{ [key: string]: never; }>;


export type GetUserMenuQuery = { __typename?: 'Query', authenticatedMember: { __typename?: 'AllMembers', firstName: string, lastName: string, photoUrl?: string | null, uuid: string, company: { __typename?: 'Company', uuid: string }, capabilities: { __typename?: 'CapabilitiesList', hasAccessToCsTools: boolean, hasAccessToProfileView: boolean } }, authenticatedUser: { __typename?: 'AuthenticatedUser', uuid: string, members: Array<{ __typename?: 'AllMembers', uuid: string, company: { __typename?: 'Company', uuid: string, name: string } }> }, currentUserProductsAndCompanies: Array<{ __typename?: 'ProductCompany', product: string, companyName: string, companyLegacyUuid: string, companyCanonicalId: string, isActive: boolean, isSelected: boolean, redirectUrl: string }> };

export type GetUserNavCapabilitiesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetUserNavCapabilitiesQuery = { __typename?: 'Query', authenticatedMember: { __typename?: 'AllMembers', uuid: string, capabilities: { __typename?: 'CapabilitiesList', hasAccessToMemberSearch: boolean, hasAccessToReceiveAppAlerts: boolean, hasAccessToWhatsNewProductPosts: boolean } } };

export type GetWhatsNewPostsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetWhatsNewPostsQuery = { __typename?: 'Query', currentMember: { __typename?: 'SelfMember', uuid: string, productPosts?: { __typename?: 'ProductPosts', unseenPostsCount: number, posts?: Array<{ __typename?: 'Posts', category: string, url?: string | null, image?: string | null, date: string, title: string, description: string, seen: boolean, callToAction?: string | null }> | null } | null } };

export type MarkProductUpdatesAsSeenMutationVariables = Exact<{ [key: string]: never; }>;


export type MarkProductUpdatesAsSeenMutation = { __typename?: 'Mutation', markProductUpdatesAsSeen?: { __typename?: 'MarkProductUpdatesAsSeenPayload', success: boolean, userErrors?: Array<{ __typename?: 'UserError', message: string }> | null } | null };

export type SwitchCompaniesMutationVariables = Exact<{
  targetCompanyCanonicalId?: InputMaybe<Scalars['String']['input']>;
  targetCompanyUuid?: InputMaybe<Scalars['String']['input']>;
}>;


export type SwitchCompaniesMutation = { __typename?: 'Mutation', switchCompanies?: { __typename?: 'SwitchCompaniesPayload', success: boolean, userErrors?: Array<{ __typename?: 'UserError', message: string }> | null } | null };

export type GetHeapInfoQueryVariables = Exact<{ [key: string]: never; }>;


export type GetHeapInfoQuery = { __typename?: 'Query', authenticatedMember: { __typename?: 'AllMembers', uuid: string, memberType: MemberType, memberStatus: MemberStatus, adminStatus: boolean, managerStatus: boolean, permissions: Array<number>, company: { __typename?: 'Company', uuid: string, companyBenefitsStatus: boolean, companyPlanType?: CompanyPlan | null }, office?: { __typename?: 'Office', uuid?: string | null } | null } };

export type GetPendoInfoQueryVariables = Exact<{ [key: string]: never; }>;


export type GetPendoInfoQuery = { __typename?: 'Query', authenticatedMember: { __typename?: 'AllMembers', nagForBeneficiaries?: boolean | null, uuid: string, adminStatus: boolean, permissions: Array<number>, memberType: MemberType, memberStatus: MemberStatus, managerPermissions: Array<string>, address?: { __typename?: 'MemberAddress', state?: string | null } | null, adoptedBenefits: { __typename?: 'AdoptedBenefits', dental: boolean, medical: boolean, vision: boolean }, company: { __typename?: 'Company', uuid: string, workersCompStatus: boolean, benefitsEligibility: string, companyPlanType?: CompanyPlan | null, numOfActiveW2Employees: number, primaryAddress?: { __typename?: 'Address', state?: string | null } | null } } };

export type GetLoggedInAsHeaderDataQueryVariables = Exact<{ [key: string]: never; }>;


export type GetLoggedInAsHeaderDataQuery = { __typename?: 'Query', authenticatedMember: { __typename?: 'AllMembers', uuid: string, firstName: string, middleName: string, lastName: string, preferredName: string, userId: number, id: number, isLoggedInAs: boolean, company: { __typename?: 'Company', uuid: string, name: string } } };

export type GetAllFeatureFlagsQueryVariables = Exact<{
  contexts?: InputMaybe<Array<Scalars['JSON']['input']> | Scalars['JSON']['input']>;
}>;


export type GetAllFeatureFlagsQuery = { __typename?: 'Query', allFeatureFlags: object };

export type GetFeatureFlagQueryVariables = Exact<{
  flag: Scalars['String']['input'];
}>;


export type GetFeatureFlagQuery = { __typename?: 'Query', featureFlag: { __typename?: 'FeatureFlag', enabled: boolean } };

export type GetMemberPermissionsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetMemberPermissionsQuery = { __typename?: 'Query', authenticatedMember: { __typename?: 'AllMembers', uuid: string, permissions: Array<number>, company: { __typename?: 'Company', companyPlanType?: CompanyPlan | null, cdmsCanonicalCompanyId?: string | null } } };

export type GetBasicInfoQueryVariables = Exact<{
  memberUuid: Scalars['String']['input'];
}>;


export type GetBasicInfoQuery = { __typename?: 'Query', authenticatedMember: { __typename?: 'AllMembers', gender?: MemberGender | null, deskTitle: string, startDate: string, uuid: string, photoUrl?: string | null, dateOfBirth?: string | null, memberHideBirthday: boolean, pronouns?: string | null, contactPhone?: string | null, phoneOffice: string, phoneHome?: string | null, phoneCell?: string | null, emailHome: string, emailWork: string, isTerminated: boolean, office?: { __typename?: 'Office', address?: { __typename?: 'Address', city?: string | null, state?: string | null } | null } | null, homeAddress?: { __typename?: 'Address', street1?: string | null, street2?: string | null, city?: string | null, state?: string | null } | null, mailingAddress?: { __typename?: 'Address', street1?: string | null, street2?: string | null, city?: string | null, state?: string | null } | null, basicInfoEmergencyContact?: { __typename?: 'BasicInfoEmergencyContact', firstName?: string | null, lastName?: string | null, phoneNumber?: string | null, phoneNumberSecondary?: string | null, relationship?: string | null } | null } };

export type GetMemberTypeQueryVariables = Exact<{ [key: string]: never; }>;


export type GetMemberTypeQuery = { __typename?: 'Query', authenticatedMember: { __typename?: 'AllMembers', memberType: MemberType } };

export type GetCompensationHistoryQueryVariables = Exact<{
  memberUuid: Scalars['String']['input'];
}>;


export type GetCompensationHistoryQuery = { __typename?: 'Query', suiClaimsMemberState?: Array<{ __typename?: 'MemberState', effectiveDate: string, memberType: MemberType, uuid: string, memberStatus: MemberStatus, payBasis: string, payRateAmount?: number | null, standardHoursPerWeek?: number | null }> | null };

export type EditProfileDetailsMutationVariables = Exact<{
  hideBirthday?: InputMaybe<Scalars['Boolean']['input']>;
  pronouns?: InputMaybe<Scalars['String']['input']>;
  photoPath?: InputMaybe<Scalars['String']['input']>;
  photo?: InputMaybe<Photo>;
}>;


export type EditProfileDetailsMutation = { __typename?: 'Mutation', editProfileDetails?: { __typename?: 'EditProfileDetailsPayload', success: boolean, userErrors?: Array<{ __typename?: 'UserError', message: string }> | null } | null };

export type GetMemberAccountSettingsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetMemberAccountSettingsQuery = { __typename?: 'Query', authenticatedMember: { __typename?: 'AllMembers', uuid: string, dateOfBirth?: string | null, memberHideBirthday: boolean, photoUrl?: string | null, friendlyFullName: string, pronouns?: string | null, isTerminated: boolean } };

export type AcceptFirmInviteMutationVariables = Exact<{
  firmInviteUuid: Scalars['String']['input'];
  permissions: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type AcceptFirmInviteMutation = { __typename?: 'Mutation', acceptFirmInvite?: { __typename?: 'AcceptFirmInvitePayload', success: boolean, error?: string | null } | null };

export type DeclineFirmInviteMutationVariables = Exact<{
  firmInviteUuid: Scalars['String']['input'];
}>;


export type DeclineFirmInviteMutation = { __typename?: 'Mutation', declineFirmInvite?: { __typename?: 'DeclineFirmInvitePayload', success: boolean, error?: string | null } | null };

export type GetAllFirmInvitesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllFirmInvitesQuery = { __typename?: 'Query', allFirmInvites: Array<{ __typename?: 'FirmInvite', firmName?: string | null, status: FirmInviteStatus, permissions: Array<string>, expiresAt: string, uuid: string, invitingFirmUser: { __typename?: 'InvitingFirmUser', firstName?: string | null, lastName?: string | null } }> };

export type GetFirmInviteQueryVariables = Exact<{
  firmInviteId: Scalars['String']['input'];
}>;


export type GetFirmInviteQuery = { __typename?: 'Query', firmInvite?: { __typename?: 'FirmInvite', uuid: string, status: FirmInviteStatus, expiresAt: string, permissions: Array<string>, firmName?: string | null, invitingFirmUser: { __typename?: 'InvitingFirmUser', firmUserId?: string | null, firstName?: string | null, lastName?: string | null, role?: string | null, email?: string | null, phone?: string | null } } | null };

export type GetFirmInvitePermissionsQueryVariables = Exact<{
  firmInviteId: Scalars['String']['input'];
}>;


export type GetFirmInvitePermissionsQuery = { __typename?: 'Query', firmInvite?: { __typename?: 'FirmInvite', permissions: Array<string> } | null };

export type FirmListFieldsFragment = { __typename?: 'Firm', uuid: string, name?: string | null, status: FirmStatus, permissions: Array<string>, invitation?: { __typename?: 'Invitation', uuid: string, email: string, fullName: string } | null, firmMembers: Array<{ __typename?: 'FirmMember', uuid: string, name?: string | null, title?: string | null, phone?: string | null, email?: string | null }> };

export type GetFirmPermissionsQueryVariables = Exact<{
  companyUuid: Scalars['String']['input'];
}>;


export type GetFirmPermissionsQuery = { __typename?: 'Query', firm?: { __typename?: 'Firm', permissions: Array<string> } | null };

export type FirmsPageQueryVariables = Exact<{
  companyUuid: Scalars['String']['input'];
}>;


export type FirmsPageQuery = { __typename?: 'Query', authenticatedMember: { __typename?: 'AllMembers', uuid: string, adminStatus: boolean, permissions: Array<number>, company: { __typename?: 'Company', uuid: string, name: string, thirdPartyAdmins: Array<{ __typename?: 'CompanyMember', uuid: string, firstName: string, lastName: string, emailWork?: string | null, deskTitle?: string | null }> } }, firm?: { __typename?: 'Firm', uuid: string, name?: string | null, status: FirmStatus, permissions: Array<string>, invitation?: { __typename?: 'Invitation', uuid: string, email: string, fullName: string } | null, firmMembers: Array<{ __typename?: 'FirmMember', uuid: string, name?: string | null, title?: string | null, phone?: string | null, email?: string | null }> } | null };

export type InviteFirmMutationVariables = Exact<{
  companyUuid: Scalars['String']['input'];
  newInvitation: NewInvitationInput;
}>;


export type InviteFirmMutation = { __typename?: 'Mutation', inviteFirm?: { __typename?: 'InviteFirmPayload', success: boolean, error?: string | null, firm?: { __typename?: 'Firm', uuid: string, name?: string | null, status: FirmStatus, permissions: Array<string>, invitation?: { __typename?: 'Invitation', uuid: string, email: string, fullName: string } | null, firmMembers: Array<{ __typename?: 'FirmMember', uuid: string, name?: string | null, title?: string | null, phone?: string | null, email?: string | null }> } | null } | null };

export type UpdatePermissionsMutationVariables = Exact<{
  companyUuid: Scalars['String']['input'];
  firmUuid: Scalars['String']['input'];
  permissions: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type UpdatePermissionsMutation = { __typename?: 'Mutation', updatePermissions?: { __typename?: 'UpdatePermissionsPayload', success: boolean, error?: string | null, firm?: { __typename?: 'Firm', uuid: string, permissions: Array<string> } | null } | null };

export type RemoveFirmMutationVariables = Exact<{
  companyUuid: Scalars['String']['input'];
  firmUuid: Scalars['String']['input'];
}>;


export type RemoveFirmMutation = { __typename?: 'Mutation', removeFirm?: { __typename?: 'RemoveFirmPayload', success: boolean, error?: string | null } | null };

export type GetAllClientInvitesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllClientInvitesQuery = { __typename?: 'Query', allClientInvites?: Array<{ __typename?: 'ClientInvite', companyId: string, email: string, expiresAt?: string | null, firstName: string, id: string, invitedFirmName: string, lastName: string, message?: string | null, permissions: Array<string>, status: ClientInviteStatus }> | null };

export type RevokeInviteToFirmMutationVariables = Exact<{
  inviteId: Scalars['String']['input'];
}>;


export type RevokeInviteToFirmMutation = { __typename?: 'Mutation', revokeInviteToFirm?: { __typename?: 'RevokeInviteToFirmPayload', success: boolean, error?: string | null } | null };

export type CreateMember401kAdditionalContributionMutationVariables = Exact<{
  year: Scalars['Int']['input'];
  amountPretax: Scalars['Int']['input'];
  amountRoth: Scalars['Int']['input'];
}>;


export type CreateMember401kAdditionalContributionMutation = { __typename?: 'Mutation', createMember401kAdditionalContribution?: { __typename?: 'CreateMember401kAdditionalContributionPayload', id: string } | null };

export type Create401kPlanEnrollmentLeadMutationVariables = Exact<{
  providerName: Scalars['String']['input'];
  leadMetadataJson: Scalars['String']['input'];
}>;


export type Create401kPlanEnrollmentLeadMutation = { __typename?: 'Mutation', create401kPlanEnrollmentLead?: { __typename?: 'Create401kPlanEnrollmentLeadPayload', id: string } | null };

export type GetCompany401kDetailsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCompany401kDetailsQuery = { __typename?: 'Query', currentMember: { __typename?: 'SelfMember', company: { __typename?: 'Company', company401kPlan?: { __typename?: 'Company401kPlan', planProvider: string, startDate: string, endDate?: string | null, discretionaryTier1Rate: number, discretionaryTier1Limit: number, discretionaryTier2Rate: number, discretionaryTier2Limit: number, safeHarborTier1Rate: number, safeHarborTier1Limit: number, safeHarborTier2Rate: number, safeHarborTier2Limit: number, safeHarborNonelective: boolean, safeHarborNonelectivePercent?: number | null, memberDetails: Array<{ __typename?: 'Company401kPlanMemberDetails', uuid: string, fullName: string, pretaxAmount?: number | null, aftertaxAmount?: number | null, companyMatchAmount?: number | null, companyNonelectiveAmount?: number | null }> } | null } } };

export type GetCompanyAdminInfoQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCompanyAdminInfoQuery = { __typename?: 'Query', currentMember: { __typename?: 'SelfMember', emailWork?: string | null, friendlyFullName: string, permissions: Array<number>, phoneCell?: string | null, phoneHome?: string | null, phoneOffice?: string | null, uuid: string, company: { __typename?: 'Company', name: string } } };

export type GetUser401kInfoQueryVariables = Exact<{ [key: string]: never; }>;


export type GetUser401kInfoQuery = { __typename?: 'Query', currentMember: { __typename?: 'SelfMember', member401kInfo: { __typename?: 'Member401kInfo', eligibleFor401kCatchup: boolean, member401kDeferralMax: number, showYtd401kActionCard: boolean, enrollmentFlowEligible: boolean, latestActiveDeferralRates: { __typename?: 'DeferralRates', salaryAftertaxAmount?: number | null, salaryAftertaxPercent?: number | null, salaryPretaxAmount?: number | null, salaryPretaxPercent?: number | null, supplementalAftertaxAmount?: number | null, supplementalAftertaxPercent?: number | null, supplementalPretaxAmount?: number | null, supplementalPretaxPercent?: number | null }, ytdContributions: { __typename?: 'YtdContributions', additionalPretax: number, additionalRoth: number, slavic: number, manual: number } } } };

export type GetUserPermissionsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetUserPermissionsQuery = { __typename?: 'Query', currentMember: { __typename?: 'SelfMember', permissions: Array<number> } };

export type GetEoRCombinedInvoicesQueryVariables = Exact<{
  processingDate?: InputMaybe<Scalars['String']['input']>;
  invoiceId?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetEoRCombinedInvoicesQuery = { __typename?: 'Query', combinedInvoices: Array<{ __typename?: 'CombinedInvoice', baseCurrency: string, companyId: string, pendingDisbursementOrders?: Array<string> | null, processingDate: string, status: string, total: number, invoices: Array<{ __typename?: 'InvoiceData', id: string, status: string, usdFxRate: number, localCurrencyTotal: number, payPeriodRange: { __typename?: 'PayPeriodRange', startDate: string, endDate: string, payDate: string, paymentDueDate: string }, country: { __typename?: 'CountryData', code: string, description: string }, currency: { __typename?: 'CurrencyData', code: string, description: string }, categories: Array<{ __typename?: 'Category', description: string, type: string, total: number, note?: string | null, entries?: Array<{ __typename?: 'CategoryEntry', description: string, amount: number }> | null }>, fees: { __typename?: 'InvoiceFees', justworksFee: number, serviceFee?: number | null, securityDeposit: number, securityDepositRefund: number } }>, fees: { __typename?: 'CombinedInvoiceFees', serviceFees: { __typename?: 'CombinedInvoiceFee', description: string, total: number, entries: Array<{ __typename?: 'FeeEntry', description: string, amount: number }> }, otherFees: { __typename?: 'CombinedInvoiceFee', description: string, total: number, entries: Array<{ __typename?: 'FeeEntry', description: string, amount: number }> } }, credits?: { __typename?: 'InvoiceCredits', description: string, type: string, total: number, entries?: Array<{ __typename?: 'CategoryEntry', description: string, amount: number }> | null } | null }> };

export type GetEoRMemberBackgroundCheckQueryVariables = Exact<{
  memberId: Scalars['String']['input'];
}>;


export type GetEoRMemberBackgroundCheckQuery = { __typename?: 'Query', backgroundCheckStatus?: { __typename?: 'BackgroundCheck', status: string, candidateFeedbackUrl?: string | null } | null };

export type GetEoRMemberByUuidQueryVariables = Exact<{
  memberUuid?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetEoRMemberByUuidQuery = { __typename?: 'Query', eorMember: { __typename?: 'Member', id: string, memberUuid: string, firstName: string, lastName: string, email?: string | null, accountCreated: boolean } };

export type GetEoRMemberIdVerificationStatusQueryVariables = Exact<{
  memberId: Scalars['String']['input'];
}>;


export type GetEoRMemberIdVerificationStatusQuery = { __typename?: 'Query', personaIdVerificationStatus: string };

export type GetEoRSupportedCountriesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetEoRSupportedCountriesQuery = { __typename?: 'Query', eorSupportedCountries: Array<{ __typename?: 'SupportedCountry', code: string, config: { __typename?: 'SupportedCountryConfig', commonName: string, emojiFlag: string, underwritingSubdivisionGroups: Array<Array<string>>, currencies: Array<{ __typename?: 'Currency', currencyCode: string, subunitToUnit: number, symbol: string }>, subdivisions: Array<{ __typename?: 'Subdivision', code: string, name: string }> } }> };

export type LaunchEoRIdVerificationMutationVariables = Exact<{
  memberId: Scalars['String']['input'];
}>;


export type LaunchEoRIdVerificationMutation = { __typename?: 'Mutation', personaLaunchIdVerification?: { __typename?: 'PersonaLaunchIdVerificationPayload', hostedFlowUrl: string } | null };

export type EditEorEmployeeBankAccountMutationVariables = Exact<{
  bankAccountId: Scalars['String']['input'];
  bankAccount: ProfileBankAccountInput;
}>;


export type EditEorEmployeeBankAccountMutation = { __typename?: 'Mutation', updateEorEmployeeBankAccount?: { __typename?: 'EditEmployeeBankAccountPayload', success: { __typename?: 'ProfileBankAccount', nickname?: string | null } } | null };

export type SubmitCompensationChangeRequestMutationVariables = Exact<{
  memberId: Scalars['String']['input'];
  employmentId: Scalars['String']['input'];
  changeRequest: Scalars['JSON']['input'];
}>;


export type SubmitCompensationChangeRequestMutation = { __typename?: 'Mutation', submitChangeRequest?: { __typename?: 'SubmitChangeRequestPayload', success: boolean } | null };

export type EditEorEmployeeProfileMutationVariables = Exact<{
  memberId: Scalars['String']['input'];
  profile: EorEmployeeProfileInput;
}>;


export type EditEorEmployeeProfileMutation = { __typename?: 'Mutation', updateEorEmployeeProfile?: { __typename?: 'EditEmployeeProfilePayload', success: { __typename?: 'EorEmployeeProfile', personalInfo?: { __typename?: 'PersonalInfo', preferredFirstName?: string | null, pronouns?: string | null } | null } } | null };

export type ResendEorInvitationEmailMutationVariables = Exact<{
  memberUuid: Scalars['String']['input'];
  sendTo?: InputMaybe<Scalars['String']['input']>;
}>;


export type ResendEorInvitationEmailMutation = { __typename?: 'Mutation', resendEorInvitationEmail?: { __typename?: 'ResendInvitationEmailPayload', success: boolean } | null };

export type GetAdminCapabilitiesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAdminCapabilitiesQuery = { __typename?: 'Query', authenticatedMember: { __typename?: 'AllMembers', uuid: string, capabilities: { __typename?: 'CapabilitiesList', hasPermissionToUpdateTimeOff: boolean, hasAccessToAdminProfileView: boolean, hasAccessToPaymentCenter: boolean } } };

export type GetEoREmployeeProfileQueryVariables = Exact<{
  memberId?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetEoREmployeeProfileQuery = { __typename?: 'Query', eorEmployeeProfile: { __typename?: 'EorEmployeeProfile', jobInformation?: { __typename?: 'JobInformation', workId?: string | null, department?: string | null, honoredStartDate?: string | null, office?: string | null, employeeType?: string | null, managerInfo?: { __typename?: 'ManagerInfo', id?: string | null, uuid?: string | null, firstName?: string | null, lastName?: string | null, middleName?: string | null, preferredFirstName?: string | null } | null } | null, contract?: { __typename?: 'Contract', id?: string | null, employmentId?: string | null, actorUuid?: string | null, term?: string | null, startDate?: string | null, endDate?: string | null } | null, employment?: { __typename?: 'Employment', id?: string | null, memberId?: string | null, memberCanonicalId?: string | null, actorUuid?: string | null, workEmail?: string | null, workCountry: string, companyUuid?: string | null, employmentStatus?: string | null, mxIsRemoteWork?: boolean | null } | null, contactDetails?: { __typename?: 'ContractDetails', homeAddress?: { __typename?: 'ProfileAddress', type?: string | null, address1?: string | null, address2?: string | null, city?: string | null, zoneCode?: string | null, postalCode?: string | null, countryCode?: string | null } | null, mailingAddress?: { __typename?: 'ProfileAddress', type?: string | null, address1?: string | null, address2?: string | null, city?: string | null, zoneCode?: string | null, postalCode?: string | null, countryCode?: string | null } | null, homePhoneNumber?: { __typename?: 'ProfilePhoneNumber', type?: string | null, value?: string | null } | null, mobilePhoneNumber?: { __typename?: 'ProfilePhoneNumber', type?: string | null, value?: string | null } | null, workPhoneNumber?: { __typename?: 'ProfilePhoneNumber', type?: string | null, value?: string | null } | null } | null, role?: { __typename?: 'Role', title?: string | null, payBasis?: string | null, payFrequency?: string | null, payRate?: number | null, currency?: string | null, departmentUuid?: string | null, responsibilities?: string | null, mxChristmasBonusDays?: number | null } | null, personalInfo?: { __typename?: 'PersonalInfo', memberUuid?: string | null, pronouns?: string | null, preferredFirstName?: string | null, middleName?: string | null, lastName?: string | null, firstName?: string | null, dateOfBirth?: string | null, email?: string | null, nationality?: string | null, brCityOfBirth?: string | null, brEducationalQualification?: string | null, brEthnicity?: string | null, brGender?: string | null, brMaritalStatus?: string | null, brPersonalId?: string | null, brPis?: string | null, brRgIssuingBody?: string | null, brRgStateOfIssue?: string | null, brStateOfBirth?: string | null, brWorkPermitStatus?: string | null, brCpf?: string | null, clAfpAgencyName?: string | null, clHealthAgencyName?: string | null, clHealthPlan?: string | null, clRut?: string | null, coCedulaDeCiudadania?: string | null, coNombreArl?: string | null, coNombreEps?: string | null, coNombreFondoDePensiones?: string | null, crCcss?: string | null, crCedulaDeIdentidad?: string | null, crIns?: string | null, crMaritalStatus?: string | null, crNumChildren?: number | null, crSpouse?: boolean | null, mxNationalId?: string | null, mxPersonalId?: string | null, mxSocialSecurityNumber?: string | null, mxWorkPermitId?: string | null, mxHasFonacotLoan?: boolean | null, mxHasInfonavitLoan?: boolean | null, mxRfc?: string | null, myEpf?: string | null, myGender?: string | null, myHasCitizenship?: string | null, myHasDisability?: string | null, myIcNumber?: string | null, myIncomeTaxBranch?: string | null, myIncomeTaxNumber?: string | null, myIncomeTaxStatus?: string | null, myMaritalStatus?: string | null, myPassportNumber?: string | null, myRace?: string | null, mySocsoNumber?: string | null, mySpouseName?: string | null, mySpouseIcNumber?: string | null, mySpouseWorkingStatus?: string | null, mySpouseDisability?: string | null, mySpouseIncomeTaxNumber?: string | null, mySpouseIncomeTaxBranch?: string | null, mySpouseTelephoneNumber?: string | null, myHasChildren?: string | null, ptCc?: string | null, ptCcExpDate?: string | null, ptCcIssDate?: string | null, ptNif?: string | null, ptNiss?: string | null, inEsic?: string | null, inPfUan?: string | null, inAadharNumber?: string | null, inPan?: string | null, esChildrensBirthDates?: Array<string> | null, esDni?: string | null, esEducationalQualification?: string | null, esMaritalStatus?: string | null, esNie?: string | null, esNumChildren?: number | null, esSsn?: string | null, ieMaritalStatus?: string | null, iePps?: string | null, phSsn?: string | null, phPhicn?: string | null, phHdmfn?: string | null, phTin?: string | null, grFirstInsuranceDate?: string | null, grIdentityCardNumber?: string | null, grMaritalStatus?: string | null, grNameOfFather?: string | null, grNameOfMother?: string | null, grNumberOfChildren?: number | null, grRevenueOffice?: string | null, grSex?: string | null, grSocialInsuranceNumber?: string | null, grSocialSecurityNumber?: string | null, grVat?: string | null, nlBsn?: string | null, keGender?: string | null, keKraPin?: string | null, keIdentityType?: string | null, keNationalId?: string | null, keForeignId?: string | null, keTaxStatus?: string | null, keNssfNumber?: string | null, keShifNumber?: string | null, keDisabledExemptionCertNumber?: string | null, ngIdentificationType?: string | null, ngIdentificationNumber?: string | null, ngHasPen?: boolean | null, ngPenNumber?: string | null, ngPensionFundAdministrator?: string | null, ngPensionCustodianBankName?: string | null, ngPensionCustodianBankAccountNo?: string | null, ngWillContributeNhf?: boolean | null, ngNhfNumber?: string | null, ngAnnualRentPaid?: string | null, ngAnnualPremiumPayment?: string | null, ngMaritalStatus?: string | null, ngGender?: string | null, ngTaxIdentificationNumber?: string | null, deCountryOfBirth?: string | null, deMainEmployer?: boolean | null, dePensionInsuranceNumber?: string | null, deHealthInsuranceStatus?: string | null, deHealthInsuranceProvider?: string | null, deReligion?: string | null, deSchoolDegree?: string | null, deTaxClass?: string | null, deProfessionalQualification?: string | null, deMaritalStatus?: string | null, deEligibleChildren?: number | null, deIdnr?: string | null, auTfn?: string | null, caSin?: string | null, dkCpr?: string | null, eeIk?: string | null, frSsn?: string | null, gbNino?: string | null, paCedula?: string | null, paPassport?: string | null, paCivilStatus?: string | null, paGender?: string | null, paEducationLevel?: string | null, paSocialInsuranceNumber?: string | null, plPesel?: string | null, roPnc?: string | null, sePersonnummer?: string | null, sgNric?: string | null, usSsn?: string | null, uyCid?: string | null, uySeguroDeSaludBps?: string | null, uyPreviousEmploymentStatus?: string | null, uyEducationLevel?: string | null, uyFieldOfEducation?: string | null, settings?: { __typename?: 'Settings', showDateOfBirth?: boolean | null } | null, emergencyContact?: { __typename?: 'EmergencyContactDetails', firstName?: string | null, lastName?: string | null, relationship?: string | null, phoneNumber?: { __typename?: 'ProfilePhoneNumber', type?: string | null, value?: string | null } | null } | null, myChildrenInformation?: Array<{ __typename?: 'ChildrenInformation', name: string, dateOfBirth: string, educationLevel: string, gender: string, icNumber: string, taxClaim: string }> | null, paDependentInformation?: Array<{ __typename?: 'PaDependentInformation', firstName: string, lastName: string, dependentType: string }> | null } | null, bankAccount?: { __typename?: 'ProfileBankAccount', id?: string | null, country?: string | null, currency?: string | null, nickname?: string | null, data?: { __typename?: 'ProfileBankAccountData', accountHolderName?: string | null, accountNumber?: string | null, accountType?: string | null, bankCode?: string | null, bankName?: string | null, branchCode?: string | null, bsbNumber?: string | null, bvn?: string | null, countryCode?: string | null, clabe?: string | null, clearingNumber?: string | null, ctsAccountNumber?: string | null, ctsFinancialEntity?: string | null, iban?: string | null, ifscCode?: string | null, institutionNumber?: string | null, irdNumber?: string | null, registrationNumber?: string | null, routingNumber?: string | null, sortCode?: string | null, swiftCode?: string | null, transitNumber?: string | null } | null } | null, onboarding?: { __typename?: 'Onboarding', workflowState?: WorkflowState | null } | null, offboarding?: { __typename?: 'Offboarding', requestedTerminationAt?: string | null, offboardingDate?: string | null } | null, activePtoPolicies?: Array<{ __typename?: 'EorTimeOffPolicy', uuid: string, name: string, policyType: string, prettyType: string, capped: boolean, effectiveDate: string, minutesPerYear?: number | null, carryoverMinutes?: number | null, timePeriodType: string, awardMethod: string, minutesAccruedRate?: number | null, minutesWorkedRate?: number | null, accrualCapMinutes?: number | null, approvedMinutesDuringCurrentTimePeriod: number, approvedUpcomingMinutes: number, balance?: number | null, annualTenureMinutes?: number | null, balanceAtBeginningOfCurrentTimePeriod?: number | null, adjustmentMinutesDuringCurrentTimePeriod?: number | null, currentTimePeriodStartDate: string, upcomingRequests?: Array<{ __typename?: 'EorTimeOffRequest', uuid: string, minutes: number, startDate: string, endDate: string, status: string }> | null, requests?: Array<{ __typename?: 'EorTimeOffRequest', uuid: string, minutes: number, startDate: string, endDate: string, status: string }> | null, adjustments?: Array<{ __typename?: 'EorTimeOffAdjustment', createdAt: string, minutes: number, effectiveDate: string, uuid: string, adjustmentByMember: { __typename?: 'AllMembers', firstName: string, lastName: string } }> | null, accrualLevels?: Array<{ __typename?: 'AccrualLevel', anniversaryNumber: number, additionalMinutes: number }> | null }> | null, memberEvents?: { __typename?: 'MemberEvents', latestEvent?: { __typename?: 'LatestEvent', id?: string | null, eventType?: string | null, createdAt?: string | null } | null } | null } };

export type ClPersonalInfoFieldsFragment = { __typename?: 'PersonalInfo', clAfpAgencyName?: string | null, clHealthAgencyName?: string | null, clHealthPlan?: string | null, clRut?: string | null };

export type CoPersonalInfoFieldsFragment = { __typename?: 'PersonalInfo', coCedulaDeCiudadania?: string | null, coNombreArl?: string | null, coNombreEps?: string | null, coNombreFondoDePensiones?: string | null };

export type CrPersonalInfoFieldsFragment = { __typename?: 'PersonalInfo', crCcss?: string | null, crCedulaDeIdentidad?: string | null, crIns?: string | null, crMaritalStatus?: string | null, crNumChildren?: number | null, crSpouse?: boolean | null };

export type MxPersonalInfoFieldsFragment = { __typename?: 'PersonalInfo', mxNationalId?: string | null, mxPersonalId?: string | null, mxSocialSecurityNumber?: string | null, mxWorkPermitId?: string | null, mxHasFonacotLoan?: boolean | null, mxHasInfonavitLoan?: boolean | null, mxRfc?: string | null };

export type PtPersonalInfoFieldsFragment = { __typename?: 'PersonalInfo', ptCc?: string | null, ptCcExpDate?: string | null, ptCcIssDate?: string | null, ptNif?: string | null, ptNiss?: string | null };

export type InPersonalInfoFieldsFragment = { __typename?: 'PersonalInfo', inEsic?: string | null, inPfUan?: string | null, inAadharNumber?: string | null, inPan?: string | null };

export type EsPersonalInfoFieldsFragment = { __typename?: 'PersonalInfo', esChildrensBirthDates?: Array<string> | null, esDni?: string | null, esEducationalQualification?: string | null, esMaritalStatus?: string | null, esNie?: string | null, esNumChildren?: number | null, esSsn?: string | null };

export type IePersonalInfoFieldsFragment = { __typename?: 'PersonalInfo', ieMaritalStatus?: string | null, iePps?: string | null };

export type BrPersonalInfoFieldsFragment = { __typename?: 'PersonalInfo', brCityOfBirth?: string | null, brEducationalQualification?: string | null, brEthnicity?: string | null, brGender?: string | null, brMaritalStatus?: string | null, brPersonalId?: string | null, brPis?: string | null, brRgIssuingBody?: string | null, brRgStateOfIssue?: string | null, brStateOfBirth?: string | null, brWorkPermitStatus?: string | null, brCpf?: string | null };

export type PhPersonalInfoFieldsFragment = { __typename?: 'PersonalInfo', phSsn?: string | null, phPhicn?: string | null, phHdmfn?: string | null, phTin?: string | null };

export type GrPersonalInfoFieldsFragment = { __typename?: 'PersonalInfo', grFirstInsuranceDate?: string | null, grIdentityCardNumber?: string | null, grMaritalStatus?: string | null, grNameOfFather?: string | null, grNameOfMother?: string | null, grNumberOfChildren?: number | null, grRevenueOffice?: string | null, grSex?: string | null, grSocialInsuranceNumber?: string | null, grSocialSecurityNumber?: string | null, grVat?: string | null };

export type MxRoleFieldsFragment = { __typename?: 'Role', mxChristmasBonusDays?: number | null };

export type MyPersonalInfoFieldsFragment = { __typename?: 'PersonalInfo', myEpf?: string | null, myGender?: string | null, myHasCitizenship?: string | null, myHasDisability?: string | null, myIcNumber?: string | null, myIncomeTaxBranch?: string | null, myIncomeTaxNumber?: string | null, myIncomeTaxStatus?: string | null, myMaritalStatus?: string | null, myPassportNumber?: string | null, myRace?: string | null, mySocsoNumber?: string | null, mySpouseName?: string | null, mySpouseIcNumber?: string | null, mySpouseWorkingStatus?: string | null, mySpouseDisability?: string | null, mySpouseIncomeTaxNumber?: string | null, mySpouseIncomeTaxBranch?: string | null, mySpouseTelephoneNumber?: string | null, myHasChildren?: string | null, myChildrenInformation?: Array<{ __typename?: 'ChildrenInformation', name: string, dateOfBirth: string, educationLevel: string, gender: string, icNumber: string, taxClaim: string }> | null };

export type NlPersonalInfoFieldsFragment = { __typename?: 'PersonalInfo', nlBsn?: string | null };

export type DePersonalInfoFieldsFragment = { __typename?: 'PersonalInfo', deCountryOfBirth?: string | null, deMainEmployer?: boolean | null, dePensionInsuranceNumber?: string | null, deHealthInsuranceStatus?: string | null, deHealthInsuranceProvider?: string | null, deReligion?: string | null, deSchoolDegree?: string | null, deTaxClass?: string | null, deProfessionalQualification?: string | null, deMaritalStatus?: string | null, deEligibleChildren?: number | null, deIdnr?: string | null };

export type AuPersonalInfoFieldsFragment = { __typename?: 'PersonalInfo', auTfn?: string | null };

export type CaPersonalInfoFieldsFragment = { __typename?: 'PersonalInfo', caSin?: string | null };

export type DkPersonalInfoFieldsFragment = { __typename?: 'PersonalInfo', dkCpr?: string | null };

export type EePersonalInfoFieldsFragment = { __typename?: 'PersonalInfo', eeIk?: string | null };

export type FrPersonalInfoFieldsFragment = { __typename?: 'PersonalInfo', frSsn?: string | null };

export type GbPersonalInfoFieldsFragment = { __typename?: 'PersonalInfo', gbNino?: string | null };

export type NgPersonalInfoFieldsFragment = { __typename?: 'PersonalInfo', ngIdentificationType?: string | null, ngIdentificationNumber?: string | null, ngHasPen?: boolean | null, ngPenNumber?: string | null, ngPensionFundAdministrator?: string | null, ngPensionCustodianBankName?: string | null, ngPensionCustodianBankAccountNo?: string | null, ngWillContributeNhf?: boolean | null, ngNhfNumber?: string | null, ngAnnualRentPaid?: string | null, ngAnnualPremiumPayment?: string | null, ngMaritalStatus?: string | null, ngGender?: string | null, ngTaxIdentificationNumber?: string | null };

export type KePersonalInfoFieldsFragment = { __typename?: 'PersonalInfo', keGender?: string | null, keKraPin?: string | null, keIdentityType?: string | null, keNationalId?: string | null, keForeignId?: string | null, keTaxStatus?: string | null, keNssfNumber?: string | null, keShifNumber?: string | null, keDisabledExemptionCertNumber?: string | null };

export type PaPersonalInfoFieldsFragment = { __typename?: 'PersonalInfo', paCedula?: string | null, paPassport?: string | null, paCivilStatus?: string | null, paGender?: string | null, paEducationLevel?: string | null, paSocialInsuranceNumber?: string | null, paDependentInformation?: Array<{ __typename?: 'PaDependentInformation', firstName: string, lastName: string, dependentType: string }> | null };

export type PlPersonalInfoFieldsFragment = { __typename?: 'PersonalInfo', plPesel?: string | null };

export type RoPersonalInfoFieldsFragment = { __typename?: 'PersonalInfo', roPnc?: string | null };

export type SePersonalInfoFieldsFragment = { __typename?: 'PersonalInfo', sePersonnummer?: string | null };

export type SgPersonalInfoFieldsFragment = { __typename?: 'PersonalInfo', sgNric?: string | null };

export type UsPersonalInfoFieldsFragment = { __typename?: 'PersonalInfo', usSsn?: string | null };

export type UyPersonalInfoFieldsFragment = { __typename?: 'PersonalInfo', uyCid?: string | null, uySeguroDeSaludBps?: string | null, uyPreviousEmploymentStatus?: string | null, uyEducationLevel?: string | null, uyFieldOfEducation?: string | null };

export type MxEmploymentFieldsFragment = { __typename?: 'Employment', mxIsRemoteWork?: boolean | null };

export type InviteEorMutationVariables = Exact<{
  formDetails: EorInviteRequest;
}>;


export type InviteEorMutation = { __typename?: 'Mutation', inviteEorMember?: { __typename?: 'InviteMemberPayload', success: boolean } | null };

export type GetCompanyFirstHireByCountryQueryVariables = Exact<{
  workCountry: Scalars['String']['input'];
}>;


export type GetCompanyFirstHireByCountryQuery = { __typename?: 'Query', companyFirstHireByCountry: { __typename?: 'CompanyFirstHireResponse', isFirstHire: boolean } };

export type GetCurrentCompanyBusinessDescriptionQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCurrentCompanyBusinessDescriptionQuery = { __typename?: 'Query', currentMember: { __typename?: 'SelfMember', company: { __typename?: 'Company', businessDescription?: string | null } } };

export type GetCurrentMemberDepartmentsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCurrentMemberDepartmentsQuery = { __typename?: 'Query', currentMember: { __typename?: 'SelfMember', company: { __typename?: 'Company', departments?: Array<{ __typename?: 'Department', name: string, uuid: string }> | null } } };

export type GetCurrentMemberCompanyDirectoryMembersQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCurrentMemberCompanyDirectoryMembersQuery = { __typename?: 'Query', currentMember: { __typename?: 'SelfMember', company: { __typename?: 'Company', directoryMembers: Array<{ __typename?: 'CompanyMember', friendlyFullName: string, uuid: string, deskTitle?: string | null }> } } };

export type BackEoROnboardingStateMutationVariables = Exact<{
  currentState: Scalars['String']['input'];
  memberId: Scalars['String']['input'];
}>;


export type BackEoROnboardingStateMutation = { __typename?: 'Mutation', eorMemberOnboardingBackState?: { __typename?: 'MemberOnboardingBackStatePayload', state: string } | null };

export type GetEoRMemberOnboardingStateQueryVariables = Exact<{
  memberId: Scalars['String']['input'];
}>;


export type GetEoRMemberOnboardingStateQuery = { __typename?: 'Query', eorMemberOnboardingState: { __typename?: 'State', state: string, contactInfo?: { __typename?: 'ContactInfo', homeEmail?: string | null, emergencyContact?: { __typename?: 'EmergencyContact', firstName?: string | null, lastName?: string | null, phoneNumber?: string | null, relationship?: string | null } | null, homeAddress?: { __typename?: 'InternationalAddress', address1?: string | null, address2?: string | null, city?: string | null, countryCode?: string | null, postalCode?: string | null, zoneCode?: string | null } | null, mailingAddress?: { __typename?: 'InternationalAddress', address1?: string | null, address2?: string | null, city?: string | null, countryCode?: string | null, postalCode?: string | null, zoneCode?: string | null } | null, phoneNumbers?: Array<{ __typename?: 'PhoneNumber', type?: string | null, value?: string | null }> | null } | null, idVerification?: { __typename?: 'IdVerification', personaInquiryId?: string | null, status: string } | null, backgroundCheck?: { __typename?: 'BackgroundCheck', status: string } | null, paymentInfo?: { __typename?: 'PaymentInfo', accountNickname?: string | null, accountHolderName?: string | null, accountNumber?: string | null, accountType?: string | null, bvn?: string | null, countryCode?: string | null, currency?: string | null, institutionNumber?: string | null, transitNumber?: string | null } | null, profileInfo?: { __typename?: 'ProfileInfo', dateOfBirth?: string | null, firstName?: string | null, lastName?: string | null, middleName?: string | null, preferredFirstName?: string | null, pronouns?: string | null, nationality?: string | null, auTitle?: string | null, auGender?: string | null, brRgIssuingBody?: string | null, clHealthPlan?: string | null, clHealthAgencyName?: string | null, clAfpAgencyName?: string | null, coCedulaDeCiudadania?: string | null, crCcss?: string | null, crCedulaDeIdentidad?: string | null, crIns?: string | null, crMaritalStatus?: string | null, crNumChildren?: number | null, crSpouse?: boolean | null, esDateSinceResidentOfSpain?: string | null, esSex?: string | null, esMaritalStatus?: string | null, esNumChildren?: number | null, esChildrensBirthDates?: Array<string> | null, esEducationalQualification?: string | null, esUnemploymentStatus?: boolean | null, hrJmbg?: string | null, hrOib?: string | null, hrEducationLevel?: string | null, hrPensionInsuranceNumber?: string | null, hrDrugiSetup?: boolean | null, ieMaritalStatus?: string | null, inPfUan?: string | null, inEsic?: string | null, inYearToDateTaxableSalary?: number | null, inYearToDateExemptions?: Array<string> | null, inYearToDateTds?: number | null, inTaxRegime?: string | null, inMaritalStatus?: string | null, itBirthplace?: string | null, itCodiceFiscale?: string | null, itEducationalLevel?: string | null, mxSex?: string | null, mxCivilStatus?: string | null, mxHasInfonavitLoan?: boolean | null, mxHasFonacotLoan?: boolean | null, myEpf?: string | null, myGender?: string | null, myHasCitizenship?: string | null, myHasDisability?: string | null, myIcNumber?: string | null, myIncomeTaxBranch?: string | null, myIncomeTaxNumber?: string | null, myIncomeTaxStatus?: string | null, myMaritalStatus?: string | null, myPassportNumber?: string | null, myRace?: string | null, mySocsoNumber?: string | null, mySpouseName?: string | null, mySpouseIcNumber?: string | null, mySpouseWorkingStatus?: string | null, mySpouseDisability?: string | null, mySpouseIncomeTaxNumber?: string | null, mySpouseIncomeTaxBranch?: string | null, mySpouseTelephoneNumber?: string | null, myHasChildren?: string | null, nlArbeidsgehandicapte?: boolean | null, nlWajongBenefitsEligible?: boolean | null, nlThirtyPercentRulingEligible?: boolean | null, nlWorkPermitType?: string | null, nlWorkPermitStartDate?: string | null, nlWorkPermitExpirationDate?: string | null, keGender?: string | null, keKraPin?: string | null, keIdentityType?: string | null, keNationalId?: string | null, keForeignId?: string | null, keTaxStatus?: string | null, keNssfNumber?: string | null, keShifNumber?: string | null, keDisabledExemptionCertNumber?: string | null, ngIdentificationType?: string | null, ngIdentificationNumber?: string | null, ngHasPen?: boolean | null, ngPenNumber?: string | null, ngPensionFundAdministrator?: string | null, ngPensionCustodianBankName?: string | null, ngPensionCustodianBankAccountNo?: string | null, ngWillContributeNhf?: boolean | null, ngNhfNumber?: string | null, ngAnnualRentPaid?: string | null, ngAnnualPremiumPayment?: string | null, ngMaritalStatus?: string | null, ngGender?: string | null, paCedula?: string | null, paPassport?: string | null, paCivilStatus?: string | null, paGender?: string | null, paEducationLevel?: string | null, paSocialInsuranceNumber?: string | null, phSsn?: string | null, phPhicn?: string | null, phHdmfn?: string | null, sgGender?: string | null, sgShgFunds?: Array<string> | null, sgCitizenshipStatus?: string | null, sgRace?: string | null, sgPermanentResidenceStartDate?: string | null, grFirstInsuranceDate?: string | null, grIdentityCardNumber?: string | null, grMaritalStatus?: string | null, grNameOfFather?: string | null, grNameOfMother?: string | null, grNumberOfChildren?: number | null, grRevenueOffice?: string | null, grSex?: string | null, grSocialInsuranceNumber?: string | null, grSocialSecurityNumber?: string | null, peGender?: string | null, peHealthInsuranceType?: string | null, peMaritalStatus?: string | null, peBirthCountry?: string | null, peBirthPlace?: string | null, pePensionFund?: string | null, pePensionFundNumber?: string | null, peIdType?: string | null, peIdNumber?: string | null, trGender?: string | null, trIncomeTaxExempt?: boolean | null, trMaritalStatus?: string | null, trNumChildren6OrAbove?: number | null, trNumChildrenBelow6?: number | null, trTaxDeductionCode?: string | null, plMaritalStatus?: string | null, plSex?: string | null, plRequiresWorkPermit?: string | null, usSsn?: string | null, uyCid?: string | null, uySeguroDeSaludBps?: string | null, uyPreviousEmploymentStatus?: string | null, uyEducationLevel?: string | null, uyFieldOfEducation?: string | null, settings?: { __typename?: 'MemberSettings', showDateOfBirth?: boolean | null } | null, myChildrenInformation?: Array<{ __typename?: 'ChildrenInformation', name: string, dateOfBirth: string, educationLevel: string, gender: string, icNumber: string, taxClaim: string }> | null, paDependentInformation?: Array<{ __typename?: 'PaDependentInformation', firstName: string, lastName: string, dependentType: string }> | null } | null, taxInfo?: { __typename?: 'TaxInfo', example?: string | null } | null } };

export type AuAdditionalFieldsFragment = { __typename?: 'ProfileInfo', auTitle?: string | null, auGender?: string | null };

export type BrAdditionalFieldsFragment = { __typename?: 'ProfileInfo', brRgIssuingBody?: string | null };

export type ClAdditionalFieldsFragment = { __typename?: 'ProfileInfo', clHealthPlan?: string | null, clHealthAgencyName?: string | null, clAfpAgencyName?: string | null };

export type CoAdditionalFieldsFragment = { __typename?: 'ProfileInfo', coCedulaDeCiudadania?: string | null };

export type CrAdditionalFieldsFragment = { __typename?: 'ProfileInfo', crCcss?: string | null, crCedulaDeIdentidad?: string | null, crIns?: string | null, crMaritalStatus?: string | null, crNumChildren?: number | null, crSpouse?: boolean | null };

export type EsAdditionalFieldsFragment = { __typename?: 'ProfileInfo', esDateSinceResidentOfSpain?: string | null, esSex?: string | null, esMaritalStatus?: string | null, esNumChildren?: number | null, esChildrensBirthDates?: Array<string> | null, esEducationalQualification?: string | null, esUnemploymentStatus?: boolean | null };

export type HrAdditionalFieldsFragment = { __typename?: 'ProfileInfo', hrJmbg?: string | null, hrOib?: string | null, hrEducationLevel?: string | null, hrPensionInsuranceNumber?: string | null, hrDrugiSetup?: boolean | null };

export type IeAdditionalFieldsFragment = { __typename?: 'ProfileInfo', ieMaritalStatus?: string | null };

export type InAdditionalFieldsFragment = { __typename?: 'ProfileInfo', inPfUan?: string | null, inEsic?: string | null, inYearToDateTaxableSalary?: number | null, inYearToDateExemptions?: Array<string> | null, inYearToDateTds?: number | null, inTaxRegime?: string | null, inMaritalStatus?: string | null };

export type ItAdditionalFieldsFragment = { __typename?: 'ProfileInfo', itBirthplace?: string | null, itCodiceFiscale?: string | null, itEducationalLevel?: string | null };

export type MxAdditionalFieldsFragment = { __typename?: 'ProfileInfo', mxSex?: string | null, mxCivilStatus?: string | null, mxHasInfonavitLoan?: boolean | null, mxHasFonacotLoan?: boolean | null };

export type NlAdditionalFieldsFragment = { __typename?: 'ProfileInfo', nlArbeidsgehandicapte?: boolean | null, nlWajongBenefitsEligible?: boolean | null, nlThirtyPercentRulingEligible?: boolean | null, nlWorkPermitType?: string | null, nlWorkPermitStartDate?: string | null, nlWorkPermitExpirationDate?: string | null };

export type NgAdditionalFieldsFragment = { __typename?: 'ProfileInfo', ngIdentificationType?: string | null, ngIdentificationNumber?: string | null, ngHasPen?: boolean | null, ngPenNumber?: string | null, ngPensionFundAdministrator?: string | null, ngPensionCustodianBankName?: string | null, ngPensionCustodianBankAccountNo?: string | null, ngWillContributeNhf?: boolean | null, ngNhfNumber?: string | null, ngAnnualRentPaid?: string | null, ngAnnualPremiumPayment?: string | null, ngMaritalStatus?: string | null, ngGender?: string | null };

export type KeAdditionalFieldsFragment = { __typename?: 'ProfileInfo', keGender?: string | null, keKraPin?: string | null, keIdentityType?: string | null, keNationalId?: string | null, keForeignId?: string | null, keTaxStatus?: string | null, keNssfNumber?: string | null, keShifNumber?: string | null, keDisabledExemptionCertNumber?: string | null };

export type PaAdditionalFieldsFragment = { __typename?: 'ProfileInfo', paCedula?: string | null, paPassport?: string | null, paCivilStatus?: string | null, paGender?: string | null, paEducationLevel?: string | null, paSocialInsuranceNumber?: string | null, paDependentInformation?: Array<{ __typename?: 'PaDependentInformation', firstName: string, lastName: string, dependentType: string }> | null };

export type PhAdditionalFieldsFragment = { __typename?: 'ProfileInfo', phSsn?: string | null, phPhicn?: string | null, phHdmfn?: string | null };

export type SgAdditionalFieldsFragment = { __typename?: 'ProfileInfo', sgGender?: string | null, sgShgFunds?: Array<string> | null, sgCitizenshipStatus?: string | null, sgRace?: string | null, sgPermanentResidenceStartDate?: string | null };

export type GrAdditionalFieldsFragment = { __typename?: 'ProfileInfo', grFirstInsuranceDate?: string | null, grIdentityCardNumber?: string | null, grMaritalStatus?: string | null, grNameOfFather?: string | null, grNameOfMother?: string | null, grNumberOfChildren?: number | null, grRevenueOffice?: string | null, grSex?: string | null, grSocialInsuranceNumber?: string | null, grSocialSecurityNumber?: string | null };

export type MyAdditionalFieldsFragment = { __typename?: 'ProfileInfo', myEpf?: string | null, myGender?: string | null, myHasCitizenship?: string | null, myHasDisability?: string | null, myIcNumber?: string | null, myIncomeTaxBranch?: string | null, myIncomeTaxNumber?: string | null, myIncomeTaxStatus?: string | null, myMaritalStatus?: string | null, myPassportNumber?: string | null, myRace?: string | null, mySocsoNumber?: string | null, mySpouseName?: string | null, mySpouseIcNumber?: string | null, mySpouseWorkingStatus?: string | null, mySpouseDisability?: string | null, mySpouseIncomeTaxNumber?: string | null, mySpouseIncomeTaxBranch?: string | null, mySpouseTelephoneNumber?: string | null, myHasChildren?: string | null, myChildrenInformation?: Array<{ __typename?: 'ChildrenInformation', name: string, dateOfBirth: string, educationLevel: string, gender: string, icNumber: string, taxClaim: string }> | null };

export type PeAdditionalFieldsFragment = { __typename?: 'ProfileInfo', peGender?: string | null, peHealthInsuranceType?: string | null, peMaritalStatus?: string | null, peBirthCountry?: string | null, peBirthPlace?: string | null, pePensionFund?: string | null, pePensionFundNumber?: string | null, peIdType?: string | null, peIdNumber?: string | null };

export type TrAdditionalFieldsFragment = { __typename?: 'ProfileInfo', trGender?: string | null, trIncomeTaxExempt?: boolean | null, trMaritalStatus?: string | null, trNumChildren6OrAbove?: number | null, trNumChildrenBelow6?: number | null, trTaxDeductionCode?: string | null };

export type PlAdditionalFieldsFragment = { __typename?: 'ProfileInfo', plMaritalStatus?: string | null, plSex?: string | null, plRequiresWorkPermit?: string | null };

export type ZaAdditionalFieldsFragment = { __typename?: 'ProfileInfo', zaGender?: string | null, zaMaritalStatus?: string | null };

export type UsAdditionalFieldsFragment = { __typename?: 'ProfileInfo', usSsn?: string | null };

export type UyAdditionalFieldsFragment = { __typename?: 'ProfileInfo', uyCid?: string | null, uySeguroDeSaludBps?: string | null, uyPreviousEmploymentStatus?: string | null, uyEducationLevel?: string | null, uyFieldOfEducation?: string | null };

export type GetEorDocumentQueryVariables = Exact<{
  fileId: Scalars['String']['input'];
}>;


export type GetEorDocumentQuery = { __typename?: 'Query', eorDocument: { __typename?: 'EorDocument', signedUrl: string } };

export type GetEoREmployeeEmploymentWorkCountryQueryVariables = Exact<{
  memberId?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetEoREmployeeEmploymentWorkCountryQuery = { __typename?: 'Query', eorEmployeeProfile: { __typename?: 'EorEmployeeProfile', employment?: { __typename?: 'Employment', workCountry: string } | null } };

export type SubmitEoROnboardingStateMutationVariables = Exact<{
  contactInfo?: InputMaybe<ContactInfoInput>;
  currentState: Scalars['String']['input'];
  memberId: Scalars['String']['input'];
  paymentInfo?: InputMaybe<PaymentInfoInput>;
  profileInfo?: InputMaybe<ProfileInfoInput>;
  taxInfo?: InputMaybe<TaxInfoInput>;
}>;


export type SubmitEoROnboardingStateMutation = { __typename?: 'Mutation', eorMemberOnboardingSubmitState?: { __typename?: 'MemberOnboardingSubmitStatePayload', state: string } | null };

export type GetDisbursementOrderQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type GetDisbursementOrderQuery = { __typename?: 'Query', disbursementOrder: { __typename?: 'IeorDisbursementOrder', id: string, memberId: string, country: string, paymentType: OrderPayment, currency: string, amount: number, payPeriodId: string, status: string, createdAt: string, data: { __typename?: 'DisbursementData', paymentSettings: { __typename?: 'OrderPaymentSettings', benefitType?: string | null, payPeriodId: string, notes?: string | null, formOfIncome?: string | null, disbursementDate?: string | null, deliveryMethod?: string | null, effectiveDate?: string | null, expenseType?: string | null, isRecurring?: boolean | null, recurringCadence?: string | null }, expenseDetails?: { __typename?: 'ExpenseDetails', transactionDate?: string | null, distance?: string | null, additionalInformation?: string | null, receipts?: Array<{ __typename?: 'OrderReceipts', uuid: string, name: string, type: string, size?: number | null, lastModified: string }> | null } | null, paymentDetails: { __typename?: 'PaymentDetails', memberId: string, grossAmount: number, currency: string, workPeriodStart?: string | null, workPeriodEnd?: string | null }, taxes?: { __typename?: 'Taxes', bonusType?: string | null, nonDiscretionaryType?: string | null, reason?: string | null, cadence?: string | null, frequency?: string | null } | null }, member: { __typename?: 'IntlDisbursementOrderMember', id: string, actorUuid: string, memberUuid: string, firstName: string, lastName: string, middleName?: string | null, preferredFirstName?: string | null, workStartDate?: string | null, workEndDate?: string | null } } };

export type EorCreateDisbursementOrdersMutationVariables = Exact<{
  paymentDetails: Scalars['JSON']['input'];
  setup: Scalars['JSON']['input'];
}>;


export type EorCreateDisbursementOrdersMutation = { __typename?: 'Mutation', eorCreateDisbursementOrders?: { __typename?: 'CreateDisbursementOrdersPayload', state: string } | null };

export type EorUpdateDisbursementOrdersMutationVariables = Exact<{
  id: Scalars['String']['input'];
  payload: Scalars['JSON']['input'];
}>;


export type EorUpdateDisbursementOrdersMutation = { __typename?: 'Mutation', eorUpdateDisbursementOrders?: { __typename?: 'UpdateDisbursementOrdersPayload', state: string } | null };

export type GetEoRDisbursementDatesQueryVariables = Exact<{
  country: Scalars['String']['input'];
}>;


export type GetEoRDisbursementDatesQuery = { __typename?: 'Query', upcomingPayDate: { __typename?: 'UpcomingPayPeriods', payPeriods: Array<{ __typename?: 'PayPeriodWithDates', id: string, disbursementDate?: string | null, endDate: string, startDate: string }> } };

export type GetEorExchangeRatesQueryVariables = Exact<{
  source: Scalars['String']['input'];
  targets: Array<Scalars['String']['input']> | Scalars['String']['input'];
  time?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetEorExchangeRatesQuery = { __typename?: 'Query', exchangeRateData: { __typename?: 'ExchangeRateResponse', rates: Array<{ __typename?: 'ExchangeRate', rate: number, source: string, target: string, date: string, subunitConversionFactor: number }> } };

export type GetActiveEoRMembersByCompanyUuidQueryVariables = Exact<{ [key: string]: never; }>;


export type GetActiveEoRMembersByCompanyUuidQuery = { __typename?: 'Query', eorMembers: Array<{ __typename?: 'IntlDisbursementOrderMember', id: string, email?: string | null, firstName: string, lastName: string, memberUuid: string, preferredFirstName?: string | null, middleName?: string | null, workCountry?: string | null, workStartDate?: string | null, workEndDate?: string | null }> };

export type GetEorPayPeriodsQueryVariables = Exact<{
  country: Scalars['String']['input'];
  startDate: Scalars['String']['input'];
  endDate: Scalars['String']['input'];
}>;


export type GetEorPayPeriodsQuery = { __typename?: 'Query', payPeriodDates: { __typename?: 'UpcomingPayPeriods', payPeriods: Array<{ __typename?: 'PayPeriodWithDates', startDate: string, endDate: string, payGroup: string }> } };

export type ActivateExpensesMutationVariables = Exact<{ [key: string]: never; }>;


export type ActivateExpensesMutation = { __typename?: 'Mutation', setCompanySetting?: { __typename?: 'CompanySettingMutationPayload', success: boolean } | null };

export type ApproveReimbursementRequestMutationVariables = Exact<{
  payDate?: InputMaybe<Scalars['APIDate']['input']>;
  reviews: Array<ReimbursementReviewInput> | ReimbursementReviewInput;
}>;


export type ApproveReimbursementRequestMutation = { __typename?: 'Mutation', reviewReimbursementRequests?: { __typename?: 'ReviewReimbursementRequestsPayload', success: boolean, error?: string | null, updatedRequests?: Array<{ __typename?: 'ReimbursementRequest', name: string, status: ReimbursementRequestStatus, totalReimbursableAmount: number, totalNonReimbursableAmount: number, member: { __typename?: 'CompanyMember', friendlyFullName: string } }> | null } | null };

export type ApproveReimbursementRequestsMutationVariables = Exact<{
  reviews: Array<ReimbursementReviewInput> | ReimbursementReviewInput;
}>;


export type ApproveReimbursementRequestsMutation = { __typename?: 'Mutation', reviewReimbursementRequests?: { __typename?: 'ReviewReimbursementRequestsPayload', success: boolean, error?: string | null, updatedRequests?: Array<{ __typename?: 'ReimbursementRequest', name: string, status: ReimbursementRequestStatus, totalNonReimbursableAmount: number, member: { __typename?: 'CompanyMember', friendlyFullName: string } }> | null } | null };

export type CreateExpensePolicyMutationVariables = Exact<{ [key: string]: never; }>;


export type CreateExpensePolicyMutation = { __typename?: 'Mutation', updateExpensePolicy?: { __typename?: 'UpdateExpensePolicyPayload', success: boolean, error?: string | null } | null };

export type CreateReimbursementRequestMutationVariables = Exact<{
  name: Scalars['String']['input'];
  expenses: Array<ExpenseInput> | ExpenseInput;
}>;


export type CreateReimbursementRequestMutation = { __typename?: 'Mutation', createReimbursementRequest?: { __typename?: 'CreateReimbursementRequestPayload', success: boolean, error?: string | null } | null };

export type CreateUnattachedExpenseMutationVariables = Exact<{
  expense: ExpenseInput;
}>;


export type CreateUnattachedExpenseMutation = { __typename?: 'Mutation', createUnattachedExpense?: { __typename?: 'CreateUnattachedExpensePayload', success: boolean, error?: string | null } | null };

export type DeleteReimbursementRequestMutationVariables = Exact<{
  uuids: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type DeleteReimbursementRequestMutation = { __typename?: 'Mutation', deleteReimbursementRequests?: { __typename?: 'DeleteReimbursementRequestsPayload', success: boolean, error?: string | null, deletedReimbursementRequests?: Array<{ __typename?: 'ReimbursementRequest', name: string }> | null } | null };

export type DeleteUnattachedExpenseMutationVariables = Exact<{
  uuids: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type DeleteUnattachedExpenseMutation = { __typename?: 'Mutation', deleteUnattachedExpenses?: { __typename?: 'DeleteUnattachedExpensesPayload', success: boolean, error?: string | null, deletedExpenses?: Array<{ __typename?: 'Expense', uuid: string }> | null } | null };

export type ReturnToEmployeeMutationVariables = Exact<{
  reviews: Array<ReimbursementReviewInput> | ReimbursementReviewInput;
}>;


export type ReturnToEmployeeMutation = { __typename?: 'Mutation', reviewReimbursementRequests?: { __typename?: 'ReviewReimbursementRequestsPayload', success: boolean, updatedRequests?: Array<{ __typename?: 'ReimbursementRequest', name: string, member: { __typename?: 'CompanyMember', friendlyFullName: string } }> | null } | null };

export type ToggleExpensesEnabledMutationVariables = Exact<{
  enabled: Scalars['Boolean']['input'];
}>;


export type ToggleExpensesEnabledMutation = { __typename?: 'Mutation', updateExpensePolicy?: { __typename?: 'UpdateExpensePolicyPayload', success: boolean, updatedPolicy?: { __typename?: 'ExpensePolicy', enabled: boolean } | null } | null };

export type UpdateCategoriesMutationVariables = Exact<{
  categories?: InputMaybe<Array<ExpenseCategoryUpdate> | ExpenseCategoryUpdate>;
}>;


export type UpdateCategoriesMutation = { __typename?: 'Mutation', updateExpenseCategories?: { __typename?: 'UpdateExpenseCategoriesPayload', success: boolean, error?: string | null, updatedCategories?: Array<{ __typename?: 'ExpenseCategory', uuid: string, name: string, visible: boolean, custom: boolean, merchant: ExpenseCategoryFieldSetting, description: ExpenseCategoryFieldSetting, receipt: ExpenseCategoryFieldSetting, attendees: ExpenseCategoryFieldSetting, billableToClient: ExpenseCategoryFieldSetting, expenseType: ExpenseCategoryFieldSetting }> | null } | null };

export type UpdateProjectsMutationVariables = Exact<{
  projectUpdates?: InputMaybe<Array<ProjectUpdate> | ProjectUpdate>;
}>;


export type UpdateProjectsMutation = { __typename?: 'Mutation', updateProjects?: { __typename?: 'UpdateProjectsPayload', success: boolean, error?: string | null, updatedProjects?: Array<{ __typename?: 'Project', projectCode?: string | null, projectName: string, uuid: string, visible: boolean }> | null } | null };

export type UpdateReimbursementRequestMutationVariables = Exact<{
  uuid: Scalars['ID']['input'];
  name: Scalars['String']['input'];
  expenses: Array<ExpenseInput> | ExpenseInput;
}>;


export type UpdateReimbursementRequestMutation = { __typename?: 'Mutation', updateReimbursementRequest?: { __typename?: 'UpdateReimbursementRequestPayload', success: boolean, error?: string | null } | null };

export type UpdateUnattachedExpenseMutationVariables = Exact<{
  expense: ExpenseInput;
}>;


export type UpdateUnattachedExpenseMutation = { __typename?: 'Mutation', updateUnattachedExpense?: { __typename?: 'UpdateUnattachedExpensePayload', success: boolean, error?: string | null } | null };

export type GetActiveRequestsQueryVariables = Exact<{
  resultsPerPage: Scalars['Int']['input'];
  pageNum: Scalars['Int']['input'];
  sortParams?: InputMaybe<Array<ReimbursementRequestSortStage> | ReimbursementRequestSortStage>;
  status?: InputMaybe<Array<ReimbursementRequestStatus> | ReimbursementRequestStatus>;
}>;


export type GetActiveRequestsQuery = { __typename?: 'Query', expenseManagement: { __typename?: 'ExpenseManagement', earliestPayDate: string, requests: { __typename?: 'PaginatedReimbursementRequests', page: number, totalPages: number, totalResults: number, requests: Array<{ __typename?: 'ReimbursementRequest', uuid: string, name: string, submittedAt: string, status: ReimbursementRequestStatus, totalNonReimbursableAmount: number, totalReimbursableAmount: number, myReport: boolean, myDirectReport: boolean, managerApprover?: { __typename?: 'CompanyMember', friendlyFullName: string } | null, member: { __typename?: 'CompanyMember', firstName: string, friendlyFullName: string }, expenses: Array<{ __typename?: 'Expense', uuid: string }> }> } } };

export type GetApproversQueryVariables = Exact<{ [key: string]: never; }>;


export type GetApproversQuery = { __typename?: 'Query', expenseManagement: { __typename?: 'ExpenseManagement', managers: Array<{ __typename?: 'CompanyMember', uuid: string, friendlyFullName: string }>, expenseAdmins: Array<{ __typename?: 'CompanyMember', uuid: string, friendlyFullName: string }> } };

export type GetAuditLogQueryVariables = Exact<{
  uuid: Scalars['ID']['input'];
}>;


export type GetAuditLogQuery = { __typename?: 'Query', expenseManagement: { __typename?: 'ExpenseManagement', request: { __typename?: 'ReimbursementRequest', uuid: string, name: string, myRequest: boolean, member: { __typename?: 'CompanyMember', friendlyFullName: string }, audits: Array<{ __typename?: 'Approved', totalAmount: number, estimatedPayDate: string, type: AuditTypeEnum, occurredAt: string, member: { __typename?: 'CompanyMember', friendlyFullName: string }, nextMembers: Array<{ __typename?: 'CompanyMember', uuid: string, friendlyFullName: string }> } | { __typename?: 'Edited', name: string, type: AuditTypeEnum, occurredAt: string, differences: Array<{ __typename?: 'ExpenseAdded', uuid: string, amount: number, attendees?: string | null, description?: string | null, merchant?: string | null, transactionDate: string, expenseType?: string | null, isBillableToClient?: boolean | null, type: AuditDetailTypeEnum, project?: { __typename?: 'Project', displayName: string } | null, category: { __typename?: 'ExpenseCategory', name: string, billableToClient: ExpenseCategoryFieldSetting }, receipts: Array<{ __typename?: 'ExpenseReceipt', uuid: string, url: string, filename: string }> } | { __typename?: 'ExpenseEdited', uuid: string, expenseType?: string | null, type: AuditDetailTypeEnum, differences: Array<{ __typename?: 'AmountChanged', amount: number, type: ExpenseEditedDetailTypeEnum } | { __typename?: 'AttendeesChanged', attendees?: string | null, type: ExpenseEditedDetailTypeEnum } | { __typename?: 'CategoryChanged', type: ExpenseEditedDetailTypeEnum, category: { __typename?: 'ExpenseCategory', name: string } } | { __typename?: 'DescriptionChanged', description?: string | null, type: ExpenseEditedDetailTypeEnum } | { __typename?: 'ExpenseTypeChanged', expenseType?: string | null, type: ExpenseEditedDetailTypeEnum } | { __typename?: 'IsBillableToClientChanged', isBillableToClient?: boolean | null, type: ExpenseEditedDetailTypeEnum } | { __typename?: 'MerchantChanged', merchant?: string | null, type: ExpenseEditedDetailTypeEnum } | { __typename?: 'ProjectChanged', type: ExpenseEditedDetailTypeEnum, project: { __typename?: 'Project', displayName: string } } | { __typename?: 'ReceiptAdded', filename: string, type: ExpenseEditedDetailTypeEnum } | { __typename?: 'ReceiptRemoved', filename: string, type: ExpenseEditedDetailTypeEnum } | { __typename?: 'TransactionDateChanged', transactionDate: string, type: ExpenseEditedDetailTypeEnum }> } | { __typename?: 'ExpenseRemoved', uuid: string, expenseType?: string | null, type: AuditDetailTypeEnum } | { __typename?: 'NameChange', newName: string, type: AuditDetailTypeEnum }>, member: { __typename?: 'CompanyMember', friendlyFullName: string }, nextMembers: Array<{ __typename?: 'CompanyMember', uuid: string, friendlyFullName: string }> } | { __typename?: 'PaymentCanceled', type: AuditTypeEnum, occurredAt: string, payment: { __typename?: 'DisbursementOrder', uuid: string }, member: { __typename?: 'CompanyMember', friendlyFullName: string }, nextMembers: Array<{ __typename?: 'CompanyMember', uuid: string, friendlyFullName: string }> } | { __typename?: 'PaymentReceived', type: AuditTypeEnum, occurredAt: string, payment: { __typename?: 'DisbursementOrder', amount: number }, member: { __typename?: 'CompanyMember', friendlyFullName: string }, nextMembers: Array<{ __typename?: 'CompanyMember', uuid: string, friendlyFullName: string }> } | { __typename?: 'Resubmitted', name: string, type: AuditTypeEnum, occurredAt: string, differences: Array<{ __typename?: 'ExpenseAdded', uuid: string, amount: number, attendees?: string | null, description?: string | null, merchant?: string | null, transactionDate: string, expenseType?: string | null, isBillableToClient?: boolean | null, type: AuditDetailTypeEnum, project?: { __typename?: 'Project', displayName: string } | null, category: { __typename?: 'ExpenseCategory', name: string, billableToClient: ExpenseCategoryFieldSetting }, receipts: Array<{ __typename?: 'ExpenseReceipt', uuid: string, url: string, filename: string }> } | { __typename?: 'ExpenseEdited', uuid: string, expenseType?: string | null, type: AuditDetailTypeEnum, differences: Array<{ __typename?: 'AmountChanged', amount: number, type: ExpenseEditedDetailTypeEnum } | { __typename?: 'AttendeesChanged', attendees?: string | null, type: ExpenseEditedDetailTypeEnum } | { __typename?: 'CategoryChanged', type: ExpenseEditedDetailTypeEnum, category: { __typename?: 'ExpenseCategory', name: string } } | { __typename?: 'DescriptionChanged', description?: string | null, type: ExpenseEditedDetailTypeEnum } | { __typename?: 'ExpenseTypeChanged', expenseType?: string | null, type: ExpenseEditedDetailTypeEnum } | { __typename?: 'IsBillableToClientChanged', isBillableToClient?: boolean | null, type: ExpenseEditedDetailTypeEnum } | { __typename?: 'MerchantChanged', merchant?: string | null, type: ExpenseEditedDetailTypeEnum } | { __typename?: 'ProjectChanged', type: ExpenseEditedDetailTypeEnum, project: { __typename?: 'Project', displayName: string } } | { __typename?: 'ReceiptAdded', filename: string, type: ExpenseEditedDetailTypeEnum } | { __typename?: 'ReceiptRemoved', filename: string, type: ExpenseEditedDetailTypeEnum } | { __typename?: 'TransactionDateChanged', transactionDate: string, type: ExpenseEditedDetailTypeEnum }> } | { __typename?: 'ExpenseRemoved', uuid: string, expenseType?: string | null, type: AuditDetailTypeEnum } | { __typename?: 'NameChange', newName: string, type: AuditDetailTypeEnum }>, member: { __typename?: 'CompanyMember', friendlyFullName: string }, nextMembers: Array<{ __typename?: 'CompanyMember', uuid: string, friendlyFullName: string }> } | { __typename?: 'Returned', name: string, reason: string, type: AuditTypeEnum, occurredAt: string, member: { __typename?: 'CompanyMember', friendlyFullName: string }, nextMembers: Array<{ __typename?: 'CompanyMember', uuid: string, friendlyFullName: string }> } | { __typename?: 'Reviewed', name: string, totalAmount: number, numExpenses: number, type: AuditTypeEnum, occurredAt: string, member: { __typename?: 'CompanyMember', friendlyFullName: string }, nextMembers: Array<{ __typename?: 'CompanyMember', uuid: string, friendlyFullName: string }> } | { __typename?: 'Submitted', name: string, totalAmount: number, type: AuditTypeEnum, occurredAt: string, expenses: Array<{ __typename?: 'ExpenseAdded', uuid: string, amount: number, attendees?: string | null, description?: string | null, merchant?: string | null, transactionDate: string, expenseType?: string | null, isBillableToClient?: boolean | null, project?: { __typename?: 'Project', displayName: string } | null, category: { __typename?: 'ExpenseCategory', name: string, billableToClient: ExpenseCategoryFieldSetting }, receipts: Array<{ __typename?: 'ExpenseReceipt', uuid: string, url: string, filename: string }> }>, member: { __typename?: 'CompanyMember', friendlyFullName: string }, nextMembers: Array<{ __typename?: 'CompanyMember', uuid: string, friendlyFullName: string }> }> } } };

export type GetCategoriesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCategoriesQuery = { __typename?: 'Query', expenseManagement: { __typename?: 'ExpenseManagement', categories: Array<{ __typename?: 'ExpenseCategory', uuid: string, name: string, visible: boolean, custom: boolean, merchant: ExpenseCategoryFieldSetting, description: ExpenseCategoryFieldSetting, receipt: ExpenseCategoryFieldSetting, attendees: ExpenseCategoryFieldSetting, billableToClient: ExpenseCategoryFieldSetting, expenseType: ExpenseCategoryFieldSetting }>, policy?: { __typename?: 'ExpensePolicy', categoriesReviewed: boolean } | null } };

export type GetConfigurationQueryVariables = Exact<{ [key: string]: never; }>;


export type GetConfigurationQuery = { __typename?: 'Query', expenseManagement: { __typename?: 'ExpenseManagement', iHaveAdminPermission: boolean, iHaveReportsPermission: boolean, iHaveManagerPermission: boolean, iHaveSubmitterPermission: boolean, iHaveGrantPermissionsPermission: boolean, iAmAllowedToFirstTimeSetup: boolean, iAmAllowedIntoReviewPage: boolean, iAmAllowedIntoSettingsPages: boolean, iAmAllowedIntoReviewHistoryPage: boolean, iAmAllowedToViewProductDetailsPage: boolean, iAmRequiredToViewProductDetailsPage: boolean, policy?: { __typename?: 'ExpensePolicy', enabled: boolean, everEnabled: boolean } | null, expenseAdmins: Array<{ __typename?: 'CompanyMember', friendlyFullName: string }>, permissionsAdmins: Array<{ __typename?: 'CompanyMember', friendlyFullName: string }> }, authenticatedMember: { __typename?: 'AllMembers', company: { __typename?: 'Company', companySetting?: { __typename?: 'CompanySetting', value?: string | null } | null } } };

export type GetExpenseDetailsPageQueryVariables = Exact<{ [key: string]: never; }>;


export type GetExpenseDetailsPageQuery = { __typename?: 'Query', expenseManagement: { __typename?: 'ExpenseManagement', categories: Array<{ __typename?: 'ExpenseCategory', uuid: string, name: string, visible: boolean, custom: boolean, merchant: ExpenseCategoryFieldSetting, description: ExpenseCategoryFieldSetting, receipt: ExpenseCategoryFieldSetting, attendees: ExpenseCategoryFieldSetting, billableToClient: ExpenseCategoryFieldSetting, expenseType: ExpenseCategoryFieldSetting }>, projects?: Array<{ __typename?: 'Project', projectCode?: string | null, projectName: string, displayName: string, uuid: string, visible: boolean }> | null }, authenticatedMember: { __typename?: 'AllMembers', friendlyFullName: string } };

export type GetExpenseLibraryQueryVariables = Exact<{
  resultsPerPage: Scalars['Int']['input'];
  pageNum: Scalars['Int']['input'];
  sortParams?: InputMaybe<Array<UnattachedExpenseSortStage> | UnattachedExpenseSortStage>;
  attachedUuids?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
  detachedUuids?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
}>;


export type GetExpenseLibraryQuery = { __typename?: 'Query', expenseManagement: { __typename?: 'ExpenseManagement', unattachedExpenses: { __typename?: 'PaginatedUnattachedExpenses', page: number, totalPages: number, totalResults: number, expenses: Array<{ __typename?: 'Expense', uuid: string, createdAt: string, transactionDate: string, amount: number, merchant?: string | null, attendees?: string | null, description?: string | null, expenseType?: string | null, isBillableToClient?: boolean | null, category: { __typename?: 'ExpenseCategory', uuid: string, name: string, visible: boolean, custom: boolean, merchant: ExpenseCategoryFieldSetting, description: ExpenseCategoryFieldSetting, receipt: ExpenseCategoryFieldSetting, attendees: ExpenseCategoryFieldSetting, expenseType: ExpenseCategoryFieldSetting, billableToClient: ExpenseCategoryFieldSetting }, project?: { __typename?: 'Project', projectCode?: string | null, projectName: string, displayName: string, uuid: string, visible: boolean } | null, receipts: Array<{ __typename?: 'ExpenseReceipt', url: string, filename: string, uuid: string }> }> } } };

export type GetExpenseTypeQueryVariables = Exact<{ [key: string]: never; }>;


export type GetExpenseTypeQuery = { __typename?: 'Query', expenseManagement: { __typename?: 'ExpenseManagement', categories: Array<{ __typename?: 'ExpenseCategory', expenseType: ExpenseCategoryFieldSetting }> } };

export type GetExpensesActivationQueryVariables = Exact<{ [key: string]: never; }>;


export type GetExpensesActivationQuery = { __typename?: 'Query', currentMember: { __typename?: 'SelfMember', company: { __typename?: 'Company', companySetting?: { __typename?: 'CompanySetting', value?: string | null } | null } } };

export type GetExpensesResourcesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetExpensesResourcesQuery = { __typename?: 'Query', expensesResources: { __typename?: 'ExpensesResources', adminOnePagerUrl: string, employeeOnePagerUrl: string, emailAnnouncementTemplateUrl: string } };

export type GetExpensesSettingsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetExpensesSettingsQuery = { __typename?: 'Query', expenseManagement: { __typename?: 'ExpenseManagement', categories: Array<{ __typename?: 'ExpenseCategory', name: string }>, policy?: { __typename?: 'ExpensePolicy', enabled: boolean, categoriesReviewed: boolean } | null, expenseAdmins: Array<{ __typename?: 'CompanyMember', uuid: string, friendlyFullName: string, deskTitle?: string | null, photoUrl?: string | null }>, reportsAdmins: Array<{ __typename?: 'CompanyMember', uuid: string, friendlyFullName: string, deskTitle?: string | null, photoUrl?: string | null }>, managers: Array<{ __typename?: 'CompanyMember', uuid: string, friendlyFullName: string, deskTitle?: string | null, photoUrl?: string | null }>, projects?: Array<{ __typename?: 'Project', projectCode?: string | null, projectName: string }> | null }, currentMember: { __typename?: 'SelfMember', uuid: string } };

export type GetManagersQueryVariables = Exact<{ [key: string]: never; }>;


export type GetManagersQuery = { __typename?: 'Query', expenseManagement: { __typename?: 'ExpenseManagement', managers: Array<{ __typename?: 'CompanyMember', friendlyFullName: string }> } };

export type GetPayDateQueryVariables = Exact<{ [key: string]: never; }>;


export type GetPayDateQuery = { __typename?: 'Query', expenseManagement: { __typename?: 'ExpenseManagement', earliestPayDate: string } };

export type GetProjectsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetProjectsQuery = { __typename?: 'Query', expenseManagement: { __typename?: 'ExpenseManagement', projects?: Array<{ __typename?: 'Project', projectCode?: string | null, projectName: string, displayName: string, uuid: string, visible: boolean }> | null } };

export type GetRequestDetailQueryVariables = Exact<{
  uuid: Scalars['ID']['input'];
}>;


export type GetRequestDetailQuery = { __typename?: 'Query', expenseManagement: { __typename?: 'ExpenseManagement', earliestPayDate: string, request: { __typename?: 'ReimbursementRequest', uuid: string, name: string, submittedAt: string, status: ReimbursementRequestStatus, totalAmount: number, myRequest: boolean, member: { __typename?: 'CompanyMember', friendlyFullName: string, firstName: string }, managerApprover?: { __typename?: 'CompanyMember', uuid: string, friendlyFullName: string } | null, expenses: Array<{ __typename?: 'Expense', uuid: string, merchant?: string | null, amount: number, transactionDate: string, description?: string | null, attendees?: string | null, expenseType?: string | null, isBillableToClient?: boolean | null, receipts: Array<{ __typename?: 'ExpenseReceipt', filename: string, url: string, uuid: string }>, category: { __typename?: 'ExpenseCategory', uuid: string, name: string, visible: boolean, custom: boolean, merchant: ExpenseCategoryFieldSetting, description: ExpenseCategoryFieldSetting, receipt: ExpenseCategoryFieldSetting, attendees: ExpenseCategoryFieldSetting, expenseType: ExpenseCategoryFieldSetting, billableToClient: ExpenseCategoryFieldSetting }, project?: { __typename?: 'Project', projectCode?: string | null, projectName: string, displayName: string, uuid: string, visible: boolean } | null }>, reviews: Array<{ __typename?: 'ReimbursementReview', type: Review, reason?: string | null, reviewedAt: string, member: { __typename?: 'CompanyMember', firstName: string, lastName: string, friendlyFullName: string, uuid: string } }>, payment?: { __typename?: 'DisbursementOrder', amount: number, payDate: string, status: string } | null } } };

export type GetRequestHistoryQueryVariables = Exact<{
  resultsPerPage: Scalars['Int']['input'];
  pageNum: Scalars['Int']['input'];
  sortParams?: InputMaybe<Array<ReimbursementRequestSortStage> | ReimbursementRequestSortStage>;
  status?: InputMaybe<Array<ReimbursementRequestStatus> | ReimbursementRequestStatus>;
}>;


export type GetRequestHistoryQuery = { __typename?: 'Query', expenseManagement: { __typename?: 'ExpenseManagement', requests: { __typename?: 'PaginatedReimbursementRequests', page: number, totalPages: number, totalResults: number, requests: Array<{ __typename?: 'ReimbursementRequest', uuid: string, name: string, submittedAt: string, status: ReimbursementRequestStatus, totalReimbursableAmount: number, totalNonReimbursableAmount: number, payment?: { __typename?: 'DisbursementOrder', status: string, payDate: string } | null, member: { __typename?: 'CompanyMember', friendlyFullName: string }, expenses: Array<{ __typename?: 'Expense', uuid: string }> }> } } };

export type GetRequestsListQueryVariables = Exact<{
  resultsPerPage: Scalars['Int']['input'];
  pageNum: Scalars['Int']['input'];
  sortParams?: InputMaybe<Array<ReimbursementRequestSortStage> | ReimbursementRequestSortStage>;
}>;


export type GetRequestsListQuery = { __typename?: 'Query', expenseManagement: { __typename?: 'ExpenseManagement', requests: { __typename?: 'PaginatedReimbursementRequests', page: number, totalPages: number, totalResults: number, requests: Array<{ __typename?: 'ReimbursementRequest', uuid: string, name: string, submittedAt: string, status: ReimbursementRequestStatus, payment?: { __typename?: 'DisbursementOrder', payDate: string, status: string } | null, expenses: Array<{ __typename?: 'Expense', uuid: string }> }> } } };

export type ProcessForm8973AnswersMutationVariables = Exact<{
  companyUuid: Scalars['String']['input'];
  form8973Answers: Form8973Answers;
}>;


export type ProcessForm8973AnswersMutation = { __typename?: 'Mutation', processForm8973Answers?: { __typename?: 'ProcessForm8973AnswersPayload', success: boolean, error: Array<string>, embeddedSignUrl?: string | null } | null };

export type GetForm8973QueryVariables = Exact<{
  companyUuid: Scalars['String']['input'];
}>;


export type GetForm8973Query = { __typename?: 'Query', form8973: { __typename?: 'CompanyForm8973Signature', companyUuid: string, companyEin: string, companyLegalEntityName: string, companyTradeName: string, companyPrimaryAddress?: { __typename?: 'Address', street1?: string | null, street2?: string | null, state?: string | null, city?: string | null, countryCode?: string | null, postalCode?: string | null } | null, unsignedForm8973Signature: { __typename?: 'Irs8973Signature', status?: string | null } } };

export type DeleteInternationalDocumentMutationVariables = Exact<{
  documentId: Scalars['ID']['input'];
}>;


export type DeleteInternationalDocumentMutation = { __typename?: 'Mutation', deleteInternationalDocument?: { __typename?: 'DeleteInternationalDocumentPayload', success: boolean } | null };

export type GetInternationalDocumentUrlQueryVariables = Exact<{
  documentId: Scalars['ID']['input'];
}>;


export type GetInternationalDocumentUrlQuery = { __typename?: 'Query', internationalDocumentUrl: { __typename?: 'InternationalDocumentUrl', url: string } };

export type GetInternationalDocumentsQueryVariables = Exact<{
  memberUuid: Scalars['ID']['input'];
}>;


export type GetInternationalDocumentsQuery = { __typename?: 'Query', internationalDocuments: Array<{ __typename?: 'InternationalDocument', id?: string | null, name: string, uploadDate: string, signatureRequired: boolean, remindersSet: boolean, category?: string | null, documentMemberAssignments: Array<{ __typename?: 'InternationalDocumentMemberAssignment', id?: string | null, visibilityLevel: string, documentId: string, memberId?: string | null }> }> };

export type GetInternationalMemberQueryVariables = Exact<{
  memberUuid: Scalars['ID']['input'];
}>;


export type GetInternationalMemberQuery = { __typename?: 'Query', internationalMember: { __typename?: 'InternationalMember', uuid?: string | null, preferredName?: string | null, firstName: string, lastName: string, email: string, pronouns?: string | null, city: string, countryCode: string, country: string, emojiFlag: string, postalCode: string, state: string, streetLine1: string, streetLine2?: string | null, serviceProvided: string, phoneNumber: string, website?: string | null, status?: string | null, hasBeenPaid: boolean } };

export type UpdateInternationalDocumentMutationVariables = Exact<{
  documentId: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  category?: InputMaybe<Scalars['String']['input']>;
  documentMemberAssignments?: InputMaybe<Array<InternationalDocumentMemberAssignmentInput> | InternationalDocumentMemberAssignmentInput>;
}>;


export type UpdateInternationalDocumentMutation = { __typename?: 'Mutation', updateInternationalDocument: { __typename?: 'InternationalDocument', id?: string | null, name: string, uploadDate: string, signatureRequired: boolean, remindersSet: boolean, category?: string | null, documentMemberAssignments: Array<{ __typename?: 'InternationalDocumentMemberAssignment', id?: string | null, visibilityLevel: string, documentId: string, memberId?: string | null }> } };

export type UpdateInternationalMemberStatusMutationVariables = Exact<{
  companyMemberId: Scalars['ID']['input'];
  status: Scalars['String']['input'];
}>;


export type UpdateInternationalMemberStatusMutation = { __typename?: 'Mutation', updateInternationalMemberStatus: { __typename?: 'InternationalMemberStatus', id?: string | null, details: Array<{ __typename?: 'InternationalMemberStatusDetail', status: string }> } };

export type GetIsViaCustomerQueryVariables = Exact<{ [key: string]: never; }>;


export type GetIsViaCustomerQuery = { __typename?: 'Query', authenticatedMember: { __typename?: 'AllMembers', company: { __typename?: 'Company', companySetting?: { __typename?: 'CompanySetting', value?: string | null } | null } } };

export type GetCompanyInfoQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCompanyInfoQuery = { __typename?: 'Query', authenticatedMember: { __typename?: 'AllMembers', uuid: string, company: { __typename?: 'Company', companyPlanType?: CompanyPlan | null, cdmsCanonicalCompanyId?: string | null } } };

export type GetIsEmployerOfRecordEnabledQueryVariables = Exact<{ [key: string]: never; }>;


export type GetIsEmployerOfRecordEnabledQuery = { __typename?: 'Query', authenticatedMember: { __typename?: 'AllMembers', company: { __typename?: 'Company', companySetting?: { __typename?: 'CompanySetting', value?: string | null } | null } } };

export type GetAdminStatusQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAdminStatusQuery = { __typename?: 'Query', authenticatedMember: { __typename?: 'AllMembers', adminStatus: boolean } };

export type CreateCompanyAncillaryBenefitPlanMutationVariables = Exact<{
  companyUuid?: InputMaybe<Scalars['String']['input']>;
  effectiveDate?: InputMaybe<Scalars['String']['input']>;
  amount?: InputMaybe<Scalars['String']['input']>;
  abpPlanType?: InputMaybe<Scalars['String']['input']>;
}>;


export type CreateCompanyAncillaryBenefitPlanMutation = { __typename?: 'Mutation', createCompanyAncillaryBenefitPlan?: { __typename?: 'CreateCompanyAncillaryBenefitPlanPayload', success: boolean, userErrors?: Array<{ __typename?: 'UserError', message: string }> | null } | null };

export type GetCompanyUuidQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCompanyUuidQuery = { __typename?: 'Query', authenticatedMember: { __typename?: 'AllMembers', company: { __typename?: 'Company', uuid: string } } };

export type EnterDemoModeMutationVariables = Exact<{ [key: string]: never; }>;


export type EnterDemoModeMutation = { __typename?: 'Mutation', vendorModeSetter?: { __typename?: 'VendorModeSetterPayload', success: boolean, userErrors?: Array<{ __typename?: 'UserError', message: string }> | null } | null };

export type GetNsfDetailsQueryVariables = Exact<{
  objectFlagId: Scalars['ID']['input'];
}>;


export type GetNsfDetailsQuery = { __typename?: 'Query', nsfDetails: { __typename?: 'NsfDetails', amount: number, returnCode: string, dueDate: string, invoiceId: string, payerId: { __typename?: 'PayerId', accountNumber?: string | null, routingNumber?: string | null } } };

export type GetTransactionsPageDataQueryVariables = Exact<{
  startDate: Scalars['APIDate']['input'];
}>;


export type GetTransactionsPageDataQuery = { __typename?: 'Query', transactions: Array<{ __typename?: 'Transaction', id: string, type: TransactionTypeEnum, amount: number, date: string, description: string, descriptionLink?: string | null }>, companyBankAccount: { __typename?: 'CompanyBankAccount', accountTail?: string | null, accountType: string, bankName?: string | null, verified: boolean }, companyWallet: { __typename?: 'Wallet', id: string, customerId?: string | null, ownerName?: string | null, balanceAmount?: { __typename?: 'Amount', value: number, currency: string } | null } };

export type GetPeopleAnalyticsCapabilityQueryVariables = Exact<{ [key: string]: never; }>;


export type GetPeopleAnalyticsCapabilityQuery = { __typename?: 'Query', authenticatedMember: { __typename?: 'AllMembers', uuid: string, capabilities: { __typename?: 'CapabilitiesList', hasAccessToPeopleAnalytics: boolean, hasAccessToPeopleAnalyticsPlus: boolean }, company: { __typename?: 'Company', uuid: string, isEligibleForBenefits: boolean, enrolledInMico: boolean, activePtoPolicies: Array<{ __typename?: 'TimeOffPolicy', uuid: string }> } } };

export type GetVisierBenefitsMetricsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetVisierBenefitsMetricsQuery = { __typename?: 'Query', visierBenefitsMetrics: { __typename?: 'VisierBenefitsMetrics', companyCostOfBenefitsLastYear?: string | null, employeeCostOfBenefitsLastYear?: string | null } };

export type GetVisierFinanceMetricsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetVisierFinanceMetricsQuery = { __typename?: 'Query', visierFinanceMetrics: { __typename?: 'VisierFinanceMetrics', compensationPaidLastThreeMonths?: string | null } };

export type GetVisierPtoMetricsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetVisierPtoMetricsQuery = { __typename?: 'Query', visierPtoMetrics: { __typename?: 'VisierPtoMetrics', averagePtoDaysLastMonth?: string | null, highestPtoDepartmentLastMonth?: { __typename?: 'HighestPtoDepartmentLastMonth', departmentName?: string | null, dayCount?: string | null } | null } };

export type GetVisierWorkforceMetricsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetVisierWorkforceMetricsQuery = { __typename?: 'Query', visierWorkforceMetrics: { __typename?: 'VisierWorkforceMetrics', fullTimeEmployeeCountCurrent?: string | null, partTimeEmployeeCountCurrent?: string | null } };

export type GetPmtIntegrationFrameworkPdpDataQueryVariables = Exact<{
  integration_uuid?: InputMaybe<Scalars['String']['input']>;
  integration_name?: InputMaybe<Scalars['String']['input']>;
  integration_instance_status?: InputMaybe<Scalars['String']['input']>;
  integration_instance_keys?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetPmtIntegrationFrameworkPdpDataQuery = { __typename?: 'Query', authenticatedMember: { __typename?: 'AllMembers', uuid: string, permissions: Array<number>, company: { __typename?: 'Company', uuid: string, cdmsCanonicalCompanyId?: string | null, name: string, admins: Array<{ __typename?: 'CompanyAdmin', permissions: Array<number>, friendlyFullName: string, firstName: string, lastName: string, uuid: string }> } }, pmtIntegrationsFramework: { __typename?: 'PmtIntegrationPayload', integration?: { __typename?: 'PmtIntegrationWithMetadata', data?: { __typename?: 'PmtIntegration', name: string, uuid: string, status: string, companyUuid: string, createdAt: string, updatedAt: string, instancesByKey?: Array<{ __typename?: 'PmtIntegrationInstancesByKey', key: string, instances: Array<{ __typename?: 'PmtIntegrationInstance', uuid: string, key: string, status: string, config?: object | null, memberId?: number | null, createdAt: string, updatedAt: string }> }> | null } | null, metadata: { __typename?: 'DisplayableMetadata', status: number, success: boolean, error?: string | null } } | null, solution?: { __typename?: 'PmtSolutionWithMetadata', data?: { __typename?: 'PmtSolution', uuid: string, status: string, name: string, copy: { __typename?: 'PmtSolutionCopy', title: string, description: string } } | null, metadata: { __typename?: 'DisplayableMetadata', status: number, success: boolean, error?: string | null } } | null } };

export type ProcessPmtIntegrationFrameworkActionMutationVariables = Exact<{
  integration_name: Scalars['String']['input'];
  action: Scalars['String']['input'];
  action_data?: InputMaybe<Scalars['JSON']['input']>;
  integration_uuid?: InputMaybe<Scalars['String']['input']>;
}>;


export type ProcessPmtIntegrationFrameworkActionMutation = { __typename?: 'Mutation', processPmtIntegrationFrameworkAction?: { __typename?: 'ProcessIntegrationActionPayload', actionData?: object | null, integration?: { __typename?: 'PmtIntegration', companyUuid: string, createdAt: string, name: string, status: string, updatedAt: string, uuid: string } | null, metadata: { __typename?: 'DisplayableMetadata', status: number, success: boolean, error?: string | null } } | null };

export type GetPmtIntegrationFrameworkSetupDataQueryVariables = Exact<{
  integration_uuid?: InputMaybe<Scalars['String']['input']>;
  integration_name?: InputMaybe<Scalars['String']['input']>;
  integration_instance_status?: InputMaybe<Scalars['String']['input']>;
  integration_instance_keys?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetPmtIntegrationFrameworkSetupDataQuery = { __typename?: 'Query', authenticatedMember: { __typename?: 'AllMembers', uuid: string, permissions: Array<number>, company: { __typename?: 'Company', uuid: string, name: string } }, pmtIntegrationsFramework: { __typename?: 'PmtIntegrationPayload', integration?: { __typename?: 'PmtIntegrationWithMetadata', data?: { __typename?: 'PmtIntegration', name: string, uuid: string, status: string, companyUuid: string, createdAt: string, updatedAt: string, instancesByKey?: Array<{ __typename?: 'PmtIntegrationInstancesByKey', key: string, instances: Array<{ __typename?: 'PmtIntegrationInstance', uuid: string, key: string, status: string, config?: object | null, memberId?: number | null, createdAt: string, updatedAt: string }> }> | null } | null, metadata: { __typename?: 'DisplayableMetadata', status: number, success: boolean, error?: string | null } } | null, solution?: { __typename?: 'PmtSolutionWithMetadata', data?: { __typename?: 'PmtSolution', uuid: string, status: string, name: string, copy: { __typename?: 'PmtSolutionCopy', title: string, description: string } } | null, metadata: { __typename?: 'DisplayableMetadata', status: number, success: boolean, error?: string | null } } | null } };

export type GetIntegrationSolutionDataQueryVariables = Exact<{ [key: string]: never; }>;


export type GetIntegrationSolutionDataQuery = { __typename?: 'Query', authenticatedMember: { __typename?: 'AllMembers', uuid: string, permissions: Array<number>, company: { __typename?: 'Company', uuid: string, name: string, companyPlanType?: CompanyPlan | null, admins: Array<{ __typename?: 'CompanyAdmin', permissions: Array<number>, friendlyFullName: string, firstName: string, lastName: string, uuid: string }>, greenhouseCandidateHiredIntegration?: { __typename?: 'Integration', name?: string | null, status: string } | null } }, externalPartnerIntegrations: { __typename?: 'ExternalPartnerIntegrationsPayload', solutions?: { __typename?: 'SolutionsWithMetadata', data?: Array<{ __typename?: 'Solution', slug: string, status: string, title: string, uuid: string, partner: { __typename?: 'Partner', name: string, uuid: string } }> | null, metadata: { __typename?: 'DisplayableMetadata', success: boolean, status: number, error?: string | null } } | null, instances?: { __typename?: 'InstancesWithMetadata', data?: Array<{ __typename?: 'Instance', status: string, solutionUuid: string, lastUsedDate?: string | null }> | null, metadata: { __typename?: 'DisplayableMetadata', success: boolean, status: number, error?: string | null } } | null }, accountingIntegrations: { __typename?: 'AccountingIntegrations', integrationsInfo: Array<{ __typename?: 'AccountingIntegrationInfo', name: string, status: AccountingIntegrationStatus, isBeta: boolean, url: string, description: string, slug: string, category: string }> } };

export type GetPmtIntegrationFrameworkDataQueryVariables = Exact<{
  integration_name?: InputMaybe<Scalars['String']['input']>;
  integration_instance_status?: InputMaybe<Scalars['String']['input']>;
  integration_instance_keys?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  integration_status?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetPmtIntegrationFrameworkDataQuery = { __typename?: 'Query', pmtIntegrationsFramework: { __typename?: 'PmtIntegrationPayload', integrations?: { __typename?: 'PmtIntegrationsWithMetadata', data?: Array<{ __typename?: 'PmtIntegration', companyUuid: string, createdAt: string, name: string, status: string, updatedAt: string, uuid: string, instancesByKey?: Array<{ __typename?: 'PmtIntegrationInstancesByKey', key: string, instances: Array<{ __typename?: 'PmtIntegrationInstance', uuid: string, key: string, status: string, config?: object | null, memberId?: number | null, createdAt: string, updatedAt: string }> }> | null }> | null, metadata: { __typename?: 'DisplayableMetadata', status: number, success: boolean, error?: string | null } } | null, solutions?: { __typename?: 'PmtSolutionsWithMetadata', data?: Array<{ __typename?: 'PmtSolution', uuid: string, name: string, status: string, copy: { __typename?: 'PmtSolutionCopy', title: string, description: string } }> | null, metadata: { __typename?: 'DisplayableMetadata', status: number, success: boolean, error?: string | null } } | null } };

export type ConfirmMemberSeparationMutationVariables = Exact<{
  memberSeparationId: Scalars['ID']['input'];
  paymentSettings: Array<PaymentSettings> | PaymentSettings;
}>;


export type ConfirmMemberSeparationMutation = { __typename?: 'Mutation', confirmMemberSeparation?: { __typename?: 'ConfirmMemberSeparationPayload', success: boolean, payments?: Array<{ __typename?: 'SeparationPayment', paymentType: string, amount: string }> | null, errors?: Array<{ __typename?: 'UserError', inputField?: string | null, message: string }> | null } | null };

export type CreateMemberSeparationMutationVariables = Exact<{
  memberUuid: Scalars['ID']['input'];
}>;


export type CreateMemberSeparationMutation = { __typename?: 'Mutation', createMemberSeparation?: { __typename?: 'CreateMemberSeparationPayload', success: boolean, memberSeparation?: { __typename?: 'MemberSeparation', companyId: number, createdAt: string, earliestPayDate: string, lastUpdatedById: number, memberSeparationId: number, questionnaireVersion: number, status: string, updatedAt: string } | null, errors?: Array<{ __typename?: 'UserError', inputField?: string | null, message: string }> | null } | null };

export type SaveMemberSeparationAnswersMutationVariables = Exact<{
  memberSeparationId: Scalars['Int']['input'];
  separationAnswers: Array<MemberSeparationAnswersInput> | MemberSeparationAnswersInput;
  separationFormType: SeparationForm;
}>;


export type SaveMemberSeparationAnswersMutation = { __typename?: 'Mutation', saveMemberSeparationAnswers?: { __typename?: 'SaveMemberSeparationAnswersPayload', success: boolean, errors?: Array<{ __typename?: 'UserError', inputField?: string | null, message: string }> | null } | null };

export type GetAdminPermissionsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAdminPermissionsQuery = { __typename?: 'Query', adminPermissions: { __typename?: 'AdminPermissions', canDoMakePayments: boolean } };

export type GetDateAnalysisQueryVariables = Exact<{
  date: Scalars['String']['input'];
}>;


export type GetDateAnalysisQuery = { __typename?: 'Query', dateAnalysis: { __typename?: 'DateAnalysis', isBusinessDay: boolean, nextBusinessDay: string, previousBusinessDay: string } };

export type GetMemberSeparationQueryVariables = Exact<{
  memberUuid: Scalars['String']['input'];
}>;


export type GetMemberSeparationQuery = { __typename?: 'Query', memberSeparation?: { __typename?: 'MemberSeparation', memberSeparationId: number, companyId: number, earliestPayDate: string, questionnaireVersion: number, status: string, lastUpdatedById: number, createdAt: string, updatedAt: string, memberSeparationAnswers?: Array<{ __typename?: 'MemberSeparationAnswer', fieldId: string, fieldLabel?: string | null, values?: Array<{ __typename?: 'MemberSeparationAnswerValue', documentTitle?: string | null, valueBoolean?: string | null, valueDate?: string | null, valueDocumentId?: number | null, valueNumeric?: number | null, valueText?: string | null, valueTextSmall?: string | null }> | null }> | null } | null };

export type GetMemberSeparationDocumentsQueryVariables = Exact<{
  documentIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type GetMemberSeparationDocumentsQuery = { __typename?: 'Query', memberSeparationDocuments?: Array<{ __typename?: 'Document', id: string, uuid?: string | null, title: string, downloadUrl: string }> | null };

export type GetMemberSeparationQuestionnaireQueryVariables = Exact<{
  terminationCode: Scalars['String']['input'];
}>;


export type GetMemberSeparationQuestionnaireQuery = { __typename?: 'Query', memberSeparationQuestionnaire?: Array<{ __typename?: 'MemberSeparationQuestion', questionId: string, questionText: string, inputType: string, validations?: { __typename?: 'MemberSeparationQuestionValidations', required?: boolean | null, minLength?: number | null } | null, answers?: Array<{ __typename?: 'MemberSeparationAnswerOption', value?: string | null, subQuestionIds?: Array<string> | null }> | null }> | null };

export type GetSeparatingMemberQueryVariables = Exact<{
  memberUuid: Scalars['String']['input'];
}>;


export type GetSeparatingMemberQuery = { __typename?: 'Query', separatingMember?: { __typename?: 'AllMembers', uuid: string, cdmsCanonicalEmploymentId: string, friendlyFullName: string, effectiveDate: string, isTerminated: boolean, memberType: MemberType, address?: { __typename?: 'MemberAddress', state?: string | null } | null } | null };

export type GetStateSeparationNoticeRequirementsQueryVariables = Exact<{
  state?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetStateSeparationNoticeRequirementsQuery = { __typename?: 'Query', stateSeparationNoticeRequirements?: Array<{ __typename?: 'SeparationNoticeDocument', stateAbbreviation: string, presignedUrl: string }> | null };

export type CreateClaimReportMutationVariables = Exact<{
  complete: Scalars['Boolean']['input'];
  draftId?: InputMaybe<Scalars['ID']['input']>;
  data: ClaimReport;
}>;


export type CreateClaimReportMutation = { __typename?: 'Mutation', createWcClaimReport?: { __typename?: 'CreateClaimReportPayload', success: boolean, error?: string | null, draftId?: string | null } | null };

export type GetCompanyAdminDetailsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCompanyAdminDetailsQuery = { __typename?: 'Query', currentMember: { __typename?: 'SelfMember', emailWork?: string | null, friendlyFullName: string, phoneOffice?: string | null, uuid: string, company: { __typename?: 'Company', id: number, name: string, uuid: string } } };

export type GetDraftsDataQueryVariables = Exact<{
  adminUuid: Scalars['String']['input'];
}>;


export type GetDraftsDataQuery = { __typename?: 'Query', draftClaimReportsByAdmin: Array<{ __typename?: 'DraftReport', createdAt: string, draftId?: string | null, data?: { __typename?: 'ClaimsReport', claim?: { __typename?: 'Claims', adminUuid?: string | null, adminEmail?: string | null, adminPhone?: string | null, companyName?: string | null, companyUuid?: string | null, memberName?: string | null, memberUuid?: string | null, clinicOrProviderName?: string | null, emergencyResponseContacted?: boolean | null, emergencyResponseDetails?: string | null, employerPolicyNumber?: string | null, estimatedAccidentDateTime?: string | null, affectedBodyPart?: string | null, oshaNumber?: string | null, fatality?: boolean | null, incidentDescription?: string | null, injuryDescription?: string | null, safeguardsUsed?: boolean | null, describedSafeguards?: string | null, treatmentGiven?: string | null, treatmentFacilityPhone?: string | null, treatmentFacilityAddress?: { __typename?: 'ClaimsAddress', city?: string | null, postalCode?: string | null, state?: string | null, street1?: string | null, street2?: string | null } | null, accidentLocation?: { __typename?: 'ClaimsAddress', city?: string | null, postalCode?: string | null, state?: string | null, street1?: string | null, street2?: string | null } | null } | null, claimant?: { __typename?: 'Claimants', personalEmail?: string | null, phoneNumber?: string | null, homeAddress?: { __typename?: 'ClaimsAddress', city?: string | null, postalCode?: string | null, state?: string | null, street1?: string | null, street2?: string | null } | null, workAddress?: { __typename?: 'ClaimsAddress', city?: string | null, postalCode?: string | null, state?: string | null, street1?: string | null, street2?: string | null } | null } | null, witnesses?: Array<{ __typename?: 'Witnesses', name?: string | null, contactInformation?: string | null, description?: string | null }> | null, workStatus?: { __typename?: 'WorksStatus', paid?: boolean | null, startTimeOut?: string | null, endTimeOut?: string | null } | null } | null }> };

export type GetEligibleClaimsMembersByDateQueryVariables = Exact<{
  injuryDate: Scalars['APIDate']['input'];
}>;


export type GetEligibleClaimsMembersByDateQuery = { __typename?: 'Query', eligibleClaimsMembersWithAddress: Array<{ __typename?: 'EligibleClaimMember', uuid: string, id: number, friendlyFullName: string, deskTitle: string, contactPhone?: string | null, emailWork: string, company: { __typename?: 'Company', name: string, primaryPhoneNumber: string, primaryAddress?: { __typename?: 'Address', city?: string | null, countryCode?: string | null, postalCode?: string | null, state?: string | null, street1?: string | null, street2?: string | null } | null }, homeAddress?: { __typename?: 'Address', city?: string | null, countryCode?: string | null, postalCode?: string | null, state?: string | null, street1?: string | null, street2?: string | null } | null, mostRecentPaymentWorkAddress?: { __typename?: 'Address', state?: string | null, city?: string | null, street1?: string | null, street2?: string | null, postalCode?: string | null, countryCode?: string | null } | null }> };

export type GetSubmittedClaimReportsByCompanyQueryVariables = Exact<{
  companyUuid: Scalars['String']['input'];
}>;


export type GetSubmittedClaimReportsByCompanyQuery = { __typename?: 'Query', submittedClaimReportsByCompany: Array<{ __typename?: 'CompleteReport', createdAt: string, pdfReport: string, data: { __typename?: 'ClaimsReport', claim?: { __typename?: 'Claims', adminUuid?: string | null, adminEmail?: string | null, adminPhone?: string | null, companyName?: string | null, companyUuid?: string | null, memberName?: string | null, memberUuid?: string | null, clinicOrProviderName?: string | null, emergencyResponseContacted?: boolean | null, emergencyResponseDetails?: string | null, employerPolicyNumber?: string | null, estimatedAccidentDateTime?: string | null, affectedBodyPart?: string | null, oshaNumber?: string | null, fatality?: boolean | null, incidentDescription?: string | null, injuryDescription?: string | null, safeguardsUsed?: boolean | null, describedSafeguards?: string | null, treatmentGiven?: string | null, treatmentFacilityPhone?: string | null, treatmentFacilityAddress?: { __typename?: 'ClaimsAddress', city?: string | null, postalCode?: string | null, state?: string | null, street1?: string | null, street2?: string | null } | null, accidentLocation?: { __typename?: 'ClaimsAddress', city?: string | null, postalCode?: string | null, state?: string | null, street1?: string | null, street2?: string | null } | null } | null, claimant?: { __typename?: 'Claimants', personalEmail?: string | null, phoneNumber?: string | null, homeAddress?: { __typename?: 'ClaimsAddress', city?: string | null, postalCode?: string | null, state?: string | null, street1?: string | null, street2?: string | null } | null, workAddress?: { __typename?: 'ClaimsAddress', city?: string | null, postalCode?: string | null, state?: string | null, street1?: string | null, street2?: string | null } | null } | null, witnesses?: Array<{ __typename?: 'Witnesses', name?: string | null, contactInformation?: string | null, description?: string | null }> | null, workStatus?: { __typename?: 'WorksStatus', paid?: boolean | null, startTimeOut?: string | null, endTimeOut?: string | null } | null } }> };

export type CreateInsuranceDocumentRequestMutationVariables = Exact<{
  request: InsuranceDocumentRequest;
}>;


export type CreateInsuranceDocumentRequestMutation = { __typename?: 'Mutation', createInsuranceDocumentRequest?: { __typename?: 'CreateInsuranceDocumentRequestPayload', success: boolean, error?: string | null } | null };

export type WcDocumentRequestQueryVariables = Exact<{ [key: string]: never; }>;


export type WcDocumentRequestQuery = { __typename?: 'Query', authenticatedMember: { __typename?: 'AllMembers', uuid: string, permissions: Array<number>, company: { __typename?: 'Company', uuid: string } } };

export type AllActiveMembersQueryVariables = Exact<{ [key: string]: never; }>;


export type AllActiveMembersQuery = { __typename?: 'Query', authenticatedMember: { __typename?: 'AllMembers', uuid: string, permissions: Array<number>, company: { __typename?: 'Company', uuid: string, directoryMembersWithoutInviteStatusCheck: Array<{ __typename?: 'CompanyMember', friendlyFullName: string, uuid: string, memberType: MemberType }>, activeW2Members: Array<{ __typename?: 'CompanyMember', friendlyFullName: string, uuid: string, memberType: MemberType }> } } };

/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  /** ISO8601 format. ex: 2021-03-09 */
  APIDate: { input: string; output: string; }
  /** ISO8601 format. ex: 2021-03-09T19:26:00+00:00 */
  APIDateTime: { input: string; output: string; }
  /** Amount in cents, derived from `BigInt`. Response encoded as a `String` */
  BigCents: { input: number; output: number; }
  /**  Represents non-fractional signed whole numeric values. Since the value may exceed the size of a 32-bit integer, it's encoded as a string.  */
  BigInt: { input: number; output: number; }
  /** Amount in cents */
  Cents: { input: number; output: number; }
  /** USD. Float rounded to 2 decimal places. */
  Dollars: { input: number; output: number; }
  /** An ISO 8601-encoded datetime */
  ISO8601DateTime: { input: string; output: string; }
  /** Represents untyped JSON */
  JSON: { input: object; output: object; }
  /** Unformatted domestic phone number. Ex: `972546939392` */
  PhoneNumberRaw: { input: string; output: string; }
};

/** All the accounting integrations available. */
export enum AccountingIntegration {
  Netsuite = 'NETSUITE',
  Qbo = 'QBO',
  SageIntacct = 'SAGE_INTACCT',
  Xero = 'XERO'
}

/** All the possible statuses for accounting Integrations */
export enum AccountingIntegrationStatus {
  Connected = 'CONNECTED',
  NotConnected = 'NOT_CONNECTED'
}

/** Address for Insurance Document Request */
export type AddressInput = {
  city: Scalars['String']['input'];
  postalCode: Scalars['String']['input'];
  state: Scalars['String']['input'];
  street1: Scalars['String']['input'];
  street2?: InputMaybe<Scalars['String']['input']>;
};

/** The possible methods of amount entry for a 'one-off' payment. */
export enum AmountEntryMethod {
  /** Enter the full amount including taxes. */
  GrossPay = 'GROSS_PAY',
  /** Enter the amount with taxes taken out. */
  NetPay = 'NET_PAY'
}

/** Used when approving/denied a Time Off Request */
export enum ApproveDenyTimeOffRequestStatus {
  /** The PTO request is approved */
  Approved = 'APPROVED',
  /** The PTO request is denied */
  Denied = 'DENIED'
}

/** The possible types for a single change made to a reimbursement request. */
export enum AuditDetailTypeEnum {
  /** An expense was added to the request. */
  ExpenseAdded = 'EXPENSE_ADDED',
  /** An existing expense on the request was edited. */
  ExpenseEdited = 'EXPENSE_EDITED',
  /** An existing expense was removed from the request. */
  ExpenseRemoved = 'EXPENSE_REMOVED',
  /** The name of the request was changed. */
  NameChange = 'NAME_CHANGE'
}

/** The possible types for a reimbursement request audit. */
export enum AuditTypeEnum {
  /** An admin's final approval. */
  Approved = 'APPROVED',
  /** An edit, made by a reviewing manager or admin. */
  Edited = 'EDITED',
  /** The cancellation of a scheduled payment which would have reimbursed an approved request. */
  PaymentCanceled = 'PAYMENT_CANCELED',
  /** The successful receipt of a payment reimbursing an approved request. */
  PaymentReceived = 'PAYMENT_RECEIVED',
  /** A resubmission by the employee. */
  Resubmitted = 'RESUBMITTED',
  /** A rejection, requesting additional changes from the employee. */
  Returned = 'RETURNED',
  /** A manager's initial approval. */
  Reviewed = 'REVIEWED',
  /** The initial submission by an employee. */
  Submitted = 'SUBMITTED'
}

/** All the accounting integrations available. */
export enum AutoSyncOption {
  Disabled = 'DISABLED',
  Enabled = 'ENABLED',
  Unset = 'UNSET'
}

/** Details about the fee or credit */
export type BillingDetails = {
  amount: Scalars['Cents']['input'];
  applyAs: InvoiceItem;
  billingType?: InputMaybe<Scalars['String']['input']>;
  description: Scalars['String']['input'];
  reference: BillingReference;
};

/** Details about billing reference in Justworks */
export type BillingReference = {
  date: Scalars['APIDate']['input'];
  type: BillingReferenceName;
  uuid: Scalars['ID']['input'];
};

export enum BillingReferenceName {
  Company = 'COMPANY',
  Member = 'MEMBER'
}

/** catch all category mappings for codat integrations */
export type CatchAllInput = {
  /** catch_all place holder for department uuid */
  departmentUuid?: InputMaybe<Scalars['String']['input']>;
  /** codat secondary catch all tracking category id */
  secondaryTrackingCategory?: InputMaybe<Scalars['String']['input']>;
  /** codat primary catch all tracking category id */
  trackingCategory?: InputMaybe<Scalars['String']['input']>;
};

/** Certificate Data object being uploaded */
export type CertificateDataInput = {
  /** The additional info of the certificate data */
  additionalInfo?: InputMaybe<Scalars['String']['input']>;
  /** The additional names of the certificate data */
  additionalNames?: InputMaybe<Scalars['String']['input']>;
  /** The primary name of the certificate data */
  primaryName: Scalars['String']['input'];
};

/** Input type for EOR Malaysia personal information */
export type ChildrenInformationInput = {
  dateOfBirth: Scalars['String']['input'];
  educationLevel: Scalars['String']['input'];
  gender: Scalars['String']['input'];
  icNumber: Scalars['String']['input'];
  name: Scalars['String']['input'];
  taxClaim: Scalars['String']['input'];
};

/** Claims Report Request */
export type Claim = {
  /** Address for the Accident */
  accidentLocation?: InputMaybe<ClaimAddress>;
  /** Admin Email */
  adminEmail?: InputMaybe<Scalars['String']['input']>;
  /** Admin Name */
  adminName?: InputMaybe<Scalars['String']['input']>;
  /** Admin Phone */
  adminPhone?: InputMaybe<Scalars['String']['input']>;
  /** Admin ID */
  adminUuid: Scalars['ID']['input'];
  /** String for body part injured */
  affectedBodyPart?: InputMaybe<Scalars['String']['input']>;
  /** Name of the Clinic or Provider */
  clinicOrProviderName?: InputMaybe<Scalars['String']['input']>;
  /** Company ID */
  companyId?: InputMaybe<Scalars['Int']['input']>;
  /** Company Name */
  companyName: Scalars['String']['input'];
  /** Company ID */
  companyUuid: Scalars['ID']['input'];
  /** List of safeguards used */
  describedSafeguards?: InputMaybe<Scalars['String']['input']>;
  /** Was emergency response contacted? */
  emergencyResponseContacted?: InputMaybe<Scalars['Boolean']['input']>;
  /** Details of the Emergency Response */
  emergencyResponseDetails?: InputMaybe<Scalars['String']['input']>;
  /** Employer policy number */
  employerPolicyNumber?: InputMaybe<Scalars['String']['input']>;
  /** DateTime of the Accident */
  estimatedAccidentDateTime?: InputMaybe<Scalars['APIDateTime']['input']>;
  /** Was the accident fatal? */
  fatality?: InputMaybe<Scalars['Boolean']['input']>;
  /** Description of the Accident */
  incidentDescription?: InputMaybe<Scalars['String']['input']>;
  /** Description of the Injury */
  injuryDescription?: InputMaybe<Scalars['String']['input']>;
  /** Member ID */
  memberId?: InputMaybe<Scalars['Int']['input']>;
  /** Member Name */
  memberName: Scalars['String']['input'];
  /** Member ID */
  memberUuid: Scalars['ID']['input'];
  /** Osha number */
  oshaNumber?: InputMaybe<Scalars['String']['input']>;
  /** Safeguards used */
  safeguardsUsed?: InputMaybe<Scalars['Boolean']['input']>;
  /** Address of the Treatment Facility */
  treatmentFacilityAddress?: InputMaybe<ClaimAddress>;
  /** Phone number for the Treatment Facility */
  treatmentFacilityPhone?: InputMaybe<Scalars['String']['input']>;
  /** Description of the Treatment Given */
  treatmentGiven?: InputMaybe<Scalars['String']['input']>;
};

/** Address Information for a Claim */
export type ClaimAddress = {
  city: Scalars['String']['input'];
  postalCode: Scalars['String']['input'];
  state: Scalars['String']['input'];
  street1: Scalars['String']['input'];
  street2?: InputMaybe<Scalars['String']['input']>;
};

/** Claims Report Request */
export type ClaimReport = {
  /** Data to save on a Claim */
  claim: Claim;
  /** Data specific to the Injured Party */
  claimant?: InputMaybe<Claimant>;
  /** Witnesses to the Incident */
  witnesses?: InputMaybe<Array<Witness>>;
  /** Time missed from work due to the incident */
  workStatus?: InputMaybe<WorkStatus>;
};

/** Information pertaining to the Injured Party */
export type Claimant = {
  /** Injured Party's Home Address */
  homeAddress?: InputMaybe<ClaimAddress>;
  /** Injured Party's Email */
  personalEmail?: InputMaybe<Scalars['String']['input']>;
  /** Injured Party's Phone Number */
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  /** Injured Party's Work Address */
  workAddress?: InputMaybe<ClaimAddress>;
};

/** The status for a client invite */
export enum ClientInviteStatus {
  /** The client invite has been accepted by the company */
  Accepted = 'ACCEPTED',
  /** The client invite has been declined by the company */
  Declined = 'DECLINED',
  /** The client invite has expired */
  Expired = 'EXPIRED',
  /** The client invite is pending */
  Pending = 'PENDING'
}

export enum CoemploymentStatus {
  Active = 'ACTIVE',
  None = 'NONE'
}

/** Tell Clockwork to send payment collection reminder email */
export type CollectionReminderInput = {
  companyUuid: Scalars['ID']['input'];
  date: Scalars['String']['input'];
  payees: Array<Payees>;
  totalPayments?: InputMaybe<Scalars['Int']['input']>;
  totalUsd: Scalars['Int']['input'];
};

/** The attribute to group members by in the directory */
export enum CompanyMemberGroupBy {
  Department = 'DEPARTMENT'
}

export enum CompanyPlan {
  Basic = 'BASIC',
  Committed = 'COMMITTED',
  InternationalStandalone = 'INTERNATIONAL_STANDALONE',
  Peo = 'PEO',
  Premier = 'PREMIER',
  Premier_2019 = 'PREMIER_2019',
  PremierUnbundled = 'PREMIER_UNBUNDLED',
  Standard = 'STANDARD',
  Starter = 'STARTER',
  StarterVetted = 'STARTER_VETTED',
  Terminated = 'TERMINATED'
}

/** Editable EOR Employee contact details */
export type ContactDetailsInput = {
  homeAddress?: InputMaybe<InternationalAddressInput>;
  homePhoneNumber?: InputMaybe<PhoneNumberInput>;
  mailingAddress?: InputMaybe<InternationalAddressInput>;
  mobilePhoneNumber?: InputMaybe<PhoneNumberInput>;
  workPhoneNumber?: InputMaybe<PhoneNumberInput>;
};

/** Argument grouping for EoR member onboarding contact info step */
export type ContactInfoInput = {
  emergencyContact: EmergencyContactInput;
  homeAddress: InternationalAddressInput;
  homeEmail: Scalars['String']['input'];
  mailingAddress: InternationalAddressInput;
  phoneNumbers: Array<PhoneNumberInput>;
};

export type DateRangeInput = {
  end: Scalars['APIDate']['input'];
  start: Scalars['APIDate']['input'];
};

export type DateRangeQueryInput = {
  end?: InputMaybe<Scalars['APIDate']['input']>;
  start?: InputMaybe<Scalars['APIDate']['input']>;
};

/** The possible deduction settings for a 'one-off' payment. */
export enum DeductionSetting {
  /** Withhold all benefit contributions, including 401(k). */
  All = 'ALL',
  /** Send the entire amount. */
  None = 'NONE',
  /** Just withhold your employees' 401(k) contribution and debit your company for any applicable match. */
  Specific = 'SPECIFIC'
}

/** The possible methods of delivery for a 'one-off' payment. */
export enum DeliveryMethod {
  /** Justworks will debit your account and then deposit the payment directly into your employee's account. */
  DirectDeposit = 'DIRECT_DEPOSIT',
  /** Justworks will calculate the taxes owed on your payment. Then, you'll hand your employee a physical check with the correct net amount. */
  PhysicalCheck = 'PHYSICAL_CHECK'
}

/** Lists the status of the department. */
export enum DepartmentStatus {
  Active = 'active',
  Historical = 'historical',
  Inactive = 'inactive'
}

/** department uuid and tracking category mappings */
export type DepartmentToCategoriesInput = {
  /** justworks department uuid */
  departmentUuid: Scalars['String']['input'];
  /** codat secondary tracking category ids */
  secondaryTrackingCategory?: InputMaybe<Scalars['String']['input']>;
  /** codat primary tracking category id */
  trackingCategory?: InputMaybe<Scalars['String']['input']>;
};

/** department uuid and class external value object */
export type DepartmentToClassInput = {
  /** class external value */
  classId: Scalars['String']['input'];
  /** department uuid */
  departmentUuid: Scalars['String']['input'];
};

/** department uuid and tracking category external value object */
export type DepartmentToTrackingCategoryInput = {
  /** department uuid */
  departmentUuid: Scalars['String']['input'];
  /** tracking category external value */
  trackingCategoryId: Scalars['String']['input'];
};

export enum DependentRelationship {
  Child = 'CHILD',
  Partner = 'PARTNER',
  Spouse = 'SPOUSE'
}

/** Document object being uploaded */
export type DocumentInput = {
  blobFile: Scalars['String']['input'];
  contentType: Scalars['String']['input'];
  headers?: InputMaybe<Scalars['String']['input']>;
  originalFilename: Scalars['String']['input'];
};

/** Argument grouping for EoR emergency contact */
export type EmergencyContactInput = {
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  phoneNumber: Scalars['String']['input'];
  relationship: Scalars['String']['input'];
};

/** Employee object being uploaded */
export type EmployeeInput = {
  name?: InputMaybe<Scalars['String']['input']>;
  uuid: Scalars['ID']['input'];
};

/** Editable EOR Employee employment details */
export type EmploymentInput = {
  mxIsRemoteWork?: InputMaybe<Scalars['Boolean']['input']>;
  workEmail?: InputMaybe<Scalars['String']['input']>;
};

export enum EnrollmentTier {
  /** Employee + Kids */
  Children = 'CHILDREN',
  /** Family */
  Family = 'FAMILY',
  /** Employee */
  Single = 'SINGLE',
  /** Employee + Spouse */
  Spouse = 'SPOUSE'
}

export enum EntityType {
  Corp = 'CORP',
  Llc = 'LLC',
  Partnership = 'PARTNERSHIP',
  SingleMemberLlc = 'SINGLE_MEMBER_LLC',
  SoleProprietorship = 'SOLE_PROPRIETORSHIP'
}

/** A request to edit an EOR employee profile */
export type EorEmployeeProfileInput = {
  contactDetails?: InputMaybe<ContactDetailsInput>;
  employment?: InputMaybe<EmploymentInput>;
  jobInformation?: InputMaybe<JobInformationInput>;
  personalInfo?: InputMaybe<PersonalInfoInput>;
};

/** Request to send an invite to a new EOR employee */
export type EorInviteRequest = {
  averageMinutesPerWeek?: InputMaybe<Scalars['Int']['input']>;
  caPtoAllowanceDays?: InputMaybe<Scalars['Int']['input']>;
  caPtoAllowanceType?: InputMaybe<Scalars['String']['input']>;
  clientBusinessDescription?: InputMaybe<Scalars['String']['input']>;
  contractTerm: Scalars['String']['input'];
  currency: Scalars['String']['input'];
  departmentUuid?: InputMaybe<Scalars['String']['input']>;
  firstName: Scalars['String']['input'];
  gbAdditionalHealthcareBenefits?: InputMaybe<Scalars['Boolean']['input']>;
  gbDiscretionaryBonuses?: InputMaybe<Scalars['Boolean']['input']>;
  gbEquity?: InputMaybe<Scalars['Boolean']['input']>;
  gbPtoAllowanceDays?: InputMaybe<Scalars['Int']['input']>;
  homeEmail?: InputMaybe<Scalars['String']['input']>;
  honoredStartDate?: InputMaybe<Scalars['APIDate']['input']>;
  inIsRemoteWork?: InputMaybe<Scalars['Boolean']['input']>;
  jobTitle: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  managerUuid?: InputMaybe<Scalars['String']['input']>;
  mxChristmasBonusDays?: InputMaybe<Scalars['Int']['input']>;
  mxIsRemoteWork?: InputMaybe<Scalars['Boolean']['input']>;
  mxMonthlyGroceryAllowance?: InputMaybe<Scalars['Int']['input']>;
  mxVacationDays?: InputMaybe<Scalars['Int']['input']>;
  mxVacationPremiumPercentage?: InputMaybe<Scalars['Int']['input']>;
  nl30PercentRulingApplies?: InputMaybe<Scalars['Boolean']['input']>;
  nlGrossPayIncludesHolidayPay?: InputMaybe<Scalars['Boolean']['input']>;
  payBasis: Scalars['String']['input'];
  payRate: Scalars['BigInt']['input'];
  probationPeriodDays?: InputMaybe<Scalars['String']['input']>;
  ptMealAllowance?: InputMaybe<Scalars['Boolean']['input']>;
  roleResponsibilities?: InputMaybe<Scalars['String']['input']>;
  sendInviteAt: Scalars['String']['input'];
  sendInviteTo: Scalars['String']['input'];
  startDate: Scalars['APIDate']['input'];
  workCountry: Scalars['String']['input'];
  workEmail: Scalars['String']['input'];
  workSubdivision?: InputMaybe<Scalars['String']['input']>;
};

/** The category of a calendar event */
export enum EventCategory {
  /** A bank holiday */
  BankHoliday = 'bank_holiday',
  /** A members birthday */
  Birthday = 'birthday',
  /** A company holiday */
  CompanyHoliday = 'company_holiday',
  /** A members first day */
  FirstDay = 'first_day',
  /** An invoice */
  Invoice = 'invoice',
  /** A members off cycle payment */
  OffCyclePayment = 'off_cycle_payment',
  /** A company payday */
  Payday = 'payday',
  /** A members PTO */
  Pto = 'pto',
  /** A members work anniversary */
  WorkAnniversary = 'work_anniversary'
}

/** The possible requirement settings for a specific field on new expense submissions. */
export enum ExpenseCategoryFieldSetting {
  Hidden = 'HIDDEN',
  Optional = 'OPTIONAL',
  Required = 'REQUIRED'
}

/** A single requested update to the expense categories. If no category exists with the given `name`, it is first created as a 'custom' category. Then, the given settings are applied. */
export type ExpenseCategoryUpdate = {
  attendees?: InputMaybe<ExpenseCategoryFieldSetting>;
  billableToClient?: InputMaybe<ExpenseCategoryFieldSetting>;
  description?: InputMaybe<ExpenseCategoryFieldSetting>;
  expenseType?: InputMaybe<ExpenseCategoryFieldSetting>;
  merchant?: InputMaybe<ExpenseCategoryFieldSetting>;
  name: Scalars['String']['input'];
  receipt?: InputMaybe<ExpenseCategoryFieldSetting>;
  visible: Scalars['Boolean']['input'];
};

/** The possible types for a single change made to an expense. */
export enum ExpenseEditedDetailTypeEnum {
  /** The field 'amount' on the expense was changed. */
  AmountChanged = 'AMOUNT_CHANGED',
  /** The field 'attendees' on the expense was changed. */
  AttendeesChanged = 'ATTENDEES_CHANGED',
  /** The expense was assigned to a different category. */
  CategoryChanged = 'CATEGORY_CHANGED',
  /** The field 'description' on the expense was changed. */
  DescriptionChanged = 'DESCRIPTION_CHANGED',
  /** The field 'expenseType' on the expense was changed. */
  ExpenseTypeChanged = 'EXPENSE_TYPE_CHANGED',
  /** The field 'isBillableToClient' on the expense was changed. */
  IsBillableToClientChanged = 'IS_BILLABLE_TO_CLIENT_CHANGED',
  /** The field 'merchant' on the expense was changed. */
  MerchantChanged = 'MERCHANT_CHANGED',
  /** The expense was assigned to a different project. */
  ProjectChanged = 'PROJECT_CHANGED',
  /** A receipt was added to the expense. */
  ReceiptAdded = 'RECEIPT_ADDED',
  /** A receipt was removed from the expense. */
  ReceiptRemoved = 'RECEIPT_REMOVED',
  /** The field 'transactionDate' on the expense was changed. */
  TransactionDateChanged = 'TRANSACTION_DATE_CHANGED'
}

/** A single expense being created or modified, either 'unattached' or within the context of a larger reimbursement request. */
export type ExpenseInput = {
  amount?: InputMaybe<Scalars['Cents']['input']>;
  attendees?: InputMaybe<Scalars['String']['input']>;
  categoryUuid?: InputMaybe<Scalars['ID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  /** If `true`, the indicated expense will be detached from the request. */
  detach?: InputMaybe<Scalars['Boolean']['input']>;
  expenseType?: InputMaybe<Scalars['String']['input']>;
  isBillableToClient?: InputMaybe<Scalars['Boolean']['input']>;
  merchant?: InputMaybe<Scalars['String']['input']>;
  projectUuid?: InputMaybe<Scalars['ID']['input']>;
  /** @deprecated This API now supports multiple receipts per expense. For backwards compatibility, this field takes precedence over `receiptUuids` if both are provided. If this field is provided, all existing receipts are deleted beforehand. */
  receiptUuid?: InputMaybe<Scalars['ID']['input']>;
  receiptUuids?: InputMaybe<Array<Scalars['ID']['input']>>;
  receiptUuidsToRemove?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** If `true`, the indicated expense will be deleted from the request. */
  remove?: InputMaybe<Scalars['Boolean']['input']>;
  /** If `true`, the provided value of `attendees` is ignored, and any existing value removed. */
  removeAttendees?: InputMaybe<Scalars['Boolean']['input']>;
  /** If `true`, the provided value of `description` is ignored, and any existing value removed. */
  removeDescription?: InputMaybe<Scalars['Boolean']['input']>;
  /** If `true`, the provided value of `merchant` is ignored, and any existing value removed. */
  removeMerchant?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * If `true`, any provided values for `receiptUuid` or `receiptUuids` are ignored, and all existing receipts are deleted.
   * @deprecated This API now supports multiple receipts per expense (see field `receiptUuidsToRemove`).
   */
  removeReceipt?: InputMaybe<Scalars['Boolean']['input']>;
  transactionDate?: InputMaybe<Scalars['APIDate']['input']>;
  /** This optional argument behaves slightly differently in the context of different mutations: - `createReimbursementRequest` — If provided, the UUID of an expense to be 'attached' to the target request. In that case, all other provided fields are applied as 'edits' before attaching. - `updateReimbursementRequest` — If provided, the UUID may refer either to an existing expense being modified, or an expense being 'attached'. In the latter case, the behavior is the same as `createReimbursementRequest`. - `createUnattachedExpense` — This argument is ignored completely. */
  uuid?: InputMaybe<Scalars['ID']['input']>;
};

/** The possible source field for an expense. */
export enum ExpensesSourceField {
  Desktop = 'DESKTOP',
  Mobile = 'MOBILE'
}

/** The status for a firm */
export enum FirmInviteStatus {
  /** The firm invite has been accepted by the company */
  Accepted = 'ACCEPTED',
  /** The firm invite has been declined by the company */
  Declined = 'DECLINED',
  /** The firm invite is pending */
  Pending = 'PENDING'
}

/** The status for a firm */
export enum FirmStatus {
  /** The firm access is active */
  Active = 'ACTIVE',
  /** The firm access is pending */
  Pending = 'PENDING',
  /** The firm access is revoked */
  Revoked = 'REVOKED'
}

/** Form 8973 answers */
export type Form8973Answers = {
  addressValid: Scalars['String']['input'];
  correctedAddressCity: Scalars['String']['input'];
  correctedAddressCountry: Scalars['String']['input'];
  correctedAddressLine1: Scalars['String']['input'];
  correctedAddressLine2: Scalars['String']['input'];
  correctedAddressState: Scalars['String']['input'];
  correctedAddressZip: Scalars['String']['input'];
  correctedEin: Scalars['String']['input'];
  correctedLegalName: Scalars['String']['input'];
  correctedTradeName: Scalars['String']['input'];
  einChangeReason: Scalars['String']['input'];
  einSupportingDocument?: InputMaybe<Form8973DocumentAnswer>;
  einValid: Scalars['String']['input'];
  legalEntityNameChangeReason: Scalars['String']['input'];
  legalEntityNameSupportingDocument?: InputMaybe<Form8973DocumentAnswer>;
  legalEntityNameValid: Scalars['String']['input'];
  tradeNameValid: Scalars['String']['input'];
};

/** Input type for a Form 8973 document upload */
export type Form8973DocumentAnswer = {
  blobFile: Scalars['String']['input'];
  contentType: Scalars['String']['input'];
  originalFilename: Scalars['String']['input'];
};

/** Input type for EOR France dependent information */
export type FrDependentInformationInput = {
  residentCardEndDate: Scalars['String']['input'];
  residentCardNumber: Scalars['String']['input'];
  residentCardStartDate: Scalars['String']['input'];
  residentCardType: Scalars['String']['input'];
};

export enum FsaElection {
  DependentCare = 'DEPENDENT_CARE',
  Healthcare = 'HEALTHCARE'
}

export enum HostName {
  Hours = 'HOURS',
  Internal = 'INTERNAL'
}

export enum HsaContributionFrequency {
  Annually = 'ANNUALLY',
  Monthly = 'MONTHLY'
}

/** The type of insurance document request */
export enum InsuranceDocument {
  Coi = 'COI',
  Waiver = 'WAIVER'
}

/** The priority of the insurance document request */
export enum InsuranceDocumentPriority {
  Critical = 'CRITICAL',
  Standard = 'STANDARD',
  Urgent = 'URGENT'
}

/** Insurance Document Request */
export type InsuranceDocumentRequest = {
  /** The address of the insurance document request */
  address: AddressInput;
  /** The cert data of the insurance document request */
  certData: CertificateDataInput;
  /** The document objects being uploaded */
  documents?: InputMaybe<Array<DocumentInput>>;
  /** The type of insurance document request */
  type: InsuranceDocument;
  /** The waiver object being uploaded */
  waiver?: InputMaybe<WaiverInput>;
};

export enum InsurancePolicyCategory {
  Dental = 'DENTAL',
  Medical = 'MEDICAL',
  Vision = 'VISION'
}

export enum InsuranceProviderName {
  Aetna = 'AETNA',
  Kaiser = 'KAISER',
  Metlife = 'METLIFE',
  United = 'UNITED'
}

/** echo event message */
export type IntegrationEventMessage = {
  integrationEventMessage?: InputMaybe<Array<IntegrationEventMessageParam>>;
};

/** echo event message param */
export type IntegrationEventMessageParam = {
  name: Scalars['String']['input'];
  /** Int */
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Argument grouping for EoR Address */
export type InternationalAddressInput = {
  address1: Scalars['String']['input'];
  address2?: InputMaybe<Scalars['String']['input']>;
  city: Scalars['String']['input'];
  countryCode: Scalars['String']['input'];
  postalCode: Scalars['String']['input'];
  zoneCode: Scalars['String']['input'];
};

/** An object describing who a document is assigned to */
export type InternationalDocumentMemberAssignmentInput = {
  documentId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  memberId?: InputMaybe<Scalars['String']['input']>;
  visibilityLevel?: InputMaybe<Scalars['String']['input']>;
};

/** The status of an invitation */
export enum InvitationStatus {
  /** The invitation has been accepted */
  Accepted = 'ACCEPTED',
  /** The invitation has been declined */
  Declined = 'DECLINED',
  /** The invitation has expired */
  Expired = 'EXPIRED',
  /** The invitation is pending */
  Pending = 'PENDING'
}

export enum InvoiceItem {
  Credit = 'CREDIT',
  Fee = 'FEE'
}

/** Information for bill/credit a company */
export type InvoiceRequest = {
  billingDetails: BillingDetails;
  companyUuid: Scalars['ID']['input'];
  payDate?: InputMaybe<PayDate>;
  payPeriod?: InputMaybe<PayPeriod>;
  senderTrackingId: Scalars['ID']['input'];
  sourceReference: SourceReference;
};

/** Editable EOR Employee job information */
export type JobInformationInput = {
  departmentUuid?: InputMaybe<Scalars['String']['input']>;
  honoredStartDate?: InputMaybe<Scalars['String']['input']>;
  managerUuid?: InputMaybe<Scalars['String']['input']>;
  workId?: InputMaybe<Scalars['String']['input']>;
};

/** The letter type of a compensation change notification letter */
export enum LetterType {
  CostOfLiving = 'cost_of_living',
  Generic = 'generic',
  MeritIncrease = 'merit_increase',
  Promotion = 'promotion',
  RoleChange = 'role_change'
}

/** Argument grouping for compensation change notification letter generation */
export type MemberChangeDataParam = {
  letterType: LetterType;
  newMemberStateUuid: Scalars['String']['input'];
  newTitle: Scalars['String']['input'];
  prevMemberStateUuid: Scalars['String']['input'];
  prevTitle?: InputMaybe<Scalars['String']['input']>;
};

export enum MemberGender {
  Female = 'FEMALE',
  Male = 'MALE'
}

/** Member separation flow field input */
export type MemberSeparationAnswersInput = {
  fieldId: Scalars['String']['input'];
  fieldLabel?: InputMaybe<Scalars['String']['input']>;
  valueBoolean?: InputMaybe<Scalars['String']['input']>;
  valueDate?: InputMaybe<Scalars['String']['input']>;
  valueDocumentId?: InputMaybe<Scalars['Int']['input']>;
  valueNumeric?: InputMaybe<Scalars['Float']['input']>;
  valueText?: InputMaybe<Scalars['String']['input']>;
  valueTextSmall?: InputMaybe<Scalars['String']['input']>;
};

/** Argument grouping for EoR member settings */
export type MemberSettingsInput = {
  showDateOfBirth?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum MemberStatus {
  Active = 'ACTIVE',
  Terminated = 'TERMINATED'
}

export enum MemberType {
  Contractor = 'CONTRACTOR',
  EmployeeEor = 'EMPLOYEE_EOR',
  EmployeeFullTime = 'EMPLOYEE_FULL_TIME',
  EmployeeInternational = 'EMPLOYEE_INTERNATIONAL',
  EmployeePartTime = 'EMPLOYEE_PART_TIME',
  Owner = 'OWNER',
  OwnerFullTime = 'OWNER_FULL_TIME',
  PaidIntern = 'PAID_INTERN',
  Temp = 'TEMP',
  Vendor = 'VENDOR'
}

export enum MemberWorkflowName {
  MemberOnboarding = 'member_onboarding',
  MemberPostOnboarding = 'member_post_onboarding',
  MemberRehire = 'member_rehire'
}

export type MultiValueStepInputParam = {
  name: Scalars['String']['input'];
  valueList: Array<StepInputParam>;
};

/** The type of badge to display on a navigation item. */
export enum NavBadgeTypeEnum {
  /** high visibility indicator (example usage would be to highlight EOY tasks) */
  Callout = 'callout',
  /** new feature indicator */
  New = 'new'
}

/** A firm invitation */
export type NewInvitationInput = {
  email: Scalars['String']['input'];
  firmName?: InputMaybe<Scalars['String']['input']>;
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  message?: InputMaybe<Scalars['String']['input']>;
  permissions: Array<Scalars['String']['input']>;
};

/** That lists the status of the office. */
export enum OfficeStatus {
  Active = 'active',
  Deleted = 'deleted',
  Historical = 'historical'
}

/** Valid payment types for disbursement orders */
export enum OrderPayment {
  Benefitsandallowances = 'BENEFITSANDALLOWANCES',
  Bonus = 'BONUS',
  Commission = 'COMMISSION',
  Offcycle = 'OFFCYCLE',
  Reimbursement = 'REIMBURSEMENT',
  Retroactive = 'RETROACTIVE'
}

/** Input type for EOR Panama dependent information */
export type PaDependentInformationInput = {
  dependentType: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
};

/** whether a dependent is active */
export enum PartnerDependentStatus {
  Active = 'active',
  Canceled = 'canceled',
  Inactive = 'inactive'
}

/** Pay Date Details */
export type PayDate = {
  dateType?: InputMaybe<Scalars['String']['input']>;
  payDate?: InputMaybe<Scalars['APIDate']['input']>;
};

export enum PayGroup {
  Biweekly = 'BIWEEKLY',
  Semimonthly = 'SEMIMONTHLY',
  Weekly = 'WEEKLY'
}

/** Pay Period Details */
export type PayPeriod = {
  id?: InputMaybe<Scalars['ID']['input']>;
  payPeriodInfo?: InputMaybe<PayPeriodInfo>;
};

/** Pay Period Details */
export type PayPeriodInfo = {
  nperYtd: Scalars['Int']['input'];
  payGroup: PayGroup;
  year: Scalars['Int']['input'];
};

/** Payees for collection reminder email */
export type Payees = {
  disbursementAmount: Scalars['String']['input'];
  localCurrency: Scalars['String']['input'];
  name: Scalars['String']['input'];
};

/** Argument grouping for EoR member onboarding payment information step */
export type PaymentInfoInput = {
  accountHolderName?: InputMaybe<Scalars['String']['input']>;
  accountNickname?: InputMaybe<Scalars['String']['input']>;
  accountNumber?: InputMaybe<Scalars['String']['input']>;
  accountType?: InputMaybe<Scalars['String']['input']>;
  bankCertificate?: InputMaybe<Photo>;
  bankCode?: InputMaybe<Scalars['String']['input']>;
  bankName?: InputMaybe<Scalars['String']['input']>;
  branchCode?: InputMaybe<Scalars['String']['input']>;
  bsbNumber?: InputMaybe<Scalars['String']['input']>;
  bvn?: InputMaybe<Scalars['String']['input']>;
  clabe?: InputMaybe<Scalars['String']['input']>;
  clearingNumber?: InputMaybe<Scalars['String']['input']>;
  countryCode: Scalars['String']['input'];
  ctsAccountNumber?: InputMaybe<Scalars['String']['input']>;
  ctsFinancialEntity?: InputMaybe<Scalars['String']['input']>;
  currency: Scalars['String']['input'];
  iban?: InputMaybe<Scalars['String']['input']>;
  ifscCode?: InputMaybe<Scalars['String']['input']>;
  institutionNumber?: InputMaybe<Scalars['String']['input']>;
  irdNumber?: InputMaybe<Scalars['String']['input']>;
  registrationNumber?: InputMaybe<Scalars['String']['input']>;
  routingNumber?: InputMaybe<Scalars['String']['input']>;
  sortCode?: InputMaybe<Scalars['String']['input']>;
  swiftCode?: InputMaybe<Scalars['String']['input']>;
  transitNumber?: InputMaybe<Scalars['String']['input']>;
};

/** object that contains the payment amount and type */
export type PaymentSettings = {
  amount: Scalars['Int']['input'];
  bonusType?: InputMaybe<Scalars['String']['input']>;
  deductionsSetting?: InputMaybe<Scalars['String']['input']>;
  isNetPay?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  numberOfPayments?: InputMaybe<Scalars['Int']['input']>;
  payDate: Scalars['String']['input'];
  payFrequency?: InputMaybe<Scalars['String']['input']>;
  payGroup?: InputMaybe<Scalars['String']['input']>;
  payeeUuid: Scalars['String']['input'];
  paymentMethod?: InputMaybe<Scalars['String']['input']>;
  repeatPayment?: InputMaybe<Scalars['Boolean']['input']>;
  taxMethod?: InputMaybe<Scalars['String']['input']>;
  type: Scalars['String']['input'];
  workEndDate?: InputMaybe<Scalars['String']['input']>;
  workStartDate?: InputMaybe<Scalars['String']['input']>;
};

/** The available sort options for the `payments` node. */
export enum PaymentSortBy {
  Amount = 'AMOUNT',
  PaymentType = 'PAYMENT_TYPE',
  PayDate = 'PAY_DATE',
  RecipientName = 'RECIPIENT_NAME'
}

/** Tell Clockwork to send payment started email */
export type PaymentStartedInput = {
  companyUuid: Scalars['ID']['input'];
  estimatedEndDate?: InputMaybe<Scalars['String']['input']>;
  estimatedStartDate?: InputMaybe<Scalars['String']['input']>;
  payeeName: Scalars['String']['input'];
  paymentCount?: InputMaybe<Scalars['Int']['input']>;
  paymentId: Scalars['ID']['input'];
  totalUsd: Scalars['Int']['input'];
};

/** The possible statuses for a 'one-off' payment. */
export enum PaymentStatus {
  Canceled = 'CANCELED',
  Completed = 'COMPLETED',
  Scheduled = 'SCHEDULED'
}

/** The possible types for a 'one-off' payment. */
export enum PaymentTypeEnum {
  Bonus = 'BONUS',
  Commission = 'COMMISSION',
  ContractorPay = 'CONTRACTOR_PAY',
  EmergencySickLeave = 'EMERGENCY_SICK_LEAVE',
  ExercisedNsos = 'EXERCISED_NSOS',
  ExpenseReimbursement = 'EXPENSE_REIMBURSEMENT',
  ExtendedFamilyMedicalLeave = 'EXTENDED_FAMILY_MEDICAL_LEAVE',
  FringeBenefit = 'FRINGE_BENEFIT',
  MiscellaneousNonTaxable = 'MISCELLANEOUS_NON_TAXABLE',
  OffCycleSalary = 'OFF_CYCLE_SALARY',
  OtherSupplementalPay = 'OTHER_SUPPLEMENTAL_PAY',
  OwnersDraw = 'OWNERS_DRAW',
  PaycheckTips = 'PAYCHECK_TIPS',
  RetroactivePay = 'RETROACTIVE_PAY',
  Severance = 'SEVERANCE',
  StockOptions = 'STOCK_OPTIONS',
  TaxableMovingExpense = 'TAXABLE_MOVING_EXPENSE',
  VendorPayment = 'VENDOR_PAYMENT',
  VestedRsus = 'VESTED_RSUS'
}

/** Input type for EOR Peru dependent information */
export type PeDependentInfoInput = {
  birthDate: Scalars['String']['input'];
  familyMemberType: Scalars['String']['input'];
  gender: Scalars['String']['input'];
  idNumber: Scalars['String']['input'];
  idType: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  middleName: Scalars['String']['input'];
  name: Scalars['String']['input'];
};

/** Personal Info Input */
export type PersonalInfoInput = {
  bgAcademicDegree?: InputMaybe<Scalars['String']['input']>;
  bgDisabilityStatus?: InputMaybe<Scalars['String']['input']>;
  bgEducationLevel?: InputMaybe<Scalars['String']['input']>;
  bgGender?: InputMaybe<Scalars['String']['input']>;
  bgIdCardDateOfIssue?: InputMaybe<Scalars['APIDate']['input']>;
  bgIdCardIssuedBy?: InputMaybe<Scalars['String']['input']>;
  bgMajorSpecialty?: InputMaybe<Scalars['String']['input']>;
  brCityOfBirth?: InputMaybe<Scalars['String']['input']>;
  brEducationalQualification?: InputMaybe<Scalars['String']['input']>;
  brEthnicity?: InputMaybe<Scalars['String']['input']>;
  brMaritalStatus?: InputMaybe<Scalars['String']['input']>;
  brStateOfBirth?: InputMaybe<Scalars['String']['input']>;
  brWorkPermitStatus?: InputMaybe<Scalars['String']['input']>;
  clAfpAgencyName?: InputMaybe<Scalars['String']['input']>;
  clHealthAgencyName?: InputMaybe<Scalars['String']['input']>;
  clHealthPlan?: InputMaybe<Scalars['String']['input']>;
  crCcss?: InputMaybe<Scalars['String']['input']>;
  crCedulaDeIdentidad?: InputMaybe<Scalars['String']['input']>;
  crIns?: InputMaybe<Scalars['String']['input']>;
  crMaritalStatus?: InputMaybe<Scalars['String']['input']>;
  crNumChildren?: InputMaybe<Scalars['Int']['input']>;
  crSpouse?: InputMaybe<Scalars['Boolean']['input']>;
  dateOfBirth?: InputMaybe<Scalars['String']['input']>;
  deCountryOfBirth?: InputMaybe<Scalars['String']['input']>;
  deEligibleChildren?: InputMaybe<Scalars['Int']['input']>;
  deHealthInsuranceProvider?: InputMaybe<Scalars['String']['input']>;
  deHealthInsuranceStatus?: InputMaybe<Scalars['String']['input']>;
  deMainEmployer?: InputMaybe<Scalars['Boolean']['input']>;
  deMaritalStatus?: InputMaybe<Scalars['String']['input']>;
  dePensionInsuranceNumber?: InputMaybe<Scalars['String']['input']>;
  deProfessionalQualification?: InputMaybe<Scalars['String']['input']>;
  deReligion?: InputMaybe<Scalars['String']['input']>;
  deSchoolDegree?: InputMaybe<Scalars['String']['input']>;
  deTaxClass?: InputMaybe<Scalars['String']['input']>;
  eeAcademicDegree?: InputMaybe<Scalars['String']['input']>;
  eeBirthCity?: InputMaybe<Scalars['String']['input']>;
  eeBirthCountry?: InputMaybe<Scalars['String']['input']>;
  eeEducationLevel?: InputMaybe<Scalars['String']['input']>;
  eeFieldOfStudy?: InputMaybe<Scalars['String']['input']>;
  eeGender?: InputMaybe<Scalars['String']['input']>;
  eeHasDisability?: InputMaybe<Scalars['Boolean']['input']>;
  eeIdCardIssueDate?: InputMaybe<Scalars['APIDate']['input']>;
  eeIdCardIssuer?: InputMaybe<Scalars['String']['input']>;
  eeMaritalStatus?: InputMaybe<Scalars['String']['input']>;
  eePassportNumber?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  emergencyContact?: InputMaybe<EmergencyContactInput>;
  esChildrensBirthDates?: InputMaybe<Array<Scalars['APIDate']['input']>>;
  esEducationalQualification?: InputMaybe<Scalars['String']['input']>;
  esMaritalStatus?: InputMaybe<Scalars['String']['input']>;
  esNumChildren?: InputMaybe<Scalars['Int']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  grFirstInsuranceDate?: InputMaybe<Scalars['APIDate']['input']>;
  grIdentityCardNumber?: InputMaybe<Scalars['String']['input']>;
  grMaritalStatus?: InputMaybe<Scalars['String']['input']>;
  grNameOfFather?: InputMaybe<Scalars['String']['input']>;
  grNameOfMother?: InputMaybe<Scalars['String']['input']>;
  grNumberOfChildren?: InputMaybe<Scalars['Int']['input']>;
  grRevenueOffice?: InputMaybe<Scalars['String']['input']>;
  grSex?: InputMaybe<Scalars['String']['input']>;
  grSocialInsuranceNumber?: InputMaybe<Scalars['String']['input']>;
  grSocialSecurityNumber?: InputMaybe<Scalars['String']['input']>;
  ieMaritalStatus?: InputMaybe<Scalars['String']['input']>;
  keDisabledExemptionCertNumber?: InputMaybe<Scalars['String']['input']>;
  keForeignId?: InputMaybe<Scalars['String']['input']>;
  keGender?: InputMaybe<Scalars['String']['input']>;
  keIdentityType?: InputMaybe<Scalars['String']['input']>;
  keKraPin?: InputMaybe<Scalars['String']['input']>;
  keNationalId?: InputMaybe<Scalars['String']['input']>;
  keNssfNumber?: InputMaybe<Scalars['String']['input']>;
  keShifNumber?: InputMaybe<Scalars['String']['input']>;
  keTaxStatus?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  middleName?: InputMaybe<Scalars['String']['input']>;
  mxHasFonacotLoan?: InputMaybe<Scalars['Boolean']['input']>;
  mxHasInfonavitLoan?: InputMaybe<Scalars['Boolean']['input']>;
  myChildrenInformation?: InputMaybe<Array<ChildrenInformationInput>>;
  myEpf?: InputMaybe<Scalars['String']['input']>;
  myGender?: InputMaybe<Scalars['String']['input']>;
  myHasChildren?: InputMaybe<Scalars['String']['input']>;
  myHasCitizenship?: InputMaybe<Scalars['String']['input']>;
  myHasDisability?: InputMaybe<Scalars['String']['input']>;
  myIcNumber?: InputMaybe<Scalars['String']['input']>;
  myIncomeTaxBranch?: InputMaybe<Scalars['String']['input']>;
  myIncomeTaxNumber?: InputMaybe<Scalars['String']['input']>;
  myIncomeTaxStatus?: InputMaybe<Scalars['String']['input']>;
  myMaritalStatus?: InputMaybe<Scalars['String']['input']>;
  myPassportNumber?: InputMaybe<Scalars['String']['input']>;
  myRace?: InputMaybe<Scalars['String']['input']>;
  mySocsoNumber?: InputMaybe<Scalars['String']['input']>;
  mySpouseDisability?: InputMaybe<Scalars['String']['input']>;
  mySpouseIcNumber?: InputMaybe<Scalars['String']['input']>;
  mySpouseIncomeTaxBranch?: InputMaybe<Scalars['String']['input']>;
  mySpouseIncomeTaxNumber?: InputMaybe<Scalars['String']['input']>;
  mySpouseName?: InputMaybe<Scalars['String']['input']>;
  mySpouseTelephoneNumber?: InputMaybe<Scalars['String']['input']>;
  mySpouseWorkingStatus?: InputMaybe<Scalars['String']['input']>;
  nationality?: InputMaybe<Scalars['String']['input']>;
  ngAnnualPremiumPayment?: InputMaybe<Scalars['String']['input']>;
  ngAnnualRentPaid?: InputMaybe<Scalars['String']['input']>;
  ngGender?: InputMaybe<Scalars['String']['input']>;
  ngHasPen?: InputMaybe<Scalars['Boolean']['input']>;
  ngIdentificationNumber?: InputMaybe<Scalars['String']['input']>;
  ngIdentificationType?: InputMaybe<Scalars['String']['input']>;
  ngMaritalStatus?: InputMaybe<Scalars['String']['input']>;
  ngNhfNumber?: InputMaybe<Scalars['String']['input']>;
  ngPenNumber?: InputMaybe<Scalars['String']['input']>;
  ngPensionCustodianBankAccountNo?: InputMaybe<Scalars['String']['input']>;
  ngPensionCustodianBankName?: InputMaybe<Scalars['String']['input']>;
  ngPensionFundAdministrator?: InputMaybe<Scalars['String']['input']>;
  ngTaxIdentificationNumber?: InputMaybe<Scalars['String']['input']>;
  ngWillContributeNhf?: InputMaybe<Scalars['Boolean']['input']>;
  paCedula?: InputMaybe<Scalars['String']['input']>;
  paCivilStatus?: InputMaybe<Scalars['String']['input']>;
  paDependentInformation?: InputMaybe<Array<PaDependentInformationInput>>;
  paEducationLevel?: InputMaybe<Scalars['String']['input']>;
  paGender?: InputMaybe<Scalars['String']['input']>;
  paPassport?: InputMaybe<Scalars['String']['input']>;
  paSocialInsuranceNumber?: InputMaybe<Scalars['String']['input']>;
  phHdmfn?: InputMaybe<Scalars['String']['input']>;
  phPhicn?: InputMaybe<Scalars['String']['input']>;
  preferredFirstName?: InputMaybe<Scalars['String']['input']>;
  pronouns?: InputMaybe<Scalars['String']['input']>;
  ptCcExpDate?: InputMaybe<Scalars['APIDate']['input']>;
  ptCcIssDate?: InputMaybe<Scalars['APIDate']['input']>;
  usSsn?: InputMaybe<Scalars['String']['input']>;
  uyCid?: InputMaybe<Scalars['String']['input']>;
  uyEducationLevel?: InputMaybe<Scalars['String']['input']>;
  uyFieldOfEducation?: InputMaybe<Scalars['String']['input']>;
  uyPreviousEmploymentStatus?: InputMaybe<Scalars['String']['input']>;
  uySeguroDeSaludBps?: InputMaybe<Scalars['String']['input']>;
};

/** Argument grouping for EoR PhoneNumber */
export type PhoneNumberInput = {
  type: Scalars['String']['input'];
  value: Scalars['String']['input'];
};

/** Photo object being uploaded */
export type Photo = {
  blobFile?: InputMaybe<Scalars['String']['input']>;
  contentType?: InputMaybe<Scalars['String']['input']>;
  headers?: InputMaybe<Scalars['String']['input']>;
  originalFilename?: InputMaybe<Scalars['String']['input']>;
};

/** Bank Account Data Input */
export type ProfileBankAccountDataInput = {
  accountHolderName?: InputMaybe<Scalars['String']['input']>;
  accountNumber?: InputMaybe<Scalars['String']['input']>;
  accountType?: InputMaybe<Scalars['String']['input']>;
  bankCertificate?: InputMaybe<Photo>;
  bankCode?: InputMaybe<Scalars['String']['input']>;
  bankName?: InputMaybe<Scalars['String']['input']>;
  branchCode?: InputMaybe<Scalars['String']['input']>;
  bsbNumber?: InputMaybe<Scalars['String']['input']>;
  bvn?: InputMaybe<Scalars['String']['input']>;
  clabe?: InputMaybe<Scalars['String']['input']>;
  clearingNumber?: InputMaybe<Scalars['String']['input']>;
  countryCode?: InputMaybe<Scalars['String']['input']>;
  ctsAccountNumber?: InputMaybe<Scalars['String']['input']>;
  ctsFinancialEntity?: InputMaybe<Scalars['String']['input']>;
  currency?: InputMaybe<Scalars['String']['input']>;
  iban?: InputMaybe<Scalars['String']['input']>;
  ifscCode?: InputMaybe<Scalars['String']['input']>;
  institutionNumber?: InputMaybe<Scalars['String']['input']>;
  irdNumber?: InputMaybe<Scalars['String']['input']>;
  registrationNumber?: InputMaybe<Scalars['String']['input']>;
  routingNumber?: InputMaybe<Scalars['String']['input']>;
  sortCode?: InputMaybe<Scalars['String']['input']>;
  swiftCode?: InputMaybe<Scalars['String']['input']>;
  transitNumber?: InputMaybe<Scalars['String']['input']>;
};

/** Bank Account Input */
export type ProfileBankAccountInput = {
  data?: InputMaybe<ProfileBankAccountDataInput>;
  nickname?: InputMaybe<Scalars['String']['input']>;
};

/** Argument grouping for EoR member onboarding profile info step */
export type ProfileInfoInput = {
  auGender?: InputMaybe<Scalars['String']['input']>;
  auTfn?: InputMaybe<Scalars['String']['input']>;
  auTitle?: InputMaybe<Scalars['String']['input']>;
  bgAcademicDegree?: InputMaybe<Scalars['String']['input']>;
  bgDisabilityStatus?: InputMaybe<Scalars['String']['input']>;
  bgEducationLevel?: InputMaybe<Scalars['String']['input']>;
  bgEgn?: InputMaybe<Scalars['String']['input']>;
  bgGender?: InputMaybe<Scalars['String']['input']>;
  bgIdCardDateOfIssue?: InputMaybe<Scalars['APIDate']['input']>;
  bgIdCardIssuedBy?: InputMaybe<Scalars['String']['input']>;
  bgIdCardNumber?: InputMaybe<Scalars['String']['input']>;
  bgMajorSpecialty?: InputMaybe<Scalars['String']['input']>;
  brCityOfBirth?: InputMaybe<Scalars['String']['input']>;
  brCpf?: InputMaybe<Scalars['String']['input']>;
  brEducationalQualification?: InputMaybe<Scalars['String']['input']>;
  brEthnicity?: InputMaybe<Scalars['String']['input']>;
  brGender?: InputMaybe<Scalars['String']['input']>;
  brMaritalStatus?: InputMaybe<Scalars['String']['input']>;
  brPersonalId?: InputMaybe<Scalars['String']['input']>;
  brPis?: InputMaybe<Scalars['String']['input']>;
  brRgIssuingBody?: InputMaybe<Scalars['String']['input']>;
  brRgStateOfIssue?: InputMaybe<Scalars['String']['input']>;
  brStateOfBirth?: InputMaybe<Scalars['String']['input']>;
  brUnionContribution?: InputMaybe<Scalars['Boolean']['input']>;
  brWorkPermitStatus?: InputMaybe<Scalars['String']['input']>;
  caSin?: InputMaybe<Scalars['String']['input']>;
  clAfpAgencyName?: InputMaybe<Scalars['String']['input']>;
  clHealthAgencyName?: InputMaybe<Scalars['String']['input']>;
  clHealthPlan?: InputMaybe<Scalars['String']['input']>;
  clRut?: InputMaybe<Scalars['String']['input']>;
  coCedulaDeCiudadania?: InputMaybe<Scalars['String']['input']>;
  coNombreArl?: InputMaybe<Scalars['String']['input']>;
  coNombreEps?: InputMaybe<Scalars['String']['input']>;
  coNombreFondoDePensiones?: InputMaybe<Scalars['String']['input']>;
  crCcss?: InputMaybe<Scalars['String']['input']>;
  crCedulaDeIdentidad?: InputMaybe<Scalars['String']['input']>;
  crIns?: InputMaybe<Scalars['String']['input']>;
  crMaritalStatus?: InputMaybe<Scalars['String']['input']>;
  crNumChildren?: InputMaybe<Scalars['Int']['input']>;
  crSpouse?: InputMaybe<Scalars['Boolean']['input']>;
  dateOfBirth: Scalars['String']['input'];
  deCountryOfBirth?: InputMaybe<Scalars['String']['input']>;
  deEligibleChildren?: InputMaybe<Scalars['Int']['input']>;
  deHealthInsuranceProvider?: InputMaybe<Scalars['String']['input']>;
  deHealthInsuranceStatus?: InputMaybe<Scalars['String']['input']>;
  deIdnr?: InputMaybe<Scalars['String']['input']>;
  deMainEmployer?: InputMaybe<Scalars['Boolean']['input']>;
  deMaritalStatus?: InputMaybe<Scalars['String']['input']>;
  dePensionInsuranceNumber?: InputMaybe<Scalars['String']['input']>;
  deProfessionalQualification?: InputMaybe<Scalars['String']['input']>;
  deReligion?: InputMaybe<Scalars['String']['input']>;
  deSchoolDegree?: InputMaybe<Scalars['String']['input']>;
  deTaxClass?: InputMaybe<Scalars['String']['input']>;
  dkCpr?: InputMaybe<Scalars['String']['input']>;
  eeAcademicDegree?: InputMaybe<Scalars['String']['input']>;
  eeBirthCity?: InputMaybe<Scalars['String']['input']>;
  eeBirthCountry?: InputMaybe<Scalars['String']['input']>;
  eeEducationLevel?: InputMaybe<Scalars['String']['input']>;
  eeFieldOfStudy?: InputMaybe<Scalars['String']['input']>;
  eeGender?: InputMaybe<Scalars['String']['input']>;
  eeHasDisability?: InputMaybe<Scalars['Boolean']['input']>;
  eeIdCardIssueDate?: InputMaybe<Scalars['APIDate']['input']>;
  eeIdCardIssuer?: InputMaybe<Scalars['String']['input']>;
  eeIk?: InputMaybe<Scalars['String']['input']>;
  eeMaritalStatus?: InputMaybe<Scalars['String']['input']>;
  eePassportNumber?: InputMaybe<Scalars['String']['input']>;
  esChildrensBirthDates?: InputMaybe<Array<Scalars['APIDate']['input']>>;
  esDateSinceResidentOfSpain?: InputMaybe<Scalars['APIDate']['input']>;
  esDni?: InputMaybe<Scalars['String']['input']>;
  esEducationalQualification?: InputMaybe<Scalars['String']['input']>;
  esMaritalStatus?: InputMaybe<Scalars['String']['input']>;
  esNie?: InputMaybe<Scalars['String']['input']>;
  esNumChildren?: InputMaybe<Scalars['Int']['input']>;
  esSex?: InputMaybe<Scalars['String']['input']>;
  esSsn?: InputMaybe<Scalars['String']['input']>;
  esTaxResidency?: InputMaybe<Scalars['Boolean']['input']>;
  esUnemploymentStatus?: InputMaybe<Scalars['Boolean']['input']>;
  firstName: Scalars['String']['input'];
  frBirthCountry?: InputMaybe<Scalars['String']['input']>;
  frBirthPlace?: InputMaybe<Scalars['String']['input']>;
  frBirthProvince?: InputMaybe<Scalars['String']['input']>;
  frDependentInformation?: InputMaybe<Array<FrDependentInformationInput>>;
  frEDoc?: InputMaybe<Scalars['Boolean']['input']>;
  frHighestDegree?: InputMaybe<Scalars['String']['input']>;
  frMaidenName?: InputMaybe<Scalars['String']['input']>;
  frMaritalStatus?: InputMaybe<Scalars['String']['input']>;
  frNumDependents?: InputMaybe<Scalars['Int']['input']>;
  frSsn?: InputMaybe<Scalars['String']['input']>;
  frTitle?: InputMaybe<Scalars['String']['input']>;
  gbNino?: InputMaybe<Scalars['String']['input']>;
  grFirstInsuranceDate?: InputMaybe<Scalars['APIDate']['input']>;
  grIdentityCardNumber?: InputMaybe<Scalars['String']['input']>;
  grMaritalStatus?: InputMaybe<Scalars['String']['input']>;
  grNameOfFather?: InputMaybe<Scalars['String']['input']>;
  grNameOfMother?: InputMaybe<Scalars['String']['input']>;
  grNumberOfChildren?: InputMaybe<Scalars['Int']['input']>;
  grRevenueOffice?: InputMaybe<Scalars['String']['input']>;
  grSex?: InputMaybe<Scalars['String']['input']>;
  grSocialInsuranceNumber?: InputMaybe<Scalars['String']['input']>;
  grSocialSecurityNumber?: InputMaybe<Scalars['String']['input']>;
  grVat?: InputMaybe<Scalars['String']['input']>;
  hrDrugiSetup?: InputMaybe<Scalars['Boolean']['input']>;
  hrEducationLevel?: InputMaybe<Scalars['String']['input']>;
  hrJmbg?: InputMaybe<Scalars['String']['input']>;
  hrOib?: InputMaybe<Scalars['String']['input']>;
  hrPensionInsuranceNumber?: InputMaybe<Scalars['String']['input']>;
  ieMaritalStatus?: InputMaybe<Scalars['String']['input']>;
  iePps?: InputMaybe<Scalars['String']['input']>;
  inAadharNumber?: InputMaybe<Scalars['String']['input']>;
  inEsic?: InputMaybe<Scalars['String']['input']>;
  inMaritalStatus?: InputMaybe<Scalars['String']['input']>;
  inPan?: InputMaybe<Scalars['String']['input']>;
  inPfUan?: InputMaybe<Scalars['String']['input']>;
  inTaxRegime?: InputMaybe<Scalars['String']['input']>;
  inYearToDateExemptions?: InputMaybe<Array<Scalars['String']['input']>>;
  inYearToDateTaxableSalary?: InputMaybe<Scalars['BigInt']['input']>;
  inYearToDateTds?: InputMaybe<Scalars['BigInt']['input']>;
  itBirthplace?: InputMaybe<Scalars['String']['input']>;
  itCodiceFiscale?: InputMaybe<Scalars['String']['input']>;
  itEducationalLevel?: InputMaybe<Scalars['String']['input']>;
  keDisabledExemptionCertNumber?: InputMaybe<Scalars['String']['input']>;
  keForeignId?: InputMaybe<Scalars['String']['input']>;
  keGender?: InputMaybe<Scalars['String']['input']>;
  keIdentityType?: InputMaybe<Scalars['String']['input']>;
  keKraPin?: InputMaybe<Scalars['String']['input']>;
  keNationalId?: InputMaybe<Scalars['String']['input']>;
  keNssfNumber?: InputMaybe<Scalars['String']['input']>;
  keShifNumber?: InputMaybe<Scalars['String']['input']>;
  keTaxStatus?: InputMaybe<Scalars['String']['input']>;
  lastName: Scalars['String']['input'];
  lvPersonasKods?: InputMaybe<Scalars['String']['input']>;
  middleName?: InputMaybe<Scalars['String']['input']>;
  mxCivilStatus?: InputMaybe<Scalars['String']['input']>;
  mxHasFonacotLoan?: InputMaybe<Scalars['Boolean']['input']>;
  mxHasInfonavitLoan?: InputMaybe<Scalars['Boolean']['input']>;
  mxNationalId?: InputMaybe<Scalars['String']['input']>;
  mxPersonalId?: InputMaybe<Scalars['String']['input']>;
  mxRfc?: InputMaybe<Scalars['String']['input']>;
  mxSex?: InputMaybe<Scalars['String']['input']>;
  mxSocialSecurityNumber?: InputMaybe<Scalars['String']['input']>;
  mxWorkPermitId?: InputMaybe<Scalars['String']['input']>;
  myChildrenInformation?: InputMaybe<Array<ChildrenInformationInput>>;
  myEpf?: InputMaybe<Scalars['String']['input']>;
  myGender?: InputMaybe<Scalars['String']['input']>;
  myHasChildren?: InputMaybe<Scalars['String']['input']>;
  myHasCitizenship?: InputMaybe<Scalars['String']['input']>;
  myHasDisability?: InputMaybe<Scalars['String']['input']>;
  myIcNumber?: InputMaybe<Scalars['String']['input']>;
  myIncomeTaxBranch?: InputMaybe<Scalars['String']['input']>;
  myIncomeTaxNumber?: InputMaybe<Scalars['String']['input']>;
  myIncomeTaxStatus?: InputMaybe<Scalars['String']['input']>;
  myMaritalStatus?: InputMaybe<Scalars['String']['input']>;
  myPassportNumber?: InputMaybe<Scalars['String']['input']>;
  myRace?: InputMaybe<Scalars['String']['input']>;
  mySocsoNumber?: InputMaybe<Scalars['String']['input']>;
  mySpouseDisability?: InputMaybe<Scalars['String']['input']>;
  mySpouseIcNumber?: InputMaybe<Scalars['String']['input']>;
  mySpouseIncomeTaxBranch?: InputMaybe<Scalars['String']['input']>;
  mySpouseIncomeTaxNumber?: InputMaybe<Scalars['String']['input']>;
  mySpouseName?: InputMaybe<Scalars['String']['input']>;
  mySpouseTelephoneNumber?: InputMaybe<Scalars['String']['input']>;
  mySpouseWorkingStatus?: InputMaybe<Scalars['String']['input']>;
  nationality?: InputMaybe<Scalars['String']['input']>;
  ngAnnualPremiumPayment?: InputMaybe<Scalars['String']['input']>;
  ngAnnualRentPaid?: InputMaybe<Scalars['String']['input']>;
  ngGender?: InputMaybe<Scalars['String']['input']>;
  ngHasPen?: InputMaybe<Scalars['Boolean']['input']>;
  ngIdentificationNumber?: InputMaybe<Scalars['String']['input']>;
  ngIdentificationType?: InputMaybe<Scalars['String']['input']>;
  ngMaritalStatus?: InputMaybe<Scalars['String']['input']>;
  ngNhfNumber?: InputMaybe<Scalars['String']['input']>;
  ngPenNumber?: InputMaybe<Scalars['String']['input']>;
  ngPensionCustodianBankAccountNo?: InputMaybe<Scalars['String']['input']>;
  ngPensionCustodianBankName?: InputMaybe<Scalars['String']['input']>;
  ngPensionFundAdministrator?: InputMaybe<Scalars['String']['input']>;
  ngTaxIdentificationNumber?: InputMaybe<Scalars['String']['input']>;
  ngWillContributeNhf?: InputMaybe<Scalars['Boolean']['input']>;
  nlArbeidsgehandicapte?: InputMaybe<Scalars['Boolean']['input']>;
  nlBsn?: InputMaybe<Scalars['String']['input']>;
  nlThirtyPercentRulingEligible?: InputMaybe<Scalars['Boolean']['input']>;
  nlWajongBenefitsEligible?: InputMaybe<Scalars['Boolean']['input']>;
  nlWorkPermitExpirationDate?: InputMaybe<Scalars['APIDate']['input']>;
  nlWorkPermitStartDate?: InputMaybe<Scalars['APIDate']['input']>;
  nlWorkPermitType?: InputMaybe<Scalars['String']['input']>;
  paCedula?: InputMaybe<Scalars['String']['input']>;
  paCivilStatus?: InputMaybe<Scalars['String']['input']>;
  paDependentInformation?: InputMaybe<Array<PaDependentInformationInput>>;
  paEducationLevel?: InputMaybe<Scalars['String']['input']>;
  paGender?: InputMaybe<Scalars['String']['input']>;
  paPassport?: InputMaybe<Scalars['String']['input']>;
  paSocialInsuranceNumber?: InputMaybe<Scalars['String']['input']>;
  peBirthCountry?: InputMaybe<Scalars['String']['input']>;
  peBirthPlace?: InputMaybe<Scalars['String']['input']>;
  peDependentInfos?: InputMaybe<Array<PeDependentInfoInput>>;
  peGender?: InputMaybe<Scalars['String']['input']>;
  peHealthInsuranceType?: InputMaybe<Scalars['String']['input']>;
  peIdNumber?: InputMaybe<Scalars['String']['input']>;
  peIdType?: InputMaybe<Scalars['String']['input']>;
  peMaritalStatus?: InputMaybe<Scalars['String']['input']>;
  peNumDependents?: InputMaybe<Scalars['Int']['input']>;
  pePensionFund?: InputMaybe<Scalars['String']['input']>;
  pePensionFundNumber?: InputMaybe<Scalars['String']['input']>;
  phHdmfn?: InputMaybe<Scalars['String']['input']>;
  phPhicn?: InputMaybe<Scalars['String']['input']>;
  phSsn?: InputMaybe<Scalars['String']['input']>;
  phTin?: InputMaybe<Scalars['String']['input']>;
  plMaritalStatus?: InputMaybe<Scalars['String']['input']>;
  plPesel?: InputMaybe<Scalars['String']['input']>;
  plRequiresWorkPermit?: InputMaybe<Scalars['String']['input']>;
  plSex?: InputMaybe<Scalars['String']['input']>;
  preferredFirstName?: InputMaybe<Scalars['String']['input']>;
  pronouns?: InputMaybe<Scalars['String']['input']>;
  ptCc?: InputMaybe<Scalars['String']['input']>;
  ptCcExpDate?: InputMaybe<Scalars['APIDate']['input']>;
  ptCcIssDate?: InputMaybe<Scalars['APIDate']['input']>;
  ptNif?: InputMaybe<Scalars['String']['input']>;
  ptNiss?: InputMaybe<Scalars['String']['input']>;
  requireVisaSponsorship: Scalars['String']['input'];
  roPnc?: InputMaybe<Scalars['String']['input']>;
  sePersonnummer?: InputMaybe<Scalars['String']['input']>;
  settings: MemberSettingsInput;
  sgCitizenshipStatus?: InputMaybe<Scalars['String']['input']>;
  sgGender?: InputMaybe<Scalars['String']['input']>;
  sgNric?: InputMaybe<Scalars['String']['input']>;
  sgPermanentResidenceStartDate?: InputMaybe<Scalars['APIDate']['input']>;
  sgRace?: InputMaybe<Scalars['String']['input']>;
  sgShgFunds?: InputMaybe<Array<Scalars['String']['input']>>;
  trGender?: InputMaybe<Scalars['String']['input']>;
  trIncomeTaxExempt?: InputMaybe<Scalars['Boolean']['input']>;
  trMaritalStatus?: InputMaybe<Scalars['String']['input']>;
  trNumChildren6OrAbove?: InputMaybe<Scalars['Int']['input']>;
  trNumChildrenBelow6?: InputMaybe<Scalars['Int']['input']>;
  trTaxDeductionCode?: InputMaybe<Scalars['String']['input']>;
  usSsn?: InputMaybe<Scalars['String']['input']>;
  uyCid?: InputMaybe<Scalars['String']['input']>;
  uyEducationLevel?: InputMaybe<Scalars['String']['input']>;
  uyFieldOfEducation?: InputMaybe<Scalars['String']['input']>;
  uyPreviousEmploymentStatus?: InputMaybe<Scalars['String']['input']>;
  uySeguroDeSaludBps?: InputMaybe<Scalars['String']['input']>;
  zaGender?: InputMaybe<Scalars['String']['input']>;
  zaMaritalStatus?: InputMaybe<Scalars['String']['input']>;
};

/** A single requested update to the projects. If a uuid is given, the corresponding project is updated. Otherwise, it is created as a new project. */
export type ProjectUpdate = {
  projectCode?: InputMaybe<Scalars['String']['input']>;
  projectName: Scalars['String']['input'];
  uuid?: InputMaybe<Scalars['ID']['input']>;
  visible: Scalars['Boolean']['input'];
};

/** Fields that can be used to sort PTORequest notifications */
export enum PtoRequestSortBy {
  CreatedAt = 'CREATED_AT',
  EndDate = 'END_DATE',
  StartDate = 'START_DATE',
  UpdatedAt = 'UPDATED_AT'
}

/** The available sort options for the `expenseManagement.requests` node. */
export enum ReimbursementRequestSortBy {
  /** Sort by field `submittedAt`. */
  Date = 'DATE',
  /** Sort by field `name`. */
  Name = 'NAME',
  /** Sort by field `status`. */
  Status = 'STATUS',
  /** Sort by member's 'friendly' full name, last-name-first and title-ized. */
  Submitter = 'SUBMITTER',
  /** Sort by field `totalAmount`. */
  TotalAmount = 'TOTAL_AMOUNT',
  /** Sort by field `totalNonReimbursableAmount`. */
  TotalNonReimbursableAmount = 'TOTAL_NON_REIMBURSABLE_AMOUNT',
  /** Sort by field `totalReimbursableAmount`. */
  TotalReimbursableAmount = 'TOTAL_REIMBURSABLE_AMOUNT'
}

/** A single sorting 'stage' in a request to sort reimbursement requests. */
export type ReimbursementRequestSortStage = {
  by: ReimbursementRequestSortBy;
  direction: SortDirection;
};

/** The possible statuses for a reimbursement request. */
export enum ReimbursementRequestStatus {
  /** This request has been approved by an admin, and a payment was scheduled. */
  Approved = 'APPROVED',
  /** This request is awaiting review by a manager (or admin). */
  InitialReview = 'INITIAL_REVIEW',
  /** This request is awaiting final approval by an admin. */
  ReadyForApproval = 'READY_FOR_APPROVAL',
  /** This request is awaiting changes to be made by the submitting employee. */
  Returned = 'RETURNED'
}

/** A single submitted review of the reimbursement request with the given UUID. */
export type ReimbursementReviewInput = {
  expenses?: InputMaybe<Array<ExpenseInput>>;
  name?: InputMaybe<Scalars['String']['input']>;
  reason?: InputMaybe<Scalars['String']['input']>;
  type: Review;
  uuid: Scalars['ID']['input'];
};

export enum RequestStatus {
  Error = 'error',
  Processing = 'processing',
  Received = 'received',
  Staged = 'staged'
}

/** The possible types for a reimbursement review. */
export enum Review {
  /** An admin's final approval. */
  Approve = 'APPROVE',
  /** A rejection, requesting additional changes from the employee. */
  Return = 'RETURN',
  /** A manager's initial review. */
  Review = 'REVIEW'
}

/** Details about sender */
export type SenderInfo = {
  host: HostName;
  senderTrackingId: Scalars['ID']['input'];
};

/** Separation form type being edited */
export enum SeparationForm {
  /** Separation confirmation form */
  Confirmation = 'confirmation',
  /** Initial intake form with basic separation info */
  IntakeForm = 'intake_form',
  /** Partially completed initial intake form */
  IntakeFormPartial = 'intake_form_partial',
  /** Separation pay form */
  Pay = 'pay',
  /** Separation questionnaire form */
  Questionnaire = 'questionnaire',
  /** Partially completed separation questionnaire form */
  QuestionnairePartial = 'questionnaire_partial'
}

export enum SortDirection {
  Asc = 'ASC',
  Desc = 'DESC'
}

/** Details about source reference in sender */
export type SourceReference = {
  host: HostName;
  referenceId: Scalars['ID']['input'];
  referenceType: Scalars['String']['input'];
};

export enum SpendingAccountProviderName {
  Optum = 'OPTUM'
}

export enum StagedRequestStatus {
  Cancelled = 'cancelled',
  Committed = 'committed',
  Error = 'error',
  New = 'new',
  Staged = 'staged'
}

export type StepInput = {
  multiValueParam?: InputMaybe<MultiValueStepInputParam>;
  singleValueParamList?: InputMaybe<Array<StepInputParam>>;
};

export type StepInputParam = {
  name: Scalars['String']['input'];
  value: Scalars['String']['input'];
};

/** Argument grouping for EoR member onboarding tax info step */
export type TaxInfoInput = {
  auSuperannuationStandardChoiceForm?: InputMaybe<Photo>;
  auTfn?: InputMaybe<Photo>;
  bgArt45IncomeCertificate?: InputMaybe<Photo>;
  brCtps?: InputMaybe<Photo>;
  caTd1FederalForm?: InputMaybe<Photo>;
  caTd1ProvincialForm?: InputMaybe<Photo>;
  clAfp?: InputMaybe<Photo>;
  clAhs?: InputMaybe<Photo>;
  coArl?: InputMaybe<Photo>;
  coBankAccountStatement?: InputMaybe<Photo>;
  coEps?: InputMaybe<Photo>;
  coPensionFund?: InputMaybe<Photo>;
  coRegistroUnicoTributario?: InputMaybe<Photo>;
  coSeveranceFund?: InputMaybe<Photo>;
  esModelo145?: InputMaybe<Photo>;
  gbP45Form?: InputMaybe<Photo>;
  hrBankStatement?: InputMaybe<Photo>;
  hrPkKartica?: InputMaybe<Photo>;
  ilDonPizurDohKubiot?: InputMaybe<Photo>;
  ilForm101?: InputMaybe<Photo>;
  ilTaxCoordinationDocument?: InputMaybe<Photo>;
  inFormB12?: InputMaybe<Photo>;
  itRichiestaDetrazioniFiscali?: InputMaybe<Photo>;
  itRimpatriati?: InputMaybe<Photo>;
  itTesseraSanitaria?: InputMaybe<Photo>;
  itTfr?: InputMaybe<Photo>;
  keDisabledExemptionCert?: InputMaybe<Photo>;
  lvHealthExamination?: InputMaybe<Photo>;
  mxBankAccountStatement?: InputMaybe<Photo>;
  mxCsf?: InputMaybe<Photo>;
  mxProofOfAddress?: InputMaybe<Photo>;
  myBankAccountStatement?: InputMaybe<Photo>;
  myTp3Form?: InputMaybe<Photo>;
  ngRecentTaxCertificate?: InputMaybe<Photo>;
  ngStateTaxCard?: InputMaybe<Photo>;
  nlPayrollTaxes?: InputMaybe<Photo>;
  nzIr330TaxForm?: InputMaybe<Photo>;
  nzKs2KiwisaverForm?: InputMaybe<Photo>;
  nzKs10KiwisaverOptOutForm?: InputMaybe<Photo>;
  peDni?: InputMaybe<Photo>;
  peEpsCertificateOfAffiliation?: InputMaybe<Photo>;
  peRiskAssessment?: InputMaybe<Photo>;
  phForm1902?: InputMaybe<Photo>;
  prForm499r41?: InputMaybe<Photo>;
  prFormI9?: InputMaybe<Photo>;
  ptDeclaracao99?: InputMaybe<Photo>;
  roDegreeCertificate?: InputMaybe<Photo>;
  roMedicalCertificate?: InputMaybe<Photo>;
  roSixMonthIncomeCertificate?: InputMaybe<Photo>;
  seATax?: InputMaybe<Photo>;
  uyFonasaDeclaration?: InputMaybe<Photo>;
  uyForm3100?: InputMaybe<Photo>;
  zaProofOfAddress?: InputMaybe<Photo>;
  zaProofOfSarsRegistration?: InputMaybe<Photo>;
};

export enum TimeOffAwardMethod {
  Annually = 'annually',
  Daily = 'daily',
  Hourly = 'hourly',
  PtoDaily = 'pto_daily'
}

/** Possible categories for the upcoming time off event */
export enum TimeOffCategory {
  CompanyHoliday = 'company_holiday',
  Pto = 'pto'
}

export enum TimeOffRequestStatus {
  /** Approved */
  Approved = 'approved',
  /** Canceled */
  Canceled = 'canceled',
  /** Denied */
  Denied = 'denied',
  /** PTO request was created by an admin */
  Manual = 'manual',
  /** Requested */
  Requested = 'requested'
}

export enum TimeOffSortBy {
  CreatedAt = 'CREATED_AT',
  ResponseDate = 'RESPONSE_DATE',
  StartDate = 'START_DATE'
}

/** Represents a day of time within a timecard */
export type TimecardDetailItemInput = {
  date: Scalars['APIDate']['input'];
  minutes: Scalars['Int']['input'];
  multiRate?: InputMaybe<Scalars['Boolean']['input']>;
  periodWeek?: InputMaybe<Scalars['Int']['input']>;
  rateAmount: Scalars['Int']['input'];
  referenceType?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  uuid?: InputMaybe<Scalars['String']['input']>;
  wageType: TimecardDetailItemWage;
};

/** Wage type for timecard detail item */
export enum TimecardDetailItemWage {
  Doubletime = 'doubletime',
  DoubletimePremium = 'doubletime_premium',
  Overtime = 'overtime',
  OvertimePremium = 'overtime_premium',
  Pto = 'pto',
  Regular = 'regular'
}

/** Pay basis for timecard */
export enum TimecardPayBasis {
  Hourly = 'hourly',
  Salary = 'salary'
}

/** Pay Period Pay Group types */
export enum TimecardPayPeriodPayGroup {
  Biweekly = 'biweekly',
  Semimonthly = 'semimonthly',
  Weekly = 'weekly'
}

/** Status for timecard */
export enum TimecardStatus {
  Approved = 'approved',
  Canceled = 'canceled',
  New = 'new',
  Rejected = 'rejected',
  Saved = 'saved',
  Submitted = 'submitted'
}

/** The type of transaction */
export enum TransactionTypeEnum {
  Collection = 'collection',
  Disbursement = 'disbursement',
  ExternalTransfer = 'external_transfer',
  InternalFunding = 'internal_funding',
  NonWalletTransaction = 'non_wallet_transaction',
  Refund = 'refund',
  Unknown = 'unknown'
}

/** The available sort options for the `expenseManagement.unattachedExpenses` node. */
export enum UnattachedExpenseSortBy {
  /** Sort by field `amount`. */
  Amount = 'AMOUNT',
  /** Sort by field `attendees`. */
  Attendees = 'ATTENDEES',
  /** Sort by field `category.name`. */
  CategoryName = 'CATEGORY_NAME',
  /** Sort by the moment the expense was created. */
  Created = 'CREATED',
  /** Sort by field `transactionDate`. */
  Date = 'DATE',
  /** Sort by field `description`. */
  Description = 'DESCRIPTION',
  /** Sort by field `merchant`. */
  Merchant = 'MERCHANT',
  /** Sort by the moment the expense was most recently updated. */
  Updated = 'UPDATED'
}

/** A single sorting 'stage' in a request to sort unattached expenses. */
export type UnattachedExpenseSortStage = {
  by: UnattachedExpenseSortBy;
  direction: SortDirection;
};

/** Waiver object being uploaded */
export type WaiverInput = {
  effectiveDate: Scalars['String']['input'];
  employees: Array<EmployeeInput>;
  endDate: Scalars['String']['input'];
  jobDuties: Scalars['String']['input'];
  jobLocations?: InputMaybe<Array<AddressInput>>;
  jobName?: InputMaybe<Scalars['String']['input']>;
  jobNumber?: InputMaybe<Scalars['String']['input']>;
  priority?: InputMaybe<InsuranceDocumentPriority>;
};

/** Witness to the Incident */
export type Witness = {
  /** Witness Contact Information */
  contactInformation?: InputMaybe<Scalars['String']['input']>;
  /** Witness Description */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Witness Name */
  name?: InputMaybe<Scalars['String']['input']>;
};

/** Data about missing work due to the incident */
export type WorkStatus = {
  /** End of time out from work */
  endTimeOut?: InputMaybe<Scalars['APIDateTime']['input']>;
  /** Were they paid for missing work? */
  paid?: InputMaybe<Scalars['Boolean']['input']>;
  /** Beginning of time out from work */
  startTimeOut?: InputMaybe<Scalars['APIDateTime']['input']>;
};

/** Workflow states */
export enum WorkflowState {
  Complete = 'complete',
  ContactInfo = 'contact_info',
  IdVerification = 'id_verification',
  PaymentInfo = 'payment_info',
  ProfileInfo = 'profile_info',
  TaxInfo = 'tax_info'
}

export enum WorkflowStepStatus {
  /** Canceled */
  Canceled = 'canceled',
  /** Completed */
  Completed = 'completed',
  /** In Progress */
  InProgress = 'in_progress',
  /** Not started */
  NotStarted = 'not_started'
}

export enum WorkflowStepTypeName {
  ActionRequiredDocument = 'action_required_document',
  BankInfo = 'bank_info',
  BasicInfo = 'basic_info',
  BasicReview = 'basic_review',
  ContactInfo = 'contact_info',
  I9Info = 'i9_info',
  I9Review = 'i9_review',
  I9Sign = 'i9_sign',
  NycSafeSickLeave = 'nyc_safe_sick_leave',
  OtherDocuments = 'other_documents',
  PostOnboardingStatusUpdate = 'post_onboarding_status_update',
  TaxInfo = 'tax_info',
  WorksiteEmployeeAcknowledgement = 'worksite_employee_acknowledgement'
}

export const FirmListFieldsFragmentDoc = gql`
    fragment FirmListFields on Firm {
  uuid
  name
  status
  permissions
  invitation {
    uuid
    email
    fullName
  }
  firmMembers {
    uuid
    name
    title
    phone
    email
  }
}
    `;
export const ClPersonalInfoFieldsFragmentDoc = gql`
    fragment clPersonalInfoFields on PersonalInfo {
  clAfpAgencyName
  clHealthAgencyName
  clHealthPlan
  clRut
}
    `;
export const CoPersonalInfoFieldsFragmentDoc = gql`
    fragment coPersonalInfoFields on PersonalInfo {
  coCedulaDeCiudadania
  coNombreArl
  coNombreEps
  coNombreFondoDePensiones
}
    `;
export const CrPersonalInfoFieldsFragmentDoc = gql`
    fragment crPersonalInfoFields on PersonalInfo {
  crCcss
  crCedulaDeIdentidad
  crIns
  crMaritalStatus
  crNumChildren
  crSpouse
}
    `;
export const MxPersonalInfoFieldsFragmentDoc = gql`
    fragment mxPersonalInfoFields on PersonalInfo {
  mxNationalId
  mxPersonalId
  mxSocialSecurityNumber
  mxWorkPermitId
  mxHasFonacotLoan
  mxHasInfonavitLoan
  mxRfc
}
    `;
export const PtPersonalInfoFieldsFragmentDoc = gql`
    fragment ptPersonalInfoFields on PersonalInfo {
  ptCc
  ptCcExpDate
  ptCcIssDate
  ptNif
  ptNiss
}
    `;
export const InPersonalInfoFieldsFragmentDoc = gql`
    fragment inPersonalInfoFields on PersonalInfo {
  inEsic
  inPfUan
  inAadharNumber
  inPan
}
    `;
export const EsPersonalInfoFieldsFragmentDoc = gql`
    fragment esPersonalInfoFields on PersonalInfo {
  esChildrensBirthDates
  esDni
  esEducationalQualification
  esMaritalStatus
  esNie
  esNumChildren
  esSsn
}
    `;
export const IePersonalInfoFieldsFragmentDoc = gql`
    fragment iePersonalInfoFields on PersonalInfo {
  ieMaritalStatus
  iePps
}
    `;
export const BrPersonalInfoFieldsFragmentDoc = gql`
    fragment brPersonalInfoFields on PersonalInfo {
  brCityOfBirth
  brEducationalQualification
  brEthnicity
  brGender
  brMaritalStatus
  brPersonalId
  brPis
  brRgIssuingBody
  brRgStateOfIssue
  brStateOfBirth
  brWorkPermitStatus
  brCpf
}
    `;
export const PhPersonalInfoFieldsFragmentDoc = gql`
    fragment phPersonalInfoFields on PersonalInfo {
  phSsn
  phPhicn
  phHdmfn
  phTin
}
    `;
export const GrPersonalInfoFieldsFragmentDoc = gql`
    fragment grPersonalInfoFields on PersonalInfo {
  grFirstInsuranceDate
  grIdentityCardNumber
  grMaritalStatus
  grNameOfFather
  grNameOfMother
  grNumberOfChildren
  grRevenueOffice
  grSex
  grSocialInsuranceNumber
  grSocialSecurityNumber
  grVat
}
    `;
export const MxRoleFieldsFragmentDoc = gql`
    fragment mxRoleFields on Role {
  mxChristmasBonusDays
}
    `;
export const MyPersonalInfoFieldsFragmentDoc = gql`
    fragment myPersonalInfoFields on PersonalInfo {
  myEpf
  myGender
  myHasCitizenship
  myHasDisability
  myIcNumber
  myIncomeTaxBranch
  myIncomeTaxNumber
  myIncomeTaxStatus
  myChildrenInformation {
    name
    dateOfBirth
    educationLevel
    gender
    icNumber
    taxClaim
  }
  myMaritalStatus
  myPassportNumber
  myRace
  mySocsoNumber
  mySpouseName
  mySpouseIcNumber
  mySpouseWorkingStatus
  mySpouseDisability
  mySpouseIncomeTaxNumber
  mySpouseIncomeTaxBranch
  mySpouseTelephoneNumber
  myHasChildren
}
    `;
export const NlPersonalInfoFieldsFragmentDoc = gql`
    fragment nlPersonalInfoFields on PersonalInfo {
  nlBsn
}
    `;
export const DePersonalInfoFieldsFragmentDoc = gql`
    fragment dePersonalInfoFields on PersonalInfo {
  deCountryOfBirth
  deMainEmployer
  dePensionInsuranceNumber
  deHealthInsuranceStatus
  deHealthInsuranceProvider
  deReligion
  deSchoolDegree
  deTaxClass
  deProfessionalQualification
  deMaritalStatus
  deEligibleChildren
  deIdnr
}
    `;
export const AuPersonalInfoFieldsFragmentDoc = gql`
    fragment auPersonalInfoFields on PersonalInfo {
  auTfn
}
    `;
export const CaPersonalInfoFieldsFragmentDoc = gql`
    fragment caPersonalInfoFields on PersonalInfo {
  caSin
}
    `;
export const DkPersonalInfoFieldsFragmentDoc = gql`
    fragment dkPersonalInfoFields on PersonalInfo {
  dkCpr
}
    `;
export const EePersonalInfoFieldsFragmentDoc = gql`
    fragment eePersonalInfoFields on PersonalInfo {
  eeIk
}
    `;
export const FrPersonalInfoFieldsFragmentDoc = gql`
    fragment frPersonalInfoFields on PersonalInfo {
  frSsn
}
    `;
export const GbPersonalInfoFieldsFragmentDoc = gql`
    fragment gbPersonalInfoFields on PersonalInfo {
  gbNino
}
    `;
export const NgPersonalInfoFieldsFragmentDoc = gql`
    fragment ngPersonalInfoFields on PersonalInfo {
  ngIdentificationType
  ngIdentificationNumber
  ngHasPen
  ngPenNumber
  ngPensionFundAdministrator
  ngPensionCustodianBankName
  ngPensionCustodianBankAccountNo
  ngWillContributeNhf
  ngNhfNumber
  ngAnnualRentPaid
  ngAnnualPremiumPayment
  ngMaritalStatus
  ngGender
  ngTaxIdentificationNumber
}
    `;
export const KePersonalInfoFieldsFragmentDoc = gql`
    fragment kePersonalInfoFields on PersonalInfo {
  keGender
  keKraPin
  keIdentityType
  keNationalId
  keForeignId
  keTaxStatus
  keNssfNumber
  keShifNumber
  keDisabledExemptionCertNumber
}
    `;
export const PaPersonalInfoFieldsFragmentDoc = gql`
    fragment paPersonalInfoFields on PersonalInfo {
  paCedula
  paPassport
  paCivilStatus
  paGender
  paEducationLevel
  paSocialInsuranceNumber
  paDependentInformation {
    firstName
    lastName
    dependentType
  }
}
    `;
export const PlPersonalInfoFieldsFragmentDoc = gql`
    fragment plPersonalInfoFields on PersonalInfo {
  plPesel
}
    `;
export const RoPersonalInfoFieldsFragmentDoc = gql`
    fragment roPersonalInfoFields on PersonalInfo {
  roPnc
}
    `;
export const SePersonalInfoFieldsFragmentDoc = gql`
    fragment sePersonalInfoFields on PersonalInfo {
  sePersonnummer
}
    `;
export const SgPersonalInfoFieldsFragmentDoc = gql`
    fragment sgPersonalInfoFields on PersonalInfo {
  sgNric
}
    `;
export const UsPersonalInfoFieldsFragmentDoc = gql`
    fragment usPersonalInfoFields on PersonalInfo {
  usSsn
}
    `;
export const UyPersonalInfoFieldsFragmentDoc = gql`
    fragment uyPersonalInfoFields on PersonalInfo {
  uyCid
  uySeguroDeSaludBps
  uyPreviousEmploymentStatus
  uyEducationLevel
  uyFieldOfEducation
}
    `;
export const MxEmploymentFieldsFragmentDoc = gql`
    fragment mxEmploymentFields on Employment {
  mxIsRemoteWork
}
    `;
export const AuAdditionalFieldsFragmentDoc = gql`
    fragment AuAdditionalFields on ProfileInfo {
  auTitle
  auGender
}
    `;
export const BrAdditionalFieldsFragmentDoc = gql`
    fragment BrAdditionalFields on ProfileInfo {
  brRgIssuingBody
}
    `;
export const ClAdditionalFieldsFragmentDoc = gql`
    fragment ClAdditionalFields on ProfileInfo {
  clHealthPlan
  clHealthAgencyName
  clAfpAgencyName
}
    `;
export const CoAdditionalFieldsFragmentDoc = gql`
    fragment CoAdditionalFields on ProfileInfo {
  coCedulaDeCiudadania
}
    `;
export const CrAdditionalFieldsFragmentDoc = gql`
    fragment CrAdditionalFields on ProfileInfo {
  crCcss
  crCedulaDeIdentidad
  crIns
  crMaritalStatus
  crNumChildren
  crSpouse
}
    `;
export const EsAdditionalFieldsFragmentDoc = gql`
    fragment EsAdditionalFields on ProfileInfo {
  esDateSinceResidentOfSpain
  esSex
  esMaritalStatus
  esNumChildren
  esChildrensBirthDates
  esEducationalQualification
  esUnemploymentStatus
}
    `;
export const HrAdditionalFieldsFragmentDoc = gql`
    fragment HrAdditionalFields on ProfileInfo {
  hrJmbg
  hrOib
  hrEducationLevel
  hrPensionInsuranceNumber
  hrDrugiSetup
}
    `;
export const IeAdditionalFieldsFragmentDoc = gql`
    fragment IeAdditionalFields on ProfileInfo {
  ieMaritalStatus
}
    `;
export const InAdditionalFieldsFragmentDoc = gql`
    fragment InAdditionalFields on ProfileInfo {
  inPfUan
  inEsic
  inYearToDateTaxableSalary
  inYearToDateExemptions
  inYearToDateTds
  inTaxRegime
  inMaritalStatus
}
    `;
export const ItAdditionalFieldsFragmentDoc = gql`
    fragment ItAdditionalFields on ProfileInfo {
  itBirthplace
  itCodiceFiscale
  itEducationalLevel
}
    `;
export const MxAdditionalFieldsFragmentDoc = gql`
    fragment MxAdditionalFields on ProfileInfo {
  mxSex
  mxCivilStatus
  mxHasInfonavitLoan
  mxHasFonacotLoan
}
    `;
export const NlAdditionalFieldsFragmentDoc = gql`
    fragment NlAdditionalFields on ProfileInfo {
  nlArbeidsgehandicapte
  nlWajongBenefitsEligible
  nlThirtyPercentRulingEligible
  nlWorkPermitType
  nlWorkPermitStartDate
  nlWorkPermitExpirationDate
}
    `;
export const NgAdditionalFieldsFragmentDoc = gql`
    fragment NgAdditionalFields on ProfileInfo {
  ngIdentificationType
  ngIdentificationNumber
  ngHasPen
  ngPenNumber
  ngPensionFundAdministrator
  ngPensionCustodianBankName
  ngPensionCustodianBankAccountNo
  ngWillContributeNhf
  ngNhfNumber
  ngAnnualRentPaid
  ngAnnualPremiumPayment
  ngMaritalStatus
  ngGender
}
    `;
export const KeAdditionalFieldsFragmentDoc = gql`
    fragment KeAdditionalFields on ProfileInfo {
  keGender
  keKraPin
  keIdentityType
  keNationalId
  keForeignId
  keTaxStatus
  keNssfNumber
  keShifNumber
  keDisabledExemptionCertNumber
}
    `;
export const PaAdditionalFieldsFragmentDoc = gql`
    fragment PaAdditionalFields on ProfileInfo {
  paCedula
  paPassport
  paCivilStatus
  paGender
  paEducationLevel
  paSocialInsuranceNumber
  paDependentInformation {
    firstName
    lastName
    dependentType
  }
}
    `;
export const PhAdditionalFieldsFragmentDoc = gql`
    fragment PhAdditionalFields on ProfileInfo {
  phSsn
  phPhicn
  phHdmfn
}
    `;
export const SgAdditionalFieldsFragmentDoc = gql`
    fragment SgAdditionalFields on ProfileInfo {
  sgGender
  sgShgFunds
  sgCitizenshipStatus
  sgRace
  sgPermanentResidenceStartDate
}
    `;
export const GrAdditionalFieldsFragmentDoc = gql`
    fragment GrAdditionalFields on ProfileInfo {
  grFirstInsuranceDate
  grIdentityCardNumber
  grMaritalStatus
  grNameOfFather
  grNameOfMother
  grNumberOfChildren
  grRevenueOffice
  grSex
  grSocialInsuranceNumber
  grSocialSecurityNumber
}
    `;
export const MyAdditionalFieldsFragmentDoc = gql`
    fragment MyAdditionalFields on ProfileInfo {
  myEpf
  myGender
  myHasCitizenship
  myHasDisability
  myIcNumber
  myIncomeTaxBranch
  myIncomeTaxNumber
  myIncomeTaxStatus
  myChildrenInformation {
    name
    dateOfBirth
    educationLevel
    gender
    icNumber
    taxClaim
  }
  myMaritalStatus
  myPassportNumber
  myRace
  mySocsoNumber
  mySpouseName
  mySpouseIcNumber
  mySpouseWorkingStatus
  mySpouseDisability
  mySpouseIncomeTaxNumber
  mySpouseIncomeTaxBranch
  mySpouseTelephoneNumber
  myHasChildren
}
    `;
export const PeAdditionalFieldsFragmentDoc = gql`
    fragment PeAdditionalFields on ProfileInfo {
  peGender
  peHealthInsuranceType
  peMaritalStatus
  peBirthCountry
  peBirthPlace
  pePensionFund
  pePensionFundNumber
  peIdType
  peIdNumber
}
    `;
export const TrAdditionalFieldsFragmentDoc = gql`
    fragment TrAdditionalFields on ProfileInfo {
  trGender
  trIncomeTaxExempt
  trMaritalStatus
  trNumChildren6OrAbove
  trNumChildrenBelow6
  trTaxDeductionCode
}
    `;
export const PlAdditionalFieldsFragmentDoc = gql`
    fragment PlAdditionalFields on ProfileInfo {
  plMaritalStatus
  plSex
  plRequiresWorkPermit
}
    `;
export const ZaAdditionalFieldsFragmentDoc = gql`
    fragment ZaAdditionalFields on ProfileInfo {
  zaGender
  zaMaritalStatus
}
    `;
export const UsAdditionalFieldsFragmentDoc = gql`
    fragment UsAdditionalFields on ProfileInfo {
  usSsn
}
    `;
export const UyAdditionalFieldsFragmentDoc = gql`
    fragment UyAdditionalFields on ProfileInfo {
  uyCid
  uySeguroDeSaludBps
  uyPreviousEmploymentStatus
  uyEducationLevel
  uyFieldOfEducation
}
    `;
export const ApproveDenyTimeOffRequestDocument = gql`
    mutation ApproveDenyTimeOffRequest($memberUuid: String!, $notesPrivate: String, $notesPublic: String, $status: ApproveDenyTimeOffRequestStatus!, $timeOffRequestUuid: String!) {
  approveDenyTimeOffRequest(
    memberUuid: $memberUuid
    notesPrivate: $notesPrivate
    notesPublic: $notesPublic
    status: $status
    timeOffRequestUuid: $timeOffRequestUuid
  ) {
    success
    userErrors {
      inputField
      message
    }
  }
}
    `;
export type ApproveDenyTimeOffRequestMutationFn = Apollo.MutationFunction<ApproveDenyTimeOffRequestMutation, ApproveDenyTimeOffRequestMutationVariables>;

/**
 * __useApproveDenyTimeOffRequestMutation__
 *
 * To run a mutation, you first call `useApproveDenyTimeOffRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useApproveDenyTimeOffRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [approveDenyTimeOffRequestMutation, { data, loading, error }] = useApproveDenyTimeOffRequestMutation({
 *   variables: {
 *      memberUuid: // value for 'memberUuid'
 *      notesPrivate: // value for 'notesPrivate'
 *      notesPublic: // value for 'notesPublic'
 *      status: // value for 'status'
 *      timeOffRequestUuid: // value for 'timeOffRequestUuid'
 *   },
 * });
 */
export function useApproveDenyTimeOffRequestMutation(baseOptions?: Apollo.MutationHookOptions<ApproveDenyTimeOffRequestMutation, ApproveDenyTimeOffRequestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ApproveDenyTimeOffRequestMutation, ApproveDenyTimeOffRequestMutationVariables>(ApproveDenyTimeOffRequestDocument, options);
      }
export type ApproveDenyTimeOffRequestMutationHookResult = ReturnType<typeof useApproveDenyTimeOffRequestMutation>;
export type ApproveDenyTimeOffRequestMutationResult = Apollo.MutationResult<ApproveDenyTimeOffRequestMutation>;
export type ApproveDenyTimeOffRequestMutationOptions = Apollo.BaseMutationOptions<ApproveDenyTimeOffRequestMutation, ApproveDenyTimeOffRequestMutationVariables>;
export const GetCompanyDisplayDocument = gql`
    query GetCompanyDisplay {
  authenticatedMember {
    uuid
    company {
      uuid
      name
    }
  }
}
    `;

/**
 * __useGetCompanyDisplayQuery__
 *
 * To run a query within a React component, call `useGetCompanyDisplayQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCompanyDisplayQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCompanyDisplayQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCompanyDisplayQuery(baseOptions?: Apollo.QueryHookOptions<GetCompanyDisplayQuery, GetCompanyDisplayQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCompanyDisplayQuery, GetCompanyDisplayQueryVariables>(GetCompanyDisplayDocument, options);
      }
export function useGetCompanyDisplayLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCompanyDisplayQuery, GetCompanyDisplayQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCompanyDisplayQuery, GetCompanyDisplayQueryVariables>(GetCompanyDisplayDocument, options);
        }
export function useGetCompanyDisplaySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCompanyDisplayQuery, GetCompanyDisplayQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCompanyDisplayQuery, GetCompanyDisplayQueryVariables>(GetCompanyDisplayDocument, options);
        }
export type GetCompanyDisplayQueryHookResult = ReturnType<typeof useGetCompanyDisplayQuery>;
export type GetCompanyDisplayLazyQueryHookResult = ReturnType<typeof useGetCompanyDisplayLazyQuery>;
export type GetCompanyDisplaySuspenseQueryHookResult = ReturnType<typeof useGetCompanyDisplaySuspenseQuery>;
export type GetCompanyDisplayQueryResult = Apollo.QueryResult<GetCompanyDisplayQuery, GetCompanyDisplayQueryVariables>;
export const GetHelpMenuDocument = gql`
    query GetHelpMenu {
  authenticatedMember {
    uuid
    capabilities {
      hasAccessToAdvancedHelpChat
    }
    company {
      uuid
      accountManager {
        emailExternal
        isDesignatedAccountManager
        name
        phone
        primaryPhotoUrl
        secondaryPhotoUrl
      }
    }
  }
}
    `;

/**
 * __useGetHelpMenuQuery__
 *
 * To run a query within a React component, call `useGetHelpMenuQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetHelpMenuQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetHelpMenuQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetHelpMenuQuery(baseOptions?: Apollo.QueryHookOptions<GetHelpMenuQuery, GetHelpMenuQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetHelpMenuQuery, GetHelpMenuQueryVariables>(GetHelpMenuDocument, options);
      }
export function useGetHelpMenuLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetHelpMenuQuery, GetHelpMenuQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetHelpMenuQuery, GetHelpMenuQueryVariables>(GetHelpMenuDocument, options);
        }
export function useGetHelpMenuSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetHelpMenuQuery, GetHelpMenuQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetHelpMenuQuery, GetHelpMenuQueryVariables>(GetHelpMenuDocument, options);
        }
export type GetHelpMenuQueryHookResult = ReturnType<typeof useGetHelpMenuQuery>;
export type GetHelpMenuLazyQueryHookResult = ReturnType<typeof useGetHelpMenuLazyQuery>;
export type GetHelpMenuSuspenseQueryHookResult = ReturnType<typeof useGetHelpMenuSuspenseQuery>;
export type GetHelpMenuQueryResult = Apollo.QueryResult<GetHelpMenuQuery, GetHelpMenuQueryVariables>;
export const GetMemberAlertsDocument = gql`
    query GetMemberAlerts {
  currentMember {
    uuid
    notificationsCount
    notificationList {
      i9ToSign {
        count
        notifications {
          addedToNotificationCount
          message
          priority
          type
          url
          member {
            preferredName
            lastName
            photoUrl
          }
        }
      }
      irsRequired {
        count
        notifications {
          addedToNotificationCount
          message
          priority
          type
          url
        }
      }
      irsVerified {
        count
        notifications {
          addedToNotificationCount
          message
          priority
          type
          url
        }
      }
      missingBankAccount {
        count
        notifications {
          addedToNotificationCount
          message
          priority
          type
          url
        }
      }
      pennyTest {
        count
        notifications {
          addedToNotificationCount
          message
          priority
          type
          url
        }
      }
      processingSuspended {
        count
        notifications {
          addedToNotificationCount
          message
          priority
          type
          url
        }
      }
      ptoRequest {
        count
        notifications {
          addedToNotificationCount
          approvalUrl
          message
          priority
          timeOffUuid
          type
          url
          member {
            preferredName
            lastName
            photoUrl
            uuid
          }
        }
      }
      unpaidEmployees {
        count
        notifications {
          addedToNotificationCount
          message
          priority
          type
          url
        }
      }
      upcomingHolidays {
        count
        notifications {
          addedToNotificationCount
          message
          priority
          type
        }
      }
      upgradePending {
        count
        notifications {
          addedToNotificationCount
          message
          priority
          type
        }
      }
      atsPendingHire {
        count
        notifications {
          addedToNotificationCount
          message
          priority
          type
          url
        }
      }
      pmtIntegrationAlerts {
        count
        notifications {
          addedToNotificationCount
          message
          priority
          type
          integrationName
          url
        }
      }
      reimbursementRequests {
        count
        notifications {
          type
          message
          priority
          addedToNotificationCount
        }
      }
      directReportsUpcomingHolidays {
        count
        notifications {
          type
          message
          priority
          addedToNotificationCount
          url
          member {
            preferredName
            lastName
            photoUrl
            uuid
          }
        }
      }
      nsfNotifications {
        count
        notifications {
          type
          message
          priority
          url
          returnCode
          addedToNotificationCount
        }
      }
      reconnectPlaid {
        count
        notifications {
          type
          message
          priority
          url
          addedToNotificationCount
        }
      }
      connectBankAccount {
        count
        notifications {
          type
          message
          priority
          url
          addedToNotificationCount
        }
      }
      confirmBankDeposits {
        count
        notifications {
          type
          message
          priority
          url
          addedToNotificationCount
        }
      }
      continueHiUpsellApp {
        count
        notifications {
          type
          message
          priority
          url
          addedToNotificationCount
        }
      }
      pendingFirmInvitation {
        count
        notifications {
          addedToNotificationCount
          message
          priority
          url
          member {
            preferredName
            lastName
            photoUrl
            uuid
          }
        }
      }
      taxExemptionRenewals {
        count
        notifications {
          addedToNotificationCount
          message
          priority
          type
          url
        }
      }
    }
  }
}
    `;

/**
 * __useGetMemberAlertsQuery__
 *
 * To run a query within a React component, call `useGetMemberAlertsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMemberAlertsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMemberAlertsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetMemberAlertsQuery(baseOptions?: Apollo.QueryHookOptions<GetMemberAlertsQuery, GetMemberAlertsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMemberAlertsQuery, GetMemberAlertsQueryVariables>(GetMemberAlertsDocument, options);
      }
export function useGetMemberAlertsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMemberAlertsQuery, GetMemberAlertsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMemberAlertsQuery, GetMemberAlertsQueryVariables>(GetMemberAlertsDocument, options);
        }
export function useGetMemberAlertsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetMemberAlertsQuery, GetMemberAlertsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetMemberAlertsQuery, GetMemberAlertsQueryVariables>(GetMemberAlertsDocument, options);
        }
export type GetMemberAlertsQueryHookResult = ReturnType<typeof useGetMemberAlertsQuery>;
export type GetMemberAlertsLazyQueryHookResult = ReturnType<typeof useGetMemberAlertsLazyQuery>;
export type GetMemberAlertsSuspenseQueryHookResult = ReturnType<typeof useGetMemberAlertsSuspenseQuery>;
export type GetMemberAlertsQueryResult = Apollo.QueryResult<GetMemberAlertsQuery, GetMemberAlertsQueryVariables>;
export const GetNavigationGroupsDocument = gql`
    query GetNavigationGroups {
  authenticatedMember {
    uuid
    routeDirectory {
      groupName
      standaloneContent
      navItems {
        path
        displayText
        hasBadge
        outstandingTaskCount
        isBoxCallout
        secondaryText
        badge {
          type
          text
          imageUrl
        }
      }
    }
  }
}
    `;

/**
 * __useGetNavigationGroupsQuery__
 *
 * To run a query within a React component, call `useGetNavigationGroupsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetNavigationGroupsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetNavigationGroupsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetNavigationGroupsQuery(baseOptions?: Apollo.QueryHookOptions<GetNavigationGroupsQuery, GetNavigationGroupsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetNavigationGroupsQuery, GetNavigationGroupsQueryVariables>(GetNavigationGroupsDocument, options);
      }
export function useGetNavigationGroupsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetNavigationGroupsQuery, GetNavigationGroupsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetNavigationGroupsQuery, GetNavigationGroupsQueryVariables>(GetNavigationGroupsDocument, options);
        }
export function useGetNavigationGroupsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetNavigationGroupsQuery, GetNavigationGroupsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetNavigationGroupsQuery, GetNavigationGroupsQueryVariables>(GetNavigationGroupsDocument, options);
        }
export type GetNavigationGroupsQueryHookResult = ReturnType<typeof useGetNavigationGroupsQuery>;
export type GetNavigationGroupsLazyQueryHookResult = ReturnType<typeof useGetNavigationGroupsLazyQuery>;
export type GetNavigationGroupsSuspenseQueryHookResult = ReturnType<typeof useGetNavigationGroupsSuspenseQuery>;
export type GetNavigationGroupsQueryResult = Apollo.QueryResult<GetNavigationGroupsQuery, GetNavigationGroupsQueryVariables>;
export const GetUserInfoDocument = gql`
    query GetUserInfo {
  currentMember {
    uuid
    company {
      uuid
      directoryMembersWithoutInviteStatusCheck {
        firstName
        lastName
        uuid
      }
    }
  }
}
    `;

/**
 * __useGetUserInfoQuery__
 *
 * To run a query within a React component, call `useGetUserInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserInfoQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetUserInfoQuery(baseOptions?: Apollo.QueryHookOptions<GetUserInfoQuery, GetUserInfoQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserInfoQuery, GetUserInfoQueryVariables>(GetUserInfoDocument, options);
      }
export function useGetUserInfoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserInfoQuery, GetUserInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserInfoQuery, GetUserInfoQueryVariables>(GetUserInfoDocument, options);
        }
export function useGetUserInfoSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetUserInfoQuery, GetUserInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetUserInfoQuery, GetUserInfoQueryVariables>(GetUserInfoDocument, options);
        }
export type GetUserInfoQueryHookResult = ReturnType<typeof useGetUserInfoQuery>;
export type GetUserInfoLazyQueryHookResult = ReturnType<typeof useGetUserInfoLazyQuery>;
export type GetUserInfoSuspenseQueryHookResult = ReturnType<typeof useGetUserInfoSuspenseQuery>;
export type GetUserInfoQueryResult = Apollo.QueryResult<GetUserInfoQuery, GetUserInfoQueryVariables>;
export const GetUserMenuDocument = gql`
    query GetUserMenu {
  authenticatedMember {
    firstName
    lastName
    photoUrl
    uuid
    company {
      uuid
    }
    capabilities {
      hasAccessToCsTools
      hasAccessToProfileView
    }
  }
  authenticatedUser {
    uuid
    members {
      uuid
      company {
        uuid
        name
      }
    }
  }
  currentUserProductsAndCompanies {
    product
    companyName
    companyLegacyUuid
    companyCanonicalId
    isActive
    isSelected
    redirectUrl
  }
}
    `;

/**
 * __useGetUserMenuQuery__
 *
 * To run a query within a React component, call `useGetUserMenuQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserMenuQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserMenuQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetUserMenuQuery(baseOptions?: Apollo.QueryHookOptions<GetUserMenuQuery, GetUserMenuQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserMenuQuery, GetUserMenuQueryVariables>(GetUserMenuDocument, options);
      }
export function useGetUserMenuLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserMenuQuery, GetUserMenuQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserMenuQuery, GetUserMenuQueryVariables>(GetUserMenuDocument, options);
        }
export function useGetUserMenuSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetUserMenuQuery, GetUserMenuQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetUserMenuQuery, GetUserMenuQueryVariables>(GetUserMenuDocument, options);
        }
export type GetUserMenuQueryHookResult = ReturnType<typeof useGetUserMenuQuery>;
export type GetUserMenuLazyQueryHookResult = ReturnType<typeof useGetUserMenuLazyQuery>;
export type GetUserMenuSuspenseQueryHookResult = ReturnType<typeof useGetUserMenuSuspenseQuery>;
export type GetUserMenuQueryResult = Apollo.QueryResult<GetUserMenuQuery, GetUserMenuQueryVariables>;
export const GetUserNavCapabilitiesDocument = gql`
    query GetUserNavCapabilities {
  authenticatedMember {
    uuid
    capabilities {
      hasAccessToMemberSearch
      hasAccessToReceiveAppAlerts
      hasAccessToWhatsNewProductPosts
    }
  }
}
    `;

/**
 * __useGetUserNavCapabilitiesQuery__
 *
 * To run a query within a React component, call `useGetUserNavCapabilitiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserNavCapabilitiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserNavCapabilitiesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetUserNavCapabilitiesQuery(baseOptions?: Apollo.QueryHookOptions<GetUserNavCapabilitiesQuery, GetUserNavCapabilitiesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserNavCapabilitiesQuery, GetUserNavCapabilitiesQueryVariables>(GetUserNavCapabilitiesDocument, options);
      }
export function useGetUserNavCapabilitiesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserNavCapabilitiesQuery, GetUserNavCapabilitiesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserNavCapabilitiesQuery, GetUserNavCapabilitiesQueryVariables>(GetUserNavCapabilitiesDocument, options);
        }
export function useGetUserNavCapabilitiesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetUserNavCapabilitiesQuery, GetUserNavCapabilitiesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetUserNavCapabilitiesQuery, GetUserNavCapabilitiesQueryVariables>(GetUserNavCapabilitiesDocument, options);
        }
export type GetUserNavCapabilitiesQueryHookResult = ReturnType<typeof useGetUserNavCapabilitiesQuery>;
export type GetUserNavCapabilitiesLazyQueryHookResult = ReturnType<typeof useGetUserNavCapabilitiesLazyQuery>;
export type GetUserNavCapabilitiesSuspenseQueryHookResult = ReturnType<typeof useGetUserNavCapabilitiesSuspenseQuery>;
export type GetUserNavCapabilitiesQueryResult = Apollo.QueryResult<GetUserNavCapabilitiesQuery, GetUserNavCapabilitiesQueryVariables>;
export const GetWhatsNewPostsDocument = gql`
    query GetWhatsNewPosts {
  currentMember {
    uuid
    productPosts {
      unseenPostsCount
      posts {
        category
        url
        image
        date
        title
        description
        seen
        callToAction
      }
    }
  }
}
    `;

/**
 * __useGetWhatsNewPostsQuery__
 *
 * To run a query within a React component, call `useGetWhatsNewPostsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWhatsNewPostsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWhatsNewPostsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetWhatsNewPostsQuery(baseOptions?: Apollo.QueryHookOptions<GetWhatsNewPostsQuery, GetWhatsNewPostsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetWhatsNewPostsQuery, GetWhatsNewPostsQueryVariables>(GetWhatsNewPostsDocument, options);
      }
export function useGetWhatsNewPostsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetWhatsNewPostsQuery, GetWhatsNewPostsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetWhatsNewPostsQuery, GetWhatsNewPostsQueryVariables>(GetWhatsNewPostsDocument, options);
        }
export function useGetWhatsNewPostsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetWhatsNewPostsQuery, GetWhatsNewPostsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetWhatsNewPostsQuery, GetWhatsNewPostsQueryVariables>(GetWhatsNewPostsDocument, options);
        }
export type GetWhatsNewPostsQueryHookResult = ReturnType<typeof useGetWhatsNewPostsQuery>;
export type GetWhatsNewPostsLazyQueryHookResult = ReturnType<typeof useGetWhatsNewPostsLazyQuery>;
export type GetWhatsNewPostsSuspenseQueryHookResult = ReturnType<typeof useGetWhatsNewPostsSuspenseQuery>;
export type GetWhatsNewPostsQueryResult = Apollo.QueryResult<GetWhatsNewPostsQuery, GetWhatsNewPostsQueryVariables>;
export const MarkProductUpdatesAsSeenDocument = gql`
    mutation MarkProductUpdatesAsSeen {
  markProductUpdatesAsSeen {
    userErrors {
      message
    }
    success
  }
}
    `;
export type MarkProductUpdatesAsSeenMutationFn = Apollo.MutationFunction<MarkProductUpdatesAsSeenMutation, MarkProductUpdatesAsSeenMutationVariables>;

/**
 * __useMarkProductUpdatesAsSeenMutation__
 *
 * To run a mutation, you first call `useMarkProductUpdatesAsSeenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkProductUpdatesAsSeenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markProductUpdatesAsSeenMutation, { data, loading, error }] = useMarkProductUpdatesAsSeenMutation({
 *   variables: {
 *   },
 * });
 */
export function useMarkProductUpdatesAsSeenMutation(baseOptions?: Apollo.MutationHookOptions<MarkProductUpdatesAsSeenMutation, MarkProductUpdatesAsSeenMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MarkProductUpdatesAsSeenMutation, MarkProductUpdatesAsSeenMutationVariables>(MarkProductUpdatesAsSeenDocument, options);
      }
export type MarkProductUpdatesAsSeenMutationHookResult = ReturnType<typeof useMarkProductUpdatesAsSeenMutation>;
export type MarkProductUpdatesAsSeenMutationResult = Apollo.MutationResult<MarkProductUpdatesAsSeenMutation>;
export type MarkProductUpdatesAsSeenMutationOptions = Apollo.BaseMutationOptions<MarkProductUpdatesAsSeenMutation, MarkProductUpdatesAsSeenMutationVariables>;
export const SwitchCompaniesDocument = gql`
    mutation SwitchCompanies($targetCompanyCanonicalId: String, $targetCompanyUuid: String) {
  switchCompanies(
    targetCompanyCanonicalId: $targetCompanyCanonicalId
    targetCompanyUuid: $targetCompanyUuid
  ) {
    success
    userErrors {
      message
    }
  }
}
    `;
export type SwitchCompaniesMutationFn = Apollo.MutationFunction<SwitchCompaniesMutation, SwitchCompaniesMutationVariables>;

/**
 * __useSwitchCompaniesMutation__
 *
 * To run a mutation, you first call `useSwitchCompaniesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSwitchCompaniesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [switchCompaniesMutation, { data, loading, error }] = useSwitchCompaniesMutation({
 *   variables: {
 *      targetCompanyCanonicalId: // value for 'targetCompanyCanonicalId'
 *      targetCompanyUuid: // value for 'targetCompanyUuid'
 *   },
 * });
 */
export function useSwitchCompaniesMutation(baseOptions?: Apollo.MutationHookOptions<SwitchCompaniesMutation, SwitchCompaniesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SwitchCompaniesMutation, SwitchCompaniesMutationVariables>(SwitchCompaniesDocument, options);
      }
export type SwitchCompaniesMutationHookResult = ReturnType<typeof useSwitchCompaniesMutation>;
export type SwitchCompaniesMutationResult = Apollo.MutationResult<SwitchCompaniesMutation>;
export type SwitchCompaniesMutationOptions = Apollo.BaseMutationOptions<SwitchCompaniesMutation, SwitchCompaniesMutationVariables>;
export const GetHeapInfoDocument = gql`
    query GetHeapInfo {
  authenticatedMember {
    uuid
    memberType
    memberStatus
    adminStatus
    company {
      uuid
      companyBenefitsStatus
      companyPlanType
    }
    managerStatus
    permissions
    office {
      uuid
    }
  }
}
    `;

/**
 * __useGetHeapInfoQuery__
 *
 * To run a query within a React component, call `useGetHeapInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetHeapInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetHeapInfoQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetHeapInfoQuery(baseOptions?: Apollo.QueryHookOptions<GetHeapInfoQuery, GetHeapInfoQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetHeapInfoQuery, GetHeapInfoQueryVariables>(GetHeapInfoDocument, options);
      }
export function useGetHeapInfoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetHeapInfoQuery, GetHeapInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetHeapInfoQuery, GetHeapInfoQueryVariables>(GetHeapInfoDocument, options);
        }
export function useGetHeapInfoSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetHeapInfoQuery, GetHeapInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetHeapInfoQuery, GetHeapInfoQueryVariables>(GetHeapInfoDocument, options);
        }
export type GetHeapInfoQueryHookResult = ReturnType<typeof useGetHeapInfoQuery>;
export type GetHeapInfoLazyQueryHookResult = ReturnType<typeof useGetHeapInfoLazyQuery>;
export type GetHeapInfoSuspenseQueryHookResult = ReturnType<typeof useGetHeapInfoSuspenseQuery>;
export type GetHeapInfoQueryResult = Apollo.QueryResult<GetHeapInfoQuery, GetHeapInfoQueryVariables>;
export const GetPendoInfoDocument = gql`
    query GetPendoInfo {
  authenticatedMember {
    nagForBeneficiaries
    uuid
    adminStatus
    permissions
    address {
      state
    }
    memberType
    memberStatus
    managerPermissions
    adoptedBenefits {
      dental
      medical
      vision
    }
    company {
      uuid
      primaryAddress {
        state
      }
      workersCompStatus
      benefitsEligibility
      companyPlanType
      numOfActiveW2Employees
    }
  }
}
    `;

/**
 * __useGetPendoInfoQuery__
 *
 * To run a query within a React component, call `useGetPendoInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPendoInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPendoInfoQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetPendoInfoQuery(baseOptions?: Apollo.QueryHookOptions<GetPendoInfoQuery, GetPendoInfoQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPendoInfoQuery, GetPendoInfoQueryVariables>(GetPendoInfoDocument, options);
      }
export function useGetPendoInfoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPendoInfoQuery, GetPendoInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPendoInfoQuery, GetPendoInfoQueryVariables>(GetPendoInfoDocument, options);
        }
export function useGetPendoInfoSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetPendoInfoQuery, GetPendoInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPendoInfoQuery, GetPendoInfoQueryVariables>(GetPendoInfoDocument, options);
        }
export type GetPendoInfoQueryHookResult = ReturnType<typeof useGetPendoInfoQuery>;
export type GetPendoInfoLazyQueryHookResult = ReturnType<typeof useGetPendoInfoLazyQuery>;
export type GetPendoInfoSuspenseQueryHookResult = ReturnType<typeof useGetPendoInfoSuspenseQuery>;
export type GetPendoInfoQueryResult = Apollo.QueryResult<GetPendoInfoQuery, GetPendoInfoQueryVariables>;
export const GetLoggedInAsHeaderDataDocument = gql`
    query GetLoggedInAsHeaderData {
  authenticatedMember {
    uuid
    firstName
    middleName
    lastName
    preferredName
    userId
    id
    isLoggedInAs
    company {
      uuid
      name
    }
  }
}
    `;

/**
 * __useGetLoggedInAsHeaderDataQuery__
 *
 * To run a query within a React component, call `useGetLoggedInAsHeaderDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLoggedInAsHeaderDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLoggedInAsHeaderDataQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetLoggedInAsHeaderDataQuery(baseOptions?: Apollo.QueryHookOptions<GetLoggedInAsHeaderDataQuery, GetLoggedInAsHeaderDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLoggedInAsHeaderDataQuery, GetLoggedInAsHeaderDataQueryVariables>(GetLoggedInAsHeaderDataDocument, options);
      }
export function useGetLoggedInAsHeaderDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLoggedInAsHeaderDataQuery, GetLoggedInAsHeaderDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLoggedInAsHeaderDataQuery, GetLoggedInAsHeaderDataQueryVariables>(GetLoggedInAsHeaderDataDocument, options);
        }
export function useGetLoggedInAsHeaderDataSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetLoggedInAsHeaderDataQuery, GetLoggedInAsHeaderDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetLoggedInAsHeaderDataQuery, GetLoggedInAsHeaderDataQueryVariables>(GetLoggedInAsHeaderDataDocument, options);
        }
export type GetLoggedInAsHeaderDataQueryHookResult = ReturnType<typeof useGetLoggedInAsHeaderDataQuery>;
export type GetLoggedInAsHeaderDataLazyQueryHookResult = ReturnType<typeof useGetLoggedInAsHeaderDataLazyQuery>;
export type GetLoggedInAsHeaderDataSuspenseQueryHookResult = ReturnType<typeof useGetLoggedInAsHeaderDataSuspenseQuery>;
export type GetLoggedInAsHeaderDataQueryResult = Apollo.QueryResult<GetLoggedInAsHeaderDataQuery, GetLoggedInAsHeaderDataQueryVariables>;
export const GetAllFeatureFlagsDocument = gql`
    query GetAllFeatureFlags($contexts: [JSON!]) {
  allFeatureFlags(contexts: $contexts)
}
    `;

/**
 * __useGetAllFeatureFlagsQuery__
 *
 * To run a query within a React component, call `useGetAllFeatureFlagsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllFeatureFlagsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllFeatureFlagsQuery({
 *   variables: {
 *      contexts: // value for 'contexts'
 *   },
 * });
 */
export function useGetAllFeatureFlagsQuery(baseOptions?: Apollo.QueryHookOptions<GetAllFeatureFlagsQuery, GetAllFeatureFlagsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllFeatureFlagsQuery, GetAllFeatureFlagsQueryVariables>(GetAllFeatureFlagsDocument, options);
      }
export function useGetAllFeatureFlagsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllFeatureFlagsQuery, GetAllFeatureFlagsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllFeatureFlagsQuery, GetAllFeatureFlagsQueryVariables>(GetAllFeatureFlagsDocument, options);
        }
export function useGetAllFeatureFlagsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetAllFeatureFlagsQuery, GetAllFeatureFlagsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAllFeatureFlagsQuery, GetAllFeatureFlagsQueryVariables>(GetAllFeatureFlagsDocument, options);
        }
export type GetAllFeatureFlagsQueryHookResult = ReturnType<typeof useGetAllFeatureFlagsQuery>;
export type GetAllFeatureFlagsLazyQueryHookResult = ReturnType<typeof useGetAllFeatureFlagsLazyQuery>;
export type GetAllFeatureFlagsSuspenseQueryHookResult = ReturnType<typeof useGetAllFeatureFlagsSuspenseQuery>;
export type GetAllFeatureFlagsQueryResult = Apollo.QueryResult<GetAllFeatureFlagsQuery, GetAllFeatureFlagsQueryVariables>;
export const GetFeatureFlagDocument = gql`
    query GetFeatureFlag($flag: String!) {
  featureFlag(flag: $flag) {
    enabled
  }
}
    `;

/**
 * __useGetFeatureFlagQuery__
 *
 * To run a query within a React component, call `useGetFeatureFlagQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFeatureFlagQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFeatureFlagQuery({
 *   variables: {
 *      flag: // value for 'flag'
 *   },
 * });
 */
export function useGetFeatureFlagQuery(baseOptions: Apollo.QueryHookOptions<GetFeatureFlagQuery, GetFeatureFlagQueryVariables> & ({ variables: GetFeatureFlagQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFeatureFlagQuery, GetFeatureFlagQueryVariables>(GetFeatureFlagDocument, options);
      }
export function useGetFeatureFlagLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetFeatureFlagQuery, GetFeatureFlagQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFeatureFlagQuery, GetFeatureFlagQueryVariables>(GetFeatureFlagDocument, options);
        }
export function useGetFeatureFlagSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetFeatureFlagQuery, GetFeatureFlagQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetFeatureFlagQuery, GetFeatureFlagQueryVariables>(GetFeatureFlagDocument, options);
        }
export type GetFeatureFlagQueryHookResult = ReturnType<typeof useGetFeatureFlagQuery>;
export type GetFeatureFlagLazyQueryHookResult = ReturnType<typeof useGetFeatureFlagLazyQuery>;
export type GetFeatureFlagSuspenseQueryHookResult = ReturnType<typeof useGetFeatureFlagSuspenseQuery>;
export type GetFeatureFlagQueryResult = Apollo.QueryResult<GetFeatureFlagQuery, GetFeatureFlagQueryVariables>;
export const GetMemberPermissionsDocument = gql`
    query GetMemberPermissions {
  authenticatedMember {
    uuid
    company {
      companyPlanType
      cdmsCanonicalCompanyId
    }
    permissions
  }
}
    `;

/**
 * __useGetMemberPermissionsQuery__
 *
 * To run a query within a React component, call `useGetMemberPermissionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMemberPermissionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMemberPermissionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetMemberPermissionsQuery(baseOptions?: Apollo.QueryHookOptions<GetMemberPermissionsQuery, GetMemberPermissionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMemberPermissionsQuery, GetMemberPermissionsQueryVariables>(GetMemberPermissionsDocument, options);
      }
export function useGetMemberPermissionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMemberPermissionsQuery, GetMemberPermissionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMemberPermissionsQuery, GetMemberPermissionsQueryVariables>(GetMemberPermissionsDocument, options);
        }
export function useGetMemberPermissionsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetMemberPermissionsQuery, GetMemberPermissionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetMemberPermissionsQuery, GetMemberPermissionsQueryVariables>(GetMemberPermissionsDocument, options);
        }
export type GetMemberPermissionsQueryHookResult = ReturnType<typeof useGetMemberPermissionsQuery>;
export type GetMemberPermissionsLazyQueryHookResult = ReturnType<typeof useGetMemberPermissionsLazyQuery>;
export type GetMemberPermissionsSuspenseQueryHookResult = ReturnType<typeof useGetMemberPermissionsSuspenseQuery>;
export type GetMemberPermissionsQueryResult = Apollo.QueryResult<GetMemberPermissionsQuery, GetMemberPermissionsQueryVariables>;
export const GetBasicInfoDocument = gql`
    query GetBasicInfo($memberUuid: String!) {
  authenticatedMember {
    gender
    deskTitle
    office {
      address {
        city
        state
      }
    }
    startDate
    uuid
    photoUrl
    dateOfBirth
    memberHideBirthday
    pronouns
    homeAddress {
      street1
      street2
      city
      state
    }
    mailingAddress {
      street1
      street2
      city
      state
    }
    contactPhone
    phoneOffice
    phoneHome
    phoneCell
    emailHome
    emailWork
    isTerminated
    basicInfoEmergencyContact {
      firstName
      lastName
      phoneNumber
      phoneNumberSecondary
      relationship
    }
  }
}
    `;

/**
 * __useGetBasicInfoQuery__
 *
 * To run a query within a React component, call `useGetBasicInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBasicInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBasicInfoQuery({
 *   variables: {
 *      memberUuid: // value for 'memberUuid'
 *   },
 * });
 */
export function useGetBasicInfoQuery(baseOptions: Apollo.QueryHookOptions<GetBasicInfoQuery, GetBasicInfoQueryVariables> & ({ variables: GetBasicInfoQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBasicInfoQuery, GetBasicInfoQueryVariables>(GetBasicInfoDocument, options);
      }
export function useGetBasicInfoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBasicInfoQuery, GetBasicInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBasicInfoQuery, GetBasicInfoQueryVariables>(GetBasicInfoDocument, options);
        }
export function useGetBasicInfoSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetBasicInfoQuery, GetBasicInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetBasicInfoQuery, GetBasicInfoQueryVariables>(GetBasicInfoDocument, options);
        }
export type GetBasicInfoQueryHookResult = ReturnType<typeof useGetBasicInfoQuery>;
export type GetBasicInfoLazyQueryHookResult = ReturnType<typeof useGetBasicInfoLazyQuery>;
export type GetBasicInfoSuspenseQueryHookResult = ReturnType<typeof useGetBasicInfoSuspenseQuery>;
export type GetBasicInfoQueryResult = Apollo.QueryResult<GetBasicInfoQuery, GetBasicInfoQueryVariables>;
export const GetMemberTypeDocument = gql`
    query GetMemberType {
  authenticatedMember {
    memberType
  }
}
    `;

/**
 * __useGetMemberTypeQuery__
 *
 * To run a query within a React component, call `useGetMemberTypeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMemberTypeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMemberTypeQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetMemberTypeQuery(baseOptions?: Apollo.QueryHookOptions<GetMemberTypeQuery, GetMemberTypeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMemberTypeQuery, GetMemberTypeQueryVariables>(GetMemberTypeDocument, options);
      }
export function useGetMemberTypeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMemberTypeQuery, GetMemberTypeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMemberTypeQuery, GetMemberTypeQueryVariables>(GetMemberTypeDocument, options);
        }
export function useGetMemberTypeSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetMemberTypeQuery, GetMemberTypeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetMemberTypeQuery, GetMemberTypeQueryVariables>(GetMemberTypeDocument, options);
        }
export type GetMemberTypeQueryHookResult = ReturnType<typeof useGetMemberTypeQuery>;
export type GetMemberTypeLazyQueryHookResult = ReturnType<typeof useGetMemberTypeLazyQuery>;
export type GetMemberTypeSuspenseQueryHookResult = ReturnType<typeof useGetMemberTypeSuspenseQuery>;
export type GetMemberTypeQueryResult = Apollo.QueryResult<GetMemberTypeQuery, GetMemberTypeQueryVariables>;
export const GetCompensationHistoryDocument = gql`
    query GetCompensationHistory($memberUuid: String!) {
  suiClaimsMemberState(memberUuid: $memberUuid) {
    effectiveDate
    memberType
    uuid
    memberStatus
    payBasis
    payRateAmount
    standardHoursPerWeek
  }
}
    `;

/**
 * __useGetCompensationHistoryQuery__
 *
 * To run a query within a React component, call `useGetCompensationHistoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCompensationHistoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCompensationHistoryQuery({
 *   variables: {
 *      memberUuid: // value for 'memberUuid'
 *   },
 * });
 */
export function useGetCompensationHistoryQuery(baseOptions: Apollo.QueryHookOptions<GetCompensationHistoryQuery, GetCompensationHistoryQueryVariables> & ({ variables: GetCompensationHistoryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCompensationHistoryQuery, GetCompensationHistoryQueryVariables>(GetCompensationHistoryDocument, options);
      }
export function useGetCompensationHistoryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCompensationHistoryQuery, GetCompensationHistoryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCompensationHistoryQuery, GetCompensationHistoryQueryVariables>(GetCompensationHistoryDocument, options);
        }
export function useGetCompensationHistorySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCompensationHistoryQuery, GetCompensationHistoryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCompensationHistoryQuery, GetCompensationHistoryQueryVariables>(GetCompensationHistoryDocument, options);
        }
export type GetCompensationHistoryQueryHookResult = ReturnType<typeof useGetCompensationHistoryQuery>;
export type GetCompensationHistoryLazyQueryHookResult = ReturnType<typeof useGetCompensationHistoryLazyQuery>;
export type GetCompensationHistorySuspenseQueryHookResult = ReturnType<typeof useGetCompensationHistorySuspenseQuery>;
export type GetCompensationHistoryQueryResult = Apollo.QueryResult<GetCompensationHistoryQuery, GetCompensationHistoryQueryVariables>;
export const EditProfileDetailsDocument = gql`
    mutation EditProfileDetails($hideBirthday: Boolean, $pronouns: String, $photoPath: String, $photo: Photo) {
  editProfileDetails(
    hideBirthday: $hideBirthday
    pronouns: $pronouns
    photoPath: $photoPath
    photo: $photo
  ) {
    success
    userErrors {
      message
    }
  }
}
    `;
export type EditProfileDetailsMutationFn = Apollo.MutationFunction<EditProfileDetailsMutation, EditProfileDetailsMutationVariables>;

/**
 * __useEditProfileDetailsMutation__
 *
 * To run a mutation, you first call `useEditProfileDetailsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditProfileDetailsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editProfileDetailsMutation, { data, loading, error }] = useEditProfileDetailsMutation({
 *   variables: {
 *      hideBirthday: // value for 'hideBirthday'
 *      pronouns: // value for 'pronouns'
 *      photoPath: // value for 'photoPath'
 *      photo: // value for 'photo'
 *   },
 * });
 */
export function useEditProfileDetailsMutation(baseOptions?: Apollo.MutationHookOptions<EditProfileDetailsMutation, EditProfileDetailsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditProfileDetailsMutation, EditProfileDetailsMutationVariables>(EditProfileDetailsDocument, options);
      }
export type EditProfileDetailsMutationHookResult = ReturnType<typeof useEditProfileDetailsMutation>;
export type EditProfileDetailsMutationResult = Apollo.MutationResult<EditProfileDetailsMutation>;
export type EditProfileDetailsMutationOptions = Apollo.BaseMutationOptions<EditProfileDetailsMutation, EditProfileDetailsMutationVariables>;
export const GetMemberAccountSettingsDocument = gql`
    query GetMemberAccountSettings {
  authenticatedMember {
    uuid
    dateOfBirth
    memberHideBirthday
    photoUrl
    friendlyFullName
    pronouns
    isTerminated
  }
}
    `;

/**
 * __useGetMemberAccountSettingsQuery__
 *
 * To run a query within a React component, call `useGetMemberAccountSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMemberAccountSettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMemberAccountSettingsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetMemberAccountSettingsQuery(baseOptions?: Apollo.QueryHookOptions<GetMemberAccountSettingsQuery, GetMemberAccountSettingsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMemberAccountSettingsQuery, GetMemberAccountSettingsQueryVariables>(GetMemberAccountSettingsDocument, options);
      }
export function useGetMemberAccountSettingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMemberAccountSettingsQuery, GetMemberAccountSettingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMemberAccountSettingsQuery, GetMemberAccountSettingsQueryVariables>(GetMemberAccountSettingsDocument, options);
        }
export function useGetMemberAccountSettingsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetMemberAccountSettingsQuery, GetMemberAccountSettingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetMemberAccountSettingsQuery, GetMemberAccountSettingsQueryVariables>(GetMemberAccountSettingsDocument, options);
        }
export type GetMemberAccountSettingsQueryHookResult = ReturnType<typeof useGetMemberAccountSettingsQuery>;
export type GetMemberAccountSettingsLazyQueryHookResult = ReturnType<typeof useGetMemberAccountSettingsLazyQuery>;
export type GetMemberAccountSettingsSuspenseQueryHookResult = ReturnType<typeof useGetMemberAccountSettingsSuspenseQuery>;
export type GetMemberAccountSettingsQueryResult = Apollo.QueryResult<GetMemberAccountSettingsQuery, GetMemberAccountSettingsQueryVariables>;
export const AcceptFirmInviteDocument = gql`
    mutation AcceptFirmInvite($firmInviteUuid: String!, $permissions: [String!]!) {
  acceptFirmInvite(firmInviteUuid: $firmInviteUuid, permissions: $permissions) {
    success
    error
  }
}
    `;
export type AcceptFirmInviteMutationFn = Apollo.MutationFunction<AcceptFirmInviteMutation, AcceptFirmInviteMutationVariables>;

/**
 * __useAcceptFirmInviteMutation__
 *
 * To run a mutation, you first call `useAcceptFirmInviteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAcceptFirmInviteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [acceptFirmInviteMutation, { data, loading, error }] = useAcceptFirmInviteMutation({
 *   variables: {
 *      firmInviteUuid: // value for 'firmInviteUuid'
 *      permissions: // value for 'permissions'
 *   },
 * });
 */
export function useAcceptFirmInviteMutation(baseOptions?: Apollo.MutationHookOptions<AcceptFirmInviteMutation, AcceptFirmInviteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AcceptFirmInviteMutation, AcceptFirmInviteMutationVariables>(AcceptFirmInviteDocument, options);
      }
export type AcceptFirmInviteMutationHookResult = ReturnType<typeof useAcceptFirmInviteMutation>;
export type AcceptFirmInviteMutationResult = Apollo.MutationResult<AcceptFirmInviteMutation>;
export type AcceptFirmInviteMutationOptions = Apollo.BaseMutationOptions<AcceptFirmInviteMutation, AcceptFirmInviteMutationVariables>;
export const DeclineFirmInviteDocument = gql`
    mutation DeclineFirmInvite($firmInviteUuid: String!) {
  declineFirmInvite(firmInviteUuid: $firmInviteUuid) {
    success
    error
  }
}
    `;
export type DeclineFirmInviteMutationFn = Apollo.MutationFunction<DeclineFirmInviteMutation, DeclineFirmInviteMutationVariables>;

/**
 * __useDeclineFirmInviteMutation__
 *
 * To run a mutation, you first call `useDeclineFirmInviteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeclineFirmInviteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [declineFirmInviteMutation, { data, loading, error }] = useDeclineFirmInviteMutation({
 *   variables: {
 *      firmInviteUuid: // value for 'firmInviteUuid'
 *   },
 * });
 */
export function useDeclineFirmInviteMutation(baseOptions?: Apollo.MutationHookOptions<DeclineFirmInviteMutation, DeclineFirmInviteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeclineFirmInviteMutation, DeclineFirmInviteMutationVariables>(DeclineFirmInviteDocument, options);
      }
export type DeclineFirmInviteMutationHookResult = ReturnType<typeof useDeclineFirmInviteMutation>;
export type DeclineFirmInviteMutationResult = Apollo.MutationResult<DeclineFirmInviteMutation>;
export type DeclineFirmInviteMutationOptions = Apollo.BaseMutationOptions<DeclineFirmInviteMutation, DeclineFirmInviteMutationVariables>;
export const GetAllFirmInvitesDocument = gql`
    query GetAllFirmInvites {
  allFirmInvites {
    firmName
    status
    permissions
    expiresAt
    status
    uuid
    invitingFirmUser {
      firstName
      lastName
    }
  }
}
    `;

/**
 * __useGetAllFirmInvitesQuery__
 *
 * To run a query within a React component, call `useGetAllFirmInvitesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllFirmInvitesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllFirmInvitesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAllFirmInvitesQuery(baseOptions?: Apollo.QueryHookOptions<GetAllFirmInvitesQuery, GetAllFirmInvitesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllFirmInvitesQuery, GetAllFirmInvitesQueryVariables>(GetAllFirmInvitesDocument, options);
      }
export function useGetAllFirmInvitesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllFirmInvitesQuery, GetAllFirmInvitesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllFirmInvitesQuery, GetAllFirmInvitesQueryVariables>(GetAllFirmInvitesDocument, options);
        }
export function useGetAllFirmInvitesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetAllFirmInvitesQuery, GetAllFirmInvitesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAllFirmInvitesQuery, GetAllFirmInvitesQueryVariables>(GetAllFirmInvitesDocument, options);
        }
export type GetAllFirmInvitesQueryHookResult = ReturnType<typeof useGetAllFirmInvitesQuery>;
export type GetAllFirmInvitesLazyQueryHookResult = ReturnType<typeof useGetAllFirmInvitesLazyQuery>;
export type GetAllFirmInvitesSuspenseQueryHookResult = ReturnType<typeof useGetAllFirmInvitesSuspenseQuery>;
export type GetAllFirmInvitesQueryResult = Apollo.QueryResult<GetAllFirmInvitesQuery, GetAllFirmInvitesQueryVariables>;
export const GetFirmInviteDocument = gql`
    query GetFirmInvite($firmInviteId: String!) {
  firmInvite(firmInviteId: $firmInviteId) {
    uuid
    status
    expiresAt
    permissions
    firmName
    invitingFirmUser {
      firmUserId
      firstName
      lastName
      role
      email
      phone
    }
  }
}
    `;

/**
 * __useGetFirmInviteQuery__
 *
 * To run a query within a React component, call `useGetFirmInviteQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFirmInviteQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFirmInviteQuery({
 *   variables: {
 *      firmInviteId: // value for 'firmInviteId'
 *   },
 * });
 */
export function useGetFirmInviteQuery(baseOptions: Apollo.QueryHookOptions<GetFirmInviteQuery, GetFirmInviteQueryVariables> & ({ variables: GetFirmInviteQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFirmInviteQuery, GetFirmInviteQueryVariables>(GetFirmInviteDocument, options);
      }
export function useGetFirmInviteLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetFirmInviteQuery, GetFirmInviteQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFirmInviteQuery, GetFirmInviteQueryVariables>(GetFirmInviteDocument, options);
        }
export function useGetFirmInviteSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetFirmInviteQuery, GetFirmInviteQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetFirmInviteQuery, GetFirmInviteQueryVariables>(GetFirmInviteDocument, options);
        }
export type GetFirmInviteQueryHookResult = ReturnType<typeof useGetFirmInviteQuery>;
export type GetFirmInviteLazyQueryHookResult = ReturnType<typeof useGetFirmInviteLazyQuery>;
export type GetFirmInviteSuspenseQueryHookResult = ReturnType<typeof useGetFirmInviteSuspenseQuery>;
export type GetFirmInviteQueryResult = Apollo.QueryResult<GetFirmInviteQuery, GetFirmInviteQueryVariables>;
export const GetFirmInvitePermissionsDocument = gql`
    query GetFirmInvitePermissions($firmInviteId: String!) {
  firmInvite(firmInviteId: $firmInviteId) {
    permissions
  }
}
    `;

/**
 * __useGetFirmInvitePermissionsQuery__
 *
 * To run a query within a React component, call `useGetFirmInvitePermissionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFirmInvitePermissionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFirmInvitePermissionsQuery({
 *   variables: {
 *      firmInviteId: // value for 'firmInviteId'
 *   },
 * });
 */
export function useGetFirmInvitePermissionsQuery(baseOptions: Apollo.QueryHookOptions<GetFirmInvitePermissionsQuery, GetFirmInvitePermissionsQueryVariables> & ({ variables: GetFirmInvitePermissionsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFirmInvitePermissionsQuery, GetFirmInvitePermissionsQueryVariables>(GetFirmInvitePermissionsDocument, options);
      }
export function useGetFirmInvitePermissionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetFirmInvitePermissionsQuery, GetFirmInvitePermissionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFirmInvitePermissionsQuery, GetFirmInvitePermissionsQueryVariables>(GetFirmInvitePermissionsDocument, options);
        }
export function useGetFirmInvitePermissionsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetFirmInvitePermissionsQuery, GetFirmInvitePermissionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetFirmInvitePermissionsQuery, GetFirmInvitePermissionsQueryVariables>(GetFirmInvitePermissionsDocument, options);
        }
export type GetFirmInvitePermissionsQueryHookResult = ReturnType<typeof useGetFirmInvitePermissionsQuery>;
export type GetFirmInvitePermissionsLazyQueryHookResult = ReturnType<typeof useGetFirmInvitePermissionsLazyQuery>;
export type GetFirmInvitePermissionsSuspenseQueryHookResult = ReturnType<typeof useGetFirmInvitePermissionsSuspenseQuery>;
export type GetFirmInvitePermissionsQueryResult = Apollo.QueryResult<GetFirmInvitePermissionsQuery, GetFirmInvitePermissionsQueryVariables>;
export const GetFirmPermissionsDocument = gql`
    query GetFirmPermissions($companyUuid: String!) {
  firm(companyUuid: $companyUuid) {
    permissions
  }
}
    `;

/**
 * __useGetFirmPermissionsQuery__
 *
 * To run a query within a React component, call `useGetFirmPermissionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFirmPermissionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFirmPermissionsQuery({
 *   variables: {
 *      companyUuid: // value for 'companyUuid'
 *   },
 * });
 */
export function useGetFirmPermissionsQuery(baseOptions: Apollo.QueryHookOptions<GetFirmPermissionsQuery, GetFirmPermissionsQueryVariables> & ({ variables: GetFirmPermissionsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFirmPermissionsQuery, GetFirmPermissionsQueryVariables>(GetFirmPermissionsDocument, options);
      }
export function useGetFirmPermissionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetFirmPermissionsQuery, GetFirmPermissionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFirmPermissionsQuery, GetFirmPermissionsQueryVariables>(GetFirmPermissionsDocument, options);
        }
export function useGetFirmPermissionsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetFirmPermissionsQuery, GetFirmPermissionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetFirmPermissionsQuery, GetFirmPermissionsQueryVariables>(GetFirmPermissionsDocument, options);
        }
export type GetFirmPermissionsQueryHookResult = ReturnType<typeof useGetFirmPermissionsQuery>;
export type GetFirmPermissionsLazyQueryHookResult = ReturnType<typeof useGetFirmPermissionsLazyQuery>;
export type GetFirmPermissionsSuspenseQueryHookResult = ReturnType<typeof useGetFirmPermissionsSuspenseQuery>;
export type GetFirmPermissionsQueryResult = Apollo.QueryResult<GetFirmPermissionsQuery, GetFirmPermissionsQueryVariables>;
export const FirmsPageDocument = gql`
    query FirmsPage($companyUuid: String!) {
  authenticatedMember {
    uuid
    adminStatus
    company {
      uuid
      name
      thirdPartyAdmins {
        uuid
        firstName
        lastName
        emailWork
        deskTitle
      }
    }
    permissions
  }
  firm(companyUuid: $companyUuid) {
    ...FirmListFields
  }
}
    ${FirmListFieldsFragmentDoc}`;

/**
 * __useFirmsPageQuery__
 *
 * To run a query within a React component, call `useFirmsPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useFirmsPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFirmsPageQuery({
 *   variables: {
 *      companyUuid: // value for 'companyUuid'
 *   },
 * });
 */
export function useFirmsPageQuery(baseOptions: Apollo.QueryHookOptions<FirmsPageQuery, FirmsPageQueryVariables> & ({ variables: FirmsPageQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FirmsPageQuery, FirmsPageQueryVariables>(FirmsPageDocument, options);
      }
export function useFirmsPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FirmsPageQuery, FirmsPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FirmsPageQuery, FirmsPageQueryVariables>(FirmsPageDocument, options);
        }
export function useFirmsPageSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<FirmsPageQuery, FirmsPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FirmsPageQuery, FirmsPageQueryVariables>(FirmsPageDocument, options);
        }
export type FirmsPageQueryHookResult = ReturnType<typeof useFirmsPageQuery>;
export type FirmsPageLazyQueryHookResult = ReturnType<typeof useFirmsPageLazyQuery>;
export type FirmsPageSuspenseQueryHookResult = ReturnType<typeof useFirmsPageSuspenseQuery>;
export type FirmsPageQueryResult = Apollo.QueryResult<FirmsPageQuery, FirmsPageQueryVariables>;
export const InviteFirmDocument = gql`
    mutation InviteFirm($companyUuid: String!, $newInvitation: NewInvitationInput!) {
  inviteFirm(companyUuid: $companyUuid, newInvitation: $newInvitation) {
    success
    error
    firm {
      ...FirmListFields
    }
  }
}
    ${FirmListFieldsFragmentDoc}`;
export type InviteFirmMutationFn = Apollo.MutationFunction<InviteFirmMutation, InviteFirmMutationVariables>;

/**
 * __useInviteFirmMutation__
 *
 * To run a mutation, you first call `useInviteFirmMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInviteFirmMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [inviteFirmMutation, { data, loading, error }] = useInviteFirmMutation({
 *   variables: {
 *      companyUuid: // value for 'companyUuid'
 *      newInvitation: // value for 'newInvitation'
 *   },
 * });
 */
export function useInviteFirmMutation(baseOptions?: Apollo.MutationHookOptions<InviteFirmMutation, InviteFirmMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InviteFirmMutation, InviteFirmMutationVariables>(InviteFirmDocument, options);
      }
export type InviteFirmMutationHookResult = ReturnType<typeof useInviteFirmMutation>;
export type InviteFirmMutationResult = Apollo.MutationResult<InviteFirmMutation>;
export type InviteFirmMutationOptions = Apollo.BaseMutationOptions<InviteFirmMutation, InviteFirmMutationVariables>;
export const UpdatePermissionsDocument = gql`
    mutation UpdatePermissions($companyUuid: String!, $firmUuid: String!, $permissions: [String!]!) {
  updatePermissions(
    companyUuid: $companyUuid
    firmUuid: $firmUuid
    permissions: $permissions
  ) {
    success
    error
    firm {
      uuid
      permissions
    }
  }
}
    `;
export type UpdatePermissionsMutationFn = Apollo.MutationFunction<UpdatePermissionsMutation, UpdatePermissionsMutationVariables>;

/**
 * __useUpdatePermissionsMutation__
 *
 * To run a mutation, you first call `useUpdatePermissionsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePermissionsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePermissionsMutation, { data, loading, error }] = useUpdatePermissionsMutation({
 *   variables: {
 *      companyUuid: // value for 'companyUuid'
 *      firmUuid: // value for 'firmUuid'
 *      permissions: // value for 'permissions'
 *   },
 * });
 */
export function useUpdatePermissionsMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePermissionsMutation, UpdatePermissionsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePermissionsMutation, UpdatePermissionsMutationVariables>(UpdatePermissionsDocument, options);
      }
export type UpdatePermissionsMutationHookResult = ReturnType<typeof useUpdatePermissionsMutation>;
export type UpdatePermissionsMutationResult = Apollo.MutationResult<UpdatePermissionsMutation>;
export type UpdatePermissionsMutationOptions = Apollo.BaseMutationOptions<UpdatePermissionsMutation, UpdatePermissionsMutationVariables>;
export const RemoveFirmDocument = gql`
    mutation RemoveFirm($companyUuid: String!, $firmUuid: String!) {
  removeFirm(companyUuid: $companyUuid, firmUuid: $firmUuid) {
    success
    error
  }
}
    `;
export type RemoveFirmMutationFn = Apollo.MutationFunction<RemoveFirmMutation, RemoveFirmMutationVariables>;

/**
 * __useRemoveFirmMutation__
 *
 * To run a mutation, you first call `useRemoveFirmMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveFirmMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeFirmMutation, { data, loading, error }] = useRemoveFirmMutation({
 *   variables: {
 *      companyUuid: // value for 'companyUuid'
 *      firmUuid: // value for 'firmUuid'
 *   },
 * });
 */
export function useRemoveFirmMutation(baseOptions?: Apollo.MutationHookOptions<RemoveFirmMutation, RemoveFirmMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveFirmMutation, RemoveFirmMutationVariables>(RemoveFirmDocument, options);
      }
export type RemoveFirmMutationHookResult = ReturnType<typeof useRemoveFirmMutation>;
export type RemoveFirmMutationResult = Apollo.MutationResult<RemoveFirmMutation>;
export type RemoveFirmMutationOptions = Apollo.BaseMutationOptions<RemoveFirmMutation, RemoveFirmMutationVariables>;
export const GetAllClientInvitesDocument = gql`
    query GetAllClientInvites {
  allClientInvites {
    companyId
    email
    expiresAt
    firstName
    id
    invitedFirmName
    lastName
    message
    permissions
    status
  }
}
    `;

/**
 * __useGetAllClientInvitesQuery__
 *
 * To run a query within a React component, call `useGetAllClientInvitesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllClientInvitesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllClientInvitesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAllClientInvitesQuery(baseOptions?: Apollo.QueryHookOptions<GetAllClientInvitesQuery, GetAllClientInvitesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllClientInvitesQuery, GetAllClientInvitesQueryVariables>(GetAllClientInvitesDocument, options);
      }
export function useGetAllClientInvitesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllClientInvitesQuery, GetAllClientInvitesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllClientInvitesQuery, GetAllClientInvitesQueryVariables>(GetAllClientInvitesDocument, options);
        }
export function useGetAllClientInvitesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetAllClientInvitesQuery, GetAllClientInvitesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAllClientInvitesQuery, GetAllClientInvitesQueryVariables>(GetAllClientInvitesDocument, options);
        }
export type GetAllClientInvitesQueryHookResult = ReturnType<typeof useGetAllClientInvitesQuery>;
export type GetAllClientInvitesLazyQueryHookResult = ReturnType<typeof useGetAllClientInvitesLazyQuery>;
export type GetAllClientInvitesSuspenseQueryHookResult = ReturnType<typeof useGetAllClientInvitesSuspenseQuery>;
export type GetAllClientInvitesQueryResult = Apollo.QueryResult<GetAllClientInvitesQuery, GetAllClientInvitesQueryVariables>;
export const RevokeInviteToFirmDocument = gql`
    mutation RevokeInviteToFirm($inviteId: String!) {
  revokeInviteToFirm(inviteId: $inviteId) {
    success
    error
  }
}
    `;
export type RevokeInviteToFirmMutationFn = Apollo.MutationFunction<RevokeInviteToFirmMutation, RevokeInviteToFirmMutationVariables>;

/**
 * __useRevokeInviteToFirmMutation__
 *
 * To run a mutation, you first call `useRevokeInviteToFirmMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRevokeInviteToFirmMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [revokeInviteToFirmMutation, { data, loading, error }] = useRevokeInviteToFirmMutation({
 *   variables: {
 *      inviteId: // value for 'inviteId'
 *   },
 * });
 */
export function useRevokeInviteToFirmMutation(baseOptions?: Apollo.MutationHookOptions<RevokeInviteToFirmMutation, RevokeInviteToFirmMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RevokeInviteToFirmMutation, RevokeInviteToFirmMutationVariables>(RevokeInviteToFirmDocument, options);
      }
export type RevokeInviteToFirmMutationHookResult = ReturnType<typeof useRevokeInviteToFirmMutation>;
export type RevokeInviteToFirmMutationResult = Apollo.MutationResult<RevokeInviteToFirmMutation>;
export type RevokeInviteToFirmMutationOptions = Apollo.BaseMutationOptions<RevokeInviteToFirmMutation, RevokeInviteToFirmMutationVariables>;
export const CreateMember401kAdditionalContributionDocument = gql`
    mutation CreateMember401kAdditionalContribution($year: Int!, $amountPretax: Int!, $amountRoth: Int!) {
  createMember401kAdditionalContribution(
    year: $year
    amountPretax: $amountPretax
    amountRoth: $amountRoth
  ) {
    id
  }
}
    `;
export type CreateMember401kAdditionalContributionMutationFn = Apollo.MutationFunction<CreateMember401kAdditionalContributionMutation, CreateMember401kAdditionalContributionMutationVariables>;

/**
 * __useCreateMember401kAdditionalContributionMutation__
 *
 * To run a mutation, you first call `useCreateMember401kAdditionalContributionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateMember401kAdditionalContributionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createMember401kAdditionalContributionMutation, { data, loading, error }] = useCreateMember401kAdditionalContributionMutation({
 *   variables: {
 *      year: // value for 'year'
 *      amountPretax: // value for 'amountPretax'
 *      amountRoth: // value for 'amountRoth'
 *   },
 * });
 */
export function useCreateMember401kAdditionalContributionMutation(baseOptions?: Apollo.MutationHookOptions<CreateMember401kAdditionalContributionMutation, CreateMember401kAdditionalContributionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateMember401kAdditionalContributionMutation, CreateMember401kAdditionalContributionMutationVariables>(CreateMember401kAdditionalContributionDocument, options);
      }
export type CreateMember401kAdditionalContributionMutationHookResult = ReturnType<typeof useCreateMember401kAdditionalContributionMutation>;
export type CreateMember401kAdditionalContributionMutationResult = Apollo.MutationResult<CreateMember401kAdditionalContributionMutation>;
export type CreateMember401kAdditionalContributionMutationOptions = Apollo.BaseMutationOptions<CreateMember401kAdditionalContributionMutation, CreateMember401kAdditionalContributionMutationVariables>;
export const Create401kPlanEnrollmentLeadDocument = gql`
    mutation Create401kPlanEnrollmentLead($providerName: String!, $leadMetadataJson: String!) {
  create401kPlanEnrollmentLead(
    providerName: $providerName
    leadMetadataJson: $leadMetadataJson
  ) {
    id
  }
}
    `;
export type Create401kPlanEnrollmentLeadMutationFn = Apollo.MutationFunction<Create401kPlanEnrollmentLeadMutation, Create401kPlanEnrollmentLeadMutationVariables>;

/**
 * __useCreate401kPlanEnrollmentLeadMutation__
 *
 * To run a mutation, you first call `useCreate401kPlanEnrollmentLeadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreate401kPlanEnrollmentLeadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [create401kPlanEnrollmentLeadMutation, { data, loading, error }] = useCreate401kPlanEnrollmentLeadMutation({
 *   variables: {
 *      providerName: // value for 'providerName'
 *      leadMetadataJson: // value for 'leadMetadataJson'
 *   },
 * });
 */
export function useCreate401kPlanEnrollmentLeadMutation(baseOptions?: Apollo.MutationHookOptions<Create401kPlanEnrollmentLeadMutation, Create401kPlanEnrollmentLeadMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Create401kPlanEnrollmentLeadMutation, Create401kPlanEnrollmentLeadMutationVariables>(Create401kPlanEnrollmentLeadDocument, options);
      }
export type Create401kPlanEnrollmentLeadMutationHookResult = ReturnType<typeof useCreate401kPlanEnrollmentLeadMutation>;
export type Create401kPlanEnrollmentLeadMutationResult = Apollo.MutationResult<Create401kPlanEnrollmentLeadMutation>;
export type Create401kPlanEnrollmentLeadMutationOptions = Apollo.BaseMutationOptions<Create401kPlanEnrollmentLeadMutation, Create401kPlanEnrollmentLeadMutationVariables>;
export const GetCompany401kDetailsDocument = gql`
    query GetCompany401kDetails {
  currentMember {
    company {
      company401kPlan {
        planProvider
        startDate
        endDate
        discretionaryTier1Rate
        discretionaryTier1Limit
        discretionaryTier2Rate
        discretionaryTier2Limit
        safeHarborTier1Rate
        safeHarborTier1Limit
        safeHarborTier2Rate
        safeHarborTier2Limit
        safeHarborNonelective
        safeHarborNonelectivePercent
        memberDetails {
          uuid
          fullName
          pretaxAmount
          aftertaxAmount
          companyMatchAmount
          companyNonelectiveAmount
        }
      }
    }
  }
}
    `;

/**
 * __useGetCompany401kDetailsQuery__
 *
 * To run a query within a React component, call `useGetCompany401kDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCompany401kDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCompany401kDetailsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCompany401kDetailsQuery(baseOptions?: Apollo.QueryHookOptions<GetCompany401kDetailsQuery, GetCompany401kDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCompany401kDetailsQuery, GetCompany401kDetailsQueryVariables>(GetCompany401kDetailsDocument, options);
      }
export function useGetCompany401kDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCompany401kDetailsQuery, GetCompany401kDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCompany401kDetailsQuery, GetCompany401kDetailsQueryVariables>(GetCompany401kDetailsDocument, options);
        }
export function useGetCompany401kDetailsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCompany401kDetailsQuery, GetCompany401kDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCompany401kDetailsQuery, GetCompany401kDetailsQueryVariables>(GetCompany401kDetailsDocument, options);
        }
export type GetCompany401kDetailsQueryHookResult = ReturnType<typeof useGetCompany401kDetailsQuery>;
export type GetCompany401kDetailsLazyQueryHookResult = ReturnType<typeof useGetCompany401kDetailsLazyQuery>;
export type GetCompany401kDetailsSuspenseQueryHookResult = ReturnType<typeof useGetCompany401kDetailsSuspenseQuery>;
export type GetCompany401kDetailsQueryResult = Apollo.QueryResult<GetCompany401kDetailsQuery, GetCompany401kDetailsQueryVariables>;
export const GetCompanyAdminInfoDocument = gql`
    query GetCompanyAdminInfo {
  currentMember {
    company {
      name
    }
    emailWork
    friendlyFullName
    permissions
    phoneCell
    phoneHome
    phoneOffice
    uuid
  }
}
    `;

/**
 * __useGetCompanyAdminInfoQuery__
 *
 * To run a query within a React component, call `useGetCompanyAdminInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCompanyAdminInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCompanyAdminInfoQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCompanyAdminInfoQuery(baseOptions?: Apollo.QueryHookOptions<GetCompanyAdminInfoQuery, GetCompanyAdminInfoQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCompanyAdminInfoQuery, GetCompanyAdminInfoQueryVariables>(GetCompanyAdminInfoDocument, options);
      }
export function useGetCompanyAdminInfoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCompanyAdminInfoQuery, GetCompanyAdminInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCompanyAdminInfoQuery, GetCompanyAdminInfoQueryVariables>(GetCompanyAdminInfoDocument, options);
        }
export function useGetCompanyAdminInfoSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCompanyAdminInfoQuery, GetCompanyAdminInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCompanyAdminInfoQuery, GetCompanyAdminInfoQueryVariables>(GetCompanyAdminInfoDocument, options);
        }
export type GetCompanyAdminInfoQueryHookResult = ReturnType<typeof useGetCompanyAdminInfoQuery>;
export type GetCompanyAdminInfoLazyQueryHookResult = ReturnType<typeof useGetCompanyAdminInfoLazyQuery>;
export type GetCompanyAdminInfoSuspenseQueryHookResult = ReturnType<typeof useGetCompanyAdminInfoSuspenseQuery>;
export type GetCompanyAdminInfoQueryResult = Apollo.QueryResult<GetCompanyAdminInfoQuery, GetCompanyAdminInfoQueryVariables>;
export const GetUser401kInfoDocument = gql`
    query GetUser401kInfo {
  currentMember {
    member401kInfo {
      eligibleFor401kCatchup
      latestActiveDeferralRates {
        salaryAftertaxAmount
        salaryAftertaxPercent
        salaryPretaxAmount
        salaryPretaxPercent
        supplementalAftertaxAmount
        supplementalAftertaxPercent
        supplementalPretaxAmount
        supplementalPretaxPercent
      }
      member401kDeferralMax
      showYtd401kActionCard
      ytdContributions {
        additionalPretax
        additionalRoth
        slavic
        manual
      }
      enrollmentFlowEligible
    }
  }
}
    `;

/**
 * __useGetUser401kInfoQuery__
 *
 * To run a query within a React component, call `useGetUser401kInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUser401kInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUser401kInfoQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetUser401kInfoQuery(baseOptions?: Apollo.QueryHookOptions<GetUser401kInfoQuery, GetUser401kInfoQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUser401kInfoQuery, GetUser401kInfoQueryVariables>(GetUser401kInfoDocument, options);
      }
export function useGetUser401kInfoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUser401kInfoQuery, GetUser401kInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUser401kInfoQuery, GetUser401kInfoQueryVariables>(GetUser401kInfoDocument, options);
        }
export function useGetUser401kInfoSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetUser401kInfoQuery, GetUser401kInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetUser401kInfoQuery, GetUser401kInfoQueryVariables>(GetUser401kInfoDocument, options);
        }
export type GetUser401kInfoQueryHookResult = ReturnType<typeof useGetUser401kInfoQuery>;
export type GetUser401kInfoLazyQueryHookResult = ReturnType<typeof useGetUser401kInfoLazyQuery>;
export type GetUser401kInfoSuspenseQueryHookResult = ReturnType<typeof useGetUser401kInfoSuspenseQuery>;
export type GetUser401kInfoQueryResult = Apollo.QueryResult<GetUser401kInfoQuery, GetUser401kInfoQueryVariables>;
export const GetUserPermissionsDocument = gql`
    query GetUserPermissions {
  currentMember {
    permissions
  }
}
    `;

/**
 * __useGetUserPermissionsQuery__
 *
 * To run a query within a React component, call `useGetUserPermissionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserPermissionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserPermissionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetUserPermissionsQuery(baseOptions?: Apollo.QueryHookOptions<GetUserPermissionsQuery, GetUserPermissionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserPermissionsQuery, GetUserPermissionsQueryVariables>(GetUserPermissionsDocument, options);
      }
export function useGetUserPermissionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserPermissionsQuery, GetUserPermissionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserPermissionsQuery, GetUserPermissionsQueryVariables>(GetUserPermissionsDocument, options);
        }
export function useGetUserPermissionsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetUserPermissionsQuery, GetUserPermissionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetUserPermissionsQuery, GetUserPermissionsQueryVariables>(GetUserPermissionsDocument, options);
        }
export type GetUserPermissionsQueryHookResult = ReturnType<typeof useGetUserPermissionsQuery>;
export type GetUserPermissionsLazyQueryHookResult = ReturnType<typeof useGetUserPermissionsLazyQuery>;
export type GetUserPermissionsSuspenseQueryHookResult = ReturnType<typeof useGetUserPermissionsSuspenseQuery>;
export type GetUserPermissionsQueryResult = Apollo.QueryResult<GetUserPermissionsQuery, GetUserPermissionsQueryVariables>;
export const GetEoRCombinedInvoicesDocument = gql`
    query GetEoRCombinedInvoices($processingDate: String, $invoiceId: String) {
  combinedInvoices(processingDate: $processingDate, invoiceId: $invoiceId) {
    baseCurrency
    companyId
    pendingDisbursementOrders
    processingDate
    status
    total
    invoices {
      id
      status
      payPeriodRange {
        startDate
        endDate
        payDate
        paymentDueDate
      }
      country {
        code
        description
      }
      currency {
        code
        description
      }
      usdFxRate
      localCurrencyTotal
      categories {
        description
        type
        total
        entries {
          description
          amount
        }
        note
      }
      fees {
        justworksFee
        serviceFee
        securityDeposit
        securityDepositRefund
      }
    }
    fees {
      serviceFees {
        description
        entries {
          description
          amount
        }
        total
      }
      otherFees {
        description
        entries {
          description
          amount
        }
        total
      }
    }
    credits {
      description
      entries {
        description
        amount
      }
      type
      total
    }
  }
}
    `;

/**
 * __useGetEoRCombinedInvoicesQuery__
 *
 * To run a query within a React component, call `useGetEoRCombinedInvoicesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEoRCombinedInvoicesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEoRCombinedInvoicesQuery({
 *   variables: {
 *      processingDate: // value for 'processingDate'
 *      invoiceId: // value for 'invoiceId'
 *   },
 * });
 */
export function useGetEoRCombinedInvoicesQuery(baseOptions?: Apollo.QueryHookOptions<GetEoRCombinedInvoicesQuery, GetEoRCombinedInvoicesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEoRCombinedInvoicesQuery, GetEoRCombinedInvoicesQueryVariables>(GetEoRCombinedInvoicesDocument, options);
      }
export function useGetEoRCombinedInvoicesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEoRCombinedInvoicesQuery, GetEoRCombinedInvoicesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEoRCombinedInvoicesQuery, GetEoRCombinedInvoicesQueryVariables>(GetEoRCombinedInvoicesDocument, options);
        }
export function useGetEoRCombinedInvoicesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetEoRCombinedInvoicesQuery, GetEoRCombinedInvoicesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetEoRCombinedInvoicesQuery, GetEoRCombinedInvoicesQueryVariables>(GetEoRCombinedInvoicesDocument, options);
        }
export type GetEoRCombinedInvoicesQueryHookResult = ReturnType<typeof useGetEoRCombinedInvoicesQuery>;
export type GetEoRCombinedInvoicesLazyQueryHookResult = ReturnType<typeof useGetEoRCombinedInvoicesLazyQuery>;
export type GetEoRCombinedInvoicesSuspenseQueryHookResult = ReturnType<typeof useGetEoRCombinedInvoicesSuspenseQuery>;
export type GetEoRCombinedInvoicesQueryResult = Apollo.QueryResult<GetEoRCombinedInvoicesQuery, GetEoRCombinedInvoicesQueryVariables>;
export const GetEoRMemberBackgroundCheckDocument = gql`
    query GetEoRMemberBackgroundCheck($memberId: String!) {
  backgroundCheckStatus(memberId: $memberId) {
    status
    candidateFeedbackUrl
  }
}
    `;

/**
 * __useGetEoRMemberBackgroundCheckQuery__
 *
 * To run a query within a React component, call `useGetEoRMemberBackgroundCheckQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEoRMemberBackgroundCheckQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEoRMemberBackgroundCheckQuery({
 *   variables: {
 *      memberId: // value for 'memberId'
 *   },
 * });
 */
export function useGetEoRMemberBackgroundCheckQuery(baseOptions: Apollo.QueryHookOptions<GetEoRMemberBackgroundCheckQuery, GetEoRMemberBackgroundCheckQueryVariables> & ({ variables: GetEoRMemberBackgroundCheckQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEoRMemberBackgroundCheckQuery, GetEoRMemberBackgroundCheckQueryVariables>(GetEoRMemberBackgroundCheckDocument, options);
      }
export function useGetEoRMemberBackgroundCheckLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEoRMemberBackgroundCheckQuery, GetEoRMemberBackgroundCheckQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEoRMemberBackgroundCheckQuery, GetEoRMemberBackgroundCheckQueryVariables>(GetEoRMemberBackgroundCheckDocument, options);
        }
export function useGetEoRMemberBackgroundCheckSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetEoRMemberBackgroundCheckQuery, GetEoRMemberBackgroundCheckQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetEoRMemberBackgroundCheckQuery, GetEoRMemberBackgroundCheckQueryVariables>(GetEoRMemberBackgroundCheckDocument, options);
        }
export type GetEoRMemberBackgroundCheckQueryHookResult = ReturnType<typeof useGetEoRMemberBackgroundCheckQuery>;
export type GetEoRMemberBackgroundCheckLazyQueryHookResult = ReturnType<typeof useGetEoRMemberBackgroundCheckLazyQuery>;
export type GetEoRMemberBackgroundCheckSuspenseQueryHookResult = ReturnType<typeof useGetEoRMemberBackgroundCheckSuspenseQuery>;
export type GetEoRMemberBackgroundCheckQueryResult = Apollo.QueryResult<GetEoRMemberBackgroundCheckQuery, GetEoRMemberBackgroundCheckQueryVariables>;
export const GetEoRMemberByUuidDocument = gql`
    query GetEoRMemberByUuid($memberUuid: String) {
  eorMember(memberUuid: $memberUuid) {
    id
    memberUuid
    firstName
    lastName
    email
    accountCreated
  }
}
    `;

/**
 * __useGetEoRMemberByUuidQuery__
 *
 * To run a query within a React component, call `useGetEoRMemberByUuidQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEoRMemberByUuidQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEoRMemberByUuidQuery({
 *   variables: {
 *      memberUuid: // value for 'memberUuid'
 *   },
 * });
 */
export function useGetEoRMemberByUuidQuery(baseOptions?: Apollo.QueryHookOptions<GetEoRMemberByUuidQuery, GetEoRMemberByUuidQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEoRMemberByUuidQuery, GetEoRMemberByUuidQueryVariables>(GetEoRMemberByUuidDocument, options);
      }
export function useGetEoRMemberByUuidLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEoRMemberByUuidQuery, GetEoRMemberByUuidQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEoRMemberByUuidQuery, GetEoRMemberByUuidQueryVariables>(GetEoRMemberByUuidDocument, options);
        }
export function useGetEoRMemberByUuidSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetEoRMemberByUuidQuery, GetEoRMemberByUuidQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetEoRMemberByUuidQuery, GetEoRMemberByUuidQueryVariables>(GetEoRMemberByUuidDocument, options);
        }
export type GetEoRMemberByUuidQueryHookResult = ReturnType<typeof useGetEoRMemberByUuidQuery>;
export type GetEoRMemberByUuidLazyQueryHookResult = ReturnType<typeof useGetEoRMemberByUuidLazyQuery>;
export type GetEoRMemberByUuidSuspenseQueryHookResult = ReturnType<typeof useGetEoRMemberByUuidSuspenseQuery>;
export type GetEoRMemberByUuidQueryResult = Apollo.QueryResult<GetEoRMemberByUuidQuery, GetEoRMemberByUuidQueryVariables>;
export const GetEoRMemberIdVerificationStatusDocument = gql`
    query GetEoRMemberIdVerificationStatus($memberId: String!) {
  personaIdVerificationStatus(memberId: $memberId)
}
    `;

/**
 * __useGetEoRMemberIdVerificationStatusQuery__
 *
 * To run a query within a React component, call `useGetEoRMemberIdVerificationStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEoRMemberIdVerificationStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEoRMemberIdVerificationStatusQuery({
 *   variables: {
 *      memberId: // value for 'memberId'
 *   },
 * });
 */
export function useGetEoRMemberIdVerificationStatusQuery(baseOptions: Apollo.QueryHookOptions<GetEoRMemberIdVerificationStatusQuery, GetEoRMemberIdVerificationStatusQueryVariables> & ({ variables: GetEoRMemberIdVerificationStatusQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEoRMemberIdVerificationStatusQuery, GetEoRMemberIdVerificationStatusQueryVariables>(GetEoRMemberIdVerificationStatusDocument, options);
      }
export function useGetEoRMemberIdVerificationStatusLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEoRMemberIdVerificationStatusQuery, GetEoRMemberIdVerificationStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEoRMemberIdVerificationStatusQuery, GetEoRMemberIdVerificationStatusQueryVariables>(GetEoRMemberIdVerificationStatusDocument, options);
        }
export function useGetEoRMemberIdVerificationStatusSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetEoRMemberIdVerificationStatusQuery, GetEoRMemberIdVerificationStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetEoRMemberIdVerificationStatusQuery, GetEoRMemberIdVerificationStatusQueryVariables>(GetEoRMemberIdVerificationStatusDocument, options);
        }
export type GetEoRMemberIdVerificationStatusQueryHookResult = ReturnType<typeof useGetEoRMemberIdVerificationStatusQuery>;
export type GetEoRMemberIdVerificationStatusLazyQueryHookResult = ReturnType<typeof useGetEoRMemberIdVerificationStatusLazyQuery>;
export type GetEoRMemberIdVerificationStatusSuspenseQueryHookResult = ReturnType<typeof useGetEoRMemberIdVerificationStatusSuspenseQuery>;
export type GetEoRMemberIdVerificationStatusQueryResult = Apollo.QueryResult<GetEoRMemberIdVerificationStatusQuery, GetEoRMemberIdVerificationStatusQueryVariables>;
export const GetEoRSupportedCountriesDocument = gql`
    query GetEoRSupportedCountries {
  eorSupportedCountries {
    code
    config {
      commonName
      currencies {
        currencyCode
        subunitToUnit
        symbol
      }
      emojiFlag
      subdivisions {
        code
        name
      }
      underwritingSubdivisionGroups
    }
  }
}
    `;

/**
 * __useGetEoRSupportedCountriesQuery__
 *
 * To run a query within a React component, call `useGetEoRSupportedCountriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEoRSupportedCountriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEoRSupportedCountriesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetEoRSupportedCountriesQuery(baseOptions?: Apollo.QueryHookOptions<GetEoRSupportedCountriesQuery, GetEoRSupportedCountriesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEoRSupportedCountriesQuery, GetEoRSupportedCountriesQueryVariables>(GetEoRSupportedCountriesDocument, options);
      }
export function useGetEoRSupportedCountriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEoRSupportedCountriesQuery, GetEoRSupportedCountriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEoRSupportedCountriesQuery, GetEoRSupportedCountriesQueryVariables>(GetEoRSupportedCountriesDocument, options);
        }
export function useGetEoRSupportedCountriesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetEoRSupportedCountriesQuery, GetEoRSupportedCountriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetEoRSupportedCountriesQuery, GetEoRSupportedCountriesQueryVariables>(GetEoRSupportedCountriesDocument, options);
        }
export type GetEoRSupportedCountriesQueryHookResult = ReturnType<typeof useGetEoRSupportedCountriesQuery>;
export type GetEoRSupportedCountriesLazyQueryHookResult = ReturnType<typeof useGetEoRSupportedCountriesLazyQuery>;
export type GetEoRSupportedCountriesSuspenseQueryHookResult = ReturnType<typeof useGetEoRSupportedCountriesSuspenseQuery>;
export type GetEoRSupportedCountriesQueryResult = Apollo.QueryResult<GetEoRSupportedCountriesQuery, GetEoRSupportedCountriesQueryVariables>;
export const LaunchEoRIdVerificationDocument = gql`
    mutation LaunchEoRIdVerification($memberId: String!) {
  personaLaunchIdVerification(memberId: $memberId) {
    hostedFlowUrl
  }
}
    `;
export type LaunchEoRIdVerificationMutationFn = Apollo.MutationFunction<LaunchEoRIdVerificationMutation, LaunchEoRIdVerificationMutationVariables>;

/**
 * __useLaunchEoRIdVerificationMutation__
 *
 * To run a mutation, you first call `useLaunchEoRIdVerificationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLaunchEoRIdVerificationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [launchEoRIdVerificationMutation, { data, loading, error }] = useLaunchEoRIdVerificationMutation({
 *   variables: {
 *      memberId: // value for 'memberId'
 *   },
 * });
 */
export function useLaunchEoRIdVerificationMutation(baseOptions?: Apollo.MutationHookOptions<LaunchEoRIdVerificationMutation, LaunchEoRIdVerificationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LaunchEoRIdVerificationMutation, LaunchEoRIdVerificationMutationVariables>(LaunchEoRIdVerificationDocument, options);
      }
export type LaunchEoRIdVerificationMutationHookResult = ReturnType<typeof useLaunchEoRIdVerificationMutation>;
export type LaunchEoRIdVerificationMutationResult = Apollo.MutationResult<LaunchEoRIdVerificationMutation>;
export type LaunchEoRIdVerificationMutationOptions = Apollo.BaseMutationOptions<LaunchEoRIdVerificationMutation, LaunchEoRIdVerificationMutationVariables>;
export const EditEorEmployeeBankAccountDocument = gql`
    mutation EditEorEmployeeBankAccount($bankAccountId: String!, $bankAccount: ProfileBankAccountInput!) {
  updateEorEmployeeBankAccount(
    bankAccountId: $bankAccountId
    bankAccount: $bankAccount
  ) {
    success {
      nickname
    }
  }
}
    `;
export type EditEorEmployeeBankAccountMutationFn = Apollo.MutationFunction<EditEorEmployeeBankAccountMutation, EditEorEmployeeBankAccountMutationVariables>;

/**
 * __useEditEorEmployeeBankAccountMutation__
 *
 * To run a mutation, you first call `useEditEorEmployeeBankAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditEorEmployeeBankAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editEorEmployeeBankAccountMutation, { data, loading, error }] = useEditEorEmployeeBankAccountMutation({
 *   variables: {
 *      bankAccountId: // value for 'bankAccountId'
 *      bankAccount: // value for 'bankAccount'
 *   },
 * });
 */
export function useEditEorEmployeeBankAccountMutation(baseOptions?: Apollo.MutationHookOptions<EditEorEmployeeBankAccountMutation, EditEorEmployeeBankAccountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditEorEmployeeBankAccountMutation, EditEorEmployeeBankAccountMutationVariables>(EditEorEmployeeBankAccountDocument, options);
      }
export type EditEorEmployeeBankAccountMutationHookResult = ReturnType<typeof useEditEorEmployeeBankAccountMutation>;
export type EditEorEmployeeBankAccountMutationResult = Apollo.MutationResult<EditEorEmployeeBankAccountMutation>;
export type EditEorEmployeeBankAccountMutationOptions = Apollo.BaseMutationOptions<EditEorEmployeeBankAccountMutation, EditEorEmployeeBankAccountMutationVariables>;
export const SubmitCompensationChangeRequestDocument = gql`
    mutation SubmitCompensationChangeRequest($memberId: String!, $employmentId: String!, $changeRequest: JSON!) {
  submitChangeRequest(
    memberId: $memberId
    employmentId: $employmentId
    changeRequest: $changeRequest
  ) {
    success
  }
}
    `;
export type SubmitCompensationChangeRequestMutationFn = Apollo.MutationFunction<SubmitCompensationChangeRequestMutation, SubmitCompensationChangeRequestMutationVariables>;

/**
 * __useSubmitCompensationChangeRequestMutation__
 *
 * To run a mutation, you first call `useSubmitCompensationChangeRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubmitCompensationChangeRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [submitCompensationChangeRequestMutation, { data, loading, error }] = useSubmitCompensationChangeRequestMutation({
 *   variables: {
 *      memberId: // value for 'memberId'
 *      employmentId: // value for 'employmentId'
 *      changeRequest: // value for 'changeRequest'
 *   },
 * });
 */
export function useSubmitCompensationChangeRequestMutation(baseOptions?: Apollo.MutationHookOptions<SubmitCompensationChangeRequestMutation, SubmitCompensationChangeRequestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SubmitCompensationChangeRequestMutation, SubmitCompensationChangeRequestMutationVariables>(SubmitCompensationChangeRequestDocument, options);
      }
export type SubmitCompensationChangeRequestMutationHookResult = ReturnType<typeof useSubmitCompensationChangeRequestMutation>;
export type SubmitCompensationChangeRequestMutationResult = Apollo.MutationResult<SubmitCompensationChangeRequestMutation>;
export type SubmitCompensationChangeRequestMutationOptions = Apollo.BaseMutationOptions<SubmitCompensationChangeRequestMutation, SubmitCompensationChangeRequestMutationVariables>;
export const EditEorEmployeeProfileDocument = gql`
    mutation EditEorEmployeeProfile($memberId: String!, $profile: EorEmployeeProfileInput!) {
  updateEorEmployeeProfile(memberId: $memberId, profile: $profile) {
    success {
      personalInfo {
        preferredFirstName
        pronouns
      }
    }
  }
}
    `;
export type EditEorEmployeeProfileMutationFn = Apollo.MutationFunction<EditEorEmployeeProfileMutation, EditEorEmployeeProfileMutationVariables>;

/**
 * __useEditEorEmployeeProfileMutation__
 *
 * To run a mutation, you first call `useEditEorEmployeeProfileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditEorEmployeeProfileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editEorEmployeeProfileMutation, { data, loading, error }] = useEditEorEmployeeProfileMutation({
 *   variables: {
 *      memberId: // value for 'memberId'
 *      profile: // value for 'profile'
 *   },
 * });
 */
export function useEditEorEmployeeProfileMutation(baseOptions?: Apollo.MutationHookOptions<EditEorEmployeeProfileMutation, EditEorEmployeeProfileMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditEorEmployeeProfileMutation, EditEorEmployeeProfileMutationVariables>(EditEorEmployeeProfileDocument, options);
      }
export type EditEorEmployeeProfileMutationHookResult = ReturnType<typeof useEditEorEmployeeProfileMutation>;
export type EditEorEmployeeProfileMutationResult = Apollo.MutationResult<EditEorEmployeeProfileMutation>;
export type EditEorEmployeeProfileMutationOptions = Apollo.BaseMutationOptions<EditEorEmployeeProfileMutation, EditEorEmployeeProfileMutationVariables>;
export const ResendEorInvitationEmailDocument = gql`
    mutation ResendEorInvitationEmail($memberUuid: String!, $sendTo: String) {
  resendEorInvitationEmail(memberUuid: $memberUuid, sendTo: $sendTo) {
    success
  }
}
    `;
export type ResendEorInvitationEmailMutationFn = Apollo.MutationFunction<ResendEorInvitationEmailMutation, ResendEorInvitationEmailMutationVariables>;

/**
 * __useResendEorInvitationEmailMutation__
 *
 * To run a mutation, you first call `useResendEorInvitationEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResendEorInvitationEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resendEorInvitationEmailMutation, { data, loading, error }] = useResendEorInvitationEmailMutation({
 *   variables: {
 *      memberUuid: // value for 'memberUuid'
 *      sendTo: // value for 'sendTo'
 *   },
 * });
 */
export function useResendEorInvitationEmailMutation(baseOptions?: Apollo.MutationHookOptions<ResendEorInvitationEmailMutation, ResendEorInvitationEmailMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ResendEorInvitationEmailMutation, ResendEorInvitationEmailMutationVariables>(ResendEorInvitationEmailDocument, options);
      }
export type ResendEorInvitationEmailMutationHookResult = ReturnType<typeof useResendEorInvitationEmailMutation>;
export type ResendEorInvitationEmailMutationResult = Apollo.MutationResult<ResendEorInvitationEmailMutation>;
export type ResendEorInvitationEmailMutationOptions = Apollo.BaseMutationOptions<ResendEorInvitationEmailMutation, ResendEorInvitationEmailMutationVariables>;
export const GetAdminCapabilitiesDocument = gql`
    query GetAdminCapabilities {
  authenticatedMember {
    uuid
    capabilities {
      hasPermissionToUpdateTimeOff
      hasAccessToAdminProfileView
      hasAccessToPaymentCenter
    }
  }
}
    `;

/**
 * __useGetAdminCapabilitiesQuery__
 *
 * To run a query within a React component, call `useGetAdminCapabilitiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAdminCapabilitiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAdminCapabilitiesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAdminCapabilitiesQuery(baseOptions?: Apollo.QueryHookOptions<GetAdminCapabilitiesQuery, GetAdminCapabilitiesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAdminCapabilitiesQuery, GetAdminCapabilitiesQueryVariables>(GetAdminCapabilitiesDocument, options);
      }
export function useGetAdminCapabilitiesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAdminCapabilitiesQuery, GetAdminCapabilitiesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAdminCapabilitiesQuery, GetAdminCapabilitiesQueryVariables>(GetAdminCapabilitiesDocument, options);
        }
export function useGetAdminCapabilitiesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetAdminCapabilitiesQuery, GetAdminCapabilitiesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAdminCapabilitiesQuery, GetAdminCapabilitiesQueryVariables>(GetAdminCapabilitiesDocument, options);
        }
export type GetAdminCapabilitiesQueryHookResult = ReturnType<typeof useGetAdminCapabilitiesQuery>;
export type GetAdminCapabilitiesLazyQueryHookResult = ReturnType<typeof useGetAdminCapabilitiesLazyQuery>;
export type GetAdminCapabilitiesSuspenseQueryHookResult = ReturnType<typeof useGetAdminCapabilitiesSuspenseQuery>;
export type GetAdminCapabilitiesQueryResult = Apollo.QueryResult<GetAdminCapabilitiesQuery, GetAdminCapabilitiesQueryVariables>;
export const GetEoREmployeeProfileDocument = gql`
    query GetEoREmployeeProfile($memberId: String) {
  eorEmployeeProfile(memberId: $memberId) {
    jobInformation {
      workId
      department
      honoredStartDate
      managerInfo {
        id
        uuid
        firstName
        lastName
        middleName
        preferredFirstName
      }
      office
      employeeType
    }
    contract {
      id
      employmentId
      actorUuid
      term
      startDate
      endDate
    }
    employment {
      id
      memberId
      memberCanonicalId
      actorUuid
      workEmail
      workCountry
      companyUuid
      employmentStatus
      ...mxEmploymentFields
    }
    contactDetails {
      homeAddress {
        type
        address1
        address2
        city
        zoneCode
        postalCode
        countryCode
      }
      mailingAddress {
        type
        address1
        address2
        city
        zoneCode
        postalCode
        countryCode
      }
      homePhoneNumber {
        type
        value
      }
      mobilePhoneNumber {
        type
        value
      }
      workPhoneNumber {
        type
        value
      }
    }
    role {
      title
      payBasis
      payFrequency
      payRate
      currency
      departmentUuid
      responsibilities
      ...mxRoleFields
    }
    personalInfo {
      memberUuid
      settings {
        showDateOfBirth
      }
      pronouns
      preferredFirstName
      middleName
      lastName
      firstName
      dateOfBirth
      email
      emergencyContact {
        firstName
        lastName
        relationship
        phoneNumber {
          type
          value
        }
      }
      nationality
      ...brPersonalInfoFields
      ...clPersonalInfoFields
      ...coPersonalInfoFields
      ...crPersonalInfoFields
      ...mxPersonalInfoFields
      ...myPersonalInfoFields
      ...ptPersonalInfoFields
      ...inPersonalInfoFields
      ...esPersonalInfoFields
      ...iePersonalInfoFields
      ...phPersonalInfoFields
      ...grPersonalInfoFields
      ...nlPersonalInfoFields
      ...kePersonalInfoFields
      ...ngPersonalInfoFields
      ...dePersonalInfoFields
      ...auPersonalInfoFields
      ...caPersonalInfoFields
      ...clPersonalInfoFields
      ...dkPersonalInfoFields
      ...eePersonalInfoFields
      ...frPersonalInfoFields
      ...gbPersonalInfoFields
      ...paPersonalInfoFields
      ...plPersonalInfoFields
      ...roPersonalInfoFields
      ...sePersonalInfoFields
      ...sgPersonalInfoFields
      ...usPersonalInfoFields
      ...uyPersonalInfoFields
    }
    bankAccount {
      id
      country
      currency
      nickname
      data {
        accountHolderName
        accountNumber
        accountType
        bankCode
        bankName
        branchCode
        bsbNumber
        bvn
        countryCode
        clabe
        clearingNumber
        ctsAccountNumber
        ctsFinancialEntity
        iban
        ifscCode
        institutionNumber
        irdNumber
        registrationNumber
        routingNumber
        sortCode
        swiftCode
        transitNumber
      }
    }
    onboarding {
      workflowState
    }
    offboarding {
      requestedTerminationAt
      offboardingDate
    }
    activePtoPolicies {
      uuid
      name
      policyType
      upcomingRequests {
        uuid
        minutes
        startDate
        endDate
        status
      }
      requests {
        uuid
        minutes
        startDate
        endDate
        status
      }
      adjustments {
        adjustmentByMember {
          firstName
          lastName
        }
        createdAt
        minutes
        effectiveDate
        uuid
      }
      prettyType
      capped
      effectiveDate
      minutesPerYear
      carryoverMinutes
      timePeriodType
      awardMethod
      minutesAccruedRate
      minutesWorkedRate
      accrualCapMinutes
      approvedMinutesDuringCurrentTimePeriod
      approvedUpcomingMinutes
      balance
      annualTenureMinutes
      balanceAtBeginningOfCurrentTimePeriod
      adjustmentMinutesDuringCurrentTimePeriod
      currentTimePeriodStartDate
      accrualLevels {
        anniversaryNumber
        additionalMinutes
      }
    }
    memberEvents {
      latestEvent {
        id
        eventType
        createdAt
      }
    }
  }
}
    ${MxEmploymentFieldsFragmentDoc}
${MxRoleFieldsFragmentDoc}
${BrPersonalInfoFieldsFragmentDoc}
${ClPersonalInfoFieldsFragmentDoc}
${CoPersonalInfoFieldsFragmentDoc}
${CrPersonalInfoFieldsFragmentDoc}
${MxPersonalInfoFieldsFragmentDoc}
${MyPersonalInfoFieldsFragmentDoc}
${PtPersonalInfoFieldsFragmentDoc}
${InPersonalInfoFieldsFragmentDoc}
${EsPersonalInfoFieldsFragmentDoc}
${IePersonalInfoFieldsFragmentDoc}
${PhPersonalInfoFieldsFragmentDoc}
${GrPersonalInfoFieldsFragmentDoc}
${NlPersonalInfoFieldsFragmentDoc}
${KePersonalInfoFieldsFragmentDoc}
${NgPersonalInfoFieldsFragmentDoc}
${DePersonalInfoFieldsFragmentDoc}
${AuPersonalInfoFieldsFragmentDoc}
${CaPersonalInfoFieldsFragmentDoc}
${DkPersonalInfoFieldsFragmentDoc}
${EePersonalInfoFieldsFragmentDoc}
${FrPersonalInfoFieldsFragmentDoc}
${GbPersonalInfoFieldsFragmentDoc}
${PaPersonalInfoFieldsFragmentDoc}
${PlPersonalInfoFieldsFragmentDoc}
${RoPersonalInfoFieldsFragmentDoc}
${SePersonalInfoFieldsFragmentDoc}
${SgPersonalInfoFieldsFragmentDoc}
${UsPersonalInfoFieldsFragmentDoc}
${UyPersonalInfoFieldsFragmentDoc}`;

/**
 * __useGetEoREmployeeProfileQuery__
 *
 * To run a query within a React component, call `useGetEoREmployeeProfileQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEoREmployeeProfileQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEoREmployeeProfileQuery({
 *   variables: {
 *      memberId: // value for 'memberId'
 *   },
 * });
 */
export function useGetEoREmployeeProfileQuery(baseOptions?: Apollo.QueryHookOptions<GetEoREmployeeProfileQuery, GetEoREmployeeProfileQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEoREmployeeProfileQuery, GetEoREmployeeProfileQueryVariables>(GetEoREmployeeProfileDocument, options);
      }
export function useGetEoREmployeeProfileLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEoREmployeeProfileQuery, GetEoREmployeeProfileQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEoREmployeeProfileQuery, GetEoREmployeeProfileQueryVariables>(GetEoREmployeeProfileDocument, options);
        }
export function useGetEoREmployeeProfileSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetEoREmployeeProfileQuery, GetEoREmployeeProfileQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetEoREmployeeProfileQuery, GetEoREmployeeProfileQueryVariables>(GetEoREmployeeProfileDocument, options);
        }
export type GetEoREmployeeProfileQueryHookResult = ReturnType<typeof useGetEoREmployeeProfileQuery>;
export type GetEoREmployeeProfileLazyQueryHookResult = ReturnType<typeof useGetEoREmployeeProfileLazyQuery>;
export type GetEoREmployeeProfileSuspenseQueryHookResult = ReturnType<typeof useGetEoREmployeeProfileSuspenseQuery>;
export type GetEoREmployeeProfileQueryResult = Apollo.QueryResult<GetEoREmployeeProfileQuery, GetEoREmployeeProfileQueryVariables>;
export const InviteEorDocument = gql`
    mutation InviteEor($formDetails: EorInviteRequest!) {
  inviteEorMember(formDetails: $formDetails) {
    success
  }
}
    `;
export type InviteEorMutationFn = Apollo.MutationFunction<InviteEorMutation, InviteEorMutationVariables>;

/**
 * __useInviteEorMutation__
 *
 * To run a mutation, you first call `useInviteEorMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInviteEorMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [inviteEorMutation, { data, loading, error }] = useInviteEorMutation({
 *   variables: {
 *      formDetails: // value for 'formDetails'
 *   },
 * });
 */
export function useInviteEorMutation(baseOptions?: Apollo.MutationHookOptions<InviteEorMutation, InviteEorMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InviteEorMutation, InviteEorMutationVariables>(InviteEorDocument, options);
      }
export type InviteEorMutationHookResult = ReturnType<typeof useInviteEorMutation>;
export type InviteEorMutationResult = Apollo.MutationResult<InviteEorMutation>;
export type InviteEorMutationOptions = Apollo.BaseMutationOptions<InviteEorMutation, InviteEorMutationVariables>;
export const GetCompanyFirstHireByCountryDocument = gql`
    query GetCompanyFirstHireByCountry($workCountry: String!) {
  companyFirstHireByCountry(workCountry: $workCountry) {
    isFirstHire
  }
}
    `;

/**
 * __useGetCompanyFirstHireByCountryQuery__
 *
 * To run a query within a React component, call `useGetCompanyFirstHireByCountryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCompanyFirstHireByCountryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCompanyFirstHireByCountryQuery({
 *   variables: {
 *      workCountry: // value for 'workCountry'
 *   },
 * });
 */
export function useGetCompanyFirstHireByCountryQuery(baseOptions: Apollo.QueryHookOptions<GetCompanyFirstHireByCountryQuery, GetCompanyFirstHireByCountryQueryVariables> & ({ variables: GetCompanyFirstHireByCountryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCompanyFirstHireByCountryQuery, GetCompanyFirstHireByCountryQueryVariables>(GetCompanyFirstHireByCountryDocument, options);
      }
export function useGetCompanyFirstHireByCountryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCompanyFirstHireByCountryQuery, GetCompanyFirstHireByCountryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCompanyFirstHireByCountryQuery, GetCompanyFirstHireByCountryQueryVariables>(GetCompanyFirstHireByCountryDocument, options);
        }
export function useGetCompanyFirstHireByCountrySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCompanyFirstHireByCountryQuery, GetCompanyFirstHireByCountryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCompanyFirstHireByCountryQuery, GetCompanyFirstHireByCountryQueryVariables>(GetCompanyFirstHireByCountryDocument, options);
        }
export type GetCompanyFirstHireByCountryQueryHookResult = ReturnType<typeof useGetCompanyFirstHireByCountryQuery>;
export type GetCompanyFirstHireByCountryLazyQueryHookResult = ReturnType<typeof useGetCompanyFirstHireByCountryLazyQuery>;
export type GetCompanyFirstHireByCountrySuspenseQueryHookResult = ReturnType<typeof useGetCompanyFirstHireByCountrySuspenseQuery>;
export type GetCompanyFirstHireByCountryQueryResult = Apollo.QueryResult<GetCompanyFirstHireByCountryQuery, GetCompanyFirstHireByCountryQueryVariables>;
export const GetCurrentCompanyBusinessDescriptionDocument = gql`
    query GetCurrentCompanyBusinessDescription {
  currentMember {
    company {
      businessDescription
    }
  }
}
    `;

/**
 * __useGetCurrentCompanyBusinessDescriptionQuery__
 *
 * To run a query within a React component, call `useGetCurrentCompanyBusinessDescriptionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCurrentCompanyBusinessDescriptionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCurrentCompanyBusinessDescriptionQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCurrentCompanyBusinessDescriptionQuery(baseOptions?: Apollo.QueryHookOptions<GetCurrentCompanyBusinessDescriptionQuery, GetCurrentCompanyBusinessDescriptionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCurrentCompanyBusinessDescriptionQuery, GetCurrentCompanyBusinessDescriptionQueryVariables>(GetCurrentCompanyBusinessDescriptionDocument, options);
      }
export function useGetCurrentCompanyBusinessDescriptionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCurrentCompanyBusinessDescriptionQuery, GetCurrentCompanyBusinessDescriptionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCurrentCompanyBusinessDescriptionQuery, GetCurrentCompanyBusinessDescriptionQueryVariables>(GetCurrentCompanyBusinessDescriptionDocument, options);
        }
export function useGetCurrentCompanyBusinessDescriptionSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCurrentCompanyBusinessDescriptionQuery, GetCurrentCompanyBusinessDescriptionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCurrentCompanyBusinessDescriptionQuery, GetCurrentCompanyBusinessDescriptionQueryVariables>(GetCurrentCompanyBusinessDescriptionDocument, options);
        }
export type GetCurrentCompanyBusinessDescriptionQueryHookResult = ReturnType<typeof useGetCurrentCompanyBusinessDescriptionQuery>;
export type GetCurrentCompanyBusinessDescriptionLazyQueryHookResult = ReturnType<typeof useGetCurrentCompanyBusinessDescriptionLazyQuery>;
export type GetCurrentCompanyBusinessDescriptionSuspenseQueryHookResult = ReturnType<typeof useGetCurrentCompanyBusinessDescriptionSuspenseQuery>;
export type GetCurrentCompanyBusinessDescriptionQueryResult = Apollo.QueryResult<GetCurrentCompanyBusinessDescriptionQuery, GetCurrentCompanyBusinessDescriptionQueryVariables>;
export const GetCurrentMemberDepartmentsDocument = gql`
    query GetCurrentMemberDepartments {
  currentMember {
    company {
      departments(status: "active") {
        name
        uuid
      }
    }
  }
}
    `;

/**
 * __useGetCurrentMemberDepartmentsQuery__
 *
 * To run a query within a React component, call `useGetCurrentMemberDepartmentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCurrentMemberDepartmentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCurrentMemberDepartmentsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCurrentMemberDepartmentsQuery(baseOptions?: Apollo.QueryHookOptions<GetCurrentMemberDepartmentsQuery, GetCurrentMemberDepartmentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCurrentMemberDepartmentsQuery, GetCurrentMemberDepartmentsQueryVariables>(GetCurrentMemberDepartmentsDocument, options);
      }
export function useGetCurrentMemberDepartmentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCurrentMemberDepartmentsQuery, GetCurrentMemberDepartmentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCurrentMemberDepartmentsQuery, GetCurrentMemberDepartmentsQueryVariables>(GetCurrentMemberDepartmentsDocument, options);
        }
export function useGetCurrentMemberDepartmentsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCurrentMemberDepartmentsQuery, GetCurrentMemberDepartmentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCurrentMemberDepartmentsQuery, GetCurrentMemberDepartmentsQueryVariables>(GetCurrentMemberDepartmentsDocument, options);
        }
export type GetCurrentMemberDepartmentsQueryHookResult = ReturnType<typeof useGetCurrentMemberDepartmentsQuery>;
export type GetCurrentMemberDepartmentsLazyQueryHookResult = ReturnType<typeof useGetCurrentMemberDepartmentsLazyQuery>;
export type GetCurrentMemberDepartmentsSuspenseQueryHookResult = ReturnType<typeof useGetCurrentMemberDepartmentsSuspenseQuery>;
export type GetCurrentMemberDepartmentsQueryResult = Apollo.QueryResult<GetCurrentMemberDepartmentsQuery, GetCurrentMemberDepartmentsQueryVariables>;
export const GetCurrentMemberCompanyDirectoryMembersDocument = gql`
    query GetCurrentMemberCompanyDirectoryMembers {
  currentMember {
    company {
      directoryMembers {
        friendlyFullName
        uuid
        deskTitle
      }
    }
  }
}
    `;

/**
 * __useGetCurrentMemberCompanyDirectoryMembersQuery__
 *
 * To run a query within a React component, call `useGetCurrentMemberCompanyDirectoryMembersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCurrentMemberCompanyDirectoryMembersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCurrentMemberCompanyDirectoryMembersQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCurrentMemberCompanyDirectoryMembersQuery(baseOptions?: Apollo.QueryHookOptions<GetCurrentMemberCompanyDirectoryMembersQuery, GetCurrentMemberCompanyDirectoryMembersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCurrentMemberCompanyDirectoryMembersQuery, GetCurrentMemberCompanyDirectoryMembersQueryVariables>(GetCurrentMemberCompanyDirectoryMembersDocument, options);
      }
export function useGetCurrentMemberCompanyDirectoryMembersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCurrentMemberCompanyDirectoryMembersQuery, GetCurrentMemberCompanyDirectoryMembersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCurrentMemberCompanyDirectoryMembersQuery, GetCurrentMemberCompanyDirectoryMembersQueryVariables>(GetCurrentMemberCompanyDirectoryMembersDocument, options);
        }
export function useGetCurrentMemberCompanyDirectoryMembersSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCurrentMemberCompanyDirectoryMembersQuery, GetCurrentMemberCompanyDirectoryMembersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCurrentMemberCompanyDirectoryMembersQuery, GetCurrentMemberCompanyDirectoryMembersQueryVariables>(GetCurrentMemberCompanyDirectoryMembersDocument, options);
        }
export type GetCurrentMemberCompanyDirectoryMembersQueryHookResult = ReturnType<typeof useGetCurrentMemberCompanyDirectoryMembersQuery>;
export type GetCurrentMemberCompanyDirectoryMembersLazyQueryHookResult = ReturnType<typeof useGetCurrentMemberCompanyDirectoryMembersLazyQuery>;
export type GetCurrentMemberCompanyDirectoryMembersSuspenseQueryHookResult = ReturnType<typeof useGetCurrentMemberCompanyDirectoryMembersSuspenseQuery>;
export type GetCurrentMemberCompanyDirectoryMembersQueryResult = Apollo.QueryResult<GetCurrentMemberCompanyDirectoryMembersQuery, GetCurrentMemberCompanyDirectoryMembersQueryVariables>;
export const BackEoROnboardingStateDocument = gql`
    mutation BackEoROnboardingState($currentState: String!, $memberId: String!) {
  eorMemberOnboardingBackState(currentState: $currentState, memberId: $memberId) {
    state
  }
}
    `;
export type BackEoROnboardingStateMutationFn = Apollo.MutationFunction<BackEoROnboardingStateMutation, BackEoROnboardingStateMutationVariables>;

/**
 * __useBackEoROnboardingStateMutation__
 *
 * To run a mutation, you first call `useBackEoROnboardingStateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBackEoROnboardingStateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [backEoROnboardingStateMutation, { data, loading, error }] = useBackEoROnboardingStateMutation({
 *   variables: {
 *      currentState: // value for 'currentState'
 *      memberId: // value for 'memberId'
 *   },
 * });
 */
export function useBackEoROnboardingStateMutation(baseOptions?: Apollo.MutationHookOptions<BackEoROnboardingStateMutation, BackEoROnboardingStateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BackEoROnboardingStateMutation, BackEoROnboardingStateMutationVariables>(BackEoROnboardingStateDocument, options);
      }
export type BackEoROnboardingStateMutationHookResult = ReturnType<typeof useBackEoROnboardingStateMutation>;
export type BackEoROnboardingStateMutationResult = Apollo.MutationResult<BackEoROnboardingStateMutation>;
export type BackEoROnboardingStateMutationOptions = Apollo.BaseMutationOptions<BackEoROnboardingStateMutation, BackEoROnboardingStateMutationVariables>;
export const GetEoRMemberOnboardingStateDocument = gql`
    query GetEoRMemberOnboardingState($memberId: String!) {
  eorMemberOnboardingState(memberId: $memberId) {
    contactInfo {
      emergencyContact {
        firstName
        lastName
        phoneNumber
        relationship
      }
      homeAddress {
        address1
        address2
        city
        countryCode
        postalCode
        zoneCode
      }
      homeEmail
      mailingAddress {
        address1
        address2
        city
        countryCode
        postalCode
        zoneCode
      }
      phoneNumbers {
        type
        value
      }
    }
    idVerification {
      personaInquiryId
      status
    }
    backgroundCheck {
      status
    }
    paymentInfo {
      accountNickname
      accountHolderName
      accountNumber
      accountType
      bvn
      countryCode
      currency
      institutionNumber
      transitNumber
    }
    profileInfo {
      dateOfBirth
      firstName
      lastName
      middleName
      preferredFirstName
      pronouns
      nationality
      ...AuAdditionalFields
      ...BrAdditionalFields
      ...ClAdditionalFields
      ...CoAdditionalFields
      ...CrAdditionalFields
      ...EsAdditionalFields
      ...HrAdditionalFields
      ...IeAdditionalFields
      ...InAdditionalFields
      ...ItAdditionalFields
      ...MxAdditionalFields
      ...MyAdditionalFields
      ...NlAdditionalFields
      ...KeAdditionalFields
      ...NgAdditionalFields
      ...PaAdditionalFields
      ...PhAdditionalFields
      ...SgAdditionalFields
      ...GrAdditionalFields
      ...PeAdditionalFields
      ...TrAdditionalFields
      ...PlAdditionalFields
      ...UsAdditionalFields
      ...UyAdditionalFields
      settings {
        showDateOfBirth
      }
    }
    state
    taxInfo {
      example
    }
  }
}
    ${AuAdditionalFieldsFragmentDoc}
${BrAdditionalFieldsFragmentDoc}
${ClAdditionalFieldsFragmentDoc}
${CoAdditionalFieldsFragmentDoc}
${CrAdditionalFieldsFragmentDoc}
${EsAdditionalFieldsFragmentDoc}
${HrAdditionalFieldsFragmentDoc}
${IeAdditionalFieldsFragmentDoc}
${InAdditionalFieldsFragmentDoc}
${ItAdditionalFieldsFragmentDoc}
${MxAdditionalFieldsFragmentDoc}
${MyAdditionalFieldsFragmentDoc}
${NlAdditionalFieldsFragmentDoc}
${KeAdditionalFieldsFragmentDoc}
${NgAdditionalFieldsFragmentDoc}
${PaAdditionalFieldsFragmentDoc}
${PhAdditionalFieldsFragmentDoc}
${SgAdditionalFieldsFragmentDoc}
${GrAdditionalFieldsFragmentDoc}
${PeAdditionalFieldsFragmentDoc}
${TrAdditionalFieldsFragmentDoc}
${PlAdditionalFieldsFragmentDoc}
${UsAdditionalFieldsFragmentDoc}
${UyAdditionalFieldsFragmentDoc}`;

/**
 * __useGetEoRMemberOnboardingStateQuery__
 *
 * To run a query within a React component, call `useGetEoRMemberOnboardingStateQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEoRMemberOnboardingStateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEoRMemberOnboardingStateQuery({
 *   variables: {
 *      memberId: // value for 'memberId'
 *   },
 * });
 */
export function useGetEoRMemberOnboardingStateQuery(baseOptions: Apollo.QueryHookOptions<GetEoRMemberOnboardingStateQuery, GetEoRMemberOnboardingStateQueryVariables> & ({ variables: GetEoRMemberOnboardingStateQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEoRMemberOnboardingStateQuery, GetEoRMemberOnboardingStateQueryVariables>(GetEoRMemberOnboardingStateDocument, options);
      }
export function useGetEoRMemberOnboardingStateLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEoRMemberOnboardingStateQuery, GetEoRMemberOnboardingStateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEoRMemberOnboardingStateQuery, GetEoRMemberOnboardingStateQueryVariables>(GetEoRMemberOnboardingStateDocument, options);
        }
export function useGetEoRMemberOnboardingStateSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetEoRMemberOnboardingStateQuery, GetEoRMemberOnboardingStateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetEoRMemberOnboardingStateQuery, GetEoRMemberOnboardingStateQueryVariables>(GetEoRMemberOnboardingStateDocument, options);
        }
export type GetEoRMemberOnboardingStateQueryHookResult = ReturnType<typeof useGetEoRMemberOnboardingStateQuery>;
export type GetEoRMemberOnboardingStateLazyQueryHookResult = ReturnType<typeof useGetEoRMemberOnboardingStateLazyQuery>;
export type GetEoRMemberOnboardingStateSuspenseQueryHookResult = ReturnType<typeof useGetEoRMemberOnboardingStateSuspenseQuery>;
export type GetEoRMemberOnboardingStateQueryResult = Apollo.QueryResult<GetEoRMemberOnboardingStateQuery, GetEoRMemberOnboardingStateQueryVariables>;
export const GetEorDocumentDocument = gql`
    query GetEorDocument($fileId: String!) {
  eorDocument(fileId: $fileId) {
    signedUrl
  }
}
    `;

/**
 * __useGetEorDocumentQuery__
 *
 * To run a query within a React component, call `useGetEorDocumentQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEorDocumentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEorDocumentQuery({
 *   variables: {
 *      fileId: // value for 'fileId'
 *   },
 * });
 */
export function useGetEorDocumentQuery(baseOptions: Apollo.QueryHookOptions<GetEorDocumentQuery, GetEorDocumentQueryVariables> & ({ variables: GetEorDocumentQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEorDocumentQuery, GetEorDocumentQueryVariables>(GetEorDocumentDocument, options);
      }
export function useGetEorDocumentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEorDocumentQuery, GetEorDocumentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEorDocumentQuery, GetEorDocumentQueryVariables>(GetEorDocumentDocument, options);
        }
export function useGetEorDocumentSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetEorDocumentQuery, GetEorDocumentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetEorDocumentQuery, GetEorDocumentQueryVariables>(GetEorDocumentDocument, options);
        }
export type GetEorDocumentQueryHookResult = ReturnType<typeof useGetEorDocumentQuery>;
export type GetEorDocumentLazyQueryHookResult = ReturnType<typeof useGetEorDocumentLazyQuery>;
export type GetEorDocumentSuspenseQueryHookResult = ReturnType<typeof useGetEorDocumentSuspenseQuery>;
export type GetEorDocumentQueryResult = Apollo.QueryResult<GetEorDocumentQuery, GetEorDocumentQueryVariables>;
export const GetEoREmployeeEmploymentWorkCountryDocument = gql`
    query GetEoREmployeeEmploymentWorkCountry($memberId: String) {
  eorEmployeeProfile(memberId: $memberId) {
    employment {
      workCountry
    }
  }
}
    `;

/**
 * __useGetEoREmployeeEmploymentWorkCountryQuery__
 *
 * To run a query within a React component, call `useGetEoREmployeeEmploymentWorkCountryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEoREmployeeEmploymentWorkCountryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEoREmployeeEmploymentWorkCountryQuery({
 *   variables: {
 *      memberId: // value for 'memberId'
 *   },
 * });
 */
export function useGetEoREmployeeEmploymentWorkCountryQuery(baseOptions?: Apollo.QueryHookOptions<GetEoREmployeeEmploymentWorkCountryQuery, GetEoREmployeeEmploymentWorkCountryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEoREmployeeEmploymentWorkCountryQuery, GetEoREmployeeEmploymentWorkCountryQueryVariables>(GetEoREmployeeEmploymentWorkCountryDocument, options);
      }
export function useGetEoREmployeeEmploymentWorkCountryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEoREmployeeEmploymentWorkCountryQuery, GetEoREmployeeEmploymentWorkCountryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEoREmployeeEmploymentWorkCountryQuery, GetEoREmployeeEmploymentWorkCountryQueryVariables>(GetEoREmployeeEmploymentWorkCountryDocument, options);
        }
export function useGetEoREmployeeEmploymentWorkCountrySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetEoREmployeeEmploymentWorkCountryQuery, GetEoREmployeeEmploymentWorkCountryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetEoREmployeeEmploymentWorkCountryQuery, GetEoREmployeeEmploymentWorkCountryQueryVariables>(GetEoREmployeeEmploymentWorkCountryDocument, options);
        }
export type GetEoREmployeeEmploymentWorkCountryQueryHookResult = ReturnType<typeof useGetEoREmployeeEmploymentWorkCountryQuery>;
export type GetEoREmployeeEmploymentWorkCountryLazyQueryHookResult = ReturnType<typeof useGetEoREmployeeEmploymentWorkCountryLazyQuery>;
export type GetEoREmployeeEmploymentWorkCountrySuspenseQueryHookResult = ReturnType<typeof useGetEoREmployeeEmploymentWorkCountrySuspenseQuery>;
export type GetEoREmployeeEmploymentWorkCountryQueryResult = Apollo.QueryResult<GetEoREmployeeEmploymentWorkCountryQuery, GetEoREmployeeEmploymentWorkCountryQueryVariables>;
export const SubmitEoROnboardingStateDocument = gql`
    mutation SubmitEoROnboardingState($contactInfo: ContactInfoInput, $currentState: String!, $memberId: String!, $paymentInfo: PaymentInfoInput, $profileInfo: ProfileInfoInput, $taxInfo: TaxInfoInput) {
  eorMemberOnboardingSubmitState(
    contactInfo: $contactInfo
    currentState: $currentState
    memberId: $memberId
    paymentInfo: $paymentInfo
    profileInfo: $profileInfo
    taxInfo: $taxInfo
  ) {
    state
  }
}
    `;
export type SubmitEoROnboardingStateMutationFn = Apollo.MutationFunction<SubmitEoROnboardingStateMutation, SubmitEoROnboardingStateMutationVariables>;

/**
 * __useSubmitEoROnboardingStateMutation__
 *
 * To run a mutation, you first call `useSubmitEoROnboardingStateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubmitEoROnboardingStateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [submitEoROnboardingStateMutation, { data, loading, error }] = useSubmitEoROnboardingStateMutation({
 *   variables: {
 *      contactInfo: // value for 'contactInfo'
 *      currentState: // value for 'currentState'
 *      memberId: // value for 'memberId'
 *      paymentInfo: // value for 'paymentInfo'
 *      profileInfo: // value for 'profileInfo'
 *      taxInfo: // value for 'taxInfo'
 *   },
 * });
 */
export function useSubmitEoROnboardingStateMutation(baseOptions?: Apollo.MutationHookOptions<SubmitEoROnboardingStateMutation, SubmitEoROnboardingStateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SubmitEoROnboardingStateMutation, SubmitEoROnboardingStateMutationVariables>(SubmitEoROnboardingStateDocument, options);
      }
export type SubmitEoROnboardingStateMutationHookResult = ReturnType<typeof useSubmitEoROnboardingStateMutation>;
export type SubmitEoROnboardingStateMutationResult = Apollo.MutationResult<SubmitEoROnboardingStateMutation>;
export type SubmitEoROnboardingStateMutationOptions = Apollo.BaseMutationOptions<SubmitEoROnboardingStateMutation, SubmitEoROnboardingStateMutationVariables>;
export const GetDisbursementOrderDocument = gql`
    query GetDisbursementOrder($id: String!) {
  disbursementOrder(id: $id) {
    id
    memberId
    country
    paymentType
    currency
    amount
    payPeriodId
    data {
      paymentSettings {
        benefitType
        payPeriodId
        notes
        formOfIncome
        disbursementDate
        deliveryMethod
        effectiveDate
        expenseType
        isRecurring
        recurringCadence
      }
      expenseDetails {
        transactionDate
        receipts {
          uuid
          name
          type
          size
          lastModified
        }
        distance
        additionalInformation
      }
      paymentDetails {
        memberId
        grossAmount
        currency
        workPeriodStart
        workPeriodEnd
      }
      taxes {
        bonusType
        nonDiscretionaryType
        reason
        cadence
        frequency
      }
    }
    status
    createdAt
    member {
      id
      actorUuid
      memberUuid
      firstName
      lastName
      middleName
      preferredFirstName
      workStartDate
      workEndDate
    }
  }
}
    `;

/**
 * __useGetDisbursementOrderQuery__
 *
 * To run a query within a React component, call `useGetDisbursementOrderQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDisbursementOrderQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDisbursementOrderQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetDisbursementOrderQuery(baseOptions: Apollo.QueryHookOptions<GetDisbursementOrderQuery, GetDisbursementOrderQueryVariables> & ({ variables: GetDisbursementOrderQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDisbursementOrderQuery, GetDisbursementOrderQueryVariables>(GetDisbursementOrderDocument, options);
      }
export function useGetDisbursementOrderLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDisbursementOrderQuery, GetDisbursementOrderQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDisbursementOrderQuery, GetDisbursementOrderQueryVariables>(GetDisbursementOrderDocument, options);
        }
export function useGetDisbursementOrderSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetDisbursementOrderQuery, GetDisbursementOrderQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetDisbursementOrderQuery, GetDisbursementOrderQueryVariables>(GetDisbursementOrderDocument, options);
        }
export type GetDisbursementOrderQueryHookResult = ReturnType<typeof useGetDisbursementOrderQuery>;
export type GetDisbursementOrderLazyQueryHookResult = ReturnType<typeof useGetDisbursementOrderLazyQuery>;
export type GetDisbursementOrderSuspenseQueryHookResult = ReturnType<typeof useGetDisbursementOrderSuspenseQuery>;
export type GetDisbursementOrderQueryResult = Apollo.QueryResult<GetDisbursementOrderQuery, GetDisbursementOrderQueryVariables>;
export const EorCreateDisbursementOrdersDocument = gql`
    mutation eorCreateDisbursementOrders($paymentDetails: JSON!, $setup: JSON!) {
  eorCreateDisbursementOrders(paymentDetails: $paymentDetails, setup: $setup) {
    state
  }
}
    `;
export type EorCreateDisbursementOrdersMutationFn = Apollo.MutationFunction<EorCreateDisbursementOrdersMutation, EorCreateDisbursementOrdersMutationVariables>;

/**
 * __useEorCreateDisbursementOrdersMutation__
 *
 * To run a mutation, you first call `useEorCreateDisbursementOrdersMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEorCreateDisbursementOrdersMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [eorCreateDisbursementOrdersMutation, { data, loading, error }] = useEorCreateDisbursementOrdersMutation({
 *   variables: {
 *      paymentDetails: // value for 'paymentDetails'
 *      setup: // value for 'setup'
 *   },
 * });
 */
export function useEorCreateDisbursementOrdersMutation(baseOptions?: Apollo.MutationHookOptions<EorCreateDisbursementOrdersMutation, EorCreateDisbursementOrdersMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EorCreateDisbursementOrdersMutation, EorCreateDisbursementOrdersMutationVariables>(EorCreateDisbursementOrdersDocument, options);
      }
export type EorCreateDisbursementOrdersMutationHookResult = ReturnType<typeof useEorCreateDisbursementOrdersMutation>;
export type EorCreateDisbursementOrdersMutationResult = Apollo.MutationResult<EorCreateDisbursementOrdersMutation>;
export type EorCreateDisbursementOrdersMutationOptions = Apollo.BaseMutationOptions<EorCreateDisbursementOrdersMutation, EorCreateDisbursementOrdersMutationVariables>;
export const EorUpdateDisbursementOrdersDocument = gql`
    mutation eorUpdateDisbursementOrders($id: String!, $payload: JSON!) {
  eorUpdateDisbursementOrders(id: $id, payload: $payload) {
    state
  }
}
    `;
export type EorUpdateDisbursementOrdersMutationFn = Apollo.MutationFunction<EorUpdateDisbursementOrdersMutation, EorUpdateDisbursementOrdersMutationVariables>;

/**
 * __useEorUpdateDisbursementOrdersMutation__
 *
 * To run a mutation, you first call `useEorUpdateDisbursementOrdersMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEorUpdateDisbursementOrdersMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [eorUpdateDisbursementOrdersMutation, { data, loading, error }] = useEorUpdateDisbursementOrdersMutation({
 *   variables: {
 *      id: // value for 'id'
 *      payload: // value for 'payload'
 *   },
 * });
 */
export function useEorUpdateDisbursementOrdersMutation(baseOptions?: Apollo.MutationHookOptions<EorUpdateDisbursementOrdersMutation, EorUpdateDisbursementOrdersMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EorUpdateDisbursementOrdersMutation, EorUpdateDisbursementOrdersMutationVariables>(EorUpdateDisbursementOrdersDocument, options);
      }
export type EorUpdateDisbursementOrdersMutationHookResult = ReturnType<typeof useEorUpdateDisbursementOrdersMutation>;
export type EorUpdateDisbursementOrdersMutationResult = Apollo.MutationResult<EorUpdateDisbursementOrdersMutation>;
export type EorUpdateDisbursementOrdersMutationOptions = Apollo.BaseMutationOptions<EorUpdateDisbursementOrdersMutation, EorUpdateDisbursementOrdersMutationVariables>;
export const GetEoRDisbursementDatesDocument = gql`
    query GetEoRDisbursementDates($country: String!) {
  upcomingPayDate(country: $country) {
    payPeriods {
      id
      disbursementDate
      endDate
      startDate
    }
  }
}
    `;

/**
 * __useGetEoRDisbursementDatesQuery__
 *
 * To run a query within a React component, call `useGetEoRDisbursementDatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEoRDisbursementDatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEoRDisbursementDatesQuery({
 *   variables: {
 *      country: // value for 'country'
 *   },
 * });
 */
export function useGetEoRDisbursementDatesQuery(baseOptions: Apollo.QueryHookOptions<GetEoRDisbursementDatesQuery, GetEoRDisbursementDatesQueryVariables> & ({ variables: GetEoRDisbursementDatesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEoRDisbursementDatesQuery, GetEoRDisbursementDatesQueryVariables>(GetEoRDisbursementDatesDocument, options);
      }
export function useGetEoRDisbursementDatesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEoRDisbursementDatesQuery, GetEoRDisbursementDatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEoRDisbursementDatesQuery, GetEoRDisbursementDatesQueryVariables>(GetEoRDisbursementDatesDocument, options);
        }
export function useGetEoRDisbursementDatesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetEoRDisbursementDatesQuery, GetEoRDisbursementDatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetEoRDisbursementDatesQuery, GetEoRDisbursementDatesQueryVariables>(GetEoRDisbursementDatesDocument, options);
        }
export type GetEoRDisbursementDatesQueryHookResult = ReturnType<typeof useGetEoRDisbursementDatesQuery>;
export type GetEoRDisbursementDatesLazyQueryHookResult = ReturnType<typeof useGetEoRDisbursementDatesLazyQuery>;
export type GetEoRDisbursementDatesSuspenseQueryHookResult = ReturnType<typeof useGetEoRDisbursementDatesSuspenseQuery>;
export type GetEoRDisbursementDatesQueryResult = Apollo.QueryResult<GetEoRDisbursementDatesQuery, GetEoRDisbursementDatesQueryVariables>;
export const GetEorExchangeRatesDocument = gql`
    query GetEorExchangeRates($source: String!, $targets: [String!]!, $time: String) {
  exchangeRateData(source: $source, targets: $targets, time: $time) {
    rates {
      rate
      source
      target
      date
      subunitConversionFactor
    }
  }
}
    `;

/**
 * __useGetEorExchangeRatesQuery__
 *
 * To run a query within a React component, call `useGetEorExchangeRatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEorExchangeRatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEorExchangeRatesQuery({
 *   variables: {
 *      source: // value for 'source'
 *      targets: // value for 'targets'
 *      time: // value for 'time'
 *   },
 * });
 */
export function useGetEorExchangeRatesQuery(baseOptions: Apollo.QueryHookOptions<GetEorExchangeRatesQuery, GetEorExchangeRatesQueryVariables> & ({ variables: GetEorExchangeRatesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEorExchangeRatesQuery, GetEorExchangeRatesQueryVariables>(GetEorExchangeRatesDocument, options);
      }
export function useGetEorExchangeRatesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEorExchangeRatesQuery, GetEorExchangeRatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEorExchangeRatesQuery, GetEorExchangeRatesQueryVariables>(GetEorExchangeRatesDocument, options);
        }
export function useGetEorExchangeRatesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetEorExchangeRatesQuery, GetEorExchangeRatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetEorExchangeRatesQuery, GetEorExchangeRatesQueryVariables>(GetEorExchangeRatesDocument, options);
        }
export type GetEorExchangeRatesQueryHookResult = ReturnType<typeof useGetEorExchangeRatesQuery>;
export type GetEorExchangeRatesLazyQueryHookResult = ReturnType<typeof useGetEorExchangeRatesLazyQuery>;
export type GetEorExchangeRatesSuspenseQueryHookResult = ReturnType<typeof useGetEorExchangeRatesSuspenseQuery>;
export type GetEorExchangeRatesQueryResult = Apollo.QueryResult<GetEorExchangeRatesQuery, GetEorExchangeRatesQueryVariables>;
export const GetActiveEoRMembersByCompanyUuidDocument = gql`
    query GetActiveEoRMembersByCompanyUuid {
  eorMembers(activeOnly: true) {
    id
    email
    firstName
    lastName
    memberUuid
    preferredFirstName
    middleName
    workCountry
    workStartDate
    workEndDate
  }
}
    `;

/**
 * __useGetActiveEoRMembersByCompanyUuidQuery__
 *
 * To run a query within a React component, call `useGetActiveEoRMembersByCompanyUuidQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetActiveEoRMembersByCompanyUuidQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetActiveEoRMembersByCompanyUuidQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetActiveEoRMembersByCompanyUuidQuery(baseOptions?: Apollo.QueryHookOptions<GetActiveEoRMembersByCompanyUuidQuery, GetActiveEoRMembersByCompanyUuidQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetActiveEoRMembersByCompanyUuidQuery, GetActiveEoRMembersByCompanyUuidQueryVariables>(GetActiveEoRMembersByCompanyUuidDocument, options);
      }
export function useGetActiveEoRMembersByCompanyUuidLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetActiveEoRMembersByCompanyUuidQuery, GetActiveEoRMembersByCompanyUuidQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetActiveEoRMembersByCompanyUuidQuery, GetActiveEoRMembersByCompanyUuidQueryVariables>(GetActiveEoRMembersByCompanyUuidDocument, options);
        }
export function useGetActiveEoRMembersByCompanyUuidSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetActiveEoRMembersByCompanyUuidQuery, GetActiveEoRMembersByCompanyUuidQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetActiveEoRMembersByCompanyUuidQuery, GetActiveEoRMembersByCompanyUuidQueryVariables>(GetActiveEoRMembersByCompanyUuidDocument, options);
        }
export type GetActiveEoRMembersByCompanyUuidQueryHookResult = ReturnType<typeof useGetActiveEoRMembersByCompanyUuidQuery>;
export type GetActiveEoRMembersByCompanyUuidLazyQueryHookResult = ReturnType<typeof useGetActiveEoRMembersByCompanyUuidLazyQuery>;
export type GetActiveEoRMembersByCompanyUuidSuspenseQueryHookResult = ReturnType<typeof useGetActiveEoRMembersByCompanyUuidSuspenseQuery>;
export type GetActiveEoRMembersByCompanyUuidQueryResult = Apollo.QueryResult<GetActiveEoRMembersByCompanyUuidQuery, GetActiveEoRMembersByCompanyUuidQueryVariables>;
export const GetEorPayPeriodsDocument = gql`
    query GetEorPayPeriods($country: String!, $startDate: String!, $endDate: String!) {
  payPeriodDates(country: $country, startDate: $startDate, endDate: $endDate) {
    payPeriods {
      startDate
      endDate
      payGroup
    }
  }
}
    `;

/**
 * __useGetEorPayPeriodsQuery__
 *
 * To run a query within a React component, call `useGetEorPayPeriodsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEorPayPeriodsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEorPayPeriodsQuery({
 *   variables: {
 *      country: // value for 'country'
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *   },
 * });
 */
export function useGetEorPayPeriodsQuery(baseOptions: Apollo.QueryHookOptions<GetEorPayPeriodsQuery, GetEorPayPeriodsQueryVariables> & ({ variables: GetEorPayPeriodsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEorPayPeriodsQuery, GetEorPayPeriodsQueryVariables>(GetEorPayPeriodsDocument, options);
      }
export function useGetEorPayPeriodsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEorPayPeriodsQuery, GetEorPayPeriodsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEorPayPeriodsQuery, GetEorPayPeriodsQueryVariables>(GetEorPayPeriodsDocument, options);
        }
export function useGetEorPayPeriodsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetEorPayPeriodsQuery, GetEorPayPeriodsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetEorPayPeriodsQuery, GetEorPayPeriodsQueryVariables>(GetEorPayPeriodsDocument, options);
        }
export type GetEorPayPeriodsQueryHookResult = ReturnType<typeof useGetEorPayPeriodsQuery>;
export type GetEorPayPeriodsLazyQueryHookResult = ReturnType<typeof useGetEorPayPeriodsLazyQuery>;
export type GetEorPayPeriodsSuspenseQueryHookResult = ReturnType<typeof useGetEorPayPeriodsSuspenseQuery>;
export type GetEorPayPeriodsQueryResult = Apollo.QueryResult<GetEorPayPeriodsQuery, GetEorPayPeriodsQueryVariables>;
export const ActivateExpensesDocument = gql`
    mutation ActivateExpenses {
  setCompanySetting(name: "feature_activation.expense_management", value: "true") {
    success
  }
}
    `;
export type ActivateExpensesMutationFn = Apollo.MutationFunction<ActivateExpensesMutation, ActivateExpensesMutationVariables>;

/**
 * __useActivateExpensesMutation__
 *
 * To run a mutation, you first call `useActivateExpensesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useActivateExpensesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [activateExpensesMutation, { data, loading, error }] = useActivateExpensesMutation({
 *   variables: {
 *   },
 * });
 */
export function useActivateExpensesMutation(baseOptions?: Apollo.MutationHookOptions<ActivateExpensesMutation, ActivateExpensesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ActivateExpensesMutation, ActivateExpensesMutationVariables>(ActivateExpensesDocument, options);
      }
export type ActivateExpensesMutationHookResult = ReturnType<typeof useActivateExpensesMutation>;
export type ActivateExpensesMutationResult = Apollo.MutationResult<ActivateExpensesMutation>;
export type ActivateExpensesMutationOptions = Apollo.BaseMutationOptions<ActivateExpensesMutation, ActivateExpensesMutationVariables>;
export const ApproveReimbursementRequestDocument = gql`
    mutation ApproveReimbursementRequest($payDate: APIDate, $reviews: [ReimbursementReviewInput!]!) {
  reviewReimbursementRequests(payDate: $payDate, reviews: $reviews) {
    success
    error
    updatedRequests {
      name
      status
      totalReimbursableAmount
      totalNonReimbursableAmount
      member {
        friendlyFullName
      }
    }
  }
}
    `;
export type ApproveReimbursementRequestMutationFn = Apollo.MutationFunction<ApproveReimbursementRequestMutation, ApproveReimbursementRequestMutationVariables>;

/**
 * __useApproveReimbursementRequestMutation__
 *
 * To run a mutation, you first call `useApproveReimbursementRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useApproveReimbursementRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [approveReimbursementRequestMutation, { data, loading, error }] = useApproveReimbursementRequestMutation({
 *   variables: {
 *      payDate: // value for 'payDate'
 *      reviews: // value for 'reviews'
 *   },
 * });
 */
export function useApproveReimbursementRequestMutation(baseOptions?: Apollo.MutationHookOptions<ApproveReimbursementRequestMutation, ApproveReimbursementRequestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ApproveReimbursementRequestMutation, ApproveReimbursementRequestMutationVariables>(ApproveReimbursementRequestDocument, options);
      }
export type ApproveReimbursementRequestMutationHookResult = ReturnType<typeof useApproveReimbursementRequestMutation>;
export type ApproveReimbursementRequestMutationResult = Apollo.MutationResult<ApproveReimbursementRequestMutation>;
export type ApproveReimbursementRequestMutationOptions = Apollo.BaseMutationOptions<ApproveReimbursementRequestMutation, ApproveReimbursementRequestMutationVariables>;
export const ApproveReimbursementRequestsDocument = gql`
    mutation ApproveReimbursementRequests($reviews: [ReimbursementReviewInput!]!) {
  reviewReimbursementRequests(reviews: $reviews) {
    success
    error
    updatedRequests {
      name
      status
      totalNonReimbursableAmount
      member {
        friendlyFullName
      }
    }
  }
}
    `;
export type ApproveReimbursementRequestsMutationFn = Apollo.MutationFunction<ApproveReimbursementRequestsMutation, ApproveReimbursementRequestsMutationVariables>;

/**
 * __useApproveReimbursementRequestsMutation__
 *
 * To run a mutation, you first call `useApproveReimbursementRequestsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useApproveReimbursementRequestsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [approveReimbursementRequestsMutation, { data, loading, error }] = useApproveReimbursementRequestsMutation({
 *   variables: {
 *      reviews: // value for 'reviews'
 *   },
 * });
 */
export function useApproveReimbursementRequestsMutation(baseOptions?: Apollo.MutationHookOptions<ApproveReimbursementRequestsMutation, ApproveReimbursementRequestsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ApproveReimbursementRequestsMutation, ApproveReimbursementRequestsMutationVariables>(ApproveReimbursementRequestsDocument, options);
      }
export type ApproveReimbursementRequestsMutationHookResult = ReturnType<typeof useApproveReimbursementRequestsMutation>;
export type ApproveReimbursementRequestsMutationResult = Apollo.MutationResult<ApproveReimbursementRequestsMutation>;
export type ApproveReimbursementRequestsMutationOptions = Apollo.BaseMutationOptions<ApproveReimbursementRequestsMutation, ApproveReimbursementRequestsMutationVariables>;
export const CreateExpensePolicyDocument = gql`
    mutation CreateExpensePolicy {
  updateExpensePolicy {
    success
    error
  }
}
    `;
export type CreateExpensePolicyMutationFn = Apollo.MutationFunction<CreateExpensePolicyMutation, CreateExpensePolicyMutationVariables>;

/**
 * __useCreateExpensePolicyMutation__
 *
 * To run a mutation, you first call `useCreateExpensePolicyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateExpensePolicyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createExpensePolicyMutation, { data, loading, error }] = useCreateExpensePolicyMutation({
 *   variables: {
 *   },
 * });
 */
export function useCreateExpensePolicyMutation(baseOptions?: Apollo.MutationHookOptions<CreateExpensePolicyMutation, CreateExpensePolicyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateExpensePolicyMutation, CreateExpensePolicyMutationVariables>(CreateExpensePolicyDocument, options);
      }
export type CreateExpensePolicyMutationHookResult = ReturnType<typeof useCreateExpensePolicyMutation>;
export type CreateExpensePolicyMutationResult = Apollo.MutationResult<CreateExpensePolicyMutation>;
export type CreateExpensePolicyMutationOptions = Apollo.BaseMutationOptions<CreateExpensePolicyMutation, CreateExpensePolicyMutationVariables>;
export const CreateReimbursementRequestDocument = gql`
    mutation CreateReimbursementRequest($name: String!, $expenses: [ExpenseInput!]!) {
  createReimbursementRequest(name: $name, expenses: $expenses, source: DESKTOP) {
    success
    error
  }
}
    `;
export type CreateReimbursementRequestMutationFn = Apollo.MutationFunction<CreateReimbursementRequestMutation, CreateReimbursementRequestMutationVariables>;

/**
 * __useCreateReimbursementRequestMutation__
 *
 * To run a mutation, you first call `useCreateReimbursementRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateReimbursementRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createReimbursementRequestMutation, { data, loading, error }] = useCreateReimbursementRequestMutation({
 *   variables: {
 *      name: // value for 'name'
 *      expenses: // value for 'expenses'
 *   },
 * });
 */
export function useCreateReimbursementRequestMutation(baseOptions?: Apollo.MutationHookOptions<CreateReimbursementRequestMutation, CreateReimbursementRequestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateReimbursementRequestMutation, CreateReimbursementRequestMutationVariables>(CreateReimbursementRequestDocument, options);
      }
export type CreateReimbursementRequestMutationHookResult = ReturnType<typeof useCreateReimbursementRequestMutation>;
export type CreateReimbursementRequestMutationResult = Apollo.MutationResult<CreateReimbursementRequestMutation>;
export type CreateReimbursementRequestMutationOptions = Apollo.BaseMutationOptions<CreateReimbursementRequestMutation, CreateReimbursementRequestMutationVariables>;
export const CreateUnattachedExpenseDocument = gql`
    mutation CreateUnattachedExpense($expense: ExpenseInput!) {
  createUnattachedExpense(expense: $expense, source: DESKTOP) {
    success
    error
  }
}
    `;
export type CreateUnattachedExpenseMutationFn = Apollo.MutationFunction<CreateUnattachedExpenseMutation, CreateUnattachedExpenseMutationVariables>;

/**
 * __useCreateUnattachedExpenseMutation__
 *
 * To run a mutation, you first call `useCreateUnattachedExpenseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateUnattachedExpenseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createUnattachedExpenseMutation, { data, loading, error }] = useCreateUnattachedExpenseMutation({
 *   variables: {
 *      expense: // value for 'expense'
 *   },
 * });
 */
export function useCreateUnattachedExpenseMutation(baseOptions?: Apollo.MutationHookOptions<CreateUnattachedExpenseMutation, CreateUnattachedExpenseMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateUnattachedExpenseMutation, CreateUnattachedExpenseMutationVariables>(CreateUnattachedExpenseDocument, options);
      }
export type CreateUnattachedExpenseMutationHookResult = ReturnType<typeof useCreateUnattachedExpenseMutation>;
export type CreateUnattachedExpenseMutationResult = Apollo.MutationResult<CreateUnattachedExpenseMutation>;
export type CreateUnattachedExpenseMutationOptions = Apollo.BaseMutationOptions<CreateUnattachedExpenseMutation, CreateUnattachedExpenseMutationVariables>;
export const DeleteReimbursementRequestDocument = gql`
    mutation DeleteReimbursementRequest($uuids: [ID!]!) {
  deleteReimbursementRequests(uuids: $uuids) {
    success
    error
    deletedReimbursementRequests {
      name
    }
  }
}
    `;
export type DeleteReimbursementRequestMutationFn = Apollo.MutationFunction<DeleteReimbursementRequestMutation, DeleteReimbursementRequestMutationVariables>;

/**
 * __useDeleteReimbursementRequestMutation__
 *
 * To run a mutation, you first call `useDeleteReimbursementRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteReimbursementRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteReimbursementRequestMutation, { data, loading, error }] = useDeleteReimbursementRequestMutation({
 *   variables: {
 *      uuids: // value for 'uuids'
 *   },
 * });
 */
export function useDeleteReimbursementRequestMutation(baseOptions?: Apollo.MutationHookOptions<DeleteReimbursementRequestMutation, DeleteReimbursementRequestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteReimbursementRequestMutation, DeleteReimbursementRequestMutationVariables>(DeleteReimbursementRequestDocument, options);
      }
export type DeleteReimbursementRequestMutationHookResult = ReturnType<typeof useDeleteReimbursementRequestMutation>;
export type DeleteReimbursementRequestMutationResult = Apollo.MutationResult<DeleteReimbursementRequestMutation>;
export type DeleteReimbursementRequestMutationOptions = Apollo.BaseMutationOptions<DeleteReimbursementRequestMutation, DeleteReimbursementRequestMutationVariables>;
export const DeleteUnattachedExpenseDocument = gql`
    mutation DeleteUnattachedExpense($uuids: [ID!]!) {
  deleteUnattachedExpenses(uuids: $uuids) {
    success
    error
    deletedExpenses {
      uuid
    }
  }
}
    `;
export type DeleteUnattachedExpenseMutationFn = Apollo.MutationFunction<DeleteUnattachedExpenseMutation, DeleteUnattachedExpenseMutationVariables>;

/**
 * __useDeleteUnattachedExpenseMutation__
 *
 * To run a mutation, you first call `useDeleteUnattachedExpenseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteUnattachedExpenseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteUnattachedExpenseMutation, { data, loading, error }] = useDeleteUnattachedExpenseMutation({
 *   variables: {
 *      uuids: // value for 'uuids'
 *   },
 * });
 */
export function useDeleteUnattachedExpenseMutation(baseOptions?: Apollo.MutationHookOptions<DeleteUnattachedExpenseMutation, DeleteUnattachedExpenseMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteUnattachedExpenseMutation, DeleteUnattachedExpenseMutationVariables>(DeleteUnattachedExpenseDocument, options);
      }
export type DeleteUnattachedExpenseMutationHookResult = ReturnType<typeof useDeleteUnattachedExpenseMutation>;
export type DeleteUnattachedExpenseMutationResult = Apollo.MutationResult<DeleteUnattachedExpenseMutation>;
export type DeleteUnattachedExpenseMutationOptions = Apollo.BaseMutationOptions<DeleteUnattachedExpenseMutation, DeleteUnattachedExpenseMutationVariables>;
export const ReturnToEmployeeDocument = gql`
    mutation ReturnToEmployee($reviews: [ReimbursementReviewInput!]!) {
  reviewReimbursementRequests(reviews: $reviews) {
    success
    updatedRequests {
      name
      member {
        friendlyFullName
      }
    }
  }
}
    `;
export type ReturnToEmployeeMutationFn = Apollo.MutationFunction<ReturnToEmployeeMutation, ReturnToEmployeeMutationVariables>;

/**
 * __useReturnToEmployeeMutation__
 *
 * To run a mutation, you first call `useReturnToEmployeeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReturnToEmployeeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [returnToEmployeeMutation, { data, loading, error }] = useReturnToEmployeeMutation({
 *   variables: {
 *      reviews: // value for 'reviews'
 *   },
 * });
 */
export function useReturnToEmployeeMutation(baseOptions?: Apollo.MutationHookOptions<ReturnToEmployeeMutation, ReturnToEmployeeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ReturnToEmployeeMutation, ReturnToEmployeeMutationVariables>(ReturnToEmployeeDocument, options);
      }
export type ReturnToEmployeeMutationHookResult = ReturnType<typeof useReturnToEmployeeMutation>;
export type ReturnToEmployeeMutationResult = Apollo.MutationResult<ReturnToEmployeeMutation>;
export type ReturnToEmployeeMutationOptions = Apollo.BaseMutationOptions<ReturnToEmployeeMutation, ReturnToEmployeeMutationVariables>;
export const ToggleExpensesEnabledDocument = gql`
    mutation ToggleExpensesEnabled($enabled: Boolean!) {
  updateExpensePolicy(enabled: $enabled) {
    success
    updatedPolicy {
      enabled
    }
  }
}
    `;
export type ToggleExpensesEnabledMutationFn = Apollo.MutationFunction<ToggleExpensesEnabledMutation, ToggleExpensesEnabledMutationVariables>;

/**
 * __useToggleExpensesEnabledMutation__
 *
 * To run a mutation, you first call `useToggleExpensesEnabledMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useToggleExpensesEnabledMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [toggleExpensesEnabledMutation, { data, loading, error }] = useToggleExpensesEnabledMutation({
 *   variables: {
 *      enabled: // value for 'enabled'
 *   },
 * });
 */
export function useToggleExpensesEnabledMutation(baseOptions?: Apollo.MutationHookOptions<ToggleExpensesEnabledMutation, ToggleExpensesEnabledMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ToggleExpensesEnabledMutation, ToggleExpensesEnabledMutationVariables>(ToggleExpensesEnabledDocument, options);
      }
export type ToggleExpensesEnabledMutationHookResult = ReturnType<typeof useToggleExpensesEnabledMutation>;
export type ToggleExpensesEnabledMutationResult = Apollo.MutationResult<ToggleExpensesEnabledMutation>;
export type ToggleExpensesEnabledMutationOptions = Apollo.BaseMutationOptions<ToggleExpensesEnabledMutation, ToggleExpensesEnabledMutationVariables>;
export const UpdateCategoriesDocument = gql`
    mutation UpdateCategories($categories: [ExpenseCategoryUpdate!]) {
  updateExpenseCategories(updates: $categories) {
    success
    error
    updatedCategories {
      uuid
      name
      visible
      custom
      merchant
      description
      receipt
      attendees
      billableToClient
      expenseType
    }
  }
}
    `;
export type UpdateCategoriesMutationFn = Apollo.MutationFunction<UpdateCategoriesMutation, UpdateCategoriesMutationVariables>;

/**
 * __useUpdateCategoriesMutation__
 *
 * To run a mutation, you first call `useUpdateCategoriesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCategoriesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCategoriesMutation, { data, loading, error }] = useUpdateCategoriesMutation({
 *   variables: {
 *      categories: // value for 'categories'
 *   },
 * });
 */
export function useUpdateCategoriesMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCategoriesMutation, UpdateCategoriesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCategoriesMutation, UpdateCategoriesMutationVariables>(UpdateCategoriesDocument, options);
      }
export type UpdateCategoriesMutationHookResult = ReturnType<typeof useUpdateCategoriesMutation>;
export type UpdateCategoriesMutationResult = Apollo.MutationResult<UpdateCategoriesMutation>;
export type UpdateCategoriesMutationOptions = Apollo.BaseMutationOptions<UpdateCategoriesMutation, UpdateCategoriesMutationVariables>;
export const UpdateProjectsDocument = gql`
    mutation UpdateProjects($projectUpdates: [ProjectUpdate!]) {
  updateProjects(updates: $projectUpdates) {
    success
    error
    updatedProjects {
      projectCode
      projectName
      uuid
      visible
    }
  }
}
    `;
export type UpdateProjectsMutationFn = Apollo.MutationFunction<UpdateProjectsMutation, UpdateProjectsMutationVariables>;

/**
 * __useUpdateProjectsMutation__
 *
 * To run a mutation, you first call `useUpdateProjectsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateProjectsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateProjectsMutation, { data, loading, error }] = useUpdateProjectsMutation({
 *   variables: {
 *      projectUpdates: // value for 'projectUpdates'
 *   },
 * });
 */
export function useUpdateProjectsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateProjectsMutation, UpdateProjectsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateProjectsMutation, UpdateProjectsMutationVariables>(UpdateProjectsDocument, options);
      }
export type UpdateProjectsMutationHookResult = ReturnType<typeof useUpdateProjectsMutation>;
export type UpdateProjectsMutationResult = Apollo.MutationResult<UpdateProjectsMutation>;
export type UpdateProjectsMutationOptions = Apollo.BaseMutationOptions<UpdateProjectsMutation, UpdateProjectsMutationVariables>;
export const UpdateReimbursementRequestDocument = gql`
    mutation UpdateReimbursementRequest($uuid: ID!, $name: String!, $expenses: [ExpenseInput!]!) {
  updateReimbursementRequest(
    uuid: $uuid
    name: $name
    expenses: $expenses
    source: DESKTOP
  ) {
    success
    error
  }
}
    `;
export type UpdateReimbursementRequestMutationFn = Apollo.MutationFunction<UpdateReimbursementRequestMutation, UpdateReimbursementRequestMutationVariables>;

/**
 * __useUpdateReimbursementRequestMutation__
 *
 * To run a mutation, you first call `useUpdateReimbursementRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateReimbursementRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateReimbursementRequestMutation, { data, loading, error }] = useUpdateReimbursementRequestMutation({
 *   variables: {
 *      uuid: // value for 'uuid'
 *      name: // value for 'name'
 *      expenses: // value for 'expenses'
 *   },
 * });
 */
export function useUpdateReimbursementRequestMutation(baseOptions?: Apollo.MutationHookOptions<UpdateReimbursementRequestMutation, UpdateReimbursementRequestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateReimbursementRequestMutation, UpdateReimbursementRequestMutationVariables>(UpdateReimbursementRequestDocument, options);
      }
export type UpdateReimbursementRequestMutationHookResult = ReturnType<typeof useUpdateReimbursementRequestMutation>;
export type UpdateReimbursementRequestMutationResult = Apollo.MutationResult<UpdateReimbursementRequestMutation>;
export type UpdateReimbursementRequestMutationOptions = Apollo.BaseMutationOptions<UpdateReimbursementRequestMutation, UpdateReimbursementRequestMutationVariables>;
export const UpdateUnattachedExpenseDocument = gql`
    mutation UpdateUnattachedExpense($expense: ExpenseInput!) {
  updateUnattachedExpense(expense: $expense) {
    success
    error
  }
}
    `;
export type UpdateUnattachedExpenseMutationFn = Apollo.MutationFunction<UpdateUnattachedExpenseMutation, UpdateUnattachedExpenseMutationVariables>;

/**
 * __useUpdateUnattachedExpenseMutation__
 *
 * To run a mutation, you first call `useUpdateUnattachedExpenseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUnattachedExpenseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUnattachedExpenseMutation, { data, loading, error }] = useUpdateUnattachedExpenseMutation({
 *   variables: {
 *      expense: // value for 'expense'
 *   },
 * });
 */
export function useUpdateUnattachedExpenseMutation(baseOptions?: Apollo.MutationHookOptions<UpdateUnattachedExpenseMutation, UpdateUnattachedExpenseMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateUnattachedExpenseMutation, UpdateUnattachedExpenseMutationVariables>(UpdateUnattachedExpenseDocument, options);
      }
export type UpdateUnattachedExpenseMutationHookResult = ReturnType<typeof useUpdateUnattachedExpenseMutation>;
export type UpdateUnattachedExpenseMutationResult = Apollo.MutationResult<UpdateUnattachedExpenseMutation>;
export type UpdateUnattachedExpenseMutationOptions = Apollo.BaseMutationOptions<UpdateUnattachedExpenseMutation, UpdateUnattachedExpenseMutationVariables>;
export const GetActiveRequestsDocument = gql`
    query GetActiveRequests($resultsPerPage: Int!, $pageNum: Int!, $sortParams: [ReimbursementRequestSortStage!], $status: [ReimbursementRequestStatus!]) {
  expenseManagement {
    requests(
      forReview: true
      resultsPerPage: $resultsPerPage
      page: $pageNum
      sort: $sortParams
      status: $status
    ) {
      page
      totalPages
      totalResults
      requests {
        uuid
        name
        submittedAt
        status
        totalNonReimbursableAmount
        totalReimbursableAmount
        managerApprover {
          friendlyFullName
        }
        myReport
        myDirectReport
        member {
          firstName
          friendlyFullName
        }
        expenses {
          uuid
        }
      }
    }
    earliestPayDate
  }
}
    `;

/**
 * __useGetActiveRequestsQuery__
 *
 * To run a query within a React component, call `useGetActiveRequestsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetActiveRequestsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetActiveRequestsQuery({
 *   variables: {
 *      resultsPerPage: // value for 'resultsPerPage'
 *      pageNum: // value for 'pageNum'
 *      sortParams: // value for 'sortParams'
 *      status: // value for 'status'
 *   },
 * });
 */
export function useGetActiveRequestsQuery(baseOptions: Apollo.QueryHookOptions<GetActiveRequestsQuery, GetActiveRequestsQueryVariables> & ({ variables: GetActiveRequestsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetActiveRequestsQuery, GetActiveRequestsQueryVariables>(GetActiveRequestsDocument, options);
      }
export function useGetActiveRequestsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetActiveRequestsQuery, GetActiveRequestsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetActiveRequestsQuery, GetActiveRequestsQueryVariables>(GetActiveRequestsDocument, options);
        }
export function useGetActiveRequestsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetActiveRequestsQuery, GetActiveRequestsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetActiveRequestsQuery, GetActiveRequestsQueryVariables>(GetActiveRequestsDocument, options);
        }
export type GetActiveRequestsQueryHookResult = ReturnType<typeof useGetActiveRequestsQuery>;
export type GetActiveRequestsLazyQueryHookResult = ReturnType<typeof useGetActiveRequestsLazyQuery>;
export type GetActiveRequestsSuspenseQueryHookResult = ReturnType<typeof useGetActiveRequestsSuspenseQuery>;
export type GetActiveRequestsQueryResult = Apollo.QueryResult<GetActiveRequestsQuery, GetActiveRequestsQueryVariables>;
export const GetApproversDocument = gql`
    query GetApprovers {
  expenseManagement {
    managers {
      uuid
      friendlyFullName
    }
    expenseAdmins {
      uuid
      friendlyFullName
    }
  }
}
    `;

/**
 * __useGetApproversQuery__
 *
 * To run a query within a React component, call `useGetApproversQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetApproversQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetApproversQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetApproversQuery(baseOptions?: Apollo.QueryHookOptions<GetApproversQuery, GetApproversQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetApproversQuery, GetApproversQueryVariables>(GetApproversDocument, options);
      }
export function useGetApproversLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetApproversQuery, GetApproversQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetApproversQuery, GetApproversQueryVariables>(GetApproversDocument, options);
        }
export function useGetApproversSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetApproversQuery, GetApproversQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetApproversQuery, GetApproversQueryVariables>(GetApproversDocument, options);
        }
export type GetApproversQueryHookResult = ReturnType<typeof useGetApproversQuery>;
export type GetApproversLazyQueryHookResult = ReturnType<typeof useGetApproversLazyQuery>;
export type GetApproversSuspenseQueryHookResult = ReturnType<typeof useGetApproversSuspenseQuery>;
export type GetApproversQueryResult = Apollo.QueryResult<GetApproversQuery, GetApproversQueryVariables>;
export const GetAuditLogDocument = gql`
    query GetAuditLog($uuid: ID!) {
  expenseManagement {
    request(uuid: $uuid) {
      uuid
      name
      myRequest
      member {
        friendlyFullName
      }
      audits {
        type
        occurredAt
        member {
          friendlyFullName
        }
        nextMembers {
          uuid
          friendlyFullName
        }
        ... on Approved {
          totalAmount
          estimatedPayDate
        }
        ... on Edited {
          name
          differences {
            type
            ... on ExpenseAdded {
              uuid
              amount
              attendees
              project {
                displayName
              }
              category {
                name
                billableToClient
              }
              description
              merchant
              receipts {
                uuid
                url
                filename
              }
              transactionDate
              expenseType
              isBillableToClient
            }
            ... on ExpenseEdited {
              uuid
              expenseType
              differences {
                type
                ... on AmountChanged {
                  amount
                }
                ... on AttendeesChanged {
                  attendees
                }
                ... on ProjectChanged {
                  project {
                    displayName
                  }
                }
                ... on CategoryChanged {
                  category {
                    name
                  }
                }
                ... on DescriptionChanged {
                  description
                }
                ... on MerchantChanged {
                  merchant
                }
                ... on ReceiptAdded {
                  filename
                }
                ... on ReceiptRemoved {
                  filename
                }
                ... on TransactionDateChanged {
                  transactionDate
                }
                ... on ExpenseTypeChanged {
                  expenseType
                }
                ... on IsBillableToClientChanged {
                  isBillableToClient
                }
              }
            }
            ... on ExpenseRemoved {
              uuid
              expenseType
            }
            ... on NameChange {
              newName
            }
          }
        }
        ... on PaymentCanceled {
          payment {
            uuid
          }
        }
        ... on PaymentReceived {
          payment {
            amount
          }
        }
        ... on Resubmitted {
          name
          differences {
            type
            ... on ExpenseAdded {
              uuid
              amount
              attendees
              project {
                displayName
              }
              category {
                name
                billableToClient
              }
              description
              merchant
              receipts {
                uuid
                url
                filename
              }
              transactionDate
              expenseType
              isBillableToClient
            }
            ... on ExpenseEdited {
              uuid
              expenseType
              differences {
                type
                ... on AmountChanged {
                  amount
                }
                ... on AttendeesChanged {
                  attendees
                }
                ... on ProjectChanged {
                  project {
                    displayName
                  }
                }
                ... on CategoryChanged {
                  category {
                    name
                  }
                }
                ... on DescriptionChanged {
                  description
                }
                ... on MerchantChanged {
                  merchant
                }
                ... on ReceiptAdded {
                  filename
                }
                ... on ReceiptRemoved {
                  filename
                }
                ... on TransactionDateChanged {
                  transactionDate
                }
                ... on ExpenseTypeChanged {
                  expenseType
                }
                ... on IsBillableToClientChanged {
                  isBillableToClient
                }
              }
            }
            ... on ExpenseRemoved {
              uuid
              expenseType
            }
            ... on NameChange {
              newName
            }
          }
        }
        ... on Returned {
          name
          reason
        }
        ... on Reviewed {
          name
          totalAmount
          numExpenses
        }
        ... on Submitted {
          name
          totalAmount
          expenses {
            uuid
            amount
            attendees
            project {
              displayName
            }
            category {
              name
              billableToClient
            }
            description
            merchant
            receipts {
              uuid
              url
              filename
            }
            transactionDate
            expenseType
            isBillableToClient
          }
        }
      }
    }
  }
}
    `;

/**
 * __useGetAuditLogQuery__
 *
 * To run a query within a React component, call `useGetAuditLogQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAuditLogQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAuditLogQuery({
 *   variables: {
 *      uuid: // value for 'uuid'
 *   },
 * });
 */
export function useGetAuditLogQuery(baseOptions: Apollo.QueryHookOptions<GetAuditLogQuery, GetAuditLogQueryVariables> & ({ variables: GetAuditLogQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAuditLogQuery, GetAuditLogQueryVariables>(GetAuditLogDocument, options);
      }
export function useGetAuditLogLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAuditLogQuery, GetAuditLogQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAuditLogQuery, GetAuditLogQueryVariables>(GetAuditLogDocument, options);
        }
export function useGetAuditLogSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetAuditLogQuery, GetAuditLogQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAuditLogQuery, GetAuditLogQueryVariables>(GetAuditLogDocument, options);
        }
export type GetAuditLogQueryHookResult = ReturnType<typeof useGetAuditLogQuery>;
export type GetAuditLogLazyQueryHookResult = ReturnType<typeof useGetAuditLogLazyQuery>;
export type GetAuditLogSuspenseQueryHookResult = ReturnType<typeof useGetAuditLogSuspenseQuery>;
export type GetAuditLogQueryResult = Apollo.QueryResult<GetAuditLogQuery, GetAuditLogQueryVariables>;
export const GetCategoriesDocument = gql`
    query GetCategories {
  expenseManagement {
    categories(includeInvisible: true) {
      uuid
      name
      visible
      custom
      merchant
      description
      receipt
      attendees
      billableToClient
      expenseType
    }
    policy {
      categoriesReviewed
    }
  }
}
    `;

/**
 * __useGetCategoriesQuery__
 *
 * To run a query within a React component, call `useGetCategoriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCategoriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCategoriesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCategoriesQuery(baseOptions?: Apollo.QueryHookOptions<GetCategoriesQuery, GetCategoriesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCategoriesQuery, GetCategoriesQueryVariables>(GetCategoriesDocument, options);
      }
export function useGetCategoriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCategoriesQuery, GetCategoriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCategoriesQuery, GetCategoriesQueryVariables>(GetCategoriesDocument, options);
        }
export function useGetCategoriesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCategoriesQuery, GetCategoriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCategoriesQuery, GetCategoriesQueryVariables>(GetCategoriesDocument, options);
        }
export type GetCategoriesQueryHookResult = ReturnType<typeof useGetCategoriesQuery>;
export type GetCategoriesLazyQueryHookResult = ReturnType<typeof useGetCategoriesLazyQuery>;
export type GetCategoriesSuspenseQueryHookResult = ReturnType<typeof useGetCategoriesSuspenseQuery>;
export type GetCategoriesQueryResult = Apollo.QueryResult<GetCategoriesQuery, GetCategoriesQueryVariables>;
export const GetConfigurationDocument = gql`
    query GetConfiguration {
  expenseManagement {
    policy {
      enabled
      everEnabled
    }
    iHaveAdminPermission
    iHaveReportsPermission
    iHaveManagerPermission
    iHaveSubmitterPermission
    iHaveGrantPermissionsPermission
    iAmAllowedToFirstTimeSetup
    iAmAllowedIntoReviewPage
    iAmAllowedIntoSettingsPages
    iAmAllowedIntoReviewHistoryPage
    iAmAllowedToViewProductDetailsPage
    iAmRequiredToViewProductDetailsPage
    expenseAdmins {
      friendlyFullName
    }
    permissionsAdmins {
      friendlyFullName
    }
  }
  authenticatedMember {
    company {
      companySetting(name: "feature_activation.expense_management") {
        value
      }
    }
  }
}
    `;

/**
 * __useGetConfigurationQuery__
 *
 * To run a query within a React component, call `useGetConfigurationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetConfigurationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetConfigurationQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetConfigurationQuery(baseOptions?: Apollo.QueryHookOptions<GetConfigurationQuery, GetConfigurationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetConfigurationQuery, GetConfigurationQueryVariables>(GetConfigurationDocument, options);
      }
export function useGetConfigurationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetConfigurationQuery, GetConfigurationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetConfigurationQuery, GetConfigurationQueryVariables>(GetConfigurationDocument, options);
        }
export function useGetConfigurationSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetConfigurationQuery, GetConfigurationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetConfigurationQuery, GetConfigurationQueryVariables>(GetConfigurationDocument, options);
        }
export type GetConfigurationQueryHookResult = ReturnType<typeof useGetConfigurationQuery>;
export type GetConfigurationLazyQueryHookResult = ReturnType<typeof useGetConfigurationLazyQuery>;
export type GetConfigurationSuspenseQueryHookResult = ReturnType<typeof useGetConfigurationSuspenseQuery>;
export type GetConfigurationQueryResult = Apollo.QueryResult<GetConfigurationQuery, GetConfigurationQueryVariables>;
export const GetExpenseDetailsPageDocument = gql`
    query GetExpenseDetailsPage {
  expenseManagement {
    categories {
      uuid
      name
      visible
      custom
      merchant
      description
      receipt
      attendees
      billableToClient
      expenseType
    }
    projects {
      projectCode
      projectName
      displayName
      uuid
      visible
    }
  }
  authenticatedMember {
    friendlyFullName
  }
}
    `;

/**
 * __useGetExpenseDetailsPageQuery__
 *
 * To run a query within a React component, call `useGetExpenseDetailsPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetExpenseDetailsPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetExpenseDetailsPageQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetExpenseDetailsPageQuery(baseOptions?: Apollo.QueryHookOptions<GetExpenseDetailsPageQuery, GetExpenseDetailsPageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetExpenseDetailsPageQuery, GetExpenseDetailsPageQueryVariables>(GetExpenseDetailsPageDocument, options);
      }
export function useGetExpenseDetailsPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetExpenseDetailsPageQuery, GetExpenseDetailsPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetExpenseDetailsPageQuery, GetExpenseDetailsPageQueryVariables>(GetExpenseDetailsPageDocument, options);
        }
export function useGetExpenseDetailsPageSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetExpenseDetailsPageQuery, GetExpenseDetailsPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetExpenseDetailsPageQuery, GetExpenseDetailsPageQueryVariables>(GetExpenseDetailsPageDocument, options);
        }
export type GetExpenseDetailsPageQueryHookResult = ReturnType<typeof useGetExpenseDetailsPageQuery>;
export type GetExpenseDetailsPageLazyQueryHookResult = ReturnType<typeof useGetExpenseDetailsPageLazyQuery>;
export type GetExpenseDetailsPageSuspenseQueryHookResult = ReturnType<typeof useGetExpenseDetailsPageSuspenseQuery>;
export type GetExpenseDetailsPageQueryResult = Apollo.QueryResult<GetExpenseDetailsPageQuery, GetExpenseDetailsPageQueryVariables>;
export const GetExpenseLibraryDocument = gql`
    query GetExpenseLibrary($resultsPerPage: Int!, $pageNum: Int!, $sortParams: [UnattachedExpenseSortStage!], $attachedUuids: [ID!], $detachedUuids: [ID!]) {
  expenseManagement {
    unattachedExpenses(
      resultsPerPage: $resultsPerPage
      page: $pageNum
      sort: $sortParams
      attachedUuids: $attachedUuids
      detachedUuids: $detachedUuids
    ) {
      page
      totalPages
      totalResults
      expenses {
        uuid
        category {
          uuid
          name
          visible
          custom
          merchant
          description
          receipt
          attendees
          expenseType
          billableToClient
        }
        project {
          projectCode
          projectName
          displayName
          uuid
          visible
        }
        createdAt
        transactionDate
        amount
        merchant
        attendees
        description
        expenseType
        isBillableToClient
        receipts {
          url
          filename
          uuid
        }
        expenseType
      }
    }
  }
}
    `;

/**
 * __useGetExpenseLibraryQuery__
 *
 * To run a query within a React component, call `useGetExpenseLibraryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetExpenseLibraryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetExpenseLibraryQuery({
 *   variables: {
 *      resultsPerPage: // value for 'resultsPerPage'
 *      pageNum: // value for 'pageNum'
 *      sortParams: // value for 'sortParams'
 *      attachedUuids: // value for 'attachedUuids'
 *      detachedUuids: // value for 'detachedUuids'
 *   },
 * });
 */
export function useGetExpenseLibraryQuery(baseOptions: Apollo.QueryHookOptions<GetExpenseLibraryQuery, GetExpenseLibraryQueryVariables> & ({ variables: GetExpenseLibraryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetExpenseLibraryQuery, GetExpenseLibraryQueryVariables>(GetExpenseLibraryDocument, options);
      }
export function useGetExpenseLibraryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetExpenseLibraryQuery, GetExpenseLibraryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetExpenseLibraryQuery, GetExpenseLibraryQueryVariables>(GetExpenseLibraryDocument, options);
        }
export function useGetExpenseLibrarySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetExpenseLibraryQuery, GetExpenseLibraryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetExpenseLibraryQuery, GetExpenseLibraryQueryVariables>(GetExpenseLibraryDocument, options);
        }
export type GetExpenseLibraryQueryHookResult = ReturnType<typeof useGetExpenseLibraryQuery>;
export type GetExpenseLibraryLazyQueryHookResult = ReturnType<typeof useGetExpenseLibraryLazyQuery>;
export type GetExpenseLibrarySuspenseQueryHookResult = ReturnType<typeof useGetExpenseLibrarySuspenseQuery>;
export type GetExpenseLibraryQueryResult = Apollo.QueryResult<GetExpenseLibraryQuery, GetExpenseLibraryQueryVariables>;
export const GetExpenseTypeDocument = gql`
    query GetExpenseType {
  expenseManagement {
    categories {
      expenseType
    }
  }
}
    `;

/**
 * __useGetExpenseTypeQuery__
 *
 * To run a query within a React component, call `useGetExpenseTypeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetExpenseTypeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetExpenseTypeQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetExpenseTypeQuery(baseOptions?: Apollo.QueryHookOptions<GetExpenseTypeQuery, GetExpenseTypeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetExpenseTypeQuery, GetExpenseTypeQueryVariables>(GetExpenseTypeDocument, options);
      }
export function useGetExpenseTypeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetExpenseTypeQuery, GetExpenseTypeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetExpenseTypeQuery, GetExpenseTypeQueryVariables>(GetExpenseTypeDocument, options);
        }
export function useGetExpenseTypeSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetExpenseTypeQuery, GetExpenseTypeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetExpenseTypeQuery, GetExpenseTypeQueryVariables>(GetExpenseTypeDocument, options);
        }
export type GetExpenseTypeQueryHookResult = ReturnType<typeof useGetExpenseTypeQuery>;
export type GetExpenseTypeLazyQueryHookResult = ReturnType<typeof useGetExpenseTypeLazyQuery>;
export type GetExpenseTypeSuspenseQueryHookResult = ReturnType<typeof useGetExpenseTypeSuspenseQuery>;
export type GetExpenseTypeQueryResult = Apollo.QueryResult<GetExpenseTypeQuery, GetExpenseTypeQueryVariables>;
export const GetExpensesActivationDocument = gql`
    query GetExpensesActivation {
  currentMember {
    company {
      companySetting(name: "feature_activation.expense_management") {
        value
      }
    }
  }
}
    `;

/**
 * __useGetExpensesActivationQuery__
 *
 * To run a query within a React component, call `useGetExpensesActivationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetExpensesActivationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetExpensesActivationQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetExpensesActivationQuery(baseOptions?: Apollo.QueryHookOptions<GetExpensesActivationQuery, GetExpensesActivationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetExpensesActivationQuery, GetExpensesActivationQueryVariables>(GetExpensesActivationDocument, options);
      }
export function useGetExpensesActivationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetExpensesActivationQuery, GetExpensesActivationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetExpensesActivationQuery, GetExpensesActivationQueryVariables>(GetExpensesActivationDocument, options);
        }
export function useGetExpensesActivationSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetExpensesActivationQuery, GetExpensesActivationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetExpensesActivationQuery, GetExpensesActivationQueryVariables>(GetExpensesActivationDocument, options);
        }
export type GetExpensesActivationQueryHookResult = ReturnType<typeof useGetExpensesActivationQuery>;
export type GetExpensesActivationLazyQueryHookResult = ReturnType<typeof useGetExpensesActivationLazyQuery>;
export type GetExpensesActivationSuspenseQueryHookResult = ReturnType<typeof useGetExpensesActivationSuspenseQuery>;
export type GetExpensesActivationQueryResult = Apollo.QueryResult<GetExpensesActivationQuery, GetExpensesActivationQueryVariables>;
export const GetExpensesResourcesDocument = gql`
    query GetExpensesResources {
  expensesResources {
    adminOnePagerUrl
    employeeOnePagerUrl
    emailAnnouncementTemplateUrl
  }
}
    `;

/**
 * __useGetExpensesResourcesQuery__
 *
 * To run a query within a React component, call `useGetExpensesResourcesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetExpensesResourcesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetExpensesResourcesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetExpensesResourcesQuery(baseOptions?: Apollo.QueryHookOptions<GetExpensesResourcesQuery, GetExpensesResourcesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetExpensesResourcesQuery, GetExpensesResourcesQueryVariables>(GetExpensesResourcesDocument, options);
      }
export function useGetExpensesResourcesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetExpensesResourcesQuery, GetExpensesResourcesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetExpensesResourcesQuery, GetExpensesResourcesQueryVariables>(GetExpensesResourcesDocument, options);
        }
export function useGetExpensesResourcesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetExpensesResourcesQuery, GetExpensesResourcesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetExpensesResourcesQuery, GetExpensesResourcesQueryVariables>(GetExpensesResourcesDocument, options);
        }
export type GetExpensesResourcesQueryHookResult = ReturnType<typeof useGetExpensesResourcesQuery>;
export type GetExpensesResourcesLazyQueryHookResult = ReturnType<typeof useGetExpensesResourcesLazyQuery>;
export type GetExpensesResourcesSuspenseQueryHookResult = ReturnType<typeof useGetExpensesResourcesSuspenseQuery>;
export type GetExpensesResourcesQueryResult = Apollo.QueryResult<GetExpensesResourcesQuery, GetExpensesResourcesQueryVariables>;
export const GetExpensesSettingsDocument = gql`
    query GetExpensesSettings {
  expenseManagement {
    categories(includeInvisible: false) {
      name
    }
    policy {
      enabled
      categoriesReviewed
    }
    expenseAdmins {
      uuid
      friendlyFullName
      deskTitle
      photoUrl
    }
    reportsAdmins {
      uuid
      friendlyFullName
      deskTitle
      photoUrl
    }
    managers(companyWide: true) {
      uuid
      friendlyFullName
      deskTitle
      photoUrl
    }
    projects(includeInvisible: false) {
      projectCode
      projectName
    }
  }
  currentMember {
    uuid
  }
}
    `;

/**
 * __useGetExpensesSettingsQuery__
 *
 * To run a query within a React component, call `useGetExpensesSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetExpensesSettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetExpensesSettingsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetExpensesSettingsQuery(baseOptions?: Apollo.QueryHookOptions<GetExpensesSettingsQuery, GetExpensesSettingsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetExpensesSettingsQuery, GetExpensesSettingsQueryVariables>(GetExpensesSettingsDocument, options);
      }
export function useGetExpensesSettingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetExpensesSettingsQuery, GetExpensesSettingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetExpensesSettingsQuery, GetExpensesSettingsQueryVariables>(GetExpensesSettingsDocument, options);
        }
export function useGetExpensesSettingsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetExpensesSettingsQuery, GetExpensesSettingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetExpensesSettingsQuery, GetExpensesSettingsQueryVariables>(GetExpensesSettingsDocument, options);
        }
export type GetExpensesSettingsQueryHookResult = ReturnType<typeof useGetExpensesSettingsQuery>;
export type GetExpensesSettingsLazyQueryHookResult = ReturnType<typeof useGetExpensesSettingsLazyQuery>;
export type GetExpensesSettingsSuspenseQueryHookResult = ReturnType<typeof useGetExpensesSettingsSuspenseQuery>;
export type GetExpensesSettingsQueryResult = Apollo.QueryResult<GetExpensesSettingsQuery, GetExpensesSettingsQueryVariables>;
export const GetManagersDocument = gql`
    query GetManagers {
  expenseManagement {
    managers {
      friendlyFullName
    }
  }
}
    `;

/**
 * __useGetManagersQuery__
 *
 * To run a query within a React component, call `useGetManagersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetManagersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetManagersQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetManagersQuery(baseOptions?: Apollo.QueryHookOptions<GetManagersQuery, GetManagersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetManagersQuery, GetManagersQueryVariables>(GetManagersDocument, options);
      }
export function useGetManagersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetManagersQuery, GetManagersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetManagersQuery, GetManagersQueryVariables>(GetManagersDocument, options);
        }
export function useGetManagersSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetManagersQuery, GetManagersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetManagersQuery, GetManagersQueryVariables>(GetManagersDocument, options);
        }
export type GetManagersQueryHookResult = ReturnType<typeof useGetManagersQuery>;
export type GetManagersLazyQueryHookResult = ReturnType<typeof useGetManagersLazyQuery>;
export type GetManagersSuspenseQueryHookResult = ReturnType<typeof useGetManagersSuspenseQuery>;
export type GetManagersQueryResult = Apollo.QueryResult<GetManagersQuery, GetManagersQueryVariables>;
export const GetPayDateDocument = gql`
    query GetPayDate {
  expenseManagement {
    earliestPayDate
  }
}
    `;

/**
 * __useGetPayDateQuery__
 *
 * To run a query within a React component, call `useGetPayDateQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPayDateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPayDateQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetPayDateQuery(baseOptions?: Apollo.QueryHookOptions<GetPayDateQuery, GetPayDateQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPayDateQuery, GetPayDateQueryVariables>(GetPayDateDocument, options);
      }
export function useGetPayDateLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPayDateQuery, GetPayDateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPayDateQuery, GetPayDateQueryVariables>(GetPayDateDocument, options);
        }
export function useGetPayDateSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetPayDateQuery, GetPayDateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPayDateQuery, GetPayDateQueryVariables>(GetPayDateDocument, options);
        }
export type GetPayDateQueryHookResult = ReturnType<typeof useGetPayDateQuery>;
export type GetPayDateLazyQueryHookResult = ReturnType<typeof useGetPayDateLazyQuery>;
export type GetPayDateSuspenseQueryHookResult = ReturnType<typeof useGetPayDateSuspenseQuery>;
export type GetPayDateQueryResult = Apollo.QueryResult<GetPayDateQuery, GetPayDateQueryVariables>;
export const GetProjectsDocument = gql`
    query GetProjects {
  expenseManagement {
    projects(includeInvisible: true) {
      projectCode
      projectName
      displayName
      uuid
      visible
    }
  }
}
    `;

/**
 * __useGetProjectsQuery__
 *
 * To run a query within a React component, call `useGetProjectsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProjectsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProjectsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetProjectsQuery(baseOptions?: Apollo.QueryHookOptions<GetProjectsQuery, GetProjectsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProjectsQuery, GetProjectsQueryVariables>(GetProjectsDocument, options);
      }
export function useGetProjectsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProjectsQuery, GetProjectsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProjectsQuery, GetProjectsQueryVariables>(GetProjectsDocument, options);
        }
export function useGetProjectsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetProjectsQuery, GetProjectsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetProjectsQuery, GetProjectsQueryVariables>(GetProjectsDocument, options);
        }
export type GetProjectsQueryHookResult = ReturnType<typeof useGetProjectsQuery>;
export type GetProjectsLazyQueryHookResult = ReturnType<typeof useGetProjectsLazyQuery>;
export type GetProjectsSuspenseQueryHookResult = ReturnType<typeof useGetProjectsSuspenseQuery>;
export type GetProjectsQueryResult = Apollo.QueryResult<GetProjectsQuery, GetProjectsQueryVariables>;
export const GetRequestDetailDocument = gql`
    query GetRequestDetail($uuid: ID!) {
  expenseManagement {
    request(uuid: $uuid) {
      uuid
      name
      member {
        friendlyFullName
        firstName
      }
      managerApprover {
        uuid
        friendlyFullName
      }
      submittedAt
      status
      totalAmount
      expenses {
        uuid
        merchant
        amount
        transactionDate
        description
        attendees
        expenseType
        isBillableToClient
        receipts {
          filename
          url
          uuid
        }
        category {
          uuid
          name
          visible
          custom
          merchant
          description
          receipt
          attendees
          expenseType
          billableToClient
        }
        project {
          projectCode
          projectName
          displayName
          uuid
          visible
        }
      }
      reviews {
        type
        reason
        reviewedAt
        member {
          firstName
          lastName
          friendlyFullName
          uuid
        }
      }
      payment {
        amount
        payDate
        status
      }
      myRequest
    }
    earliestPayDate
  }
}
    `;

/**
 * __useGetRequestDetailQuery__
 *
 * To run a query within a React component, call `useGetRequestDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRequestDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRequestDetailQuery({
 *   variables: {
 *      uuid: // value for 'uuid'
 *   },
 * });
 */
export function useGetRequestDetailQuery(baseOptions: Apollo.QueryHookOptions<GetRequestDetailQuery, GetRequestDetailQueryVariables> & ({ variables: GetRequestDetailQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRequestDetailQuery, GetRequestDetailQueryVariables>(GetRequestDetailDocument, options);
      }
export function useGetRequestDetailLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRequestDetailQuery, GetRequestDetailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRequestDetailQuery, GetRequestDetailQueryVariables>(GetRequestDetailDocument, options);
        }
export function useGetRequestDetailSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetRequestDetailQuery, GetRequestDetailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetRequestDetailQuery, GetRequestDetailQueryVariables>(GetRequestDetailDocument, options);
        }
export type GetRequestDetailQueryHookResult = ReturnType<typeof useGetRequestDetailQuery>;
export type GetRequestDetailLazyQueryHookResult = ReturnType<typeof useGetRequestDetailLazyQuery>;
export type GetRequestDetailSuspenseQueryHookResult = ReturnType<typeof useGetRequestDetailSuspenseQuery>;
export type GetRequestDetailQueryResult = Apollo.QueryResult<GetRequestDetailQuery, GetRequestDetailQueryVariables>;
export const GetRequestHistoryDocument = gql`
    query GetRequestHistory($resultsPerPage: Int!, $pageNum: Int!, $sortParams: [ReimbursementRequestSortStage!], $status: [ReimbursementRequestStatus!]) {
  expenseManagement {
    requests(
      forReview: true
      resultsPerPage: $resultsPerPage
      page: $pageNum
      sort: $sortParams
      status: $status
    ) {
      page
      totalPages
      totalResults
      requests {
        uuid
        name
        submittedAt
        status
        totalReimbursableAmount
        totalNonReimbursableAmount
        payment {
          status
          payDate
        }
        member {
          friendlyFullName
        }
        expenses {
          uuid
        }
      }
    }
  }
}
    `;

/**
 * __useGetRequestHistoryQuery__
 *
 * To run a query within a React component, call `useGetRequestHistoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRequestHistoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRequestHistoryQuery({
 *   variables: {
 *      resultsPerPage: // value for 'resultsPerPage'
 *      pageNum: // value for 'pageNum'
 *      sortParams: // value for 'sortParams'
 *      status: // value for 'status'
 *   },
 * });
 */
export function useGetRequestHistoryQuery(baseOptions: Apollo.QueryHookOptions<GetRequestHistoryQuery, GetRequestHistoryQueryVariables> & ({ variables: GetRequestHistoryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRequestHistoryQuery, GetRequestHistoryQueryVariables>(GetRequestHistoryDocument, options);
      }
export function useGetRequestHistoryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRequestHistoryQuery, GetRequestHistoryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRequestHistoryQuery, GetRequestHistoryQueryVariables>(GetRequestHistoryDocument, options);
        }
export function useGetRequestHistorySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetRequestHistoryQuery, GetRequestHistoryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetRequestHistoryQuery, GetRequestHistoryQueryVariables>(GetRequestHistoryDocument, options);
        }
export type GetRequestHistoryQueryHookResult = ReturnType<typeof useGetRequestHistoryQuery>;
export type GetRequestHistoryLazyQueryHookResult = ReturnType<typeof useGetRequestHistoryLazyQuery>;
export type GetRequestHistorySuspenseQueryHookResult = ReturnType<typeof useGetRequestHistorySuspenseQuery>;
export type GetRequestHistoryQueryResult = Apollo.QueryResult<GetRequestHistoryQuery, GetRequestHistoryQueryVariables>;
export const GetRequestsListDocument = gql`
    query GetRequestsList($resultsPerPage: Int!, $pageNum: Int!, $sortParams: [ReimbursementRequestSortStage!]) {
  expenseManagement {
    requests(resultsPerPage: $resultsPerPage, page: $pageNum, sort: $sortParams) {
      page
      totalPages
      totalResults
      requests {
        uuid
        name
        submittedAt
        status
        payment {
          payDate
          status
        }
        expenses {
          uuid
        }
      }
    }
  }
}
    `;

/**
 * __useGetRequestsListQuery__
 *
 * To run a query within a React component, call `useGetRequestsListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRequestsListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRequestsListQuery({
 *   variables: {
 *      resultsPerPage: // value for 'resultsPerPage'
 *      pageNum: // value for 'pageNum'
 *      sortParams: // value for 'sortParams'
 *   },
 * });
 */
export function useGetRequestsListQuery(baseOptions: Apollo.QueryHookOptions<GetRequestsListQuery, GetRequestsListQueryVariables> & ({ variables: GetRequestsListQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRequestsListQuery, GetRequestsListQueryVariables>(GetRequestsListDocument, options);
      }
export function useGetRequestsListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRequestsListQuery, GetRequestsListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRequestsListQuery, GetRequestsListQueryVariables>(GetRequestsListDocument, options);
        }
export function useGetRequestsListSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetRequestsListQuery, GetRequestsListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetRequestsListQuery, GetRequestsListQueryVariables>(GetRequestsListDocument, options);
        }
export type GetRequestsListQueryHookResult = ReturnType<typeof useGetRequestsListQuery>;
export type GetRequestsListLazyQueryHookResult = ReturnType<typeof useGetRequestsListLazyQuery>;
export type GetRequestsListSuspenseQueryHookResult = ReturnType<typeof useGetRequestsListSuspenseQuery>;
export type GetRequestsListQueryResult = Apollo.QueryResult<GetRequestsListQuery, GetRequestsListQueryVariables>;
export const ProcessForm8973AnswersDocument = gql`
    mutation ProcessForm8973Answers($companyUuid: String!, $form8973Answers: Form8973Answers!) {
  processForm8973Answers(
    companyUuid: $companyUuid
    form8973Answers: $form8973Answers
  ) {
    success
    error
    embeddedSignUrl
  }
}
    `;
export type ProcessForm8973AnswersMutationFn = Apollo.MutationFunction<ProcessForm8973AnswersMutation, ProcessForm8973AnswersMutationVariables>;

/**
 * __useProcessForm8973AnswersMutation__
 *
 * To run a mutation, you first call `useProcessForm8973AnswersMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProcessForm8973AnswersMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [processForm8973AnswersMutation, { data, loading, error }] = useProcessForm8973AnswersMutation({
 *   variables: {
 *      companyUuid: // value for 'companyUuid'
 *      form8973Answers: // value for 'form8973Answers'
 *   },
 * });
 */
export function useProcessForm8973AnswersMutation(baseOptions?: Apollo.MutationHookOptions<ProcessForm8973AnswersMutation, ProcessForm8973AnswersMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ProcessForm8973AnswersMutation, ProcessForm8973AnswersMutationVariables>(ProcessForm8973AnswersDocument, options);
      }
export type ProcessForm8973AnswersMutationHookResult = ReturnType<typeof useProcessForm8973AnswersMutation>;
export type ProcessForm8973AnswersMutationResult = Apollo.MutationResult<ProcessForm8973AnswersMutation>;
export type ProcessForm8973AnswersMutationOptions = Apollo.BaseMutationOptions<ProcessForm8973AnswersMutation, ProcessForm8973AnswersMutationVariables>;
export const GetForm8973Document = gql`
    query GetForm8973($companyUuid: String!) {
  form8973(companyUuid: $companyUuid) {
    companyUuid
    companyEin
    companyLegalEntityName
    companyTradeName
    companyPrimaryAddress {
      street1
      street2
      state
      city
      countryCode
      postalCode
    }
    unsignedForm8973Signature {
      status
    }
  }
}
    `;

/**
 * __useGetForm8973Query__
 *
 * To run a query within a React component, call `useGetForm8973Query` and pass it any options that fit your needs.
 * When your component renders, `useGetForm8973Query` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetForm8973Query({
 *   variables: {
 *      companyUuid: // value for 'companyUuid'
 *   },
 * });
 */
export function useGetForm8973Query(baseOptions: Apollo.QueryHookOptions<GetForm8973Query, GetForm8973QueryVariables> & ({ variables: GetForm8973QueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetForm8973Query, GetForm8973QueryVariables>(GetForm8973Document, options);
      }
export function useGetForm8973LazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetForm8973Query, GetForm8973QueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetForm8973Query, GetForm8973QueryVariables>(GetForm8973Document, options);
        }
export function useGetForm8973SuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetForm8973Query, GetForm8973QueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetForm8973Query, GetForm8973QueryVariables>(GetForm8973Document, options);
        }
export type GetForm8973QueryHookResult = ReturnType<typeof useGetForm8973Query>;
export type GetForm8973LazyQueryHookResult = ReturnType<typeof useGetForm8973LazyQuery>;
export type GetForm8973SuspenseQueryHookResult = ReturnType<typeof useGetForm8973SuspenseQuery>;
export type GetForm8973QueryResult = Apollo.QueryResult<GetForm8973Query, GetForm8973QueryVariables>;
export const DeleteInternationalDocumentDocument = gql`
    mutation DeleteInternationalDocument($documentId: ID!) {
  deleteInternationalDocument(documentId: $documentId) {
    success
  }
}
    `;
export type DeleteInternationalDocumentMutationFn = Apollo.MutationFunction<DeleteInternationalDocumentMutation, DeleteInternationalDocumentMutationVariables>;

/**
 * __useDeleteInternationalDocumentMutation__
 *
 * To run a mutation, you first call `useDeleteInternationalDocumentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteInternationalDocumentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteInternationalDocumentMutation, { data, loading, error }] = useDeleteInternationalDocumentMutation({
 *   variables: {
 *      documentId: // value for 'documentId'
 *   },
 * });
 */
export function useDeleteInternationalDocumentMutation(baseOptions?: Apollo.MutationHookOptions<DeleteInternationalDocumentMutation, DeleteInternationalDocumentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteInternationalDocumentMutation, DeleteInternationalDocumentMutationVariables>(DeleteInternationalDocumentDocument, options);
      }
export type DeleteInternationalDocumentMutationHookResult = ReturnType<typeof useDeleteInternationalDocumentMutation>;
export type DeleteInternationalDocumentMutationResult = Apollo.MutationResult<DeleteInternationalDocumentMutation>;
export type DeleteInternationalDocumentMutationOptions = Apollo.BaseMutationOptions<DeleteInternationalDocumentMutation, DeleteInternationalDocumentMutationVariables>;
export const GetInternationalDocumentUrlDocument = gql`
    query GetInternationalDocumentUrl($documentId: ID!) {
  internationalDocumentUrl(documentId: $documentId) {
    url
  }
}
    `;

/**
 * __useGetInternationalDocumentUrlQuery__
 *
 * To run a query within a React component, call `useGetInternationalDocumentUrlQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInternationalDocumentUrlQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInternationalDocumentUrlQuery({
 *   variables: {
 *      documentId: // value for 'documentId'
 *   },
 * });
 */
export function useGetInternationalDocumentUrlQuery(baseOptions: Apollo.QueryHookOptions<GetInternationalDocumentUrlQuery, GetInternationalDocumentUrlQueryVariables> & ({ variables: GetInternationalDocumentUrlQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetInternationalDocumentUrlQuery, GetInternationalDocumentUrlQueryVariables>(GetInternationalDocumentUrlDocument, options);
      }
export function useGetInternationalDocumentUrlLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetInternationalDocumentUrlQuery, GetInternationalDocumentUrlQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetInternationalDocumentUrlQuery, GetInternationalDocumentUrlQueryVariables>(GetInternationalDocumentUrlDocument, options);
        }
export function useGetInternationalDocumentUrlSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetInternationalDocumentUrlQuery, GetInternationalDocumentUrlQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetInternationalDocumentUrlQuery, GetInternationalDocumentUrlQueryVariables>(GetInternationalDocumentUrlDocument, options);
        }
export type GetInternationalDocumentUrlQueryHookResult = ReturnType<typeof useGetInternationalDocumentUrlQuery>;
export type GetInternationalDocumentUrlLazyQueryHookResult = ReturnType<typeof useGetInternationalDocumentUrlLazyQuery>;
export type GetInternationalDocumentUrlSuspenseQueryHookResult = ReturnType<typeof useGetInternationalDocumentUrlSuspenseQuery>;
export type GetInternationalDocumentUrlQueryResult = Apollo.QueryResult<GetInternationalDocumentUrlQuery, GetInternationalDocumentUrlQueryVariables>;
export const GetInternationalDocumentsDocument = gql`
    query GetInternationalDocuments($memberUuid: ID!) {
  internationalDocuments(memberUuid: $memberUuid) {
    id
    name
    uploadDate
    signatureRequired
    remindersSet
    category
    documentMemberAssignments {
      id
      visibilityLevel
      documentId
      memberId
    }
  }
}
    `;

/**
 * __useGetInternationalDocumentsQuery__
 *
 * To run a query within a React component, call `useGetInternationalDocumentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInternationalDocumentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInternationalDocumentsQuery({
 *   variables: {
 *      memberUuid: // value for 'memberUuid'
 *   },
 * });
 */
export function useGetInternationalDocumentsQuery(baseOptions: Apollo.QueryHookOptions<GetInternationalDocumentsQuery, GetInternationalDocumentsQueryVariables> & ({ variables: GetInternationalDocumentsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetInternationalDocumentsQuery, GetInternationalDocumentsQueryVariables>(GetInternationalDocumentsDocument, options);
      }
export function useGetInternationalDocumentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetInternationalDocumentsQuery, GetInternationalDocumentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetInternationalDocumentsQuery, GetInternationalDocumentsQueryVariables>(GetInternationalDocumentsDocument, options);
        }
export function useGetInternationalDocumentsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetInternationalDocumentsQuery, GetInternationalDocumentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetInternationalDocumentsQuery, GetInternationalDocumentsQueryVariables>(GetInternationalDocumentsDocument, options);
        }
export type GetInternationalDocumentsQueryHookResult = ReturnType<typeof useGetInternationalDocumentsQuery>;
export type GetInternationalDocumentsLazyQueryHookResult = ReturnType<typeof useGetInternationalDocumentsLazyQuery>;
export type GetInternationalDocumentsSuspenseQueryHookResult = ReturnType<typeof useGetInternationalDocumentsSuspenseQuery>;
export type GetInternationalDocumentsQueryResult = Apollo.QueryResult<GetInternationalDocumentsQuery, GetInternationalDocumentsQueryVariables>;
export const GetInternationalMemberDocument = gql`
    query GetInternationalMember($memberUuid: ID!) {
  internationalMember(memberUuid: $memberUuid) {
    uuid
    preferredName
    firstName
    lastName
    email
    pronouns
    city
    countryCode
    country
    emojiFlag
    postalCode
    state
    streetLine1
    streetLine2
    serviceProvided
    phoneNumber
    website
    status
    hasBeenPaid
  }
}
    `;

/**
 * __useGetInternationalMemberQuery__
 *
 * To run a query within a React component, call `useGetInternationalMemberQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInternationalMemberQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInternationalMemberQuery({
 *   variables: {
 *      memberUuid: // value for 'memberUuid'
 *   },
 * });
 */
export function useGetInternationalMemberQuery(baseOptions: Apollo.QueryHookOptions<GetInternationalMemberQuery, GetInternationalMemberQueryVariables> & ({ variables: GetInternationalMemberQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetInternationalMemberQuery, GetInternationalMemberQueryVariables>(GetInternationalMemberDocument, options);
      }
export function useGetInternationalMemberLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetInternationalMemberQuery, GetInternationalMemberQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetInternationalMemberQuery, GetInternationalMemberQueryVariables>(GetInternationalMemberDocument, options);
        }
export function useGetInternationalMemberSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetInternationalMemberQuery, GetInternationalMemberQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetInternationalMemberQuery, GetInternationalMemberQueryVariables>(GetInternationalMemberDocument, options);
        }
export type GetInternationalMemberQueryHookResult = ReturnType<typeof useGetInternationalMemberQuery>;
export type GetInternationalMemberLazyQueryHookResult = ReturnType<typeof useGetInternationalMemberLazyQuery>;
export type GetInternationalMemberSuspenseQueryHookResult = ReturnType<typeof useGetInternationalMemberSuspenseQuery>;
export type GetInternationalMemberQueryResult = Apollo.QueryResult<GetInternationalMemberQuery, GetInternationalMemberQueryVariables>;
export const UpdateInternationalDocumentDocument = gql`
    mutation UpdateInternationalDocument($documentId: ID!, $name: String, $category: String, $documentMemberAssignments: [InternationalDocumentMemberAssignmentInput!]) {
  updateInternationalDocument(
    documentId: $documentId
    name: $name
    category: $category
    documentMemberAssignments: $documentMemberAssignments
  ) {
    id
    name
    uploadDate
    signatureRequired
    remindersSet
    category
    documentMemberAssignments {
      id
      visibilityLevel
      documentId
      memberId
    }
  }
}
    `;
export type UpdateInternationalDocumentMutationFn = Apollo.MutationFunction<UpdateInternationalDocumentMutation, UpdateInternationalDocumentMutationVariables>;

/**
 * __useUpdateInternationalDocumentMutation__
 *
 * To run a mutation, you first call `useUpdateInternationalDocumentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateInternationalDocumentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateInternationalDocumentMutation, { data, loading, error }] = useUpdateInternationalDocumentMutation({
 *   variables: {
 *      documentId: // value for 'documentId'
 *      name: // value for 'name'
 *      category: // value for 'category'
 *      documentMemberAssignments: // value for 'documentMemberAssignments'
 *   },
 * });
 */
export function useUpdateInternationalDocumentMutation(baseOptions?: Apollo.MutationHookOptions<UpdateInternationalDocumentMutation, UpdateInternationalDocumentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateInternationalDocumentMutation, UpdateInternationalDocumentMutationVariables>(UpdateInternationalDocumentDocument, options);
      }
export type UpdateInternationalDocumentMutationHookResult = ReturnType<typeof useUpdateInternationalDocumentMutation>;
export type UpdateInternationalDocumentMutationResult = Apollo.MutationResult<UpdateInternationalDocumentMutation>;
export type UpdateInternationalDocumentMutationOptions = Apollo.BaseMutationOptions<UpdateInternationalDocumentMutation, UpdateInternationalDocumentMutationVariables>;
export const UpdateInternationalMemberStatusDocument = gql`
    mutation UpdateInternationalMemberStatus($companyMemberId: ID!, $status: String!) {
  updateInternationalMemberStatus(
    companyMemberId: $companyMemberId
    status: $status
  ) {
    id
    details {
      status
    }
  }
}
    `;
export type UpdateInternationalMemberStatusMutationFn = Apollo.MutationFunction<UpdateInternationalMemberStatusMutation, UpdateInternationalMemberStatusMutationVariables>;

/**
 * __useUpdateInternationalMemberStatusMutation__
 *
 * To run a mutation, you first call `useUpdateInternationalMemberStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateInternationalMemberStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateInternationalMemberStatusMutation, { data, loading, error }] = useUpdateInternationalMemberStatusMutation({
 *   variables: {
 *      companyMemberId: // value for 'companyMemberId'
 *      status: // value for 'status'
 *   },
 * });
 */
export function useUpdateInternationalMemberStatusMutation(baseOptions?: Apollo.MutationHookOptions<UpdateInternationalMemberStatusMutation, UpdateInternationalMemberStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateInternationalMemberStatusMutation, UpdateInternationalMemberStatusMutationVariables>(UpdateInternationalMemberStatusDocument, options);
      }
export type UpdateInternationalMemberStatusMutationHookResult = ReturnType<typeof useUpdateInternationalMemberStatusMutation>;
export type UpdateInternationalMemberStatusMutationResult = Apollo.MutationResult<UpdateInternationalMemberStatusMutation>;
export type UpdateInternationalMemberStatusMutationOptions = Apollo.BaseMutationOptions<UpdateInternationalMemberStatusMutation, UpdateInternationalMemberStatusMutationVariables>;
export const GetIsViaCustomerDocument = gql`
    query GetIsViaCustomer {
  authenticatedMember {
    company {
      companySetting(name: "via_customer") {
        value
      }
    }
  }
}
    `;

/**
 * __useGetIsViaCustomerQuery__
 *
 * To run a query within a React component, call `useGetIsViaCustomerQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetIsViaCustomerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetIsViaCustomerQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetIsViaCustomerQuery(baseOptions?: Apollo.QueryHookOptions<GetIsViaCustomerQuery, GetIsViaCustomerQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetIsViaCustomerQuery, GetIsViaCustomerQueryVariables>(GetIsViaCustomerDocument, options);
      }
export function useGetIsViaCustomerLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetIsViaCustomerQuery, GetIsViaCustomerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetIsViaCustomerQuery, GetIsViaCustomerQueryVariables>(GetIsViaCustomerDocument, options);
        }
export function useGetIsViaCustomerSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetIsViaCustomerQuery, GetIsViaCustomerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetIsViaCustomerQuery, GetIsViaCustomerQueryVariables>(GetIsViaCustomerDocument, options);
        }
export type GetIsViaCustomerQueryHookResult = ReturnType<typeof useGetIsViaCustomerQuery>;
export type GetIsViaCustomerLazyQueryHookResult = ReturnType<typeof useGetIsViaCustomerLazyQuery>;
export type GetIsViaCustomerSuspenseQueryHookResult = ReturnType<typeof useGetIsViaCustomerSuspenseQuery>;
export type GetIsViaCustomerQueryResult = Apollo.QueryResult<GetIsViaCustomerQuery, GetIsViaCustomerQueryVariables>;
export const GetCompanyInfoDocument = gql`
    query GetCompanyInfo {
  authenticatedMember {
    uuid
    company {
      companyPlanType
      cdmsCanonicalCompanyId
    }
  }
}
    `;

/**
 * __useGetCompanyInfoQuery__
 *
 * To run a query within a React component, call `useGetCompanyInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCompanyInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCompanyInfoQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCompanyInfoQuery(baseOptions?: Apollo.QueryHookOptions<GetCompanyInfoQuery, GetCompanyInfoQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCompanyInfoQuery, GetCompanyInfoQueryVariables>(GetCompanyInfoDocument, options);
      }
export function useGetCompanyInfoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCompanyInfoQuery, GetCompanyInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCompanyInfoQuery, GetCompanyInfoQueryVariables>(GetCompanyInfoDocument, options);
        }
export function useGetCompanyInfoSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCompanyInfoQuery, GetCompanyInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCompanyInfoQuery, GetCompanyInfoQueryVariables>(GetCompanyInfoDocument, options);
        }
export type GetCompanyInfoQueryHookResult = ReturnType<typeof useGetCompanyInfoQuery>;
export type GetCompanyInfoLazyQueryHookResult = ReturnType<typeof useGetCompanyInfoLazyQuery>;
export type GetCompanyInfoSuspenseQueryHookResult = ReturnType<typeof useGetCompanyInfoSuspenseQuery>;
export type GetCompanyInfoQueryResult = Apollo.QueryResult<GetCompanyInfoQuery, GetCompanyInfoQueryVariables>;
export const GetIsEmployerOfRecordEnabledDocument = gql`
    query GetIsEmployerOfRecordEnabled {
  authenticatedMember {
    company {
      companySetting(name: "employer_of_record_enabled") {
        value
      }
    }
  }
}
    `;

/**
 * __useGetIsEmployerOfRecordEnabledQuery__
 *
 * To run a query within a React component, call `useGetIsEmployerOfRecordEnabledQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetIsEmployerOfRecordEnabledQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetIsEmployerOfRecordEnabledQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetIsEmployerOfRecordEnabledQuery(baseOptions?: Apollo.QueryHookOptions<GetIsEmployerOfRecordEnabledQuery, GetIsEmployerOfRecordEnabledQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetIsEmployerOfRecordEnabledQuery, GetIsEmployerOfRecordEnabledQueryVariables>(GetIsEmployerOfRecordEnabledDocument, options);
      }
export function useGetIsEmployerOfRecordEnabledLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetIsEmployerOfRecordEnabledQuery, GetIsEmployerOfRecordEnabledQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetIsEmployerOfRecordEnabledQuery, GetIsEmployerOfRecordEnabledQueryVariables>(GetIsEmployerOfRecordEnabledDocument, options);
        }
export function useGetIsEmployerOfRecordEnabledSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetIsEmployerOfRecordEnabledQuery, GetIsEmployerOfRecordEnabledQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetIsEmployerOfRecordEnabledQuery, GetIsEmployerOfRecordEnabledQueryVariables>(GetIsEmployerOfRecordEnabledDocument, options);
        }
export type GetIsEmployerOfRecordEnabledQueryHookResult = ReturnType<typeof useGetIsEmployerOfRecordEnabledQuery>;
export type GetIsEmployerOfRecordEnabledLazyQueryHookResult = ReturnType<typeof useGetIsEmployerOfRecordEnabledLazyQuery>;
export type GetIsEmployerOfRecordEnabledSuspenseQueryHookResult = ReturnType<typeof useGetIsEmployerOfRecordEnabledSuspenseQuery>;
export type GetIsEmployerOfRecordEnabledQueryResult = Apollo.QueryResult<GetIsEmployerOfRecordEnabledQuery, GetIsEmployerOfRecordEnabledQueryVariables>;
export const GetAdminStatusDocument = gql`
    query GetAdminStatus {
  authenticatedMember {
    adminStatus
  }
}
    `;

/**
 * __useGetAdminStatusQuery__
 *
 * To run a query within a React component, call `useGetAdminStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAdminStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAdminStatusQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAdminStatusQuery(baseOptions?: Apollo.QueryHookOptions<GetAdminStatusQuery, GetAdminStatusQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAdminStatusQuery, GetAdminStatusQueryVariables>(GetAdminStatusDocument, options);
      }
export function useGetAdminStatusLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAdminStatusQuery, GetAdminStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAdminStatusQuery, GetAdminStatusQueryVariables>(GetAdminStatusDocument, options);
        }
export function useGetAdminStatusSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetAdminStatusQuery, GetAdminStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAdminStatusQuery, GetAdminStatusQueryVariables>(GetAdminStatusDocument, options);
        }
export type GetAdminStatusQueryHookResult = ReturnType<typeof useGetAdminStatusQuery>;
export type GetAdminStatusLazyQueryHookResult = ReturnType<typeof useGetAdminStatusLazyQuery>;
export type GetAdminStatusSuspenseQueryHookResult = ReturnType<typeof useGetAdminStatusSuspenseQuery>;
export type GetAdminStatusQueryResult = Apollo.QueryResult<GetAdminStatusQuery, GetAdminStatusQueryVariables>;
export const CreateCompanyAncillaryBenefitPlanDocument = gql`
    mutation CreateCompanyAncillaryBenefitPlan($companyUuid: String, $effectiveDate: String, $amount: String, $abpPlanType: String) {
  createCompanyAncillaryBenefitPlan(
    companyUuid: $companyUuid
    effectiveDate: $effectiveDate
    amount: $amount
    abpPlanType: $abpPlanType
  ) {
    success
    userErrors {
      message
    }
  }
}
    `;
export type CreateCompanyAncillaryBenefitPlanMutationFn = Apollo.MutationFunction<CreateCompanyAncillaryBenefitPlanMutation, CreateCompanyAncillaryBenefitPlanMutationVariables>;

/**
 * __useCreateCompanyAncillaryBenefitPlanMutation__
 *
 * To run a mutation, you first call `useCreateCompanyAncillaryBenefitPlanMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCompanyAncillaryBenefitPlanMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCompanyAncillaryBenefitPlanMutation, { data, loading, error }] = useCreateCompanyAncillaryBenefitPlanMutation({
 *   variables: {
 *      companyUuid: // value for 'companyUuid'
 *      effectiveDate: // value for 'effectiveDate'
 *      amount: // value for 'amount'
 *      abpPlanType: // value for 'abpPlanType'
 *   },
 * });
 */
export function useCreateCompanyAncillaryBenefitPlanMutation(baseOptions?: Apollo.MutationHookOptions<CreateCompanyAncillaryBenefitPlanMutation, CreateCompanyAncillaryBenefitPlanMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateCompanyAncillaryBenefitPlanMutation, CreateCompanyAncillaryBenefitPlanMutationVariables>(CreateCompanyAncillaryBenefitPlanDocument, options);
      }
export type CreateCompanyAncillaryBenefitPlanMutationHookResult = ReturnType<typeof useCreateCompanyAncillaryBenefitPlanMutation>;
export type CreateCompanyAncillaryBenefitPlanMutationResult = Apollo.MutationResult<CreateCompanyAncillaryBenefitPlanMutation>;
export type CreateCompanyAncillaryBenefitPlanMutationOptions = Apollo.BaseMutationOptions<CreateCompanyAncillaryBenefitPlanMutation, CreateCompanyAncillaryBenefitPlanMutationVariables>;
export const GetCompanyUuidDocument = gql`
    query GetCompanyUuid {
  authenticatedMember {
    company {
      uuid
    }
  }
}
    `;

/**
 * __useGetCompanyUuidQuery__
 *
 * To run a query within a React component, call `useGetCompanyUuidQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCompanyUuidQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCompanyUuidQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCompanyUuidQuery(baseOptions?: Apollo.QueryHookOptions<GetCompanyUuidQuery, GetCompanyUuidQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCompanyUuidQuery, GetCompanyUuidQueryVariables>(GetCompanyUuidDocument, options);
      }
export function useGetCompanyUuidLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCompanyUuidQuery, GetCompanyUuidQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCompanyUuidQuery, GetCompanyUuidQueryVariables>(GetCompanyUuidDocument, options);
        }
export function useGetCompanyUuidSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCompanyUuidQuery, GetCompanyUuidQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCompanyUuidQuery, GetCompanyUuidQueryVariables>(GetCompanyUuidDocument, options);
        }
export type GetCompanyUuidQueryHookResult = ReturnType<typeof useGetCompanyUuidQuery>;
export type GetCompanyUuidLazyQueryHookResult = ReturnType<typeof useGetCompanyUuidLazyQuery>;
export type GetCompanyUuidSuspenseQueryHookResult = ReturnType<typeof useGetCompanyUuidSuspenseQuery>;
export type GetCompanyUuidQueryResult = Apollo.QueryResult<GetCompanyUuidQuery, GetCompanyUuidQueryVariables>;
export const EnterDemoModeDocument = gql`
    mutation EnterDemoMode {
  vendorModeSetter(enableDemoMode: true) {
    success
    userErrors {
      message
    }
  }
}
    `;
export type EnterDemoModeMutationFn = Apollo.MutationFunction<EnterDemoModeMutation, EnterDemoModeMutationVariables>;

/**
 * __useEnterDemoModeMutation__
 *
 * To run a mutation, you first call `useEnterDemoModeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEnterDemoModeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [enterDemoModeMutation, { data, loading, error }] = useEnterDemoModeMutation({
 *   variables: {
 *   },
 * });
 */
export function useEnterDemoModeMutation(baseOptions?: Apollo.MutationHookOptions<EnterDemoModeMutation, EnterDemoModeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EnterDemoModeMutation, EnterDemoModeMutationVariables>(EnterDemoModeDocument, options);
      }
export type EnterDemoModeMutationHookResult = ReturnType<typeof useEnterDemoModeMutation>;
export type EnterDemoModeMutationResult = Apollo.MutationResult<EnterDemoModeMutation>;
export type EnterDemoModeMutationOptions = Apollo.BaseMutationOptions<EnterDemoModeMutation, EnterDemoModeMutationVariables>;
export const GetNsfDetailsDocument = gql`
    query GetNsfDetails($objectFlagId: ID!) {
  nsfDetails(objectFlagId: $objectFlagId) {
    amount
    returnCode
    dueDate
    invoiceId
    payerId {
      accountNumber
      routingNumber
    }
  }
}
    `;

/**
 * __useGetNsfDetailsQuery__
 *
 * To run a query within a React component, call `useGetNsfDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetNsfDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetNsfDetailsQuery({
 *   variables: {
 *      objectFlagId: // value for 'objectFlagId'
 *   },
 * });
 */
export function useGetNsfDetailsQuery(baseOptions: Apollo.QueryHookOptions<GetNsfDetailsQuery, GetNsfDetailsQueryVariables> & ({ variables: GetNsfDetailsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetNsfDetailsQuery, GetNsfDetailsQueryVariables>(GetNsfDetailsDocument, options);
      }
export function useGetNsfDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetNsfDetailsQuery, GetNsfDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetNsfDetailsQuery, GetNsfDetailsQueryVariables>(GetNsfDetailsDocument, options);
        }
export function useGetNsfDetailsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetNsfDetailsQuery, GetNsfDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetNsfDetailsQuery, GetNsfDetailsQueryVariables>(GetNsfDetailsDocument, options);
        }
export type GetNsfDetailsQueryHookResult = ReturnType<typeof useGetNsfDetailsQuery>;
export type GetNsfDetailsLazyQueryHookResult = ReturnType<typeof useGetNsfDetailsLazyQuery>;
export type GetNsfDetailsSuspenseQueryHookResult = ReturnType<typeof useGetNsfDetailsSuspenseQuery>;
export type GetNsfDetailsQueryResult = Apollo.QueryResult<GetNsfDetailsQuery, GetNsfDetailsQueryVariables>;
export const GetTransactionsPageDataDocument = gql`
    query GetTransactionsPageData($startDate: APIDate!) {
  transactions(startDate: $startDate) {
    id
    type
    amount
    date
    description
    descriptionLink
  }
  companyBankAccount {
    accountTail
    accountType
    bankName
    verified
  }
  companyWallet {
    id
    balanceAmount {
      value
      currency
    }
    customerId
    ownerName
  }
}
    `;

/**
 * __useGetTransactionsPageDataQuery__
 *
 * To run a query within a React component, call `useGetTransactionsPageDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTransactionsPageDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTransactionsPageDataQuery({
 *   variables: {
 *      startDate: // value for 'startDate'
 *   },
 * });
 */
export function useGetTransactionsPageDataQuery(baseOptions: Apollo.QueryHookOptions<GetTransactionsPageDataQuery, GetTransactionsPageDataQueryVariables> & ({ variables: GetTransactionsPageDataQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTransactionsPageDataQuery, GetTransactionsPageDataQueryVariables>(GetTransactionsPageDataDocument, options);
      }
export function useGetTransactionsPageDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTransactionsPageDataQuery, GetTransactionsPageDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTransactionsPageDataQuery, GetTransactionsPageDataQueryVariables>(GetTransactionsPageDataDocument, options);
        }
export function useGetTransactionsPageDataSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetTransactionsPageDataQuery, GetTransactionsPageDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetTransactionsPageDataQuery, GetTransactionsPageDataQueryVariables>(GetTransactionsPageDataDocument, options);
        }
export type GetTransactionsPageDataQueryHookResult = ReturnType<typeof useGetTransactionsPageDataQuery>;
export type GetTransactionsPageDataLazyQueryHookResult = ReturnType<typeof useGetTransactionsPageDataLazyQuery>;
export type GetTransactionsPageDataSuspenseQueryHookResult = ReturnType<typeof useGetTransactionsPageDataSuspenseQuery>;
export type GetTransactionsPageDataQueryResult = Apollo.QueryResult<GetTransactionsPageDataQuery, GetTransactionsPageDataQueryVariables>;
export const GetPeopleAnalyticsCapabilityDocument = gql`
    query GetPeopleAnalyticsCapability {
  authenticatedMember {
    uuid
    capabilities {
      hasAccessToPeopleAnalytics
      hasAccessToPeopleAnalyticsPlus
    }
    company {
      uuid
      isEligibleForBenefits
      enrolledInMico
      activePtoPolicies {
        uuid
      }
    }
  }
}
    `;

/**
 * __useGetPeopleAnalyticsCapabilityQuery__
 *
 * To run a query within a React component, call `useGetPeopleAnalyticsCapabilityQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPeopleAnalyticsCapabilityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPeopleAnalyticsCapabilityQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetPeopleAnalyticsCapabilityQuery(baseOptions?: Apollo.QueryHookOptions<GetPeopleAnalyticsCapabilityQuery, GetPeopleAnalyticsCapabilityQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPeopleAnalyticsCapabilityQuery, GetPeopleAnalyticsCapabilityQueryVariables>(GetPeopleAnalyticsCapabilityDocument, options);
      }
export function useGetPeopleAnalyticsCapabilityLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPeopleAnalyticsCapabilityQuery, GetPeopleAnalyticsCapabilityQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPeopleAnalyticsCapabilityQuery, GetPeopleAnalyticsCapabilityQueryVariables>(GetPeopleAnalyticsCapabilityDocument, options);
        }
export function useGetPeopleAnalyticsCapabilitySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetPeopleAnalyticsCapabilityQuery, GetPeopleAnalyticsCapabilityQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPeopleAnalyticsCapabilityQuery, GetPeopleAnalyticsCapabilityQueryVariables>(GetPeopleAnalyticsCapabilityDocument, options);
        }
export type GetPeopleAnalyticsCapabilityQueryHookResult = ReturnType<typeof useGetPeopleAnalyticsCapabilityQuery>;
export type GetPeopleAnalyticsCapabilityLazyQueryHookResult = ReturnType<typeof useGetPeopleAnalyticsCapabilityLazyQuery>;
export type GetPeopleAnalyticsCapabilitySuspenseQueryHookResult = ReturnType<typeof useGetPeopleAnalyticsCapabilitySuspenseQuery>;
export type GetPeopleAnalyticsCapabilityQueryResult = Apollo.QueryResult<GetPeopleAnalyticsCapabilityQuery, GetPeopleAnalyticsCapabilityQueryVariables>;
export const GetVisierBenefitsMetricsDocument = gql`
    query GetVisierBenefitsMetrics {
  visierBenefitsMetrics {
    companyCostOfBenefitsLastYear
    employeeCostOfBenefitsLastYear
  }
}
    `;

/**
 * __useGetVisierBenefitsMetricsQuery__
 *
 * To run a query within a React component, call `useGetVisierBenefitsMetricsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetVisierBenefitsMetricsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetVisierBenefitsMetricsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetVisierBenefitsMetricsQuery(baseOptions?: Apollo.QueryHookOptions<GetVisierBenefitsMetricsQuery, GetVisierBenefitsMetricsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetVisierBenefitsMetricsQuery, GetVisierBenefitsMetricsQueryVariables>(GetVisierBenefitsMetricsDocument, options);
      }
export function useGetVisierBenefitsMetricsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetVisierBenefitsMetricsQuery, GetVisierBenefitsMetricsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetVisierBenefitsMetricsQuery, GetVisierBenefitsMetricsQueryVariables>(GetVisierBenefitsMetricsDocument, options);
        }
export function useGetVisierBenefitsMetricsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetVisierBenefitsMetricsQuery, GetVisierBenefitsMetricsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetVisierBenefitsMetricsQuery, GetVisierBenefitsMetricsQueryVariables>(GetVisierBenefitsMetricsDocument, options);
        }
export type GetVisierBenefitsMetricsQueryHookResult = ReturnType<typeof useGetVisierBenefitsMetricsQuery>;
export type GetVisierBenefitsMetricsLazyQueryHookResult = ReturnType<typeof useGetVisierBenefitsMetricsLazyQuery>;
export type GetVisierBenefitsMetricsSuspenseQueryHookResult = ReturnType<typeof useGetVisierBenefitsMetricsSuspenseQuery>;
export type GetVisierBenefitsMetricsQueryResult = Apollo.QueryResult<GetVisierBenefitsMetricsQuery, GetVisierBenefitsMetricsQueryVariables>;
export const GetVisierFinanceMetricsDocument = gql`
    query GetVisierFinanceMetrics {
  visierFinanceMetrics {
    compensationPaidLastThreeMonths
  }
}
    `;

/**
 * __useGetVisierFinanceMetricsQuery__
 *
 * To run a query within a React component, call `useGetVisierFinanceMetricsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetVisierFinanceMetricsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetVisierFinanceMetricsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetVisierFinanceMetricsQuery(baseOptions?: Apollo.QueryHookOptions<GetVisierFinanceMetricsQuery, GetVisierFinanceMetricsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetVisierFinanceMetricsQuery, GetVisierFinanceMetricsQueryVariables>(GetVisierFinanceMetricsDocument, options);
      }
export function useGetVisierFinanceMetricsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetVisierFinanceMetricsQuery, GetVisierFinanceMetricsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetVisierFinanceMetricsQuery, GetVisierFinanceMetricsQueryVariables>(GetVisierFinanceMetricsDocument, options);
        }
export function useGetVisierFinanceMetricsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetVisierFinanceMetricsQuery, GetVisierFinanceMetricsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetVisierFinanceMetricsQuery, GetVisierFinanceMetricsQueryVariables>(GetVisierFinanceMetricsDocument, options);
        }
export type GetVisierFinanceMetricsQueryHookResult = ReturnType<typeof useGetVisierFinanceMetricsQuery>;
export type GetVisierFinanceMetricsLazyQueryHookResult = ReturnType<typeof useGetVisierFinanceMetricsLazyQuery>;
export type GetVisierFinanceMetricsSuspenseQueryHookResult = ReturnType<typeof useGetVisierFinanceMetricsSuspenseQuery>;
export type GetVisierFinanceMetricsQueryResult = Apollo.QueryResult<GetVisierFinanceMetricsQuery, GetVisierFinanceMetricsQueryVariables>;
export const GetVisierPtoMetricsDocument = gql`
    query GetVisierPtoMetrics {
  visierPtoMetrics {
    averagePtoDaysLastMonth
    highestPtoDepartmentLastMonth {
      departmentName
      dayCount
    }
  }
}
    `;

/**
 * __useGetVisierPtoMetricsQuery__
 *
 * To run a query within a React component, call `useGetVisierPtoMetricsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetVisierPtoMetricsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetVisierPtoMetricsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetVisierPtoMetricsQuery(baseOptions?: Apollo.QueryHookOptions<GetVisierPtoMetricsQuery, GetVisierPtoMetricsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetVisierPtoMetricsQuery, GetVisierPtoMetricsQueryVariables>(GetVisierPtoMetricsDocument, options);
      }
export function useGetVisierPtoMetricsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetVisierPtoMetricsQuery, GetVisierPtoMetricsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetVisierPtoMetricsQuery, GetVisierPtoMetricsQueryVariables>(GetVisierPtoMetricsDocument, options);
        }
export function useGetVisierPtoMetricsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetVisierPtoMetricsQuery, GetVisierPtoMetricsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetVisierPtoMetricsQuery, GetVisierPtoMetricsQueryVariables>(GetVisierPtoMetricsDocument, options);
        }
export type GetVisierPtoMetricsQueryHookResult = ReturnType<typeof useGetVisierPtoMetricsQuery>;
export type GetVisierPtoMetricsLazyQueryHookResult = ReturnType<typeof useGetVisierPtoMetricsLazyQuery>;
export type GetVisierPtoMetricsSuspenseQueryHookResult = ReturnType<typeof useGetVisierPtoMetricsSuspenseQuery>;
export type GetVisierPtoMetricsQueryResult = Apollo.QueryResult<GetVisierPtoMetricsQuery, GetVisierPtoMetricsQueryVariables>;
export const GetVisierWorkforceMetricsDocument = gql`
    query GetVisierWorkforceMetrics {
  visierWorkforceMetrics {
    fullTimeEmployeeCountCurrent
    partTimeEmployeeCountCurrent
  }
}
    `;

/**
 * __useGetVisierWorkforceMetricsQuery__
 *
 * To run a query within a React component, call `useGetVisierWorkforceMetricsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetVisierWorkforceMetricsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetVisierWorkforceMetricsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetVisierWorkforceMetricsQuery(baseOptions?: Apollo.QueryHookOptions<GetVisierWorkforceMetricsQuery, GetVisierWorkforceMetricsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetVisierWorkforceMetricsQuery, GetVisierWorkforceMetricsQueryVariables>(GetVisierWorkforceMetricsDocument, options);
      }
export function useGetVisierWorkforceMetricsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetVisierWorkforceMetricsQuery, GetVisierWorkforceMetricsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetVisierWorkforceMetricsQuery, GetVisierWorkforceMetricsQueryVariables>(GetVisierWorkforceMetricsDocument, options);
        }
export function useGetVisierWorkforceMetricsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetVisierWorkforceMetricsQuery, GetVisierWorkforceMetricsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetVisierWorkforceMetricsQuery, GetVisierWorkforceMetricsQueryVariables>(GetVisierWorkforceMetricsDocument, options);
        }
export type GetVisierWorkforceMetricsQueryHookResult = ReturnType<typeof useGetVisierWorkforceMetricsQuery>;
export type GetVisierWorkforceMetricsLazyQueryHookResult = ReturnType<typeof useGetVisierWorkforceMetricsLazyQuery>;
export type GetVisierWorkforceMetricsSuspenseQueryHookResult = ReturnType<typeof useGetVisierWorkforceMetricsSuspenseQuery>;
export type GetVisierWorkforceMetricsQueryResult = Apollo.QueryResult<GetVisierWorkforceMetricsQuery, GetVisierWorkforceMetricsQueryVariables>;
export const GetPmtIntegrationFrameworkPdpDataDocument = gql`
    query GetPmtIntegrationFrameworkPdpData($integration_uuid: String, $integration_name: String, $integration_instance_status: String, $integration_instance_keys: [String!], $limit: Int) {
  authenticatedMember {
    uuid
    permissions
    company {
      uuid
      cdmsCanonicalCompanyId
      name
      admins {
        permissions
        friendlyFullName
        firstName
        lastName
        uuid
      }
    }
  }
  pmtIntegrationsFramework {
    integration(uuid: $integration_uuid, integrationName: $integration_name) {
      data {
        name
        uuid
        status
        companyUuid
        createdAt
        updatedAt
        instancesByKey(
          instanceStatus: $integration_instance_status
          keys: $integration_instance_keys
          limit: $limit
        ) {
          key
          instances {
            uuid
            key
            status
            config
            memberId
            createdAt
            updatedAt
          }
        }
      }
      metadata {
        status
        success
        error
      }
    }
    solution(integrationName: $integration_name) {
      data {
        uuid
        status
        name
        copy {
          title
          description
        }
      }
      metadata {
        status
        success
        error
      }
    }
  }
}
    `;

/**
 * __useGetPmtIntegrationFrameworkPdpDataQuery__
 *
 * To run a query within a React component, call `useGetPmtIntegrationFrameworkPdpDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPmtIntegrationFrameworkPdpDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPmtIntegrationFrameworkPdpDataQuery({
 *   variables: {
 *      integration_uuid: // value for 'integration_uuid'
 *      integration_name: // value for 'integration_name'
 *      integration_instance_status: // value for 'integration_instance_status'
 *      integration_instance_keys: // value for 'integration_instance_keys'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useGetPmtIntegrationFrameworkPdpDataQuery(baseOptions?: Apollo.QueryHookOptions<GetPmtIntegrationFrameworkPdpDataQuery, GetPmtIntegrationFrameworkPdpDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPmtIntegrationFrameworkPdpDataQuery, GetPmtIntegrationFrameworkPdpDataQueryVariables>(GetPmtIntegrationFrameworkPdpDataDocument, options);
      }
export function useGetPmtIntegrationFrameworkPdpDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPmtIntegrationFrameworkPdpDataQuery, GetPmtIntegrationFrameworkPdpDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPmtIntegrationFrameworkPdpDataQuery, GetPmtIntegrationFrameworkPdpDataQueryVariables>(GetPmtIntegrationFrameworkPdpDataDocument, options);
        }
export function useGetPmtIntegrationFrameworkPdpDataSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetPmtIntegrationFrameworkPdpDataQuery, GetPmtIntegrationFrameworkPdpDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPmtIntegrationFrameworkPdpDataQuery, GetPmtIntegrationFrameworkPdpDataQueryVariables>(GetPmtIntegrationFrameworkPdpDataDocument, options);
        }
export type GetPmtIntegrationFrameworkPdpDataQueryHookResult = ReturnType<typeof useGetPmtIntegrationFrameworkPdpDataQuery>;
export type GetPmtIntegrationFrameworkPdpDataLazyQueryHookResult = ReturnType<typeof useGetPmtIntegrationFrameworkPdpDataLazyQuery>;
export type GetPmtIntegrationFrameworkPdpDataSuspenseQueryHookResult = ReturnType<typeof useGetPmtIntegrationFrameworkPdpDataSuspenseQuery>;
export type GetPmtIntegrationFrameworkPdpDataQueryResult = Apollo.QueryResult<GetPmtIntegrationFrameworkPdpDataQuery, GetPmtIntegrationFrameworkPdpDataQueryVariables>;
export const ProcessPmtIntegrationFrameworkActionDocument = gql`
    mutation ProcessPMTIntegrationFrameworkAction($integration_name: String!, $action: String!, $action_data: JSON, $integration_uuid: String) {
  processPmtIntegrationFrameworkAction(
    integrationName: $integration_name
    action: $action
    actionData: $action_data
    integrationUuid: $integration_uuid
  ) {
    integration {
      companyUuid
      createdAt
      name
      status
      updatedAt
      uuid
    }
    actionData
    metadata {
      status
      success
      error
    }
  }
}
    `;
export type ProcessPmtIntegrationFrameworkActionMutationFn = Apollo.MutationFunction<ProcessPmtIntegrationFrameworkActionMutation, ProcessPmtIntegrationFrameworkActionMutationVariables>;

/**
 * __useProcessPmtIntegrationFrameworkActionMutation__
 *
 * To run a mutation, you first call `useProcessPmtIntegrationFrameworkActionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProcessPmtIntegrationFrameworkActionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [processPmtIntegrationFrameworkActionMutation, { data, loading, error }] = useProcessPmtIntegrationFrameworkActionMutation({
 *   variables: {
 *      integration_name: // value for 'integration_name'
 *      action: // value for 'action'
 *      action_data: // value for 'action_data'
 *      integration_uuid: // value for 'integration_uuid'
 *   },
 * });
 */
export function useProcessPmtIntegrationFrameworkActionMutation(baseOptions?: Apollo.MutationHookOptions<ProcessPmtIntegrationFrameworkActionMutation, ProcessPmtIntegrationFrameworkActionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ProcessPmtIntegrationFrameworkActionMutation, ProcessPmtIntegrationFrameworkActionMutationVariables>(ProcessPmtIntegrationFrameworkActionDocument, options);
      }
export type ProcessPmtIntegrationFrameworkActionMutationHookResult = ReturnType<typeof useProcessPmtIntegrationFrameworkActionMutation>;
export type ProcessPmtIntegrationFrameworkActionMutationResult = Apollo.MutationResult<ProcessPmtIntegrationFrameworkActionMutation>;
export type ProcessPmtIntegrationFrameworkActionMutationOptions = Apollo.BaseMutationOptions<ProcessPmtIntegrationFrameworkActionMutation, ProcessPmtIntegrationFrameworkActionMutationVariables>;
export const GetPmtIntegrationFrameworkSetupDataDocument = gql`
    query GetPmtIntegrationFrameworkSetupData($integration_uuid: String, $integration_name: String, $integration_instance_status: String, $integration_instance_keys: [String!], $limit: Int) {
  authenticatedMember {
    uuid
    permissions
    company {
      uuid
      name
    }
  }
  pmtIntegrationsFramework {
    integration(uuid: $integration_uuid, integrationName: $integration_name) {
      data {
        name
        uuid
        status
        companyUuid
        createdAt
        updatedAt
        instancesByKey(
          instanceStatus: $integration_instance_status
          keys: $integration_instance_keys
          limit: $limit
        ) {
          key
          instances {
            uuid
            key
            status
            config
            memberId
            createdAt
            updatedAt
          }
        }
      }
      metadata {
        status
        success
        error
      }
    }
    solution(integrationName: $integration_name) {
      data {
        uuid
        status
        name
        copy {
          title
          description
        }
      }
      metadata {
        status
        success
        error
      }
    }
  }
}
    `;

/**
 * __useGetPmtIntegrationFrameworkSetupDataQuery__
 *
 * To run a query within a React component, call `useGetPmtIntegrationFrameworkSetupDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPmtIntegrationFrameworkSetupDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPmtIntegrationFrameworkSetupDataQuery({
 *   variables: {
 *      integration_uuid: // value for 'integration_uuid'
 *      integration_name: // value for 'integration_name'
 *      integration_instance_status: // value for 'integration_instance_status'
 *      integration_instance_keys: // value for 'integration_instance_keys'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useGetPmtIntegrationFrameworkSetupDataQuery(baseOptions?: Apollo.QueryHookOptions<GetPmtIntegrationFrameworkSetupDataQuery, GetPmtIntegrationFrameworkSetupDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPmtIntegrationFrameworkSetupDataQuery, GetPmtIntegrationFrameworkSetupDataQueryVariables>(GetPmtIntegrationFrameworkSetupDataDocument, options);
      }
export function useGetPmtIntegrationFrameworkSetupDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPmtIntegrationFrameworkSetupDataQuery, GetPmtIntegrationFrameworkSetupDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPmtIntegrationFrameworkSetupDataQuery, GetPmtIntegrationFrameworkSetupDataQueryVariables>(GetPmtIntegrationFrameworkSetupDataDocument, options);
        }
export function useGetPmtIntegrationFrameworkSetupDataSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetPmtIntegrationFrameworkSetupDataQuery, GetPmtIntegrationFrameworkSetupDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPmtIntegrationFrameworkSetupDataQuery, GetPmtIntegrationFrameworkSetupDataQueryVariables>(GetPmtIntegrationFrameworkSetupDataDocument, options);
        }
export type GetPmtIntegrationFrameworkSetupDataQueryHookResult = ReturnType<typeof useGetPmtIntegrationFrameworkSetupDataQuery>;
export type GetPmtIntegrationFrameworkSetupDataLazyQueryHookResult = ReturnType<typeof useGetPmtIntegrationFrameworkSetupDataLazyQuery>;
export type GetPmtIntegrationFrameworkSetupDataSuspenseQueryHookResult = ReturnType<typeof useGetPmtIntegrationFrameworkSetupDataSuspenseQuery>;
export type GetPmtIntegrationFrameworkSetupDataQueryResult = Apollo.QueryResult<GetPmtIntegrationFrameworkSetupDataQuery, GetPmtIntegrationFrameworkSetupDataQueryVariables>;
export const GetIntegrationSolutionDataDocument = gql`
    query GetIntegrationSolutionData {
  authenticatedMember {
    uuid
    permissions
    company {
      uuid
      name
      companyPlanType
      admins {
        permissions
        friendlyFullName
        firstName
        lastName
        uuid
      }
      greenhouseCandidateHiredIntegration {
        name
        status
      }
    }
  }
  externalPartnerIntegrations {
    solutions {
      data {
        slug
        status
        title
        uuid
        partner {
          name
          uuid
        }
      }
      metadata {
        success
        status
        error
      }
    }
    instances {
      data {
        status
        solutionUuid
        lastUsedDate
      }
      metadata {
        success
        status
        error
      }
    }
  }
  accountingIntegrations {
    integrationsInfo {
      name
      status
      isBeta
      url
      description
      slug
      category
    }
  }
}
    `;

/**
 * __useGetIntegrationSolutionDataQuery__
 *
 * To run a query within a React component, call `useGetIntegrationSolutionDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetIntegrationSolutionDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetIntegrationSolutionDataQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetIntegrationSolutionDataQuery(baseOptions?: Apollo.QueryHookOptions<GetIntegrationSolutionDataQuery, GetIntegrationSolutionDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetIntegrationSolutionDataQuery, GetIntegrationSolutionDataQueryVariables>(GetIntegrationSolutionDataDocument, options);
      }
export function useGetIntegrationSolutionDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetIntegrationSolutionDataQuery, GetIntegrationSolutionDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetIntegrationSolutionDataQuery, GetIntegrationSolutionDataQueryVariables>(GetIntegrationSolutionDataDocument, options);
        }
export function useGetIntegrationSolutionDataSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetIntegrationSolutionDataQuery, GetIntegrationSolutionDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetIntegrationSolutionDataQuery, GetIntegrationSolutionDataQueryVariables>(GetIntegrationSolutionDataDocument, options);
        }
export type GetIntegrationSolutionDataQueryHookResult = ReturnType<typeof useGetIntegrationSolutionDataQuery>;
export type GetIntegrationSolutionDataLazyQueryHookResult = ReturnType<typeof useGetIntegrationSolutionDataLazyQuery>;
export type GetIntegrationSolutionDataSuspenseQueryHookResult = ReturnType<typeof useGetIntegrationSolutionDataSuspenseQuery>;
export type GetIntegrationSolutionDataQueryResult = Apollo.QueryResult<GetIntegrationSolutionDataQuery, GetIntegrationSolutionDataQueryVariables>;
export const GetPmtIntegrationFrameworkDataDocument = gql`
    query GetPmtIntegrationFrameworkData($integration_name: String, $integration_instance_status: String, $integration_instance_keys: [String!], $integration_status: [String!], $limit: Int) {
  pmtIntegrationsFramework {
    integrations(integrationName: $integration_name, status: $integration_status) {
      data {
        companyUuid
        createdAt
        name
        status
        updatedAt
        uuid
        instancesByKey(
          instanceStatus: $integration_instance_status
          keys: $integration_instance_keys
          limit: $limit
        ) {
          key
          instances {
            uuid
            key
            status
            config
            memberId
            createdAt
            updatedAt
          }
        }
      }
      metadata {
        status
        success
        error
      }
    }
    solutions {
      data {
        uuid
        name
        status
        copy {
          title
          description
        }
      }
      metadata {
        status
        success
        error
      }
    }
  }
}
    `;

/**
 * __useGetPmtIntegrationFrameworkDataQuery__
 *
 * To run a query within a React component, call `useGetPmtIntegrationFrameworkDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPmtIntegrationFrameworkDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPmtIntegrationFrameworkDataQuery({
 *   variables: {
 *      integration_name: // value for 'integration_name'
 *      integration_instance_status: // value for 'integration_instance_status'
 *      integration_instance_keys: // value for 'integration_instance_keys'
 *      integration_status: // value for 'integration_status'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useGetPmtIntegrationFrameworkDataQuery(baseOptions?: Apollo.QueryHookOptions<GetPmtIntegrationFrameworkDataQuery, GetPmtIntegrationFrameworkDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPmtIntegrationFrameworkDataQuery, GetPmtIntegrationFrameworkDataQueryVariables>(GetPmtIntegrationFrameworkDataDocument, options);
      }
export function useGetPmtIntegrationFrameworkDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPmtIntegrationFrameworkDataQuery, GetPmtIntegrationFrameworkDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPmtIntegrationFrameworkDataQuery, GetPmtIntegrationFrameworkDataQueryVariables>(GetPmtIntegrationFrameworkDataDocument, options);
        }
export function useGetPmtIntegrationFrameworkDataSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetPmtIntegrationFrameworkDataQuery, GetPmtIntegrationFrameworkDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPmtIntegrationFrameworkDataQuery, GetPmtIntegrationFrameworkDataQueryVariables>(GetPmtIntegrationFrameworkDataDocument, options);
        }
export type GetPmtIntegrationFrameworkDataQueryHookResult = ReturnType<typeof useGetPmtIntegrationFrameworkDataQuery>;
export type GetPmtIntegrationFrameworkDataLazyQueryHookResult = ReturnType<typeof useGetPmtIntegrationFrameworkDataLazyQuery>;
export type GetPmtIntegrationFrameworkDataSuspenseQueryHookResult = ReturnType<typeof useGetPmtIntegrationFrameworkDataSuspenseQuery>;
export type GetPmtIntegrationFrameworkDataQueryResult = Apollo.QueryResult<GetPmtIntegrationFrameworkDataQuery, GetPmtIntegrationFrameworkDataQueryVariables>;
export const ConfirmMemberSeparationDocument = gql`
    mutation ConfirmMemberSeparation($memberSeparationId: ID!, $paymentSettings: [PaymentSettings!]!) {
  confirmMemberSeparation(
    memberSeparationId: $memberSeparationId
    paymentSettings: $paymentSettings
  ) {
    success
    payments {
      paymentType
      amount
    }
    errors {
      inputField
      message
    }
  }
}
    `;
export type ConfirmMemberSeparationMutationFn = Apollo.MutationFunction<ConfirmMemberSeparationMutation, ConfirmMemberSeparationMutationVariables>;

/**
 * __useConfirmMemberSeparationMutation__
 *
 * To run a mutation, you first call `useConfirmMemberSeparationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConfirmMemberSeparationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [confirmMemberSeparationMutation, { data, loading, error }] = useConfirmMemberSeparationMutation({
 *   variables: {
 *      memberSeparationId: // value for 'memberSeparationId'
 *      paymentSettings: // value for 'paymentSettings'
 *   },
 * });
 */
export function useConfirmMemberSeparationMutation(baseOptions?: Apollo.MutationHookOptions<ConfirmMemberSeparationMutation, ConfirmMemberSeparationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ConfirmMemberSeparationMutation, ConfirmMemberSeparationMutationVariables>(ConfirmMemberSeparationDocument, options);
      }
export type ConfirmMemberSeparationMutationHookResult = ReturnType<typeof useConfirmMemberSeparationMutation>;
export type ConfirmMemberSeparationMutationResult = Apollo.MutationResult<ConfirmMemberSeparationMutation>;
export type ConfirmMemberSeparationMutationOptions = Apollo.BaseMutationOptions<ConfirmMemberSeparationMutation, ConfirmMemberSeparationMutationVariables>;
export const CreateMemberSeparationDocument = gql`
    mutation CreateMemberSeparation($memberUuid: ID!) {
  createMemberSeparation(memberUuid: $memberUuid) {
    success
    memberSeparation {
      companyId
      createdAt
      earliestPayDate
      lastUpdatedById
      memberSeparationId
      questionnaireVersion
      status
      updatedAt
    }
    errors {
      inputField
      message
    }
  }
}
    `;
export type CreateMemberSeparationMutationFn = Apollo.MutationFunction<CreateMemberSeparationMutation, CreateMemberSeparationMutationVariables>;

/**
 * __useCreateMemberSeparationMutation__
 *
 * To run a mutation, you first call `useCreateMemberSeparationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateMemberSeparationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createMemberSeparationMutation, { data, loading, error }] = useCreateMemberSeparationMutation({
 *   variables: {
 *      memberUuid: // value for 'memberUuid'
 *   },
 * });
 */
export function useCreateMemberSeparationMutation(baseOptions?: Apollo.MutationHookOptions<CreateMemberSeparationMutation, CreateMemberSeparationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateMemberSeparationMutation, CreateMemberSeparationMutationVariables>(CreateMemberSeparationDocument, options);
      }
export type CreateMemberSeparationMutationHookResult = ReturnType<typeof useCreateMemberSeparationMutation>;
export type CreateMemberSeparationMutationResult = Apollo.MutationResult<CreateMemberSeparationMutation>;
export type CreateMemberSeparationMutationOptions = Apollo.BaseMutationOptions<CreateMemberSeparationMutation, CreateMemberSeparationMutationVariables>;
export const SaveMemberSeparationAnswersDocument = gql`
    mutation SaveMemberSeparationAnswers($memberSeparationId: Int!, $separationAnswers: [MemberSeparationAnswersInput!]!, $separationFormType: SeparationForm!) {
  saveMemberSeparationAnswers(
    memberSeparationId: $memberSeparationId
    separationAnswers: $separationAnswers
    separationFormType: $separationFormType
  ) {
    success
    errors {
      inputField
      message
    }
  }
}
    `;
export type SaveMemberSeparationAnswersMutationFn = Apollo.MutationFunction<SaveMemberSeparationAnswersMutation, SaveMemberSeparationAnswersMutationVariables>;

/**
 * __useSaveMemberSeparationAnswersMutation__
 *
 * To run a mutation, you first call `useSaveMemberSeparationAnswersMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveMemberSeparationAnswersMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveMemberSeparationAnswersMutation, { data, loading, error }] = useSaveMemberSeparationAnswersMutation({
 *   variables: {
 *      memberSeparationId: // value for 'memberSeparationId'
 *      separationAnswers: // value for 'separationAnswers'
 *      separationFormType: // value for 'separationFormType'
 *   },
 * });
 */
export function useSaveMemberSeparationAnswersMutation(baseOptions?: Apollo.MutationHookOptions<SaveMemberSeparationAnswersMutation, SaveMemberSeparationAnswersMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveMemberSeparationAnswersMutation, SaveMemberSeparationAnswersMutationVariables>(SaveMemberSeparationAnswersDocument, options);
      }
export type SaveMemberSeparationAnswersMutationHookResult = ReturnType<typeof useSaveMemberSeparationAnswersMutation>;
export type SaveMemberSeparationAnswersMutationResult = Apollo.MutationResult<SaveMemberSeparationAnswersMutation>;
export type SaveMemberSeparationAnswersMutationOptions = Apollo.BaseMutationOptions<SaveMemberSeparationAnswersMutation, SaveMemberSeparationAnswersMutationVariables>;
export const GetAdminPermissionsDocument = gql`
    query GetAdminPermissions {
  adminPermissions {
    canDoMakePayments
  }
}
    `;

/**
 * __useGetAdminPermissionsQuery__
 *
 * To run a query within a React component, call `useGetAdminPermissionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAdminPermissionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAdminPermissionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAdminPermissionsQuery(baseOptions?: Apollo.QueryHookOptions<GetAdminPermissionsQuery, GetAdminPermissionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAdminPermissionsQuery, GetAdminPermissionsQueryVariables>(GetAdminPermissionsDocument, options);
      }
export function useGetAdminPermissionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAdminPermissionsQuery, GetAdminPermissionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAdminPermissionsQuery, GetAdminPermissionsQueryVariables>(GetAdminPermissionsDocument, options);
        }
export function useGetAdminPermissionsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetAdminPermissionsQuery, GetAdminPermissionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAdminPermissionsQuery, GetAdminPermissionsQueryVariables>(GetAdminPermissionsDocument, options);
        }
export type GetAdminPermissionsQueryHookResult = ReturnType<typeof useGetAdminPermissionsQuery>;
export type GetAdminPermissionsLazyQueryHookResult = ReturnType<typeof useGetAdminPermissionsLazyQuery>;
export type GetAdminPermissionsSuspenseQueryHookResult = ReturnType<typeof useGetAdminPermissionsSuspenseQuery>;
export type GetAdminPermissionsQueryResult = Apollo.QueryResult<GetAdminPermissionsQuery, GetAdminPermissionsQueryVariables>;
export const GetDateAnalysisDocument = gql`
    query GetDateAnalysis($date: String!) {
  dateAnalysis(date: $date) {
    isBusinessDay
    nextBusinessDay
    previousBusinessDay
  }
}
    `;

/**
 * __useGetDateAnalysisQuery__
 *
 * To run a query within a React component, call `useGetDateAnalysisQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDateAnalysisQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDateAnalysisQuery({
 *   variables: {
 *      date: // value for 'date'
 *   },
 * });
 */
export function useGetDateAnalysisQuery(baseOptions: Apollo.QueryHookOptions<GetDateAnalysisQuery, GetDateAnalysisQueryVariables> & ({ variables: GetDateAnalysisQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDateAnalysisQuery, GetDateAnalysisQueryVariables>(GetDateAnalysisDocument, options);
      }
export function useGetDateAnalysisLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDateAnalysisQuery, GetDateAnalysisQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDateAnalysisQuery, GetDateAnalysisQueryVariables>(GetDateAnalysisDocument, options);
        }
export function useGetDateAnalysisSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetDateAnalysisQuery, GetDateAnalysisQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetDateAnalysisQuery, GetDateAnalysisQueryVariables>(GetDateAnalysisDocument, options);
        }
export type GetDateAnalysisQueryHookResult = ReturnType<typeof useGetDateAnalysisQuery>;
export type GetDateAnalysisLazyQueryHookResult = ReturnType<typeof useGetDateAnalysisLazyQuery>;
export type GetDateAnalysisSuspenseQueryHookResult = ReturnType<typeof useGetDateAnalysisSuspenseQuery>;
export type GetDateAnalysisQueryResult = Apollo.QueryResult<GetDateAnalysisQuery, GetDateAnalysisQueryVariables>;
export const GetMemberSeparationDocument = gql`
    query GetMemberSeparation($memberUuid: String!) {
  memberSeparation(memberUuid: $memberUuid) {
    memberSeparationId
    companyId
    earliestPayDate
    questionnaireVersion
    status
    lastUpdatedById
    createdAt
    updatedAt
    memberSeparationAnswers {
      fieldId
      fieldLabel
      values {
        documentTitle
        valueBoolean
        valueDate
        valueDocumentId
        valueNumeric
        valueText
        valueTextSmall
      }
    }
  }
}
    `;

/**
 * __useGetMemberSeparationQuery__
 *
 * To run a query within a React component, call `useGetMemberSeparationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMemberSeparationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMemberSeparationQuery({
 *   variables: {
 *      memberUuid: // value for 'memberUuid'
 *   },
 * });
 */
export function useGetMemberSeparationQuery(baseOptions: Apollo.QueryHookOptions<GetMemberSeparationQuery, GetMemberSeparationQueryVariables> & ({ variables: GetMemberSeparationQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMemberSeparationQuery, GetMemberSeparationQueryVariables>(GetMemberSeparationDocument, options);
      }
export function useGetMemberSeparationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMemberSeparationQuery, GetMemberSeparationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMemberSeparationQuery, GetMemberSeparationQueryVariables>(GetMemberSeparationDocument, options);
        }
export function useGetMemberSeparationSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetMemberSeparationQuery, GetMemberSeparationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetMemberSeparationQuery, GetMemberSeparationQueryVariables>(GetMemberSeparationDocument, options);
        }
export type GetMemberSeparationQueryHookResult = ReturnType<typeof useGetMemberSeparationQuery>;
export type GetMemberSeparationLazyQueryHookResult = ReturnType<typeof useGetMemberSeparationLazyQuery>;
export type GetMemberSeparationSuspenseQueryHookResult = ReturnType<typeof useGetMemberSeparationSuspenseQuery>;
export type GetMemberSeparationQueryResult = Apollo.QueryResult<GetMemberSeparationQuery, GetMemberSeparationQueryVariables>;
export const GetMemberSeparationDocumentsDocument = gql`
    query GetMemberSeparationDocuments($documentIds: [ID!]!) {
  memberSeparationDocuments(documentIds: $documentIds) {
    id
    uuid
    title
    downloadUrl
  }
}
    `;

/**
 * __useGetMemberSeparationDocumentsQuery__
 *
 * To run a query within a React component, call `useGetMemberSeparationDocumentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMemberSeparationDocumentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMemberSeparationDocumentsQuery({
 *   variables: {
 *      documentIds: // value for 'documentIds'
 *   },
 * });
 */
export function useGetMemberSeparationDocumentsQuery(baseOptions: Apollo.QueryHookOptions<GetMemberSeparationDocumentsQuery, GetMemberSeparationDocumentsQueryVariables> & ({ variables: GetMemberSeparationDocumentsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMemberSeparationDocumentsQuery, GetMemberSeparationDocumentsQueryVariables>(GetMemberSeparationDocumentsDocument, options);
      }
export function useGetMemberSeparationDocumentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMemberSeparationDocumentsQuery, GetMemberSeparationDocumentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMemberSeparationDocumentsQuery, GetMemberSeparationDocumentsQueryVariables>(GetMemberSeparationDocumentsDocument, options);
        }
export function useGetMemberSeparationDocumentsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetMemberSeparationDocumentsQuery, GetMemberSeparationDocumentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetMemberSeparationDocumentsQuery, GetMemberSeparationDocumentsQueryVariables>(GetMemberSeparationDocumentsDocument, options);
        }
export type GetMemberSeparationDocumentsQueryHookResult = ReturnType<typeof useGetMemberSeparationDocumentsQuery>;
export type GetMemberSeparationDocumentsLazyQueryHookResult = ReturnType<typeof useGetMemberSeparationDocumentsLazyQuery>;
export type GetMemberSeparationDocumentsSuspenseQueryHookResult = ReturnType<typeof useGetMemberSeparationDocumentsSuspenseQuery>;
export type GetMemberSeparationDocumentsQueryResult = Apollo.QueryResult<GetMemberSeparationDocumentsQuery, GetMemberSeparationDocumentsQueryVariables>;
export const GetMemberSeparationQuestionnaireDocument = gql`
    query GetMemberSeparationQuestionnaire($terminationCode: String!) {
  memberSeparationQuestionnaire(terminationCode: $terminationCode) {
    questionId
    questionText
    inputType
    validations {
      required
      minLength
    }
    answers {
      value
      subQuestionIds
    }
  }
}
    `;

/**
 * __useGetMemberSeparationQuestionnaireQuery__
 *
 * To run a query within a React component, call `useGetMemberSeparationQuestionnaireQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMemberSeparationQuestionnaireQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMemberSeparationQuestionnaireQuery({
 *   variables: {
 *      terminationCode: // value for 'terminationCode'
 *   },
 * });
 */
export function useGetMemberSeparationQuestionnaireQuery(baseOptions: Apollo.QueryHookOptions<GetMemberSeparationQuestionnaireQuery, GetMemberSeparationQuestionnaireQueryVariables> & ({ variables: GetMemberSeparationQuestionnaireQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMemberSeparationQuestionnaireQuery, GetMemberSeparationQuestionnaireQueryVariables>(GetMemberSeparationQuestionnaireDocument, options);
      }
export function useGetMemberSeparationQuestionnaireLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMemberSeparationQuestionnaireQuery, GetMemberSeparationQuestionnaireQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMemberSeparationQuestionnaireQuery, GetMemberSeparationQuestionnaireQueryVariables>(GetMemberSeparationQuestionnaireDocument, options);
        }
export function useGetMemberSeparationQuestionnaireSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetMemberSeparationQuestionnaireQuery, GetMemberSeparationQuestionnaireQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetMemberSeparationQuestionnaireQuery, GetMemberSeparationQuestionnaireQueryVariables>(GetMemberSeparationQuestionnaireDocument, options);
        }
export type GetMemberSeparationQuestionnaireQueryHookResult = ReturnType<typeof useGetMemberSeparationQuestionnaireQuery>;
export type GetMemberSeparationQuestionnaireLazyQueryHookResult = ReturnType<typeof useGetMemberSeparationQuestionnaireLazyQuery>;
export type GetMemberSeparationQuestionnaireSuspenseQueryHookResult = ReturnType<typeof useGetMemberSeparationQuestionnaireSuspenseQuery>;
export type GetMemberSeparationQuestionnaireQueryResult = Apollo.QueryResult<GetMemberSeparationQuestionnaireQuery, GetMemberSeparationQuestionnaireQueryVariables>;
export const GetSeparatingMemberDocument = gql`
    query GetSeparatingMember($memberUuid: String!) {
  separatingMember(memberUuid: $memberUuid) {
    uuid
    cdmsCanonicalEmploymentId
    friendlyFullName
    effectiveDate
    isTerminated
    address {
      state
    }
    memberType
  }
}
    `;

/**
 * __useGetSeparatingMemberQuery__
 *
 * To run a query within a React component, call `useGetSeparatingMemberQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSeparatingMemberQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSeparatingMemberQuery({
 *   variables: {
 *      memberUuid: // value for 'memberUuid'
 *   },
 * });
 */
export function useGetSeparatingMemberQuery(baseOptions: Apollo.QueryHookOptions<GetSeparatingMemberQuery, GetSeparatingMemberQueryVariables> & ({ variables: GetSeparatingMemberQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSeparatingMemberQuery, GetSeparatingMemberQueryVariables>(GetSeparatingMemberDocument, options);
      }
export function useGetSeparatingMemberLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSeparatingMemberQuery, GetSeparatingMemberQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSeparatingMemberQuery, GetSeparatingMemberQueryVariables>(GetSeparatingMemberDocument, options);
        }
export function useGetSeparatingMemberSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetSeparatingMemberQuery, GetSeparatingMemberQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetSeparatingMemberQuery, GetSeparatingMemberQueryVariables>(GetSeparatingMemberDocument, options);
        }
export type GetSeparatingMemberQueryHookResult = ReturnType<typeof useGetSeparatingMemberQuery>;
export type GetSeparatingMemberLazyQueryHookResult = ReturnType<typeof useGetSeparatingMemberLazyQuery>;
export type GetSeparatingMemberSuspenseQueryHookResult = ReturnType<typeof useGetSeparatingMemberSuspenseQuery>;
export type GetSeparatingMemberQueryResult = Apollo.QueryResult<GetSeparatingMemberQuery, GetSeparatingMemberQueryVariables>;
export const GetStateSeparationNoticeRequirementsDocument = gql`
    query GetStateSeparationNoticeRequirements($state: String) {
  stateSeparationNoticeRequirements(state: $state) {
    stateAbbreviation
    presignedUrl
  }
}
    `;

/**
 * __useGetStateSeparationNoticeRequirementsQuery__
 *
 * To run a query within a React component, call `useGetStateSeparationNoticeRequirementsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStateSeparationNoticeRequirementsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetStateSeparationNoticeRequirementsQuery({
 *   variables: {
 *      state: // value for 'state'
 *   },
 * });
 */
export function useGetStateSeparationNoticeRequirementsQuery(baseOptions?: Apollo.QueryHookOptions<GetStateSeparationNoticeRequirementsQuery, GetStateSeparationNoticeRequirementsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetStateSeparationNoticeRequirementsQuery, GetStateSeparationNoticeRequirementsQueryVariables>(GetStateSeparationNoticeRequirementsDocument, options);
      }
export function useGetStateSeparationNoticeRequirementsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetStateSeparationNoticeRequirementsQuery, GetStateSeparationNoticeRequirementsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetStateSeparationNoticeRequirementsQuery, GetStateSeparationNoticeRequirementsQueryVariables>(GetStateSeparationNoticeRequirementsDocument, options);
        }
export function useGetStateSeparationNoticeRequirementsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetStateSeparationNoticeRequirementsQuery, GetStateSeparationNoticeRequirementsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetStateSeparationNoticeRequirementsQuery, GetStateSeparationNoticeRequirementsQueryVariables>(GetStateSeparationNoticeRequirementsDocument, options);
        }
export type GetStateSeparationNoticeRequirementsQueryHookResult = ReturnType<typeof useGetStateSeparationNoticeRequirementsQuery>;
export type GetStateSeparationNoticeRequirementsLazyQueryHookResult = ReturnType<typeof useGetStateSeparationNoticeRequirementsLazyQuery>;
export type GetStateSeparationNoticeRequirementsSuspenseQueryHookResult = ReturnType<typeof useGetStateSeparationNoticeRequirementsSuspenseQuery>;
export type GetStateSeparationNoticeRequirementsQueryResult = Apollo.QueryResult<GetStateSeparationNoticeRequirementsQuery, GetStateSeparationNoticeRequirementsQueryVariables>;
export const CreateClaimReportDocument = gql`
    mutation CreateClaimReport($complete: Boolean!, $draftId: ID, $data: ClaimReport!) {
  createWcClaimReport(complete: $complete, data: $data, draftId: $draftId) {
    success
    error
    draftId
  }
}
    `;
export type CreateClaimReportMutationFn = Apollo.MutationFunction<CreateClaimReportMutation, CreateClaimReportMutationVariables>;

/**
 * __useCreateClaimReportMutation__
 *
 * To run a mutation, you first call `useCreateClaimReportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateClaimReportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createClaimReportMutation, { data, loading, error }] = useCreateClaimReportMutation({
 *   variables: {
 *      complete: // value for 'complete'
 *      draftId: // value for 'draftId'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateClaimReportMutation(baseOptions?: Apollo.MutationHookOptions<CreateClaimReportMutation, CreateClaimReportMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateClaimReportMutation, CreateClaimReportMutationVariables>(CreateClaimReportDocument, options);
      }
export type CreateClaimReportMutationHookResult = ReturnType<typeof useCreateClaimReportMutation>;
export type CreateClaimReportMutationResult = Apollo.MutationResult<CreateClaimReportMutation>;
export type CreateClaimReportMutationOptions = Apollo.BaseMutationOptions<CreateClaimReportMutation, CreateClaimReportMutationVariables>;
export const GetCompanyAdminDetailsDocument = gql`
    query GetCompanyAdminDetails {
  currentMember {
    company {
      id
      name
      uuid
    }
    emailWork
    friendlyFullName
    phoneOffice
    uuid
  }
}
    `;

/**
 * __useGetCompanyAdminDetailsQuery__
 *
 * To run a query within a React component, call `useGetCompanyAdminDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCompanyAdminDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCompanyAdminDetailsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCompanyAdminDetailsQuery(baseOptions?: Apollo.QueryHookOptions<GetCompanyAdminDetailsQuery, GetCompanyAdminDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCompanyAdminDetailsQuery, GetCompanyAdminDetailsQueryVariables>(GetCompanyAdminDetailsDocument, options);
      }
export function useGetCompanyAdminDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCompanyAdminDetailsQuery, GetCompanyAdminDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCompanyAdminDetailsQuery, GetCompanyAdminDetailsQueryVariables>(GetCompanyAdminDetailsDocument, options);
        }
export function useGetCompanyAdminDetailsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCompanyAdminDetailsQuery, GetCompanyAdminDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCompanyAdminDetailsQuery, GetCompanyAdminDetailsQueryVariables>(GetCompanyAdminDetailsDocument, options);
        }
export type GetCompanyAdminDetailsQueryHookResult = ReturnType<typeof useGetCompanyAdminDetailsQuery>;
export type GetCompanyAdminDetailsLazyQueryHookResult = ReturnType<typeof useGetCompanyAdminDetailsLazyQuery>;
export type GetCompanyAdminDetailsSuspenseQueryHookResult = ReturnType<typeof useGetCompanyAdminDetailsSuspenseQuery>;
export type GetCompanyAdminDetailsQueryResult = Apollo.QueryResult<GetCompanyAdminDetailsQuery, GetCompanyAdminDetailsQueryVariables>;
export const GetDraftsDataDocument = gql`
    query GetDraftsData($adminUuid: String!) {
  draftClaimReportsByAdmin(adminUuid: $adminUuid) {
    createdAt
    draftId
    data {
      claim {
        adminUuid
        adminEmail
        adminPhone
        companyName
        companyUuid
        memberName
        memberUuid
        clinicOrProviderName
        emergencyResponseContacted
        emergencyResponseDetails
        employerPolicyNumber
        estimatedAccidentDateTime
        affectedBodyPart
        oshaNumber
        fatality
        incidentDescription
        injuryDescription
        safeguardsUsed
        describedSafeguards
        treatmentGiven
        treatmentFacilityPhone
        treatmentFacilityAddress {
          city
          postalCode
          state
          street1
          street2
        }
        accidentLocation {
          city
          postalCode
          state
          street1
          street2
        }
      }
      claimant {
        personalEmail
        phoneNumber
        homeAddress {
          city
          postalCode
          state
          street1
          street2
        }
        workAddress {
          city
          postalCode
          state
          street1
          street2
        }
      }
      witnesses {
        name
        contactInformation
        description
      }
      workStatus {
        paid
        startTimeOut
        endTimeOut
      }
    }
  }
}
    `;

/**
 * __useGetDraftsDataQuery__
 *
 * To run a query within a React component, call `useGetDraftsDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDraftsDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDraftsDataQuery({
 *   variables: {
 *      adminUuid: // value for 'adminUuid'
 *   },
 * });
 */
export function useGetDraftsDataQuery(baseOptions: Apollo.QueryHookOptions<GetDraftsDataQuery, GetDraftsDataQueryVariables> & ({ variables: GetDraftsDataQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDraftsDataQuery, GetDraftsDataQueryVariables>(GetDraftsDataDocument, options);
      }
export function useGetDraftsDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDraftsDataQuery, GetDraftsDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDraftsDataQuery, GetDraftsDataQueryVariables>(GetDraftsDataDocument, options);
        }
export function useGetDraftsDataSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetDraftsDataQuery, GetDraftsDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetDraftsDataQuery, GetDraftsDataQueryVariables>(GetDraftsDataDocument, options);
        }
export type GetDraftsDataQueryHookResult = ReturnType<typeof useGetDraftsDataQuery>;
export type GetDraftsDataLazyQueryHookResult = ReturnType<typeof useGetDraftsDataLazyQuery>;
export type GetDraftsDataSuspenseQueryHookResult = ReturnType<typeof useGetDraftsDataSuspenseQuery>;
export type GetDraftsDataQueryResult = Apollo.QueryResult<GetDraftsDataQuery, GetDraftsDataQueryVariables>;
export const GetEligibleClaimsMembersByDateDocument = gql`
    query GetEligibleClaimsMembersByDate($injuryDate: APIDate!) {
  eligibleClaimsMembersWithAddress(injuryDate: $injuryDate) {
    uuid
    id
    friendlyFullName
    deskTitle
    contactPhone
    emailWork
    company {
      name
      primaryPhoneNumber
      primaryAddress {
        city
        countryCode
        postalCode
        state
        street1
        street2
      }
    }
    homeAddress {
      city
      countryCode
      postalCode
      state
      street1
      street2
    }
    mostRecentPaymentWorkAddress {
      state
      city
      street1
      street2
      postalCode
      countryCode
    }
  }
}
    `;

/**
 * __useGetEligibleClaimsMembersByDateQuery__
 *
 * To run a query within a React component, call `useGetEligibleClaimsMembersByDateQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEligibleClaimsMembersByDateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEligibleClaimsMembersByDateQuery({
 *   variables: {
 *      injuryDate: // value for 'injuryDate'
 *   },
 * });
 */
export function useGetEligibleClaimsMembersByDateQuery(baseOptions: Apollo.QueryHookOptions<GetEligibleClaimsMembersByDateQuery, GetEligibleClaimsMembersByDateQueryVariables> & ({ variables: GetEligibleClaimsMembersByDateQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEligibleClaimsMembersByDateQuery, GetEligibleClaimsMembersByDateQueryVariables>(GetEligibleClaimsMembersByDateDocument, options);
      }
export function useGetEligibleClaimsMembersByDateLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEligibleClaimsMembersByDateQuery, GetEligibleClaimsMembersByDateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEligibleClaimsMembersByDateQuery, GetEligibleClaimsMembersByDateQueryVariables>(GetEligibleClaimsMembersByDateDocument, options);
        }
export function useGetEligibleClaimsMembersByDateSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetEligibleClaimsMembersByDateQuery, GetEligibleClaimsMembersByDateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetEligibleClaimsMembersByDateQuery, GetEligibleClaimsMembersByDateQueryVariables>(GetEligibleClaimsMembersByDateDocument, options);
        }
export type GetEligibleClaimsMembersByDateQueryHookResult = ReturnType<typeof useGetEligibleClaimsMembersByDateQuery>;
export type GetEligibleClaimsMembersByDateLazyQueryHookResult = ReturnType<typeof useGetEligibleClaimsMembersByDateLazyQuery>;
export type GetEligibleClaimsMembersByDateSuspenseQueryHookResult = ReturnType<typeof useGetEligibleClaimsMembersByDateSuspenseQuery>;
export type GetEligibleClaimsMembersByDateQueryResult = Apollo.QueryResult<GetEligibleClaimsMembersByDateQuery, GetEligibleClaimsMembersByDateQueryVariables>;
export const GetSubmittedClaimReportsByCompanyDocument = gql`
    query GetSubmittedClaimReportsByCompany($companyUuid: String!) {
  submittedClaimReportsByCompany(companyUuid: $companyUuid) {
    createdAt
    pdfReport
    data {
      claim {
        adminUuid
        adminEmail
        adminPhone
        companyName
        companyUuid
        memberName
        memberUuid
        clinicOrProviderName
        emergencyResponseContacted
        emergencyResponseDetails
        employerPolicyNumber
        estimatedAccidentDateTime
        affectedBodyPart
        oshaNumber
        fatality
        incidentDescription
        injuryDescription
        safeguardsUsed
        describedSafeguards
        treatmentGiven
        treatmentFacilityPhone
        treatmentFacilityAddress {
          city
          postalCode
          state
          street1
          street2
        }
        accidentLocation {
          city
          postalCode
          state
          street1
          street2
        }
      }
      claimant {
        personalEmail
        phoneNumber
        homeAddress {
          city
          postalCode
          state
          street1
          street2
        }
        workAddress {
          city
          postalCode
          state
          street1
          street2
        }
      }
      witnesses {
        name
        contactInformation
        description
      }
      workStatus {
        paid
        startTimeOut
        endTimeOut
      }
    }
  }
}
    `;

/**
 * __useGetSubmittedClaimReportsByCompanyQuery__
 *
 * To run a query within a React component, call `useGetSubmittedClaimReportsByCompanyQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSubmittedClaimReportsByCompanyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSubmittedClaimReportsByCompanyQuery({
 *   variables: {
 *      companyUuid: // value for 'companyUuid'
 *   },
 * });
 */
export function useGetSubmittedClaimReportsByCompanyQuery(baseOptions: Apollo.QueryHookOptions<GetSubmittedClaimReportsByCompanyQuery, GetSubmittedClaimReportsByCompanyQueryVariables> & ({ variables: GetSubmittedClaimReportsByCompanyQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSubmittedClaimReportsByCompanyQuery, GetSubmittedClaimReportsByCompanyQueryVariables>(GetSubmittedClaimReportsByCompanyDocument, options);
      }
export function useGetSubmittedClaimReportsByCompanyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSubmittedClaimReportsByCompanyQuery, GetSubmittedClaimReportsByCompanyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSubmittedClaimReportsByCompanyQuery, GetSubmittedClaimReportsByCompanyQueryVariables>(GetSubmittedClaimReportsByCompanyDocument, options);
        }
export function useGetSubmittedClaimReportsByCompanySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetSubmittedClaimReportsByCompanyQuery, GetSubmittedClaimReportsByCompanyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetSubmittedClaimReportsByCompanyQuery, GetSubmittedClaimReportsByCompanyQueryVariables>(GetSubmittedClaimReportsByCompanyDocument, options);
        }
export type GetSubmittedClaimReportsByCompanyQueryHookResult = ReturnType<typeof useGetSubmittedClaimReportsByCompanyQuery>;
export type GetSubmittedClaimReportsByCompanyLazyQueryHookResult = ReturnType<typeof useGetSubmittedClaimReportsByCompanyLazyQuery>;
export type GetSubmittedClaimReportsByCompanySuspenseQueryHookResult = ReturnType<typeof useGetSubmittedClaimReportsByCompanySuspenseQuery>;
export type GetSubmittedClaimReportsByCompanyQueryResult = Apollo.QueryResult<GetSubmittedClaimReportsByCompanyQuery, GetSubmittedClaimReportsByCompanyQueryVariables>;
export const CreateInsuranceDocumentRequestDocument = gql`
    mutation CreateInsuranceDocumentRequest($request: InsuranceDocumentRequest!) {
  createInsuranceDocumentRequest(request: $request) {
    success
    error
  }
}
    `;
export type CreateInsuranceDocumentRequestMutationFn = Apollo.MutationFunction<CreateInsuranceDocumentRequestMutation, CreateInsuranceDocumentRequestMutationVariables>;

/**
 * __useCreateInsuranceDocumentRequestMutation__
 *
 * To run a mutation, you first call `useCreateInsuranceDocumentRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateInsuranceDocumentRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createInsuranceDocumentRequestMutation, { data, loading, error }] = useCreateInsuranceDocumentRequestMutation({
 *   variables: {
 *      request: // value for 'request'
 *   },
 * });
 */
export function useCreateInsuranceDocumentRequestMutation(baseOptions?: Apollo.MutationHookOptions<CreateInsuranceDocumentRequestMutation, CreateInsuranceDocumentRequestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateInsuranceDocumentRequestMutation, CreateInsuranceDocumentRequestMutationVariables>(CreateInsuranceDocumentRequestDocument, options);
      }
export type CreateInsuranceDocumentRequestMutationHookResult = ReturnType<typeof useCreateInsuranceDocumentRequestMutation>;
export type CreateInsuranceDocumentRequestMutationResult = Apollo.MutationResult<CreateInsuranceDocumentRequestMutation>;
export type CreateInsuranceDocumentRequestMutationOptions = Apollo.BaseMutationOptions<CreateInsuranceDocumentRequestMutation, CreateInsuranceDocumentRequestMutationVariables>;
export const WcDocumentRequestDocument = gql`
    query WCDocumentRequest {
  authenticatedMember {
    uuid
    permissions
    company {
      uuid
    }
  }
}
    `;

/**
 * __useWcDocumentRequestQuery__
 *
 * To run a query within a React component, call `useWcDocumentRequestQuery` and pass it any options that fit your needs.
 * When your component renders, `useWcDocumentRequestQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWcDocumentRequestQuery({
 *   variables: {
 *   },
 * });
 */
export function useWcDocumentRequestQuery(baseOptions?: Apollo.QueryHookOptions<WcDocumentRequestQuery, WcDocumentRequestQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<WcDocumentRequestQuery, WcDocumentRequestQueryVariables>(WcDocumentRequestDocument, options);
      }
export function useWcDocumentRequestLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<WcDocumentRequestQuery, WcDocumentRequestQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<WcDocumentRequestQuery, WcDocumentRequestQueryVariables>(WcDocumentRequestDocument, options);
        }
export function useWcDocumentRequestSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<WcDocumentRequestQuery, WcDocumentRequestQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<WcDocumentRequestQuery, WcDocumentRequestQueryVariables>(WcDocumentRequestDocument, options);
        }
export type WcDocumentRequestQueryHookResult = ReturnType<typeof useWcDocumentRequestQuery>;
export type WcDocumentRequestLazyQueryHookResult = ReturnType<typeof useWcDocumentRequestLazyQuery>;
export type WcDocumentRequestSuspenseQueryHookResult = ReturnType<typeof useWcDocumentRequestSuspenseQuery>;
export type WcDocumentRequestQueryResult = Apollo.QueryResult<WcDocumentRequestQuery, WcDocumentRequestQueryVariables>;
export const AllActiveMembersDocument = gql`
    query AllActiveMembers {
  authenticatedMember {
    uuid
    permissions
    company {
      uuid
      directoryMembersWithoutInviteStatusCheck {
        friendlyFullName
        uuid
        memberType
      }
      activeW2Members {
        friendlyFullName
        uuid
        memberType
      }
    }
  }
}
    `;

/**
 * __useAllActiveMembersQuery__
 *
 * To run a query within a React component, call `useAllActiveMembersQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllActiveMembersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllActiveMembersQuery({
 *   variables: {
 *   },
 * });
 */
export function useAllActiveMembersQuery(baseOptions?: Apollo.QueryHookOptions<AllActiveMembersQuery, AllActiveMembersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AllActiveMembersQuery, AllActiveMembersQueryVariables>(AllActiveMembersDocument, options);
      }
export function useAllActiveMembersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllActiveMembersQuery, AllActiveMembersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AllActiveMembersQuery, AllActiveMembersQueryVariables>(AllActiveMembersDocument, options);
        }
export function useAllActiveMembersSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<AllActiveMembersQuery, AllActiveMembersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AllActiveMembersQuery, AllActiveMembersQueryVariables>(AllActiveMembersDocument, options);
        }
export type AllActiveMembersQueryHookResult = ReturnType<typeof useAllActiveMembersQuery>;
export type AllActiveMembersLazyQueryHookResult = ReturnType<typeof useAllActiveMembersLazyQuery>;
export type AllActiveMembersSuspenseQueryHookResult = ReturnType<typeof useAllActiveMembersSuspenseQuery>;
export type AllActiveMembersQueryResult = Apollo.QueryResult<AllActiveMembersQuery, AllActiveMembersQueryVariables>;